export const timeData = [
  { date: '2023-01-01T00:00:00', value: 15.03 },
  { date: '2023-01-01T01:00:00', value: 53.21 },
  { date: '2023-01-01T02:00:00', value: 77.35 },
  { date: '2023-01-01T03:00:00', value: 85.76 },
  { date: '2023-01-01T04:00:00', value: 14.5 },
  { date: '2023-01-01T05:00:00', value: 46.22 },
  { date: '2023-01-01T06:00:00', value: 10.93 },
  { date: '2023-01-01T07:00:00', value: 13.58 },
  { date: '2023-01-01T08:00:00', value: 38.78 },
  { date: '2023-01-01T09:00:00', value: 81.77 },
  { date: '2023-01-01T10:00:00', value: 63.98 },
  { date: '2023-01-01T11:00:00', value: 47.64 },
  { date: '2023-01-01T12:00:00', value: 72.88 },
  { date: '2023-01-01T13:00:00', value: 56.08 },
  { date: '2023-01-01T14:00:00', value: 73.06 },
  { date: '2023-01-01T15:00:00', value: 3.72 },
  { date: '2023-01-01T16:00:00', value: 73.66 },
  { date: '2023-01-01T17:00:00', value: 10.74 },
  { date: '2023-01-01T18:00:00', value: 33.92 },
  { date: '2023-01-01T19:00:00', value: 80.18 },
  { date: '2023-01-01T20:00:00', value: 99.98 },
  { date: '2023-01-01T21:00:00', value: 16.39 },
  { date: '2023-01-01T22:00:00', value: 20.41 },
  { date: '2023-01-01T23:00:00', value: 75.3 },
  { date: '2023-01-02T00:00:00', value: 24.48 },
  { date: '2023-01-02T01:00:00', value: 96.49 },
  { date: '2023-01-02T02:00:00', value: 31.93 },
  { date: '2023-01-02T03:00:00', value: 80.57 },
  { date: '2023-01-02T04:00:00', value: 95.34 },
  { date: '2023-01-02T05:00:00', value: 52.68 },
  { date: '2023-01-02T06:00:00', value: 64.99 },
  { date: '2023-01-02T07:00:00', value: 2.61 },
  { date: '2023-01-02T08:00:00', value: 99.4 },
  { date: '2023-01-02T09:00:00', value: 24.66 },
  { date: '2023-01-02T10:00:00', value: 97.28 },
  { date: '2023-01-02T11:00:00', value: 58.87 },
  { date: '2023-01-02T12:00:00', value: 97.02 },
  { date: '2023-01-02T13:00:00', value: 73.25 },
  { date: '2023-01-02T14:00:00', value: 7.77 },
  { date: '2023-01-02T15:00:00', value: 5.87 },
  { date: '2023-01-02T16:00:00', value: 43.94 },
  { date: '2023-01-02T17:00:00', value: 99.42 },
  { date: '2023-01-02T18:00:00', value: 40.17 },
  { date: '2023-01-02T19:00:00', value: 74.72 },
  { date: '2023-01-02T20:00:00', value: 88.9 },
  { date: '2023-01-02T21:00:00', value: 74.91 },
  { date: '2023-01-02T22:00:00', value: 19.87 },
  { date: '2023-01-02T23:00:00', value: 97.16 },
  { date: '2023-01-03T00:00:00', value: 93.41 },
  { date: '2023-01-03T01:00:00', value: 39.62 },
  { date: '2023-01-03T02:00:00', value: 19.82 },
  { date: '2023-01-03T03:00:00', value: 15.86 },
  { date: '2023-01-03T04:00:00', value: 86.81 },
  { date: '2023-01-03T05:00:00', value: 37.7 },
  { date: '2023-01-03T06:00:00', value: 37.5 },
  { date: '2023-01-03T07:00:00', value: 80.04 },
  { date: '2023-01-03T08:00:00', value: 66.86 },
  { date: '2023-01-03T09:00:00', value: 61.92 },
  { date: '2023-01-03T10:00:00', value: 37.38 },
  { date: '2023-01-03T11:00:00', value: 31.44 },
  { date: '2023-01-03T12:00:00', value: 14.73 },
  { date: '2023-01-03T13:00:00', value: 13.79 },
  { date: '2023-01-03T14:00:00', value: 49.0 },
  { date: '2023-01-03T15:00:00', value: 81.8 },
  { date: '2023-01-03T16:00:00', value: 21.35 },
  { date: '2023-01-03T17:00:00', value: 5.48 },
  { date: '2023-01-03T18:00:00', value: 67.18 },
  { date: '2023-01-03T19:00:00', value: 33.6 },
  { date: '2023-01-03T20:00:00', value: 31.13 },
  { date: '2023-01-03T21:00:00', value: 95.24 },
  { date: '2023-01-03T22:00:00', value: 8.31 },
  { date: '2023-01-03T23:00:00', value: 50.19 },
  { date: '2023-01-04T00:00:00', value: 5.62 },
  { date: '2023-01-04T01:00:00', value: 77.47 },
  { date: '2023-01-04T02:00:00', value: 15.97 },
  { date: '2023-01-04T03:00:00', value: 4.97 },
  { date: '2023-01-04T04:00:00', value: 39.06 },
  { date: '2023-01-04T05:00:00', value: 60.33 },
  { date: '2023-01-04T06:00:00', value: 17.14 },
  { date: '2023-01-04T07:00:00', value: 43.17 },
  { date: '2023-01-04T08:00:00', value: 15.34 },
  { date: '2023-01-04T09:00:00', value: 83.92 },
  { date: '2023-01-04T10:00:00', value: 26.99 },
  { date: '2023-01-04T11:00:00', value: 77.15 },
  { date: '2023-01-04T12:00:00', value: 21.96 },
  { date: '2023-01-04T13:00:00', value: 56.85 },
  { date: '2023-01-04T14:00:00', value: 94.01 },
  { date: '2023-01-04T15:00:00', value: 75.03 },
  { date: '2023-01-04T16:00:00', value: 17.03 },
  { date: '2023-01-04T17:00:00', value: 63.67 },
  { date: '2023-01-04T18:00:00', value: 7.7 },
  { date: '2023-01-04T19:00:00', value: 81.76 },
  { date: '2023-01-04T20:00:00', value: 76.73 },
  { date: '2023-01-04T21:00:00', value: 58.7 },
  { date: '2023-01-04T22:00:00', value: 28.62 },
  { date: '2023-01-04T23:00:00', value: 11.65 },
  { date: '2023-01-05T00:00:00', value: 72.52 },
  { date: '2023-01-05T01:00:00', value: 78.82 },
  { date: '2023-01-05T02:00:00', value: 68.72 },
  { date: '2023-01-05T03:00:00', value: 69.02 },
  { date: '2023-01-05T04:00:00', value: 35.16 },
  { date: '2023-01-05T05:00:00', value: 94.69 },
  { date: '2023-01-05T06:00:00', value: 71.04 },
  { date: '2023-01-05T07:00:00', value: 35.47 },
  { date: '2023-01-05T08:00:00', value: 15.11 },
  { date: '2023-01-05T09:00:00', value: 25.16 },
  { date: '2023-01-05T10:00:00', value: 34.09 },
  { date: '2023-01-05T11:00:00', value: 54.05 },
  { date: '2023-01-05T12:00:00', value: 62.04 },
  { date: '2023-01-05T13:00:00', value: 9.07 },
  { date: '2023-01-05T14:00:00', value: 5.53 },
  { date: '2023-01-05T15:00:00', value: 62.42 },
  { date: '2023-01-05T16:00:00', value: 22.16 },
  { date: '2023-01-05T17:00:00', value: 59.53 },
  { date: '2023-01-05T18:00:00', value: 7.17 },
  { date: '2023-01-05T19:00:00', value: 29.49 },
  { date: '2023-01-05T20:00:00', value: 10.75 },
  { date: '2023-01-05T21:00:00', value: 45.86 },
  { date: '2023-01-05T22:00:00', value: 14.15 },
  { date: '2023-01-05T23:00:00', value: 2.18 },
  { date: '2023-01-06T00:00:00', value: 18.45 },
  { date: '2023-01-06T01:00:00', value: 66.73 },
  { date: '2023-01-06T02:00:00', value: 83.57 },
  { date: '2023-01-06T03:00:00', value: 85.11 },
  { date: '2023-01-06T04:00:00', value: 29.57 },
  { date: '2023-01-06T05:00:00', value: 48.94 },
  { date: '2023-01-06T06:00:00', value: 46.55 },
  { date: '2023-01-06T07:00:00', value: 99.52 },
  { date: '2023-01-06T08:00:00', value: 43.14 },
  { date: '2023-01-06T09:00:00', value: 49.76 },
  { date: '2023-01-06T10:00:00', value: 98.8 },
  { date: '2023-01-06T11:00:00', value: 44.34 },
  { date: '2023-01-06T12:00:00', value: 75.67 },
  { date: '2023-01-06T13:00:00', value: 79.39 },
  { date: '2023-01-06T14:00:00', value: 39.59 },
  { date: '2023-01-06T15:00:00', value: 64.97 },
  { date: '2023-01-06T16:00:00', value: 93.85 },
  { date: '2023-01-06T17:00:00', value: 39.04 },
  { date: '2023-01-06T18:00:00', value: 57.77 },
  { date: '2023-01-06T19:00:00', value: 20.07 },
  { date: '2023-01-06T20:00:00', value: 59.79 },
  { date: '2023-01-06T21:00:00', value: 45.26 },
  { date: '2023-01-06T22:00:00', value: 66.11 },
  { date: '2023-01-06T23:00:00', value: 15.12 },
  { date: '2023-01-07T00:00:00', value: 51.73 },
  { date: '2023-01-07T01:00:00', value: 47.27 },
  { date: '2023-01-07T02:00:00', value: 65.35 },
  { date: '2023-01-07T03:00:00', value: 40.43 },
  { date: '2023-01-07T04:00:00', value: 43.73 },
  { date: '2023-01-07T05:00:00', value: 69.01 },
  { date: '2023-01-07T06:00:00', value: 20.83 },
  { date: '2023-01-07T07:00:00', value: 45.36 },
  { date: '2023-01-07T08:00:00', value: 53.02 },
  { date: '2023-01-07T09:00:00', value: 29.5 },
  { date: '2023-01-07T10:00:00', value: 90.27 },
  { date: '2023-01-07T11:00:00', value: 80.56 },
  { date: '2023-01-07T12:00:00', value: 89.78 },
  { date: '2023-01-07T13:00:00', value: 94.27 },
  { date: '2023-01-07T14:00:00', value: 34.1 },
  { date: '2023-01-07T15:00:00', value: 78.29 },
  { date: '2023-01-07T16:00:00', value: 14.57 },
  { date: '2023-01-07T17:00:00', value: 62.93 },
  { date: '2023-01-07T18:00:00', value: 52.61 },
  { date: '2023-01-07T19:00:00', value: 74.86 },
  { date: '2023-01-07T20:00:00', value: 84.85 },
  { date: '2023-01-07T21:00:00', value: 92.12 },
  { date: '2023-01-07T22:00:00', value: 84.06 },
  { date: '2023-01-07T23:00:00', value: 69.73 },
  { date: '2023-01-08T00:00:00', value: 63.98 },
  { date: '2023-01-08T01:00:00', value: 69.06 },
  { date: '2023-01-08T02:00:00', value: 85.61 },
  { date: '2023-01-08T03:00:00', value: 36.14 },
  { date: '2023-01-08T04:00:00', value: 84.51 },
  { date: '2023-01-08T05:00:00', value: 5.06 },
  { date: '2023-01-08T06:00:00', value: 33.04 },
  { date: '2023-01-08T07:00:00', value: 36.59 },
  { date: '2023-01-08T08:00:00', value: 56.43 },
  { date: '2023-01-08T09:00:00', value: 40.41 },
  { date: '2023-01-08T10:00:00', value: 3.49 },
  { date: '2023-01-08T11:00:00', value: 98.28 },
  { date: '2023-01-08T12:00:00', value: 87.41 },
  { date: '2023-01-08T13:00:00', value: 31.98 },
  { date: '2023-01-08T14:00:00', value: 15.74 },
  { date: '2023-01-08T15:00:00', value: 10.9 },
  { date: '2023-01-08T16:00:00', value: 56.19 },
  { date: '2023-01-08T17:00:00', value: 9.02 },
  { date: '2023-01-08T18:00:00', value: 15.19 },
  { date: '2023-01-08T19:00:00', value: 24.03 },
  { date: '2023-01-08T20:00:00', value: 40.07 },
  { date: '2023-01-08T21:00:00', value: 60.34 },
  { date: '2023-01-08T22:00:00', value: 58.89 },
  { date: '2023-01-08T23:00:00', value: 46.72 },
  { date: '2023-01-09T00:00:00', value: 21.08 },
  { date: '2023-01-09T01:00:00', value: 35.38 },
  { date: '2023-01-09T02:00:00', value: 97.78 },
  { date: '2023-01-09T03:00:00', value: 33.65 },
  { date: '2023-01-09T04:00:00', value: 18.98 },
  { date: '2023-01-09T05:00:00', value: 64.64 },
  { date: '2023-01-09T06:00:00', value: 11.25 },
  { date: '2023-01-09T07:00:00', value: 5.31 },
  { date: '2023-01-09T08:00:00', value: 43.17 },
  { date: '2023-01-09T09:00:00', value: 16.78 },
  { date: '2023-01-09T10:00:00', value: 79.96 },
  { date: '2023-01-09T11:00:00', value: 78.98 },
  { date: '2023-01-09T12:00:00', value: 80.22 },
  { date: '2023-01-09T13:00:00', value: 7.8 },
  { date: '2023-01-09T14:00:00', value: 81.23 },
  { date: '2023-01-09T15:00:00', value: 87.45 },
  { date: '2023-01-09T16:00:00', value: 48.25 },
  { date: '2023-01-09T17:00:00', value: 56.65 },
  { date: '2023-01-09T18:00:00', value: 98.27 },
  { date: '2023-01-09T19:00:00', value: 56.87 },
  { date: '2023-01-09T20:00:00', value: 17.12 },
  { date: '2023-01-09T21:00:00', value: 91.62 },
  { date: '2023-01-09T22:00:00', value: 78.92 },
  { date: '2023-01-09T23:00:00', value: 9.02 },
  { date: '2023-01-10T00:00:00', value: 59.38 },
  { date: '2023-01-10T01:00:00', value: 82.35 },
  { date: '2023-01-10T02:00:00', value: 11.65 },
  { date: '2023-01-10T03:00:00', value: 64.96 },
  { date: '2023-01-10T04:00:00', value: 11.95 },
  { date: '2023-01-10T05:00:00', value: 60.64 },
  { date: '2023-01-10T06:00:00', value: 50.44 },
  { date: '2023-01-10T07:00:00', value: 12.8 },
  { date: '2023-01-10T08:00:00', value: 35.68 },
  { date: '2023-01-10T09:00:00', value: 44.5 },
  { date: '2023-01-10T10:00:00', value: 54.48 },
  { date: '2023-01-10T11:00:00', value: 21.51 },
  { date: '2023-01-10T12:00:00', value: 96.72 },
  { date: '2023-01-10T13:00:00', value: 2.89 },
  { date: '2023-01-10T14:00:00', value: 69.46 },
  { date: '2023-01-10T15:00:00', value: 25.02 },
  { date: '2023-01-10T16:00:00', value: 64.42 },
  { date: '2023-01-10T17:00:00', value: 19.24 },
  { date: '2023-01-10T18:00:00', value: 62.76 },
  { date: '2023-01-10T19:00:00', value: 84.11 },
  { date: '2023-01-10T20:00:00', value: 16.29 },
  { date: '2023-01-10T21:00:00', value: 12.99 },
  { date: '2023-01-10T22:00:00', value: 1.39 },
  { date: '2023-01-10T23:00:00', value: 6.85 },
  { date: '2023-01-11T00:00:00', value: 47.76 },
  { date: '2023-01-11T01:00:00', value: 75.87 },
  { date: '2023-01-11T02:00:00', value: 45.32 },
  { date: '2023-01-11T03:00:00', value: 33.19 },
  { date: '2023-01-11T04:00:00', value: 49.11 },
  { date: '2023-01-11T05:00:00', value: 36.09 },
  { date: '2023-01-11T06:00:00', value: 47.44 },
  { date: '2023-01-11T07:00:00', value: 90.12 },
  { date: '2023-01-11T08:00:00', value: 27.95 },
  { date: '2023-01-11T09:00:00', value: 30.66 },
  { date: '2023-01-11T10:00:00', value: 12.98 },
  { date: '2023-01-11T11:00:00', value: 30.15 },
  { date: '2023-01-11T12:00:00', value: 8.06 },
  { date: '2023-01-11T13:00:00', value: 62.39 },
  { date: '2023-01-11T14:00:00', value: 77.2 },
  { date: '2023-01-11T15:00:00', value: 72.17 },
  { date: '2023-01-11T16:00:00', value: 41.18 },
  { date: '2023-01-11T17:00:00', value: 79.4 },
  { date: '2023-01-11T18:00:00', value: 20.03 },
  { date: '2023-01-11T19:00:00', value: 9.88 },
  { date: '2023-01-11T20:00:00', value: 91.63 },
  { date: '2023-01-11T21:00:00', value: 97.22 },
  { date: '2023-01-11T22:00:00', value: 44.86 },
  { date: '2023-01-11T23:00:00', value: 99.1 },
  { date: '2023-01-12T00:00:00', value: 69.82 },
  { date: '2023-01-12T01:00:00', value: 23.49 },
  { date: '2023-01-12T02:00:00', value: 90.08 },
  { date: '2023-01-12T03:00:00', value: 56.81 },
  { date: '2023-01-12T04:00:00', value: 36.59 },
  { date: '2023-01-12T05:00:00', value: 83.66 },
  { date: '2023-01-12T06:00:00', value: 18.33 },
  { date: '2023-01-12T07:00:00', value: 26.09 },
  { date: '2023-01-12T08:00:00', value: 89.97 },
  { date: '2023-01-12T09:00:00', value: 61.03 },
  { date: '2023-01-12T10:00:00', value: 60.17 },
  { date: '2023-01-12T11:00:00', value: 97.45 },
  { date: '2023-01-12T12:00:00', value: 92.12 },
  { date: '2023-01-12T13:00:00', value: 28.36 },
  { date: '2023-01-12T14:00:00', value: 67.64 },
  { date: '2023-01-12T15:00:00', value: 12.46 },
  { date: '2023-01-12T16:00:00', value: 74.72 },
  { date: '2023-01-12T17:00:00', value: 38.84 },
  { date: '2023-01-12T18:00:00', value: 91.37 },
  { date: '2023-01-12T19:00:00', value: 9.94 },
  { date: '2023-01-12T20:00:00', value: 80.68 },
  { date: '2023-01-12T21:00:00', value: 38.54 },
  { date: '2023-01-12T22:00:00', value: 10.36 },
  { date: '2023-01-12T23:00:00', value: 99.96 },
  { date: '2023-01-13T00:00:00', value: 55.89 },
  { date: '2023-01-13T01:00:00', value: 51.96 },
  { date: '2023-01-13T02:00:00', value: 19.6 },
  { date: '2023-01-13T03:00:00', value: 43.37 },
  { date: '2023-01-13T04:00:00', value: 31.02 },
  { date: '2023-01-13T05:00:00', value: 81.42 },
  { date: '2023-01-13T06:00:00', value: 58.45 },
  { date: '2023-01-13T07:00:00', value: 99.28 },
  { date: '2023-01-13T08:00:00', value: 24.66 },
  { date: '2023-01-13T09:00:00', value: 97.75 },
  { date: '2023-01-13T10:00:00', value: 99.1 },
  { date: '2023-01-13T11:00:00', value: 33.79 },
  { date: '2023-01-13T12:00:00', value: 94.31 },
  { date: '2023-01-13T13:00:00', value: 21.07 },
  { date: '2023-01-13T14:00:00', value: 47.5 },
  { date: '2023-01-13T15:00:00', value: 63.42 },
  { date: '2023-01-13T16:00:00', value: 82.32 },
  { date: '2023-01-13T17:00:00', value: 47.23 },
  { date: '2023-01-13T18:00:00', value: 68.64 },
  { date: '2023-01-13T19:00:00', value: 45.28 },
  { date: '2023-01-13T20:00:00', value: 42.15 },
  { date: '2023-01-13T21:00:00', value: 40.67 },
  { date: '2023-01-13T22:00:00', value: 58.48 },
  { date: '2023-01-13T23:00:00', value: 63.83 },
  { date: '2023-01-14T00:00:00', value: 10.66 },
  { date: '2023-01-14T01:00:00', value: 2.53 },
  { date: '2023-01-14T02:00:00', value: 38.07 },
  { date: '2023-01-14T03:00:00', value: 25.65 },
  { date: '2023-01-14T04:00:00', value: 11.93 },
  { date: '2023-01-14T05:00:00', value: 20.7 },
  { date: '2023-01-14T06:00:00', value: 10.05 },
  { date: '2023-01-14T07:00:00', value: 8.1 },
  { date: '2023-01-14T08:00:00', value: 9.29 },
  { date: '2023-01-14T09:00:00', value: 13.14 },
  { date: '2023-01-14T10:00:00', value: 21.9 },
  { date: '2023-01-14T11:00:00', value: 68.05 },
  { date: '2023-01-14T12:00:00', value: 20.17 },
  { date: '2023-01-14T13:00:00', value: 2.56 },
  { date: '2023-01-14T14:00:00', value: 59.46 },
  { date: '2023-01-14T15:00:00', value: 77.64 },
  { date: '2023-01-14T16:00:00', value: 41.81 },
  { date: '2023-01-14T17:00:00', value: 66.16 },
  { date: '2023-01-14T18:00:00', value: 43.39 },
  { date: '2023-01-14T19:00:00', value: 54.99 },
  { date: '2023-01-14T20:00:00', value: 41.22 },
  { date: '2023-01-14T21:00:00', value: 10.99 },
  { date: '2023-01-14T22:00:00', value: 40.41 },
  { date: '2023-01-14T23:00:00', value: 80.35 },
  { date: '2023-01-15T00:00:00', value: 3.67 },
  { date: '2023-01-15T01:00:00', value: 69.02 },
  { date: '2023-01-15T02:00:00', value: 26.71 },
  { date: '2023-01-15T03:00:00', value: 31.19 },
  { date: '2023-01-15T04:00:00', value: 78.46 },
  { date: '2023-01-15T05:00:00', value: 7.61 },
  { date: '2023-01-15T06:00:00', value: 60.26 },
  { date: '2023-01-15T07:00:00', value: 61.21 },
  { date: '2023-01-15T08:00:00', value: 49.38 },
  { date: '2023-01-15T09:00:00', value: 11.79 },
  { date: '2023-01-15T10:00:00', value: 82.35 },
  { date: '2023-01-15T11:00:00', value: 2.94 },
  { date: '2023-01-15T12:00:00', value: 59.49 },
  { date: '2023-01-15T13:00:00', value: 38.11 },
  { date: '2023-01-15T14:00:00', value: 19.59 },
  { date: '2023-01-15T15:00:00', value: 69.12 },
  { date: '2023-01-15T16:00:00', value: 50.06 },
  { date: '2023-01-15T17:00:00', value: 51.64 },
  { date: '2023-01-15T18:00:00', value: 33.98 },
  { date: '2023-01-15T19:00:00', value: 38.96 },
  { date: '2023-01-15T20:00:00', value: 31.02 },
  { date: '2023-01-15T21:00:00', value: 10.47 },
  { date: '2023-01-15T22:00:00', value: 10.57 },
  { date: '2023-01-15T23:00:00', value: 46.79 },
  { date: '2023-01-16T00:00:00', value: 10.83 },
  { date: '2023-01-16T01:00:00', value: 3.91 },
  { date: '2023-01-16T02:00:00', value: 57.44 },
  { date: '2023-01-16T03:00:00', value: 99.25 },
  { date: '2023-01-16T04:00:00', value: 20.52 },
  { date: '2023-01-16T05:00:00', value: 50.95 },
  { date: '2023-01-16T06:00:00', value: 7.15 },
  { date: '2023-01-16T07:00:00', value: 96.66 },
  { date: '2023-01-16T08:00:00', value: 83.93 },
  { date: '2023-01-16T09:00:00', value: 64.9 },
  { date: '2023-01-16T10:00:00', value: 95.32 },
  { date: '2023-01-16T11:00:00', value: 47.13 },
  { date: '2023-01-16T12:00:00', value: 95.33 },
  { date: '2023-01-16T13:00:00', value: 26.15 },
  { date: '2023-01-16T14:00:00', value: 85.99 },
  { date: '2023-01-16T15:00:00', value: 20.17 },
  { date: '2023-01-16T16:00:00', value: 32.57 },
  { date: '2023-01-16T17:00:00', value: 80.83 },
  { date: '2023-01-16T18:00:00', value: 90.07 },
  { date: '2023-01-16T19:00:00', value: 11.5 },
  { date: '2023-01-16T20:00:00', value: 99.64 },
  { date: '2023-01-16T21:00:00', value: 37.89 },
  { date: '2023-01-16T22:00:00', value: 66.5 },
  { date: '2023-01-16T23:00:00', value: 15.21 },
  { date: '2023-01-17T00:00:00', value: 58.89 },
  { date: '2023-01-17T01:00:00', value: 31.85 },
  { date: '2023-01-17T02:00:00', value: 80.64 },
  { date: '2023-01-17T03:00:00', value: 93.42 },
  { date: '2023-01-17T04:00:00', value: 41.2 },
  { date: '2023-01-17T05:00:00', value: 87.34 },
  { date: '2023-01-17T06:00:00', value: 38.13 },
  { date: '2023-01-17T07:00:00', value: 12.06 },
  { date: '2023-01-17T08:00:00', value: 43.44 },
  { date: '2023-01-17T09:00:00', value: 93.78 },
  { date: '2023-01-17T10:00:00', value: 29.56 },
  { date: '2023-01-17T11:00:00', value: 12.62 },
  { date: '2023-01-17T12:00:00', value: 36.83 },
  { date: '2023-01-17T13:00:00', value: 87.48 },
  { date: '2023-01-17T14:00:00', value: 18.28 },
  { date: '2023-01-17T15:00:00', value: 10.3 },
  { date: '2023-01-17T16:00:00', value: 25.36 },
  { date: '2023-01-17T17:00:00', value: 94.03 },
  { date: '2023-01-17T18:00:00', value: 18.54 },
  { date: '2023-01-17T19:00:00', value: 87.99 },
  { date: '2023-01-17T20:00:00', value: 44.79 },
  { date: '2023-01-17T21:00:00', value: 73.02 },
  { date: '2023-01-17T22:00:00', value: 50.4 },
  { date: '2023-01-17T23:00:00', value: 96.67 },
  { date: '2023-01-18T00:00:00', value: 64.99 },
  { date: '2023-01-18T01:00:00', value: 4.82 },
  { date: '2023-01-18T02:00:00', value: 56.72 },
  { date: '2023-01-18T03:00:00', value: 80.08 },
  { date: '2023-01-18T04:00:00', value: 59.43 },
  { date: '2023-01-18T05:00:00', value: 16.04 },
  { date: '2023-01-18T06:00:00', value: 96.42 },
  { date: '2023-01-18T07:00:00', value: 34.47 },
  { date: '2023-01-18T08:00:00', value: 56.37 },
  { date: '2023-01-18T09:00:00', value: 62.12 },
  { date: '2023-01-18T10:00:00', value: 31.22 },
  { date: '2023-01-18T11:00:00', value: 75.36 },
  { date: '2023-01-18T12:00:00', value: 9.61 },
  { date: '2023-01-18T13:00:00', value: 12.77 },
  { date: '2023-01-18T14:00:00', value: 61.24 },
  { date: '2023-01-18T15:00:00', value: 62.16 },
  { date: '2023-01-18T16:00:00', value: 45.67 },
  { date: '2023-01-18T17:00:00', value: 31.02 },
  { date: '2023-01-18T18:00:00', value: 55.93 },
  { date: '2023-01-18T19:00:00', value: 9.27 },
  { date: '2023-01-18T20:00:00', value: 97.01 },
  { date: '2023-01-18T21:00:00', value: 46.67 },
  { date: '2023-01-18T22:00:00', value: 63.11 },
  { date: '2023-01-18T23:00:00', value: 19.79 },
  { date: '2023-01-19T00:00:00', value: 35.11 },
  { date: '2023-01-19T01:00:00', value: 90.13 },
  { date: '2023-01-19T02:00:00', value: 93.75 },
  { date: '2023-01-19T03:00:00', value: 50.23 },
  { date: '2023-01-19T04:00:00', value: 53.45 },
  { date: '2023-01-19T05:00:00', value: 56.23 },
  { date: '2023-01-19T06:00:00', value: 69.97 },
  { date: '2023-01-19T07:00:00', value: 80.67 },
  { date: '2023-01-19T08:00:00', value: 60.29 },
  { date: '2023-01-19T09:00:00', value: 69.14 },
  { date: '2023-01-19T10:00:00', value: 76.75 },
  { date: '2023-01-19T11:00:00', value: 65.41 },
  { date: '2023-01-19T12:00:00', value: 49.56 },
  { date: '2023-01-19T13:00:00', value: 71.25 },
  { date: '2023-01-19T14:00:00', value: 11.75 },
  { date: '2023-01-19T15:00:00', value: 80.65 },
  { date: '2023-01-19T16:00:00', value: 16.91 },
  { date: '2023-01-19T17:00:00', value: 57.9 },
  { date: '2023-01-19T18:00:00', value: 33.11 },
  { date: '2023-01-19T19:00:00', value: 94.36 },
  { date: '2023-01-19T20:00:00', value: 68.94 },
  { date: '2023-01-19T21:00:00', value: 57.9 },
  { date: '2023-01-19T22:00:00', value: 22.36 },
  { date: '2023-01-19T23:00:00', value: 97.97 },
  { date: '2023-01-20T00:00:00', value: 62.79 },
  { date: '2023-01-20T01:00:00', value: 95.36 },
  { date: '2023-01-20T02:00:00', value: 5.67 },
  { date: '2023-01-20T03:00:00', value: 93.71 },
  { date: '2023-01-20T04:00:00', value: 3.28 },
  { date: '2023-01-20T05:00:00', value: 87.04 },
  { date: '2023-01-20T06:00:00', value: 32.57 },
  { date: '2023-01-20T07:00:00', value: 20.05 },
  { date: '2023-01-20T08:00:00', value: 76.07 },
  { date: '2023-01-20T09:00:00', value: 7.59 },
  { date: '2023-01-20T10:00:00', value: 43.75 },
  { date: '2023-01-20T11:00:00', value: 36.51 },
  { date: '2023-01-20T12:00:00', value: 66.71 },
  { date: '2023-01-20T13:00:00', value: 10.35 },
  { date: '2023-01-20T14:00:00', value: 42.51 },
  { date: '2023-01-20T15:00:00', value: 90.43 },
  { date: '2023-01-20T16:00:00', value: 1.8 },
  { date: '2023-01-20T17:00:00', value: 46.06 },
  { date: '2023-01-20T18:00:00', value: 79.85 },
  { date: '2023-01-20T19:00:00', value: 30.14 },
  { date: '2023-01-20T20:00:00', value: 80.9 },
  { date: '2023-01-20T21:00:00', value: 37.7 },
  { date: '2023-01-20T22:00:00', value: 85.39 },
  { date: '2023-01-20T23:00:00', value: 56.08 },
  { date: '2023-01-21T00:00:00', value: 91.97 },
  { date: '2023-01-21T01:00:00', value: 14.61 },
  { date: '2023-01-21T02:00:00', value: 12.31 },
  { date: '2023-01-21T03:00:00', value: 44.38 },
  { date: '2023-01-21T04:00:00', value: 20.54 },
  { date: '2023-01-21T05:00:00', value: 54.48 },
  { date: '2023-01-21T06:00:00', value: 40.02 },
  { date: '2023-01-21T07:00:00', value: 68.89 },
  { date: '2023-01-21T08:00:00', value: 12.73 },
  { date: '2023-01-21T09:00:00', value: 52.39 },
  { date: '2023-01-21T10:00:00', value: 84.26 },
  { date: '2023-01-21T11:00:00', value: 77.09 },
  { date: '2023-01-21T12:00:00', value: 47.78 },
  { date: '2023-01-21T13:00:00', value: 56.4 },
  { date: '2023-01-21T14:00:00', value: 77.24 },
  { date: '2023-01-21T15:00:00', value: 93.52 },
  { date: '2023-01-21T16:00:00', value: 89.81 },
  { date: '2023-01-21T17:00:00', value: 47.31 },
  { date: '2023-01-21T18:00:00', value: 41.64 },
  { date: '2023-01-21T19:00:00', value: 25.98 },
  { date: '2023-01-21T20:00:00', value: 28.57 },
  { date: '2023-01-21T21:00:00', value: 87.45 },
  { date: '2023-01-21T22:00:00', value: 1.72 },
  { date: '2023-01-21T23:00:00', value: 45.01 },
  { date: '2023-01-22T00:00:00', value: 98.63 },
  { date: '2023-01-22T01:00:00', value: 58.6 },
  { date: '2023-01-22T02:00:00', value: 44.01 },
  { date: '2023-01-22T03:00:00', value: 26.95 },
  { date: '2023-01-22T04:00:00', value: 36.2 },
  { date: '2023-01-22T05:00:00', value: 42.05 },
  { date: '2023-01-22T06:00:00', value: 90.73 },
  { date: '2023-01-22T07:00:00', value: 92.06 },
  { date: '2023-01-22T08:00:00', value: 77.75 },
  { date: '2023-01-22T09:00:00', value: 92.11 },
  { date: '2023-01-22T10:00:00', value: 34.66 },
  { date: '2023-01-22T11:00:00', value: 14.28 },
  { date: '2023-01-22T12:00:00', value: 9.63 },
  { date: '2023-01-22T13:00:00', value: 96.5 },
  { date: '2023-01-22T14:00:00', value: 9.26 },
  { date: '2023-01-22T15:00:00', value: 7.71 },
  { date: '2023-01-22T16:00:00', value: 93.2 },
  { date: '2023-01-22T17:00:00', value: 71.01 },
  { date: '2023-01-22T18:00:00', value: 23.51 },
  { date: '2023-01-22T19:00:00', value: 19.12 },
  { date: '2023-01-22T20:00:00', value: 59.18 },
  { date: '2023-01-22T21:00:00', value: 51.86 },
  { date: '2023-01-22T22:00:00', value: 56.89 },
  { date: '2023-01-22T23:00:00', value: 29.71 },
  { date: '2023-01-23T00:00:00', value: 91.95 },
  { date: '2023-01-23T01:00:00', value: 64.76 },
  { date: '2023-01-23T02:00:00', value: 30.47 },
  { date: '2023-01-23T03:00:00', value: 8.09 },
  { date: '2023-01-23T04:00:00', value: 33.05 },
  { date: '2023-01-23T05:00:00', value: 60.22 },
  { date: '2023-01-23T06:00:00', value: 3.15 },
  { date: '2023-01-23T07:00:00', value: 30.12 },
  { date: '2023-01-23T08:00:00', value: 11.65 },
  { date: '2023-01-23T09:00:00', value: 94.33 },
  { date: '2023-01-23T10:00:00', value: 54.76 },
  { date: '2023-01-23T11:00:00', value: 55.55 },
  { date: '2023-01-23T12:00:00', value: 38.4 },
  { date: '2023-01-23T13:00:00', value: 14.89 },
  { date: '2023-01-23T14:00:00', value: 4.35 },
  { date: '2023-01-23T15:00:00', value: 37.02 },
  { date: '2023-01-23T16:00:00', value: 61.71 },
  { date: '2023-01-23T17:00:00', value: 11.59 },
  { date: '2023-01-23T18:00:00', value: 69.19 },
  { date: '2023-01-23T19:00:00', value: 68.34 },
  { date: '2023-01-23T20:00:00', value: 54.14 },
  { date: '2023-01-23T21:00:00', value: 73.31 },
  { date: '2023-01-23T22:00:00', value: 13.67 },
  { date: '2023-01-23T23:00:00', value: 51.49 },
  { date: '2023-01-24T00:00:00', value: 86.84 },
  { date: '2023-01-24T01:00:00', value: 51.53 },
  { date: '2023-01-24T02:00:00', value: 31.52 },
  { date: '2023-01-24T03:00:00', value: 5.06 },
  { date: '2023-01-24T04:00:00', value: 80.98 },
  { date: '2023-01-24T05:00:00', value: 53.89 },
  { date: '2023-01-24T06:00:00', value: 93.54 },
  { date: '2023-01-24T07:00:00', value: 90.27 },
  { date: '2023-01-24T08:00:00', value: 7.17 },
  { date: '2023-01-24T09:00:00', value: 19.09 },
  { date: '2023-01-24T10:00:00', value: 80.3 },
  { date: '2023-01-24T11:00:00', value: 30.98 },
  { date: '2023-01-24T12:00:00', value: 62.08 },
  { date: '2023-01-24T13:00:00', value: 17.25 },
  { date: '2023-01-24T14:00:00', value: 6.62 },
  { date: '2023-01-24T15:00:00', value: 19.81 },
  { date: '2023-01-24T16:00:00', value: 58.36 },
  { date: '2023-01-24T17:00:00', value: 15.07 },
  { date: '2023-01-24T18:00:00', value: 74.4 },
  { date: '2023-01-24T19:00:00', value: 66.98 },
  { date: '2023-01-24T20:00:00', value: 68.68 },
  { date: '2023-01-24T21:00:00', value: 63.0 },
  { date: '2023-01-24T22:00:00', value: 52.13 },
  { date: '2023-01-24T23:00:00', value: 12.24 },
  { date: '2023-01-25T00:00:00', value: 98.21 },
  { date: '2023-01-25T01:00:00', value: 47.59 },
  { date: '2023-01-25T02:00:00', value: 94.05 },
  { date: '2023-01-25T03:00:00', value: 46.15 },
  { date: '2023-01-25T04:00:00', value: 95.9 },
  { date: '2023-01-25T05:00:00', value: 94.76 },
  { date: '2023-01-25T06:00:00', value: 39.83 },
  { date: '2023-01-25T07:00:00', value: 11.24 },
  { date: '2023-01-25T08:00:00', value: 26.69 },
  { date: '2023-01-25T09:00:00', value: 80.34 },
  { date: '2023-01-25T10:00:00', value: 2.39 },
  { date: '2023-01-25T11:00:00', value: 61.46 },
  { date: '2023-01-25T12:00:00', value: 35.16 },
  { date: '2023-01-25T13:00:00', value: 33.33 },
  { date: '2023-01-25T14:00:00', value: 97.13 },
  { date: '2023-01-25T15:00:00', value: 20.73 },
  { date: '2023-01-25T16:00:00', value: 43.31 },
  { date: '2023-01-25T17:00:00', value: 6.75 },
  { date: '2023-01-25T18:00:00', value: 52.45 },
  { date: '2023-01-25T19:00:00', value: 57.69 },
  { date: '2023-01-25T20:00:00', value: 64.11 },
  { date: '2023-01-25T21:00:00', value: 2.61 },
  { date: '2023-01-25T22:00:00', value: 69.22 },
  { date: '2023-01-25T23:00:00', value: 94.15 },
  { date: '2023-01-26T00:00:00', value: 87.6 },
  { date: '2023-01-26T01:00:00', value: 81.09 },
  { date: '2023-01-26T02:00:00', value: 85.86 },
  { date: '2023-01-26T03:00:00', value: 51.19 },
  { date: '2023-01-26T04:00:00', value: 90.15 },
  { date: '2023-01-26T05:00:00', value: 92.58 },
  { date: '2023-01-26T06:00:00', value: 13.48 },
  { date: '2023-01-26T07:00:00', value: 48.72 },
  { date: '2023-01-26T08:00:00', value: 93.37 },
  { date: '2023-01-26T09:00:00', value: 28.66 },
  { date: '2023-01-26T10:00:00', value: 65.08 },
  { date: '2023-01-26T11:00:00', value: 18.23 },
  { date: '2023-01-26T12:00:00', value: 16.37 },
  { date: '2023-01-26T13:00:00', value: 65.43 },
  { date: '2023-01-26T14:00:00', value: 81.5 },
  { date: '2023-01-26T15:00:00', value: 60.54 },
  { date: '2023-01-26T16:00:00', value: 44.09 },
  { date: '2023-01-26T17:00:00', value: 52.18 },
  { date: '2023-01-26T18:00:00', value: 84.49 },
  { date: '2023-01-26T19:00:00', value: 54.71 },
  { date: '2023-01-26T20:00:00', value: 18.94 },
  { date: '2023-01-26T21:00:00', value: 10.68 },
  { date: '2023-01-26T22:00:00', value: 77.06 },
  { date: '2023-01-26T23:00:00', value: 64.73 },
  { date: '2023-01-27T00:00:00', value: 84.71 },
  { date: '2023-01-27T01:00:00', value: 16.51 },
  { date: '2023-01-27T02:00:00', value: 51.16 },
  { date: '2023-01-27T03:00:00', value: 63.74 },
  { date: '2023-01-27T04:00:00', value: 87.54 },
  { date: '2023-01-27T05:00:00', value: 74.61 },
  { date: '2023-01-27T06:00:00', value: 78.39 },
  { date: '2023-01-27T07:00:00', value: 27.49 },
  { date: '2023-01-27T08:00:00', value: 6.8 },
  { date: '2023-01-27T09:00:00', value: 99.67 },
  { date: '2023-01-27T10:00:00', value: 45.84 },
  { date: '2023-01-27T11:00:00', value: 76.13 },
  { date: '2023-01-27T12:00:00', value: 14.07 },
  { date: '2023-01-27T13:00:00', value: 10.93 },
  { date: '2023-01-27T14:00:00', value: 42.26 },
  { date: '2023-01-27T15:00:00', value: 57.99 },
  { date: '2023-01-27T16:00:00', value: 79.54 },
  { date: '2023-01-27T17:00:00', value: 47.3 },
  { date: '2023-01-27T18:00:00', value: 76.07 },
  { date: '2023-01-27T19:00:00', value: 86.37 },
  { date: '2023-01-27T20:00:00', value: 32.1 },
  { date: '2023-01-27T21:00:00', value: 98.6 },
  { date: '2023-01-27T22:00:00', value: 96.53 },
  { date: '2023-01-27T23:00:00', value: 35.35 },
  { date: '2023-01-28T00:00:00', value: 87.32 },
  { date: '2023-01-28T01:00:00', value: 44.29 },
  { date: '2023-01-28T02:00:00', value: 75.72 },
  { date: '2023-01-28T03:00:00', value: 28.78 },
  { date: '2023-01-28T04:00:00', value: 41.5 },
  { date: '2023-01-28T05:00:00', value: 1.22 },
  { date: '2023-01-28T06:00:00', value: 66.15 },
  { date: '2023-01-28T07:00:00', value: 55.13 },
  { date: '2023-01-28T08:00:00', value: 96.81 },
  { date: '2023-01-28T09:00:00', value: 82.8 },
  { date: '2023-01-28T10:00:00', value: 13.15 },
  { date: '2023-01-28T11:00:00', value: 17.05 },
  { date: '2023-01-28T12:00:00', value: 51.29 },
  { date: '2023-01-28T13:00:00', value: 26.0 },
  { date: '2023-01-28T14:00:00', value: 41.21 },
  { date: '2023-01-28T15:00:00', value: 34.37 },
  { date: '2023-01-28T16:00:00', value: 91.23 },
  { date: '2023-01-28T17:00:00', value: 45.49 },
  { date: '2023-01-28T18:00:00', value: 48.4 },
  { date: '2023-01-28T19:00:00', value: 49.1 },
  { date: '2023-01-28T20:00:00', value: 67.69 },
  { date: '2023-01-28T21:00:00', value: 17.36 },
  { date: '2023-01-28T22:00:00', value: 56.65 },
  { date: '2023-01-28T23:00:00', value: 49.05 },
  { date: '2023-01-29T00:00:00', value: 20.57 },
  { date: '2023-01-29T01:00:00', value: 52.75 },
  { date: '2023-01-29T02:00:00', value: 80.96 },
  { date: '2023-01-29T03:00:00', value: 40.43 },
  { date: '2023-01-29T04:00:00', value: 32.22 },
  { date: '2023-01-29T05:00:00', value: 81.46 },
  { date: '2023-01-29T06:00:00', value: 57.23 },
  { date: '2023-01-29T07:00:00', value: 13.63 },
  { date: '2023-01-29T08:00:00', value: 68.81 },
  { date: '2023-01-29T09:00:00', value: 3.71 },
  { date: '2023-01-29T10:00:00', value: 62.95 },
  { date: '2023-01-29T11:00:00', value: 7.77 },
  { date: '2023-01-29T12:00:00', value: 96.26 },
  { date: '2023-01-29T13:00:00', value: 26.86 },
  { date: '2023-01-29T14:00:00', value: 75.9 },
  { date: '2023-01-29T15:00:00', value: 72.71 },
  { date: '2023-01-29T16:00:00', value: 31.11 },
  { date: '2023-01-29T17:00:00', value: 98.99 },
  { date: '2023-01-29T18:00:00', value: 12.83 },
  { date: '2023-01-29T19:00:00', value: 56.65 },
  { date: '2023-01-29T20:00:00', value: 95.79 },
  { date: '2023-01-29T21:00:00', value: 57.21 },
  { date: '2023-01-29T22:00:00', value: 38.4 },
  { date: '2023-01-29T23:00:00', value: 39.04 },
  { date: '2023-01-30T00:00:00', value: 44.68 },
  { date: '2023-01-30T01:00:00', value: 27.76 },
  { date: '2023-01-30T02:00:00', value: 46.29 },
  { date: '2023-01-30T03:00:00', value: 15.76 },
  { date: '2023-01-30T04:00:00', value: 58.06 },
  { date: '2023-01-30T05:00:00', value: 95.18 },
  { date: '2023-01-30T06:00:00', value: 80.77 },
  { date: '2023-01-30T07:00:00', value: 25.04 },
  { date: '2023-01-30T08:00:00', value: 43.78 },
  { date: '2023-01-30T09:00:00', value: 27.74 },
  { date: '2023-01-30T10:00:00', value: 45.46 },
  { date: '2023-01-30T11:00:00', value: 49.31 },
  { date: '2023-01-30T12:00:00', value: 90.79 },
  { date: '2023-01-30T13:00:00', value: 12.15 },
  { date: '2023-01-30T14:00:00', value: 8.57 },
  { date: '2023-01-30T15:00:00', value: 79.14 },
  { date: '2023-01-30T16:00:00', value: 75.8 },
  { date: '2023-01-30T17:00:00', value: 65.59 },
  { date: '2023-01-30T18:00:00', value: 73.51 },
  { date: '2023-01-30T19:00:00', value: 20.11 },
  { date: '2023-01-30T20:00:00', value: 1.55 },
  { date: '2023-01-30T21:00:00', value: 79.3 },
  { date: '2023-01-30T22:00:00', value: 48.31 },
  { date: '2023-01-30T23:00:00', value: 88.23 },
  { date: '2023-01-31T00:00:00', value: 26.48 },
  { date: '2023-01-31T01:00:00', value: 69.02 },
  { date: '2023-01-31T02:00:00', value: 20.17 },
  { date: '2023-01-31T03:00:00', value: 94.36 },
  { date: '2023-01-31T04:00:00', value: 51.8 },
  { date: '2023-01-31T05:00:00', value: 13.46 },
  { date: '2023-01-31T06:00:00', value: 56.56 },
  { date: '2023-01-31T07:00:00', value: 26.23 },
  { date: '2023-01-31T08:00:00', value: 59.86 },
  { date: '2023-01-31T09:00:00', value: 81.91 },
  { date: '2023-01-31T10:00:00', value: 10.05 },
  { date: '2023-01-31T11:00:00', value: 29.45 },
  { date: '2023-01-31T12:00:00', value: 77.36 },
  { date: '2023-01-31T13:00:00', value: 54.01 },
  { date: '2023-01-31T14:00:00', value: 91.46 },
  { date: '2023-01-31T15:00:00', value: 16.7 },
  { date: '2023-01-31T16:00:00', value: 60.62 },
  { date: '2023-01-31T17:00:00', value: 76.65 },
  { date: '2023-01-31T18:00:00', value: 44.99 },
  { date: '2023-01-31T19:00:00', value: 4.99 },
  { date: '2023-01-31T20:00:00', value: 44.4 },
  { date: '2023-01-31T21:00:00', value: 16.07 },
  { date: '2023-01-31T22:00:00', value: 68.4 },
  { date: '2023-01-31T23:00:00', value: 19.0 },
  { date: '2023-02-01T00:00:00', value: 15.9 },
  { date: '2023-02-01T01:00:00', value: 37.65 },
  { date: '2023-02-01T02:00:00', value: 28.73 },
  { date: '2023-02-01T03:00:00', value: 28.96 },
  { date: '2023-02-01T04:00:00', value: 84.38 },
  { date: '2023-02-01T05:00:00', value: 33.18 },
  { date: '2023-02-01T06:00:00', value: 10.45 },
  { date: '2023-02-01T07:00:00', value: 71.06 },
  { date: '2023-02-01T08:00:00', value: 17.6 },
  { date: '2023-02-01T09:00:00', value: 25.93 },
  { date: '2023-02-01T10:00:00', value: 59.0 },
  { date: '2023-02-01T11:00:00', value: 45.45 },
  { date: '2023-02-01T12:00:00', value: 51.81 },
  { date: '2023-02-01T13:00:00', value: 38.41 },
  { date: '2023-02-01T14:00:00', value: 40.01 },
  { date: '2023-02-01T15:00:00', value: 36.36 },
  { date: '2023-02-01T16:00:00', value: 10.8 },
  { date: '2023-02-01T17:00:00', value: 24.33 },
  { date: '2023-02-01T18:00:00', value: 83.38 },
  { date: '2023-02-01T19:00:00', value: 2.24 },
  { date: '2023-02-01T20:00:00', value: 71.29 },
  { date: '2023-02-01T21:00:00', value: 56.53 },
  { date: '2023-02-01T22:00:00', value: 22.32 },
  { date: '2023-02-01T23:00:00', value: 92.57 },
  { date: '2023-02-02T00:00:00', value: 3.46 },
  { date: '2023-02-02T01:00:00', value: 73.6 },
  { date: '2023-02-02T02:00:00', value: 5.5 },
  { date: '2023-02-02T03:00:00', value: 11.41 },
  { date: '2023-02-02T04:00:00', value: 8.21 },
  { date: '2023-02-02T05:00:00', value: 10.47 },
  { date: '2023-02-02T06:00:00', value: 24.3 },
  { date: '2023-02-02T07:00:00', value: 26.72 },
  { date: '2023-02-02T08:00:00', value: 18.53 },
  { date: '2023-02-02T09:00:00', value: 48.18 },
  { date: '2023-02-02T10:00:00', value: 70.06 },
  { date: '2023-02-02T11:00:00', value: 33.66 },
  { date: '2023-02-02T12:00:00', value: 80.44 },
  { date: '2023-02-02T13:00:00', value: 11.15 },
  { date: '2023-02-02T14:00:00', value: 75.56 },
  { date: '2023-02-02T15:00:00', value: 11.89 },
  { date: '2023-02-02T16:00:00', value: 44.66 },
  { date: '2023-02-02T17:00:00', value: 8.43 },
  { date: '2023-02-02T18:00:00', value: 18.16 },
  { date: '2023-02-02T19:00:00', value: 45.2 },
  { date: '2023-02-02T20:00:00', value: 96.0 },
  { date: '2023-02-02T21:00:00', value: 19.09 },
  { date: '2023-02-02T22:00:00', value: 41.45 },
  { date: '2023-02-02T23:00:00', value: 12.9 },
  { date: '2023-02-03T00:00:00', value: 11.38 },
  { date: '2023-02-03T01:00:00', value: 23.14 },
  { date: '2023-02-03T02:00:00', value: 38.85 },
  { date: '2023-02-03T03:00:00', value: 53.43 },
  { date: '2023-02-03T04:00:00', value: 84.06 },
  { date: '2023-02-03T05:00:00', value: 26.13 },
  { date: '2023-02-03T06:00:00', value: 58.2 },
  { date: '2023-02-03T07:00:00', value: 51.64 },
  { date: '2023-02-03T08:00:00', value: 51.59 },
  { date: '2023-02-03T09:00:00', value: 81.82 },
  { date: '2023-02-03T10:00:00', value: 7.67 },
  { date: '2023-02-03T11:00:00', value: 17.96 },
  { date: '2023-02-03T12:00:00', value: 6.11 },
  { date: '2023-02-03T13:00:00', value: 95.61 },
  { date: '2023-02-03T14:00:00', value: 12.82 },
  { date: '2023-02-03T15:00:00', value: 53.68 },
  { date: '2023-02-03T16:00:00', value: 28.5 },
  { date: '2023-02-03T17:00:00', value: 19.03 },
  { date: '2023-02-03T18:00:00', value: 25.99 },
  { date: '2023-02-03T19:00:00', value: 44.26 },
  { date: '2023-02-03T20:00:00', value: 27.04 },
  { date: '2023-02-03T21:00:00', value: 83.99 },
  { date: '2023-02-03T22:00:00', value: 56.55 },
  { date: '2023-02-03T23:00:00', value: 54.72 },
  { date: '2023-02-04T00:00:00', value: 8.68 },
  { date: '2023-02-04T01:00:00', value: 54.47 },
  { date: '2023-02-04T02:00:00', value: 44.26 },
  { date: '2023-02-04T03:00:00', value: 50.48 },
  { date: '2023-02-04T04:00:00', value: 66.79 },
  { date: '2023-02-04T05:00:00', value: 89.33 },
  { date: '2023-02-04T06:00:00', value: 45.61 },
  { date: '2023-02-04T07:00:00', value: 49.06 },
  { date: '2023-02-04T08:00:00', value: 8.03 },
  { date: '2023-02-04T09:00:00', value: 34.96 },
  { date: '2023-02-04T10:00:00', value: 97.37 },
  { date: '2023-02-04T11:00:00', value: 10.37 },
  { date: '2023-02-04T12:00:00', value: 30.63 },
  { date: '2023-02-04T13:00:00', value: 77.97 },
  { date: '2023-02-04T14:00:00', value: 100.0 },
  { date: '2023-02-04T15:00:00', value: 99.59 },
  { date: '2023-02-04T16:00:00', value: 77.54 },
  { date: '2023-02-04T17:00:00', value: 59.37 },
  { date: '2023-02-04T18:00:00', value: 61.97 },
  { date: '2023-02-04T19:00:00', value: 1.81 },
  { date: '2023-02-04T20:00:00', value: 56.22 },
  { date: '2023-02-04T21:00:00', value: 71.08 },
  { date: '2023-02-04T22:00:00', value: 84.73 },
  { date: '2023-02-04T23:00:00', value: 37.46 },
  { date: '2023-02-05T00:00:00', value: 65.61 },
  { date: '2023-02-05T01:00:00', value: 95.95 },
  { date: '2023-02-05T02:00:00', value: 99.44 },
  { date: '2023-02-05T03:00:00', value: 77.76 },
  { date: '2023-02-05T04:00:00', value: 31.43 },
  { date: '2023-02-05T05:00:00', value: 67.91 },
  { date: '2023-02-05T06:00:00', value: 37.45 },
  { date: '2023-02-05T07:00:00', value: 55.43 },
  { date: '2023-02-05T08:00:00', value: 19.92 },
  { date: '2023-02-05T09:00:00', value: 86.41 },
  { date: '2023-02-05T10:00:00', value: 31.14 },
  { date: '2023-02-05T11:00:00', value: 71.65 },
  { date: '2023-02-05T12:00:00', value: 48.08 },
  { date: '2023-02-05T13:00:00', value: 7.34 },
  { date: '2023-02-05T14:00:00', value: 68.8 },
  { date: '2023-02-05T15:00:00', value: 68.04 },
  { date: '2023-02-05T16:00:00', value: 34.2 },
  { date: '2023-02-05T17:00:00', value: 9.91 },
  { date: '2023-02-05T18:00:00', value: 65.93 },
  { date: '2023-02-05T19:00:00', value: 34.97 },
  { date: '2023-02-05T20:00:00', value: 8.72 },
  { date: '2023-02-05T21:00:00', value: 9.98 },
  { date: '2023-02-05T22:00:00', value: 31.3 },
  { date: '2023-02-05T23:00:00', value: 93.63 },
  { date: '2023-02-06T00:00:00', value: 22.37 },
  { date: '2023-02-06T01:00:00', value: 78.24 },
  { date: '2023-02-06T02:00:00', value: 5.2 },
  { date: '2023-02-06T03:00:00', value: 33.28 },
  { date: '2023-02-06T04:00:00', value: 12.87 },
  { date: '2023-02-06T05:00:00', value: 60.37 },
  { date: '2023-02-06T06:00:00', value: 59.89 },
  { date: '2023-02-06T07:00:00', value: 35.79 },
  { date: '2023-02-06T08:00:00', value: 25.63 },
  { date: '2023-02-06T09:00:00', value: 3.63 },
  { date: '2023-02-06T10:00:00', value: 30.01 },
  { date: '2023-02-06T11:00:00', value: 14.22 },
  { date: '2023-02-06T12:00:00', value: 81.66 },
  { date: '2023-02-06T13:00:00', value: 46.04 },
  { date: '2023-02-06T14:00:00', value: 51.19 },
  { date: '2023-02-06T15:00:00', value: 99.18 },
  { date: '2023-02-06T16:00:00', value: 51.87 },
  { date: '2023-02-06T17:00:00', value: 34.74 },
  { date: '2023-02-06T18:00:00', value: 51.33 },
  { date: '2023-02-06T19:00:00', value: 59.93 },
  { date: '2023-02-06T20:00:00', value: 81.96 },
  { date: '2023-02-06T21:00:00', value: 16.28 },
  { date: '2023-02-06T22:00:00', value: 63.76 },
  { date: '2023-02-06T23:00:00', value: 68.2 },
  { date: '2023-02-07T00:00:00', value: 1.67 },
  { date: '2023-02-07T01:00:00', value: 62.76 },
  { date: '2023-02-07T02:00:00', value: 76.18 },
  { date: '2023-02-07T03:00:00', value: 17.85 },
  { date: '2023-02-07T04:00:00', value: 39.69 },
  { date: '2023-02-07T05:00:00', value: 16.45 },
  { date: '2023-02-07T06:00:00', value: 88.15 },
  { date: '2023-02-07T07:00:00', value: 87.43 },
  { date: '2023-02-07T08:00:00', value: 83.19 },
  { date: '2023-02-07T09:00:00', value: 48.23 },
  { date: '2023-02-07T10:00:00', value: 98.49 },
  { date: '2023-02-07T11:00:00', value: 91.49 },
  { date: '2023-02-07T12:00:00', value: 67.41 },
  { date: '2023-02-07T13:00:00', value: 68.91 },
  { date: '2023-02-07T14:00:00', value: 45.35 },
  { date: '2023-02-07T15:00:00', value: 87.13 },
  { date: '2023-02-07T16:00:00', value: 68.55 },
  { date: '2023-02-07T17:00:00', value: 30.7 },
  { date: '2023-02-07T18:00:00', value: 8.8 },
  { date: '2023-02-07T19:00:00', value: 27.76 },
  { date: '2023-02-07T20:00:00', value: 10.75 },
  { date: '2023-02-07T21:00:00', value: 24.8 },
  { date: '2023-02-07T22:00:00', value: 22.91 },
  { date: '2023-02-07T23:00:00', value: 52.8 },
  { date: '2023-02-08T00:00:00', value: 10.82 },
  { date: '2023-02-08T01:00:00', value: 59.23 },
  { date: '2023-02-08T02:00:00', value: 5.1 },
  { date: '2023-02-08T03:00:00', value: 11.42 },
  { date: '2023-02-08T04:00:00', value: 6.63 },
  { date: '2023-02-08T05:00:00', value: 73.11 },
  { date: '2023-02-08T06:00:00', value: 3.86 },
  { date: '2023-02-08T07:00:00', value: 52.0 },
  { date: '2023-02-08T08:00:00', value: 48.59 },
  { date: '2023-02-08T09:00:00', value: 88.03 },
  { date: '2023-02-08T10:00:00', value: 35.97 },
  { date: '2023-02-08T11:00:00', value: 67.84 },
  { date: '2023-02-08T12:00:00', value: 65.69 },
  { date: '2023-02-08T13:00:00', value: 77.38 },
  { date: '2023-02-08T14:00:00', value: 87.8 },
  { date: '2023-02-08T15:00:00', value: 34.89 },
  { date: '2023-02-08T16:00:00', value: 47.51 },
  { date: '2023-02-08T17:00:00', value: 74.7 },
  { date: '2023-02-08T18:00:00', value: 36.56 },
  { date: '2023-02-08T19:00:00', value: 18.78 },
  { date: '2023-02-08T20:00:00', value: 94.1 },
  { date: '2023-02-08T21:00:00', value: 21.05 },
  { date: '2023-02-08T22:00:00', value: 81.33 },
  { date: '2023-02-08T23:00:00', value: 69.37 },
  { date: '2023-02-09T00:00:00', value: 99.84 },
  { date: '2023-02-09T01:00:00', value: 52.63 },
  { date: '2023-02-09T02:00:00', value: 59.06 },
  { date: '2023-02-09T03:00:00', value: 98.06 },
  { date: '2023-02-09T04:00:00', value: 38.39 },
  { date: '2023-02-09T05:00:00', value: 83.25 },
  { date: '2023-02-09T06:00:00', value: 69.51 },
  { date: '2023-02-09T07:00:00', value: 28.08 },
  { date: '2023-02-09T08:00:00', value: 33.92 },
  { date: '2023-02-09T09:00:00', value: 22.56 },
  { date: '2023-02-09T10:00:00', value: 56.62 },
  { date: '2023-02-09T11:00:00', value: 77.8 },
  { date: '2023-02-09T12:00:00', value: 88.05 },
  { date: '2023-02-09T13:00:00', value: 53.65 },
  { date: '2023-02-09T14:00:00', value: 87.33 },
  { date: '2023-02-09T15:00:00', value: 19.91 },
  { date: '2023-02-09T16:00:00', value: 4.18 },
  { date: '2023-02-09T17:00:00', value: 46.41 },
  { date: '2023-02-09T18:00:00', value: 58.55 },
  { date: '2023-02-09T19:00:00', value: 71.52 },
  { date: '2023-02-09T20:00:00', value: 87.58 },
  { date: '2023-02-09T21:00:00', value: 96.9 },
  { date: '2023-02-09T22:00:00', value: 50.39 },
  { date: '2023-02-09T23:00:00', value: 57.24 },
  { date: '2023-02-10T00:00:00', value: 59.99 },
  { date: '2023-02-10T01:00:00', value: 59.34 },
  { date: '2023-02-10T02:00:00', value: 67.35 },
  { date: '2023-02-10T03:00:00', value: 66.07 },
  { date: '2023-02-10T04:00:00', value: 50.74 },
  { date: '2023-02-10T05:00:00', value: 87.32 },
  { date: '2023-02-10T06:00:00', value: 19.93 },
  { date: '2023-02-10T07:00:00', value: 32.73 },
  { date: '2023-02-10T08:00:00', value: 40.33 },
  { date: '2023-02-10T09:00:00', value: 85.47 },
  { date: '2023-02-10T10:00:00', value: 2.1 },
  { date: '2023-02-10T11:00:00', value: 37.54 },
  { date: '2023-02-10T12:00:00', value: 58.72 },
  { date: '2023-02-10T13:00:00', value: 8.7 },
  { date: '2023-02-10T14:00:00', value: 6.84 },
  { date: '2023-02-10T15:00:00', value: 63.52 },
  { date: '2023-02-10T16:00:00', value: 1.13 },
  { date: '2023-02-10T17:00:00', value: 16.42 },
  { date: '2023-02-10T18:00:00', value: 94.96 },
  { date: '2023-02-10T19:00:00', value: 49.64 },
  { date: '2023-02-10T20:00:00', value: 2.19 },
  { date: '2023-02-10T21:00:00', value: 3.73 },
  { date: '2023-02-10T22:00:00', value: 79.72 },
  { date: '2023-02-10T23:00:00', value: 84.61 },
  { date: '2023-02-11T00:00:00', value: 56.22 },
  { date: '2023-02-11T01:00:00', value: 85.58 },
  { date: '2023-02-11T02:00:00', value: 1.23 },
  { date: '2023-02-11T03:00:00', value: 61.59 },
  { date: '2023-02-11T04:00:00', value: 37.11 },
  { date: '2023-02-11T05:00:00', value: 30.18 },
  { date: '2023-02-11T06:00:00', value: 13.26 },
  { date: '2023-02-11T07:00:00', value: 7.53 },
  { date: '2023-02-11T08:00:00', value: 22.97 },
  { date: '2023-02-11T09:00:00', value: 58.29 },
  { date: '2023-02-11T10:00:00', value: 19.62 },
  { date: '2023-02-11T11:00:00', value: 74.94 },
  { date: '2023-02-11T12:00:00', value: 89.08 },
  { date: '2023-02-11T13:00:00', value: 42.07 },
  { date: '2023-02-11T14:00:00', value: 12.06 },
  { date: '2023-02-11T15:00:00', value: 17.58 },
  { date: '2023-02-11T16:00:00', value: 56.53 },
  { date: '2023-02-11T17:00:00', value: 96.11 },
  { date: '2023-02-11T18:00:00', value: 57.44 },
  { date: '2023-02-11T19:00:00', value: 20.8 },
  { date: '2023-02-11T20:00:00', value: 81.07 },
  { date: '2023-02-11T21:00:00', value: 2.26 },
  { date: '2023-02-11T22:00:00', value: 72.49 },
  { date: '2023-02-11T23:00:00', value: 28.4 },
  { date: '2023-02-12T00:00:00', value: 71.67 },
  { date: '2023-02-12T01:00:00', value: 44.67 },
  { date: '2023-02-12T02:00:00', value: 30.68 },
  { date: '2023-02-12T03:00:00', value: 36.06 },
  { date: '2023-02-12T04:00:00', value: 51.65 },
  { date: '2023-02-12T05:00:00', value: 45.51 },
  { date: '2023-02-12T06:00:00', value: 38.38 },
  { date: '2023-02-12T07:00:00', value: 52.56 },
  { date: '2023-02-12T08:00:00', value: 32.3 },
  { date: '2023-02-12T09:00:00', value: 23.65 },
  { date: '2023-02-12T10:00:00', value: 22.45 },
  { date: '2023-02-12T11:00:00', value: 80.5 },
  { date: '2023-02-12T12:00:00', value: 88.3 },
  { date: '2023-02-12T13:00:00', value: 74.24 },
  { date: '2023-02-12T14:00:00', value: 10.21 },
  { date: '2023-02-12T15:00:00', value: 31.09 },
  { date: '2023-02-12T16:00:00', value: 80.41 },
  { date: '2023-02-12T17:00:00', value: 24.2 },
  { date: '2023-02-12T18:00:00', value: 98.93 },
  { date: '2023-02-12T19:00:00', value: 48.61 },
  { date: '2023-02-12T20:00:00', value: 51.05 },
  { date: '2023-02-12T21:00:00', value: 5.37 },
  { date: '2023-02-12T22:00:00', value: 74.0 },
  { date: '2023-02-12T23:00:00', value: 11.84 },
  { date: '2023-02-13T00:00:00', value: 58.48 },
  { date: '2023-02-13T01:00:00', value: 45.45 },
  { date: '2023-02-13T02:00:00', value: 59.37 },
  { date: '2023-02-13T03:00:00', value: 74.15 },
  { date: '2023-02-13T04:00:00', value: 71.73 },
  { date: '2023-02-13T05:00:00', value: 8.89 },
  { date: '2023-02-13T06:00:00', value: 51.8 },
  { date: '2023-02-13T07:00:00', value: 65.29 },
  { date: '2023-02-13T08:00:00', value: 67.53 },
  { date: '2023-02-13T09:00:00', value: 35.38 },
  { date: '2023-02-13T10:00:00', value: 12.95 },
  { date: '2023-02-13T11:00:00', value: 55.29 },
  { date: '2023-02-13T12:00:00', value: 31.9 },
  { date: '2023-02-13T13:00:00', value: 78.39 },
  { date: '2023-02-13T14:00:00', value: 2.57 },
  { date: '2023-02-13T15:00:00', value: 7.39 },
  { date: '2023-02-13T16:00:00', value: 53.63 },
  { date: '2023-02-13T17:00:00', value: 44.08 },
  { date: '2023-02-13T18:00:00', value: 59.29 },
  { date: '2023-02-13T19:00:00', value: 50.11 },
  { date: '2023-02-13T20:00:00', value: 52.14 },
  { date: '2023-02-13T21:00:00', value: 48.05 },
  { date: '2023-02-13T22:00:00', value: 82.63 },
  { date: '2023-02-13T23:00:00', value: 60.53 },
  { date: '2023-02-14T00:00:00', value: 27.9 },
  { date: '2023-02-14T01:00:00', value: 82.64 },
  { date: '2023-02-14T02:00:00', value: 22.29 },
  { date: '2023-02-14T03:00:00', value: 63.22 },
  { date: '2023-02-14T04:00:00', value: 83.81 },
  { date: '2023-02-14T05:00:00', value: 3.73 },
  { date: '2023-02-14T06:00:00', value: 87.0 },
  { date: '2023-02-14T07:00:00', value: 50.92 },
  { date: '2023-02-14T08:00:00', value: 88.76 },
  { date: '2023-02-14T09:00:00', value: 79.47 },
  { date: '2023-02-14T10:00:00', value: 6.98 },
  { date: '2023-02-14T11:00:00', value: 4.86 },
  { date: '2023-02-14T12:00:00', value: 73.24 },
  { date: '2023-02-14T13:00:00', value: 37.42 },
  { date: '2023-02-14T14:00:00', value: 10.91 },
  { date: '2023-02-14T15:00:00', value: 97.19 },
  { date: '2023-02-14T16:00:00', value: 98.6 },
  { date: '2023-02-14T17:00:00', value: 79.91 },
  { date: '2023-02-14T18:00:00', value: 45.19 },
  { date: '2023-02-14T19:00:00', value: 38.94 },
  { date: '2023-02-14T20:00:00', value: 11.83 },
  { date: '2023-02-14T21:00:00', value: 1.16 },
  { date: '2023-02-14T22:00:00', value: 69.56 },
  { date: '2023-02-14T23:00:00', value: 39.21 },
  { date: '2023-02-15T00:00:00', value: 85.52 },
  { date: '2023-02-15T01:00:00', value: 23.94 },
  { date: '2023-02-15T02:00:00', value: 17.98 },
  { date: '2023-02-15T03:00:00', value: 7.06 },
  { date: '2023-02-15T04:00:00', value: 57.13 },
  { date: '2023-02-15T05:00:00', value: 96.24 },
  { date: '2023-02-15T06:00:00', value: 55.43 },
  { date: '2023-02-15T07:00:00', value: 68.98 },
  { date: '2023-02-15T08:00:00', value: 40.49 },
  { date: '2023-02-15T09:00:00', value: 13.35 },
  { date: '2023-02-15T10:00:00', value: 62.92 },
  { date: '2023-02-15T11:00:00', value: 4.08 },
  { date: '2023-02-15T12:00:00', value: 7.31 },
  { date: '2023-02-15T13:00:00', value: 8.58 },
  { date: '2023-02-15T14:00:00', value: 95.95 },
  { date: '2023-02-15T15:00:00', value: 82.49 },
  { date: '2023-02-15T16:00:00', value: 31.35 },
  { date: '2023-02-15T17:00:00', value: 19.99 },
  { date: '2023-02-15T18:00:00', value: 48.5 },
  { date: '2023-02-15T19:00:00', value: 11.03 },
  { date: '2023-02-15T20:00:00', value: 50.95 },
  { date: '2023-02-15T21:00:00', value: 55.63 },
  { date: '2023-02-15T22:00:00', value: 13.88 },
  { date: '2023-02-15T23:00:00', value: 28.28 },
  { date: '2023-02-16T00:00:00', value: 4.81 },
  { date: '2023-02-16T01:00:00', value: 83.92 },
  { date: '2023-02-16T02:00:00', value: 9.14 },
  { date: '2023-02-16T03:00:00', value: 59.53 },
  { date: '2023-02-16T04:00:00', value: 32.9 },
  { date: '2023-02-16T05:00:00', value: 2.73 },
  { date: '2023-02-16T06:00:00', value: 32.86 },
  { date: '2023-02-16T07:00:00', value: 21.91 },
  { date: '2023-02-16T08:00:00', value: 7.3 },
  { date: '2023-02-16T09:00:00', value: 21.17 },
  { date: '2023-02-16T10:00:00', value: 16.92 },
  { date: '2023-02-16T11:00:00', value: 99.94 },
  { date: '2023-02-16T12:00:00', value: 43.1 },
  { date: '2023-02-16T13:00:00', value: 71.55 },
  { date: '2023-02-16T14:00:00', value: 68.0 },
  { date: '2023-02-16T15:00:00', value: 4.34 },
  { date: '2023-02-16T16:00:00', value: 38.92 },
  { date: '2023-02-16T17:00:00', value: 23.12 },
  { date: '2023-02-16T18:00:00', value: 44.34 },
  { date: '2023-02-16T19:00:00', value: 15.94 },
  { date: '2023-02-16T20:00:00', value: 85.81 },
  { date: '2023-02-16T21:00:00', value: 22.98 },
  { date: '2023-02-16T22:00:00', value: 93.99 },
  { date: '2023-02-16T23:00:00', value: 21.78 },
  { date: '2023-02-17T00:00:00', value: 41.7 },
  { date: '2023-02-17T01:00:00', value: 97.7 },
  { date: '2023-02-17T02:00:00', value: 26.2 },
  { date: '2023-02-17T03:00:00', value: 26.26 },
  { date: '2023-02-17T04:00:00', value: 56.05 },
  { date: '2023-02-17T05:00:00', value: 44.6 },
  { date: '2023-02-17T06:00:00', value: 53.38 },
  { date: '2023-02-17T07:00:00', value: 65.45 },
  { date: '2023-02-17T08:00:00', value: 83.08 },
  { date: '2023-02-17T09:00:00', value: 82.39 },
  { date: '2023-02-17T10:00:00', value: 41.26 },
  { date: '2023-02-17T11:00:00', value: 21.68 },
  { date: '2023-02-17T12:00:00', value: 79.83 },
  { date: '2023-02-17T13:00:00', value: 19.22 },
  { date: '2023-02-17T14:00:00', value: 11.15 },
  { date: '2023-02-17T15:00:00', value: 74.77 },
  { date: '2023-02-17T16:00:00', value: 56.6 },
  { date: '2023-02-17T17:00:00', value: 4.24 },
  { date: '2023-02-17T18:00:00', value: 43.66 },
  { date: '2023-02-17T19:00:00', value: 25.69 },
  { date: '2023-02-17T20:00:00', value: 82.19 },
  { date: '2023-02-17T21:00:00', value: 6.34 },
  { date: '2023-02-17T22:00:00', value: 9.12 },
  { date: '2023-02-17T23:00:00', value: 56.83 },
  { date: '2023-02-18T00:00:00', value: 29.3 },
  { date: '2023-02-18T01:00:00', value: 79.76 },
  { date: '2023-02-18T02:00:00', value: 24.63 },
  { date: '2023-02-18T03:00:00', value: 91.27 },
  { date: '2023-02-18T04:00:00', value: 36.46 },
  { date: '2023-02-18T05:00:00', value: 44.47 },
  { date: '2023-02-18T06:00:00', value: 51.08 },
  { date: '2023-02-18T07:00:00', value: 49.68 },
  { date: '2023-02-18T08:00:00', value: 89.34 },
  { date: '2023-02-18T09:00:00', value: 41.44 },
  { date: '2023-02-18T10:00:00', value: 25.2 },
  { date: '2023-02-18T11:00:00', value: 64.89 },
  { date: '2023-02-18T12:00:00', value: 71.15 },
  { date: '2023-02-18T13:00:00', value: 12.0 },
  { date: '2023-02-18T14:00:00', value: 28.14 },
  { date: '2023-02-18T15:00:00', value: 79.42 },
  { date: '2023-02-18T16:00:00', value: 83.35 },
  { date: '2023-02-18T17:00:00', value: 37.41 },
  { date: '2023-02-18T18:00:00', value: 51.4 },
  { date: '2023-02-18T19:00:00', value: 74.09 },
  { date: '2023-02-18T20:00:00', value: 14.95 },
  { date: '2023-02-18T21:00:00', value: 2.45 },
  { date: '2023-02-18T22:00:00', value: 61.39 },
  { date: '2023-02-18T23:00:00', value: 27.47 },
  { date: '2023-02-19T00:00:00', value: 26.08 },
  { date: '2023-02-19T01:00:00', value: 96.19 },
  { date: '2023-02-19T02:00:00', value: 88.03 },
  { date: '2023-02-19T03:00:00', value: 26.69 },
  { date: '2023-02-19T04:00:00', value: 89.95 },
  { date: '2023-02-19T05:00:00', value: 22.94 },
  { date: '2023-02-19T06:00:00', value: 33.59 },
  { date: '2023-02-19T07:00:00', value: 24.41 },
  { date: '2023-02-19T08:00:00', value: 71.88 },
  { date: '2023-02-19T09:00:00', value: 99.17 },
  { date: '2023-02-19T10:00:00', value: 58.74 },
  { date: '2023-02-19T11:00:00', value: 11.25 },
  { date: '2023-02-19T12:00:00', value: 35.54 },
  { date: '2023-02-19T13:00:00', value: 67.11 },
  { date: '2023-02-19T14:00:00', value: 94.94 },
  { date: '2023-02-19T15:00:00', value: 67.15 },
  { date: '2023-02-19T16:00:00', value: 78.84 },
  { date: '2023-02-19T17:00:00', value: 29.11 },
  { date: '2023-02-19T18:00:00', value: 63.35 },
  { date: '2023-02-19T19:00:00', value: 14.35 },
  { date: '2023-02-19T20:00:00', value: 87.64 },
  { date: '2023-02-19T21:00:00', value: 10.09 },
  { date: '2023-02-19T22:00:00', value: 25.34 },
  { date: '2023-02-19T23:00:00', value: 5.19 },
  { date: '2023-02-20T00:00:00', value: 2.92 },
  { date: '2023-02-20T01:00:00', value: 59.2 },
  { date: '2023-02-20T02:00:00', value: 47.47 },
  { date: '2023-02-20T03:00:00', value: 29.81 },
  { date: '2023-02-20T04:00:00', value: 19.06 },
  { date: '2023-02-20T05:00:00', value: 91.81 },
  { date: '2023-02-20T06:00:00', value: 83.21 },
  { date: '2023-02-20T07:00:00', value: 5.89 },
  { date: '2023-02-20T08:00:00', value: 91.69 },
  { date: '2023-02-20T09:00:00', value: 44.66 },
  { date: '2023-02-20T10:00:00', value: 64.09 },
  { date: '2023-02-20T11:00:00', value: 78.39 },
  { date: '2023-02-20T12:00:00', value: 54.63 },
  { date: '2023-02-20T13:00:00', value: 26.15 },
  { date: '2023-02-20T14:00:00', value: 21.36 },
  { date: '2023-02-20T15:00:00', value: 13.56 },
  { date: '2023-02-20T16:00:00', value: 57.77 },
  { date: '2023-02-20T17:00:00', value: 18.15 },
  { date: '2023-02-20T18:00:00', value: 15.04 },
  { date: '2023-02-20T19:00:00', value: 32.34 },
  { date: '2023-02-20T20:00:00', value: 73.2 },
  { date: '2023-02-20T21:00:00', value: 97.75 },
  { date: '2023-02-20T22:00:00', value: 81.53 },
  { date: '2023-02-20T23:00:00', value: 87.88 },
  { date: '2023-02-21T00:00:00', value: 49.23 },
  { date: '2023-02-21T01:00:00', value: 2.28 },
  { date: '2023-02-21T02:00:00', value: 5.58 },
  { date: '2023-02-21T03:00:00', value: 29.58 },
  { date: '2023-02-21T04:00:00', value: 34.81 },
  { date: '2023-02-21T05:00:00', value: 73.98 },
  { date: '2023-02-21T06:00:00', value: 45.33 },
  { date: '2023-02-21T07:00:00', value: 17.09 },
  { date: '2023-02-21T08:00:00', value: 40.9 },
  { date: '2023-02-21T09:00:00', value: 79.27 },
  { date: '2023-02-21T10:00:00', value: 90.59 },
  { date: '2023-02-21T11:00:00', value: 39.84 },
  { date: '2023-02-21T12:00:00', value: 58.96 },
  { date: '2023-02-21T13:00:00', value: 62.71 },
  { date: '2023-02-21T14:00:00', value: 21.11 },
  { date: '2023-02-21T15:00:00', value: 7.98 },
  { date: '2023-02-21T16:00:00', value: 50.55 },
  { date: '2023-02-21T17:00:00', value: 21.74 },
  { date: '2023-02-21T18:00:00', value: 13.11 },
  { date: '2023-02-21T19:00:00', value: 28.06 },
  { date: '2023-02-21T20:00:00', value: 4.18 },
  { date: '2023-02-21T21:00:00', value: 81.02 },
  { date: '2023-02-21T22:00:00', value: 57.2 },
  { date: '2023-02-21T23:00:00', value: 27.37 },
  { date: '2023-02-22T00:00:00', value: 95.75 },
  { date: '2023-02-22T01:00:00', value: 80.77 },
  { date: '2023-02-22T02:00:00', value: 70.23 },
  { date: '2023-02-22T03:00:00', value: 92.4 },
  { date: '2023-02-22T04:00:00', value: 37.96 },
  { date: '2023-02-22T05:00:00', value: 66.43 },
  { date: '2023-02-22T06:00:00', value: 71.34 },
  { date: '2023-02-22T07:00:00', value: 85.93 },
  { date: '2023-02-22T08:00:00', value: 21.85 },
  { date: '2023-02-22T09:00:00', value: 40.84 },
  { date: '2023-02-22T10:00:00', value: 43.32 },
  { date: '2023-02-22T11:00:00', value: 32.21 },
  { date: '2023-02-22T12:00:00', value: 67.22 },
  { date: '2023-02-22T13:00:00', value: 89.35 },
  { date: '2023-02-22T14:00:00', value: 14.48 },
  { date: '2023-02-22T15:00:00', value: 98.44 },
  { date: '2023-02-22T16:00:00', value: 13.18 },
  { date: '2023-02-22T17:00:00', value: 34.48 },
  { date: '2023-02-22T18:00:00', value: 63.16 },
  { date: '2023-02-22T19:00:00', value: 21.76 },
  { date: '2023-02-22T20:00:00', value: 1.89 },
  { date: '2023-02-22T21:00:00', value: 49.34 },
  { date: '2023-02-22T22:00:00', value: 70.59 },
  { date: '2023-02-22T23:00:00', value: 95.2 },
  { date: '2023-02-23T00:00:00', value: 74.16 },
  { date: '2023-02-23T01:00:00', value: 27.16 },
  { date: '2023-02-23T02:00:00', value: 61.79 },
  { date: '2023-02-23T03:00:00', value: 45.51 },
  { date: '2023-02-23T04:00:00', value: 18.27 },
  { date: '2023-02-23T05:00:00', value: 25.59 },
  { date: '2023-02-23T06:00:00', value: 3.81 },
  { date: '2023-02-23T07:00:00', value: 25.97 },
  { date: '2023-02-23T08:00:00', value: 7.86 },
  { date: '2023-02-23T09:00:00', value: 54.92 },
  { date: '2023-02-23T10:00:00', value: 52.6 },
  { date: '2023-02-23T11:00:00', value: 20.32 },
  { date: '2023-02-23T12:00:00', value: 23.64 },
  { date: '2023-02-23T13:00:00', value: 86.78 },
  { date: '2023-02-23T14:00:00', value: 78.92 },
  { date: '2023-02-23T15:00:00', value: 38.52 },
  { date: '2023-02-23T16:00:00', value: 4.35 },
  { date: '2023-02-23T17:00:00', value: 16.14 },
  { date: '2023-02-23T18:00:00', value: 8.42 },
  { date: '2023-02-23T19:00:00', value: 63.54 },
  { date: '2023-02-23T20:00:00', value: 22.09 },
  { date: '2023-02-23T21:00:00', value: 20.88 },
  { date: '2023-02-23T22:00:00', value: 84.59 },
  { date: '2023-02-23T23:00:00', value: 63.19 },
  { date: '2023-02-24T00:00:00', value: 53.71 },
  { date: '2023-02-24T01:00:00', value: 4.11 },
  { date: '2023-02-24T02:00:00', value: 20.99 },
  { date: '2023-02-24T03:00:00', value: 96.46 },
  { date: '2023-02-24T04:00:00', value: 87.6 },
  { date: '2023-02-24T05:00:00', value: 73.31 },
  { date: '2023-02-24T06:00:00', value: 16.15 },
  { date: '2023-02-24T07:00:00', value: 51.64 },
  { date: '2023-02-24T08:00:00', value: 61.18 },
  { date: '2023-02-24T09:00:00', value: 15.15 },
  { date: '2023-02-24T10:00:00', value: 3.48 },
  { date: '2023-02-24T11:00:00', value: 31.15 },
  { date: '2023-02-24T12:00:00', value: 81.37 },
  { date: '2023-02-24T13:00:00', value: 81.72 },
  { date: '2023-02-24T14:00:00', value: 22.05 },
  { date: '2023-02-24T15:00:00', value: 51.43 },
  { date: '2023-02-24T16:00:00', value: 4.5 },
  { date: '2023-02-24T17:00:00', value: 92.73 },
  { date: '2023-02-24T18:00:00', value: 75.16 },
  { date: '2023-02-24T19:00:00', value: 27.21 },
  { date: '2023-02-24T20:00:00', value: 34.88 },
  { date: '2023-02-24T21:00:00', value: 82.36 },
  { date: '2023-02-24T22:00:00', value: 53.87 },
  { date: '2023-02-24T23:00:00', value: 87.79 },
  { date: '2023-02-25T00:00:00', value: 58.75 },
  { date: '2023-02-25T01:00:00', value: 80.01 },
  { date: '2023-02-25T02:00:00', value: 67.06 },
  { date: '2023-02-25T03:00:00', value: 41.74 },
  { date: '2023-02-25T04:00:00', value: 75.7 },
  { date: '2023-02-25T05:00:00', value: 24.86 },
  { date: '2023-02-25T06:00:00', value: 29.04 },
  { date: '2023-02-25T07:00:00', value: 59.58 },
  { date: '2023-02-25T08:00:00', value: 72.8 },
  { date: '2023-02-25T09:00:00', value: 78.64 },
  { date: '2023-02-25T10:00:00', value: 27.95 },
  { date: '2023-02-25T11:00:00', value: 22.72 },
  { date: '2023-02-25T12:00:00', value: 94.41 },
  { date: '2023-02-25T13:00:00', value: 53.46 },
  { date: '2023-02-25T14:00:00', value: 70.65 },
  { date: '2023-02-25T15:00:00', value: 11.84 },
  { date: '2023-02-25T16:00:00', value: 54.35 },
  { date: '2023-02-25T17:00:00', value: 78.4 },
  { date: '2023-02-25T18:00:00', value: 48.66 },
  { date: '2023-02-25T19:00:00', value: 89.32 },
  { date: '2023-02-25T20:00:00', value: 8.59 },
  { date: '2023-02-25T21:00:00', value: 51.47 },
  { date: '2023-02-25T22:00:00', value: 4.59 },
  { date: '2023-02-25T23:00:00', value: 48.55 },
  { date: '2023-02-26T00:00:00', value: 71.86 },
  { date: '2023-02-26T01:00:00', value: 66.01 },
  { date: '2023-02-26T02:00:00', value: 57.43 },
  { date: '2023-02-26T03:00:00', value: 99.59 },
  { date: '2023-02-26T04:00:00', value: 14.38 },
  { date: '2023-02-26T05:00:00', value: 76.55 },
  { date: '2023-02-26T06:00:00', value: 40.32 },
  { date: '2023-02-26T07:00:00', value: 2.64 },
  { date: '2023-02-26T08:00:00', value: 57.48 },
  { date: '2023-02-26T09:00:00', value: 1.95 },
  { date: '2023-02-26T10:00:00', value: 18.07 },
  { date: '2023-02-26T11:00:00', value: 78.02 },
  { date: '2023-02-26T12:00:00', value: 43.23 },
  { date: '2023-02-26T13:00:00', value: 24.46 },
  { date: '2023-02-26T14:00:00', value: 37.0 },
  { date: '2023-02-26T15:00:00', value: 98.11 },
  { date: '2023-02-26T16:00:00', value: 35.68 },
  { date: '2023-02-26T17:00:00', value: 87.14 },
  { date: '2023-02-26T18:00:00', value: 24.92 },
  { date: '2023-02-26T19:00:00', value: 84.17 },
  { date: '2023-02-26T20:00:00', value: 88.27 },
  { date: '2023-02-26T21:00:00', value: 76.2 },
  { date: '2023-02-26T22:00:00', value: 11.23 },
  { date: '2023-02-26T23:00:00', value: 43.69 },
  { date: '2023-02-27T00:00:00', value: 27.25 },
  { date: '2023-02-27T01:00:00', value: 82.7 },
  { date: '2023-02-27T02:00:00', value: 91.1 },
  { date: '2023-02-27T03:00:00', value: 22.17 },
  { date: '2023-02-27T04:00:00', value: 98.52 },
  { date: '2023-02-27T05:00:00', value: 50.53 },
  { date: '2023-02-27T06:00:00', value: 32.42 },
  { date: '2023-02-27T07:00:00', value: 82.1 },
  { date: '2023-02-27T08:00:00', value: 31.72 },
  { date: '2023-02-27T09:00:00', value: 68.67 },
  { date: '2023-02-27T10:00:00', value: 9.09 },
  { date: '2023-02-27T11:00:00', value: 13.76 },
  { date: '2023-02-27T12:00:00', value: 45.63 },
  { date: '2023-02-27T13:00:00', value: 5.33 },
  { date: '2023-02-27T14:00:00', value: 73.67 },
  { date: '2023-02-27T15:00:00', value: 28.37 },
  { date: '2023-02-27T16:00:00', value: 53.11 },
  { date: '2023-02-27T17:00:00', value: 52.78 },
  { date: '2023-02-27T18:00:00', value: 65.77 },
  { date: '2023-02-27T19:00:00', value: 35.29 },
  { date: '2023-02-27T20:00:00', value: 89.57 },
  { date: '2023-02-27T21:00:00', value: 43.6 },
  { date: '2023-02-27T22:00:00', value: 93.13 },
  { date: '2023-02-27T23:00:00', value: 32.38 },
  { date: '2023-02-28T00:00:00', value: 73.63 },
  { date: '2023-02-28T01:00:00', value: 23.71 },
  { date: '2023-02-28T02:00:00', value: 1.18 },
  { date: '2023-02-28T03:00:00', value: 36.94 },
  { date: '2023-02-28T04:00:00', value: 26.17 },
  { date: '2023-02-28T05:00:00', value: 29.79 },
  { date: '2023-02-28T06:00:00', value: 52.41 },
  { date: '2023-02-28T07:00:00', value: 21.63 },
  { date: '2023-02-28T08:00:00', value: 58.68 },
  { date: '2023-02-28T09:00:00', value: 53.55 },
  { date: '2023-02-28T10:00:00', value: 6.62 },
  { date: '2023-02-28T11:00:00', value: 46.57 },
  { date: '2023-02-28T12:00:00', value: 73.79 },
  { date: '2023-02-28T13:00:00', value: 71.45 },
  { date: '2023-02-28T14:00:00', value: 96.63 },
  { date: '2023-02-28T15:00:00', value: 33.7 },
  { date: '2023-02-28T16:00:00', value: 67.65 },
  { date: '2023-02-28T17:00:00', value: 64.02 },
  { date: '2023-02-28T18:00:00', value: 35.25 },
  { date: '2023-02-28T19:00:00', value: 22.41 },
  { date: '2023-02-28T20:00:00', value: 46.53 },
  { date: '2023-02-28T21:00:00', value: 92.0 },
  { date: '2023-02-28T22:00:00', value: 71.51 },
  { date: '2023-02-28T23:00:00', value: 55.91 },
  { date: '2023-03-01T00:00:00', value: 11.5 },
  { date: '2023-03-01T01:00:00', value: 36.68 },
  { date: '2023-03-01T02:00:00', value: 95.05 },
  { date: '2023-03-01T03:00:00', value: 1.81 },
  { date: '2023-03-01T04:00:00', value: 66.97 },
  { date: '2023-03-01T05:00:00', value: 76.87 },
  { date: '2023-03-01T06:00:00', value: 45.81 },
  { date: '2023-03-01T07:00:00', value: 67.94 },
  { date: '2023-03-01T08:00:00', value: 97.7 },
  { date: '2023-03-01T09:00:00', value: 18.77 },
  { date: '2023-03-01T10:00:00', value: 30.75 },
  { date: '2023-03-01T11:00:00', value: 84.46 },
  { date: '2023-03-01T12:00:00', value: 87.92 },
  { date: '2023-03-01T13:00:00', value: 62.01 },
  { date: '2023-03-01T14:00:00', value: 76.17 },
  { date: '2023-03-01T15:00:00', value: 33.36 },
  { date: '2023-03-01T16:00:00', value: 19.53 },
  { date: '2023-03-01T17:00:00', value: 56.88 },
  { date: '2023-03-01T18:00:00', value: 65.11 },
  { date: '2023-03-01T19:00:00', value: 8.82 },
  { date: '2023-03-01T20:00:00', value: 70.63 },
  { date: '2023-03-01T21:00:00', value: 94.75 },
  { date: '2023-03-01T22:00:00', value: 74.24 },
  { date: '2023-03-01T23:00:00', value: 72.52 },
  { date: '2023-03-02T00:00:00', value: 28.87 },
  { date: '2023-03-02T01:00:00', value: 43.08 },
  { date: '2023-03-02T02:00:00', value: 92.1 },
  { date: '2023-03-02T03:00:00', value: 40.68 },
  { date: '2023-03-02T04:00:00', value: 97.78 },
  { date: '2023-03-02T05:00:00', value: 39.24 },
  { date: '2023-03-02T06:00:00', value: 1.13 },
  { date: '2023-03-02T07:00:00', value: 4.8 },
  { date: '2023-03-02T08:00:00', value: 24.2 },
  { date: '2023-03-02T09:00:00', value: 55.22 },
  { date: '2023-03-02T10:00:00', value: 69.61 },
  { date: '2023-03-02T11:00:00', value: 80.03 },
  { date: '2023-03-02T12:00:00', value: 84.5 },
  { date: '2023-03-02T13:00:00', value: 6.87 },
  { date: '2023-03-02T14:00:00', value: 66.0 },
  { date: '2023-03-02T15:00:00', value: 68.72 },
  { date: '2023-03-02T16:00:00', value: 19.2 },
  { date: '2023-03-02T17:00:00', value: 78.37 },
  { date: '2023-03-02T18:00:00', value: 93.46 },
  { date: '2023-03-02T19:00:00', value: 90.14 },
  { date: '2023-03-02T20:00:00', value: 49.51 },
  { date: '2023-03-02T21:00:00', value: 88.99 },
  { date: '2023-03-02T22:00:00', value: 36.75 },
  { date: '2023-03-02T23:00:00', value: 33.41 },
  { date: '2023-03-03T00:00:00', value: 78.64 },
  { date: '2023-03-03T01:00:00', value: 49.05 },
  { date: '2023-03-03T02:00:00', value: 55.91 },
  { date: '2023-03-03T03:00:00', value: 43.95 },
  { date: '2023-03-03T04:00:00', value: 39.23 },
  { date: '2023-03-03T05:00:00', value: 65.24 },
  { date: '2023-03-03T06:00:00', value: 91.06 },
  { date: '2023-03-03T07:00:00', value: 42.39 },
  { date: '2023-03-03T08:00:00', value: 17.45 },
  { date: '2023-03-03T09:00:00', value: 52.99 },
  { date: '2023-03-03T10:00:00', value: 82.5 },
  { date: '2023-03-03T11:00:00', value: 98.46 },
  { date: '2023-03-03T12:00:00', value: 73.61 },
  { date: '2023-03-03T13:00:00', value: 93.62 },
  { date: '2023-03-03T14:00:00', value: 51.59 },
  { date: '2023-03-03T15:00:00', value: 69.69 },
  { date: '2023-03-03T16:00:00', value: 3.28 },
  { date: '2023-03-03T17:00:00', value: 84.65 },
  { date: '2023-03-03T18:00:00', value: 32.52 },
  { date: '2023-03-03T19:00:00', value: 61.57 },
  { date: '2023-03-03T20:00:00', value: 54.02 },
  { date: '2023-03-03T21:00:00', value: 1.76 },
  { date: '2023-03-03T22:00:00', value: 68.14 },
  { date: '2023-03-03T23:00:00', value: 68.0 },
  { date: '2023-03-04T00:00:00', value: 89.2 },
  { date: '2023-03-04T01:00:00', value: 92.77 },
  { date: '2023-03-04T02:00:00', value: 42.85 },
  { date: '2023-03-04T03:00:00', value: 35.01 },
  { date: '2023-03-04T04:00:00', value: 78.37 },
  { date: '2023-03-04T05:00:00', value: 47.75 },
  { date: '2023-03-04T06:00:00', value: 52.87 },
  { date: '2023-03-04T07:00:00', value: 24.66 },
  { date: '2023-03-04T08:00:00', value: 22.43 },
  { date: '2023-03-04T09:00:00', value: 9.83 },
  { date: '2023-03-04T10:00:00', value: 77.59 },
  { date: '2023-03-04T11:00:00', value: 17.02 },
  { date: '2023-03-04T12:00:00', value: 98.67 },
  { date: '2023-03-04T13:00:00', value: 1.78 },
  { date: '2023-03-04T14:00:00', value: 17.51 },
  { date: '2023-03-04T15:00:00', value: 10.72 },
  { date: '2023-03-04T16:00:00', value: 88.31 },
  { date: '2023-03-04T17:00:00', value: 99.02 },
  { date: '2023-03-04T18:00:00', value: 8.3 },
  { date: '2023-03-04T19:00:00', value: 18.17 },
  { date: '2023-03-04T20:00:00', value: 75.15 },
  { date: '2023-03-04T21:00:00', value: 28.8 },
  { date: '2023-03-04T22:00:00', value: 78.25 },
  { date: '2023-03-04T23:00:00', value: 57.98 },
  { date: '2023-03-05T00:00:00', value: 58.52 },
  { date: '2023-03-05T01:00:00', value: 71.53 },
  { date: '2023-03-05T02:00:00', value: 55.82 },
  { date: '2023-03-05T03:00:00', value: 61.08 },
  { date: '2023-03-05T04:00:00', value: 45.55 },
  { date: '2023-03-05T05:00:00', value: 21.49 },
  { date: '2023-03-05T06:00:00', value: 70.11 },
  { date: '2023-03-05T07:00:00', value: 69.61 },
  { date: '2023-03-05T08:00:00', value: 88.44 },
  { date: '2023-03-05T09:00:00', value: 43.58 },
  { date: '2023-03-05T10:00:00', value: 47.4 },
  { date: '2023-03-05T11:00:00', value: 74.47 },
  { date: '2023-03-05T12:00:00', value: 14.44 },
  { date: '2023-03-05T13:00:00', value: 40.99 },
  { date: '2023-03-05T14:00:00', value: 92.82 },
  { date: '2023-03-05T15:00:00', value: 68.47 },
  { date: '2023-03-05T16:00:00', value: 51.37 },
  { date: '2023-03-05T17:00:00', value: 30.97 },
  { date: '2023-03-05T18:00:00', value: 81.48 },
  { date: '2023-03-05T19:00:00', value: 1.44 },
  { date: '2023-03-05T20:00:00', value: 91.57 },
  { date: '2023-03-05T21:00:00', value: 10.57 },
  { date: '2023-03-05T22:00:00', value: 77.78 },
  { date: '2023-03-05T23:00:00', value: 63.86 },
  { date: '2023-03-06T00:00:00', value: 42.4 },
  { date: '2023-03-06T01:00:00', value: 11.33 },
  { date: '2023-03-06T02:00:00', value: 65.9 },
  { date: '2023-03-06T03:00:00', value: 3.31 },
  { date: '2023-03-06T04:00:00', value: 51.21 },
  { date: '2023-03-06T05:00:00', value: 48.58 },
  { date: '2023-03-06T06:00:00', value: 21.56 },
  { date: '2023-03-06T07:00:00', value: 92.88 },
  { date: '2023-03-06T08:00:00', value: 86.85 },
  { date: '2023-03-06T09:00:00', value: 90.85 },
  { date: '2023-03-06T10:00:00', value: 25.14 },
  { date: '2023-03-06T11:00:00', value: 89.47 },
  { date: '2023-03-06T12:00:00', value: 18.13 },
  { date: '2023-03-06T13:00:00', value: 12.41 },
  { date: '2023-03-06T14:00:00', value: 37.52 },
  { date: '2023-03-06T15:00:00', value: 25.89 },
  { date: '2023-03-06T16:00:00', value: 20.34 },
  { date: '2023-03-06T17:00:00', value: 58.94 },
  { date: '2023-03-06T18:00:00', value: 62.48 },
  { date: '2023-03-06T19:00:00', value: 86.79 },
  { date: '2023-03-06T20:00:00', value: 67.18 },
  { date: '2023-03-06T21:00:00', value: 93.63 },
  { date: '2023-03-06T22:00:00', value: 27.74 },
  { date: '2023-03-06T23:00:00', value: 63.12 },
  { date: '2023-03-07T00:00:00', value: 37.29 },
  { date: '2023-03-07T01:00:00', value: 94.97 },
  { date: '2023-03-07T02:00:00', value: 8.76 },
  { date: '2023-03-07T03:00:00', value: 99.68 },
  { date: '2023-03-07T04:00:00', value: 56.46 },
  { date: '2023-03-07T05:00:00', value: 10.93 },
  { date: '2023-03-07T06:00:00', value: 12.36 },
  { date: '2023-03-07T07:00:00', value: 41.98 },
  { date: '2023-03-07T08:00:00', value: 57.83 },
  { date: '2023-03-07T09:00:00', value: 18.51 },
  { date: '2023-03-07T10:00:00', value: 34.95 },
  { date: '2023-03-07T11:00:00', value: 76.14 },
  { date: '2023-03-07T12:00:00', value: 57.66 },
  { date: '2023-03-07T13:00:00', value: 58.59 },
  { date: '2023-03-07T14:00:00', value: 73.66 },
  { date: '2023-03-07T15:00:00', value: 57.74 },
  { date: '2023-03-07T16:00:00', value: 4.62 },
  { date: '2023-03-07T17:00:00', value: 46.03 },
  { date: '2023-03-07T18:00:00', value: 79.73 },
  { date: '2023-03-07T19:00:00', value: 63.52 },
  { date: '2023-03-07T20:00:00', value: 52.39 },
  { date: '2023-03-07T21:00:00', value: 88.84 },
  { date: '2023-03-07T22:00:00', value: 31.06 },
  { date: '2023-03-07T23:00:00', value: 29.76 },
  { date: '2023-03-08T00:00:00', value: 1.81 },
  { date: '2023-03-08T01:00:00', value: 4.31 },
  { date: '2023-03-08T02:00:00', value: 40.24 },
  { date: '2023-03-08T03:00:00', value: 27.19 },
  { date: '2023-03-08T04:00:00', value: 64.39 },
  { date: '2023-03-08T05:00:00', value: 36.68 },
  { date: '2023-03-08T06:00:00', value: 68.44 },
  { date: '2023-03-08T07:00:00', value: 39.03 },
  { date: '2023-03-08T08:00:00', value: 63.59 },
  { date: '2023-03-08T09:00:00', value: 15.81 },
  { date: '2023-03-08T10:00:00', value: 92.36 },
  { date: '2023-03-08T11:00:00', value: 24.19 },
  { date: '2023-03-08T12:00:00', value: 92.45 },
  { date: '2023-03-08T13:00:00', value: 55.37 },
  { date: '2023-03-08T14:00:00', value: 14.07 },
  { date: '2023-03-08T15:00:00', value: 4.44 },
  { date: '2023-03-08T16:00:00', value: 76.42 },
  { date: '2023-03-08T17:00:00', value: 61.31 },
  { date: '2023-03-08T18:00:00', value: 16.09 },
  { date: '2023-03-08T19:00:00', value: 29.82 },
  { date: '2023-03-08T20:00:00', value: 43.18 },
  { date: '2023-03-08T21:00:00', value: 46.78 },
  { date: '2023-03-08T22:00:00', value: 12.36 },
  { date: '2023-03-08T23:00:00', value: 98.1 },
  { date: '2023-03-09T00:00:00', value: 71.29 },
  { date: '2023-03-09T01:00:00', value: 96.11 },
  { date: '2023-03-09T02:00:00', value: 45.86 },
  { date: '2023-03-09T03:00:00', value: 30.59 },
  { date: '2023-03-09T04:00:00', value: 70.86 },
  { date: '2023-03-09T05:00:00', value: 66.94 },
  { date: '2023-03-09T06:00:00', value: 55.4 },
  { date: '2023-03-09T07:00:00', value: 36.45 },
  { date: '2023-03-09T08:00:00', value: 22.66 },
  { date: '2023-03-09T09:00:00', value: 25.51 },
  { date: '2023-03-09T10:00:00', value: 6.66 },
  { date: '2023-03-09T11:00:00', value: 72.24 },
  { date: '2023-03-09T12:00:00', value: 64.55 },
  { date: '2023-03-09T13:00:00', value: 81.17 },
  { date: '2023-03-09T14:00:00', value: 45.23 },
  { date: '2023-03-09T15:00:00', value: 30.87 },
  { date: '2023-03-09T16:00:00', value: 9.26 },
  { date: '2023-03-09T17:00:00', value: 68.95 },
  { date: '2023-03-09T18:00:00', value: 46.36 },
  { date: '2023-03-09T19:00:00', value: 27.21 },
  { date: '2023-03-09T20:00:00', value: 69.16 },
  { date: '2023-03-09T21:00:00', value: 52.68 },
  { date: '2023-03-09T22:00:00', value: 34.96 },
  { date: '2023-03-09T23:00:00', value: 69.28 },
  { date: '2023-03-10T00:00:00', value: 4.09 },
  { date: '2023-03-10T01:00:00', value: 79.55 },
  { date: '2023-03-10T02:00:00', value: 36.48 },
  { date: '2023-03-10T03:00:00', value: 54.01 },
  { date: '2023-03-10T04:00:00', value: 48.16 },
  { date: '2023-03-10T05:00:00', value: 55.98 },
  { date: '2023-03-10T06:00:00', value: 21.53 },
  { date: '2023-03-10T07:00:00', value: 28.2 },
  { date: '2023-03-10T08:00:00', value: 7.32 },
  { date: '2023-03-10T09:00:00', value: 15.65 },
  { date: '2023-03-10T10:00:00', value: 94.2 },
  { date: '2023-03-10T11:00:00', value: 8.47 },
  { date: '2023-03-10T12:00:00', value: 56.18 },
  { date: '2023-03-10T13:00:00', value: 2.68 },
  { date: '2023-03-10T14:00:00', value: 48.04 },
  { date: '2023-03-10T15:00:00', value: 32.04 },
  { date: '2023-03-10T16:00:00', value: 21.85 },
  { date: '2023-03-10T17:00:00', value: 8.24 },
  { date: '2023-03-10T18:00:00', value: 23.78 },
  { date: '2023-03-10T19:00:00', value: 61.05 },
  { date: '2023-03-10T20:00:00', value: 9.0 },
  { date: '2023-03-10T21:00:00', value: 63.31 },
  { date: '2023-03-10T22:00:00', value: 32.56 },
  { date: '2023-03-10T23:00:00', value: 69.66 },
  { date: '2023-03-11T00:00:00', value: 38.77 },
  { date: '2023-03-11T01:00:00', value: 34.13 },
  { date: '2023-03-11T02:00:00', value: 20.33 },
  { date: '2023-03-11T03:00:00', value: 13.38 },
  { date: '2023-03-11T04:00:00', value: 72.94 },
  { date: '2023-03-11T05:00:00', value: 85.81 },
  { date: '2023-03-11T06:00:00', value: 88.84 },
  { date: '2023-03-11T07:00:00', value: 1.58 },
  { date: '2023-03-11T08:00:00', value: 45.33 },
  { date: '2023-03-11T09:00:00', value: 45.6 },
  { date: '2023-03-11T10:00:00', value: 14.55 },
  { date: '2023-03-11T11:00:00', value: 70.24 },
  { date: '2023-03-11T12:00:00', value: 28.35 },
  { date: '2023-03-11T13:00:00', value: 20.64 },
  { date: '2023-03-11T14:00:00', value: 73.81 },
  { date: '2023-03-11T15:00:00', value: 54.61 },
  { date: '2023-03-11T16:00:00', value: 30.97 },
  { date: '2023-03-11T17:00:00', value: 9.78 },
  { date: '2023-03-11T18:00:00', value: 24.6 },
  { date: '2023-03-11T19:00:00', value: 6.34 },
  { date: '2023-03-11T20:00:00', value: 45.52 },
  { date: '2023-03-11T21:00:00', value: 15.66 },
  { date: '2023-03-11T22:00:00', value: 50.23 },
  { date: '2023-03-11T23:00:00', value: 18.83 },
  { date: '2023-03-12T00:00:00', value: 51.76 },
  { date: '2023-03-12T01:00:00', value: 36.3 },
  { date: '2023-03-12T02:00:00', value: 37.65 },
  { date: '2023-03-12T03:00:00', value: 27.16 },
  { date: '2023-03-12T04:00:00', value: 58.19 },
  { date: '2023-03-12T05:00:00', value: 19.35 },
  { date: '2023-03-12T06:00:00', value: 86.36 },
  { date: '2023-03-12T07:00:00', value: 72.65 },
  { date: '2023-03-12T08:00:00', value: 44.15 },
  { date: '2023-03-12T09:00:00', value: 9.91 },
  { date: '2023-03-12T10:00:00', value: 11.54 },
  { date: '2023-03-12T11:00:00', value: 35.06 },
  { date: '2023-03-12T12:00:00', value: 33.11 },
  { date: '2023-03-12T13:00:00', value: 46.55 },
  { date: '2023-03-12T14:00:00', value: 52.3 },
  { date: '2023-03-12T15:00:00', value: 99.21 },
  { date: '2023-03-12T16:00:00', value: 91.7 },
  { date: '2023-03-12T17:00:00', value: 99.89 },
  { date: '2023-03-12T18:00:00', value: 19.12 },
  { date: '2023-03-12T19:00:00', value: 98.27 },
  { date: '2023-03-12T20:00:00', value: 23.3 },
  { date: '2023-03-12T21:00:00', value: 36.11 },
  { date: '2023-03-12T22:00:00', value: 9.42 },
  { date: '2023-03-12T23:00:00', value: 68.68 },
  { date: '2023-03-13T00:00:00', value: 37.52 },
  { date: '2023-03-13T01:00:00', value: 60.3 },
  { date: '2023-03-13T02:00:00', value: 37.87 },
  { date: '2023-03-13T03:00:00', value: 37.23 },
  { date: '2023-03-13T04:00:00', value: 6.79 },
  { date: '2023-03-13T05:00:00', value: 16.38 },
  { date: '2023-03-13T06:00:00', value: 79.94 },
  { date: '2023-03-13T07:00:00', value: 28.86 },
  { date: '2023-03-13T08:00:00', value: 65.33 },
  { date: '2023-03-13T09:00:00', value: 89.88 },
  { date: '2023-03-13T10:00:00', value: 30.25 },
  { date: '2023-03-13T11:00:00', value: 55.83 },
  { date: '2023-03-13T12:00:00', value: 7.11 },
  { date: '2023-03-13T13:00:00', value: 38.39 },
  { date: '2023-03-13T14:00:00', value: 99.76 },
  { date: '2023-03-13T15:00:00', value: 92.1 },
  { date: '2023-03-13T16:00:00', value: 83.47 },
  { date: '2023-03-13T17:00:00', value: 68.13 },
  { date: '2023-03-13T18:00:00', value: 84.18 },
  { date: '2023-03-13T19:00:00', value: 37.91 },
  { date: '2023-03-13T20:00:00', value: 2.01 },
  { date: '2023-03-13T21:00:00', value: 13.52 },
  { date: '2023-03-13T22:00:00', value: 66.84 },
  { date: '2023-03-13T23:00:00', value: 85.08 },
  { date: '2023-03-14T00:00:00', value: 11.76 },
  { date: '2023-03-14T01:00:00', value: 16.15 },
  { date: '2023-03-14T02:00:00', value: 40.86 },
  { date: '2023-03-14T03:00:00', value: 47.08 },
  { date: '2023-03-14T04:00:00', value: 93.13 },
  { date: '2023-03-14T05:00:00', value: 10.02 },
  { date: '2023-03-14T06:00:00', value: 55.36 },
  { date: '2023-03-14T07:00:00', value: 77.92 },
  { date: '2023-03-14T08:00:00', value: 74.34 },
  { date: '2023-03-14T09:00:00', value: 70.21 },
  { date: '2023-03-14T10:00:00', value: 26.43 },
  { date: '2023-03-14T11:00:00', value: 14.02 },
  { date: '2023-03-14T12:00:00', value: 39.33 },
  { date: '2023-03-14T13:00:00', value: 69.01 },
  { date: '2023-03-14T14:00:00', value: 46.11 },
  { date: '2023-03-14T15:00:00', value: 86.03 },
  { date: '2023-03-14T16:00:00', value: 42.37 },
  { date: '2023-03-14T17:00:00', value: 73.74 },
  { date: '2023-03-14T18:00:00', value: 17.98 },
  { date: '2023-03-14T19:00:00', value: 45.84 },
  { date: '2023-03-14T20:00:00', value: 4.16 },
  { date: '2023-03-14T21:00:00', value: 49.04 },
  { date: '2023-03-14T22:00:00', value: 91.51 },
  { date: '2023-03-14T23:00:00', value: 61.01 },
  { date: '2023-03-15T00:00:00', value: 21.92 },
  { date: '2023-03-15T01:00:00', value: 44.18 },
  { date: '2023-03-15T02:00:00', value: 98.1 },
  { date: '2023-03-15T03:00:00', value: 97.76 },
  { date: '2023-03-15T04:00:00', value: 92.43 },
  { date: '2023-03-15T05:00:00', value: 42.68 },
  { date: '2023-03-15T06:00:00', value: 58.79 },
  { date: '2023-03-15T07:00:00', value: 27.11 },
  { date: '2023-03-15T08:00:00', value: 81.31 },
  { date: '2023-03-15T09:00:00', value: 28.95 },
  { date: '2023-03-15T10:00:00', value: 29.21 },
  { date: '2023-03-15T11:00:00', value: 30.01 },
  { date: '2023-03-15T12:00:00', value: 79.76 },
  { date: '2023-03-15T13:00:00', value: 25.29 },
  { date: '2023-03-15T14:00:00', value: 18.69 },
  { date: '2023-03-15T15:00:00', value: 17.65 },
  { date: '2023-03-15T16:00:00', value: 46.56 },
  { date: '2023-03-15T17:00:00', value: 28.29 },
  { date: '2023-03-15T18:00:00', value: 55.68 },
  { date: '2023-03-15T19:00:00', value: 95.84 },
  { date: '2023-03-15T20:00:00', value: 26.53 },
  { date: '2023-03-15T21:00:00', value: 68.1 },
  { date: '2023-03-15T22:00:00', value: 93.61 },
  { date: '2023-03-15T23:00:00', value: 88.44 },
  { date: '2023-03-16T00:00:00', value: 82.96 },
  { date: '2023-03-16T01:00:00', value: 29.14 },
  { date: '2023-03-16T02:00:00', value: 41.4 },
  { date: '2023-03-16T03:00:00', value: 40.92 },
  { date: '2023-03-16T04:00:00', value: 68.38 },
  { date: '2023-03-16T05:00:00', value: 27.15 },
  { date: '2023-03-16T06:00:00', value: 51.16 },
  { date: '2023-03-16T07:00:00', value: 23.3 },
  { date: '2023-03-16T08:00:00', value: 56.1 },
  { date: '2023-03-16T09:00:00', value: 30.45 },
  { date: '2023-03-16T10:00:00', value: 10.8 },
  { date: '2023-03-16T11:00:00', value: 76.83 },
  { date: '2023-03-16T12:00:00', value: 59.53 },
  { date: '2023-03-16T13:00:00', value: 18.4 },
  { date: '2023-03-16T14:00:00', value: 87.06 },
  { date: '2023-03-16T15:00:00', value: 74.68 },
  { date: '2023-03-16T16:00:00', value: 99.63 },
  { date: '2023-03-16T17:00:00', value: 24.29 },
  { date: '2023-03-16T18:00:00', value: 53.91 },
  { date: '2023-03-16T19:00:00', value: 51.05 },
  { date: '2023-03-16T20:00:00', value: 56.56 },
  { date: '2023-03-16T21:00:00', value: 78.67 },
  { date: '2023-03-16T22:00:00', value: 57.27 },
  { date: '2023-03-16T23:00:00', value: 85.28 },
  { date: '2023-03-17T00:00:00', value: 35.27 },
  { date: '2023-03-17T01:00:00', value: 67.07 },
  { date: '2023-03-17T02:00:00', value: 68.31 },
  { date: '2023-03-17T03:00:00', value: 33.1 },
  { date: '2023-03-17T04:00:00', value: 13.7 },
  { date: '2023-03-17T05:00:00', value: 77.74 },
  { date: '2023-03-17T06:00:00', value: 41.28 },
  { date: '2023-03-17T07:00:00', value: 15.87 },
  { date: '2023-03-17T08:00:00', value: 72.17 },
  { date: '2023-03-17T09:00:00', value: 22.37 },
  { date: '2023-03-17T10:00:00', value: 48.42 },
  { date: '2023-03-17T11:00:00', value: 26.14 },
  { date: '2023-03-17T12:00:00', value: 17.48 },
  { date: '2023-03-17T13:00:00', value: 41.88 },
  { date: '2023-03-17T14:00:00', value: 23.62 },
  { date: '2023-03-17T15:00:00', value: 8.65 },
  { date: '2023-03-17T16:00:00', value: 22.87 },
  { date: '2023-03-17T17:00:00', value: 48.17 },
  { date: '2023-03-17T18:00:00', value: 38.24 },
  { date: '2023-03-17T19:00:00', value: 18.58 },
  { date: '2023-03-17T20:00:00', value: 77.28 },
  { date: '2023-03-17T21:00:00', value: 52.5 },
  { date: '2023-03-17T22:00:00', value: 7.88 },
  { date: '2023-03-17T23:00:00', value: 87.63 },
  { date: '2023-03-18T00:00:00', value: 1.74 },
  { date: '2023-03-18T01:00:00', value: 32.22 },
  { date: '2023-03-18T02:00:00', value: 43.89 },
  { date: '2023-03-18T03:00:00', value: 54.62 },
  { date: '2023-03-18T04:00:00', value: 31.8 },
  { date: '2023-03-18T05:00:00', value: 83.19 },
  { date: '2023-03-18T06:00:00', value: 92.61 },
  { date: '2023-03-18T07:00:00', value: 97.4 },
  { date: '2023-03-18T08:00:00', value: 41.99 },
  { date: '2023-03-18T09:00:00', value: 42.62 },
  { date: '2023-03-18T10:00:00', value: 19.22 },
  { date: '2023-03-18T11:00:00', value: 8.14 },
  { date: '2023-03-18T12:00:00', value: 38.5 },
  { date: '2023-03-18T13:00:00', value: 48.69 },
  { date: '2023-03-18T14:00:00', value: 7.08 },
  { date: '2023-03-18T15:00:00', value: 33.74 },
  { date: '2023-03-18T16:00:00', value: 77.1 },
  { date: '2023-03-18T17:00:00', value: 33.01 },
  { date: '2023-03-18T18:00:00', value: 2.48 },
  { date: '2023-03-18T19:00:00', value: 50.76 },
  { date: '2023-03-18T20:00:00', value: 52.41 },
  { date: '2023-03-18T21:00:00', value: 80.69 },
  { date: '2023-03-18T22:00:00', value: 33.75 },
  { date: '2023-03-18T23:00:00', value: 44.76 },
  { date: '2023-03-19T00:00:00', value: 35.82 },
  { date: '2023-03-19T01:00:00', value: 19.3 },
  { date: '2023-03-19T02:00:00', value: 95.78 },
  { date: '2023-03-19T03:00:00', value: 52.27 },
  { date: '2023-03-19T04:00:00', value: 2.2 },
  { date: '2023-03-19T05:00:00', value: 52.77 },
  { date: '2023-03-19T06:00:00', value: 1.14 },
  { date: '2023-03-19T07:00:00', value: 49.39 },
  { date: '2023-03-19T08:00:00', value: 12.89 },
  { date: '2023-03-19T09:00:00', value: 7.21 },
  { date: '2023-03-19T10:00:00', value: 1.26 },
  { date: '2023-03-19T11:00:00', value: 64.74 },
  { date: '2023-03-19T12:00:00', value: 25.26 },
  { date: '2023-03-19T13:00:00', value: 32.23 },
  { date: '2023-03-19T14:00:00', value: 20.15 },
  { date: '2023-03-19T15:00:00', value: 98.79 },
  { date: '2023-03-19T16:00:00', value: 13.63 },
  { date: '2023-03-19T17:00:00', value: 17.6 },
  { date: '2023-03-19T18:00:00', value: 66.16 },
  { date: '2023-03-19T19:00:00', value: 53.25 },
  { date: '2023-03-19T20:00:00', value: 39.0 },
  { date: '2023-03-19T21:00:00', value: 63.76 },
  { date: '2023-03-19T22:00:00', value: 57.62 },
  { date: '2023-03-19T23:00:00', value: 94.85 },
  { date: '2023-03-20T00:00:00', value: 74.64 },
  { date: '2023-03-20T01:00:00', value: 69.57 },
  { date: '2023-03-20T02:00:00', value: 25.43 },
  { date: '2023-03-20T03:00:00', value: 62.57 },
  { date: '2023-03-20T04:00:00', value: 96.74 },
  { date: '2023-03-20T05:00:00', value: 10.67 },
  { date: '2023-03-20T06:00:00', value: 78.55 },
  { date: '2023-03-20T07:00:00', value: 44.18 },
  { date: '2023-03-20T08:00:00', value: 30.98 },
  { date: '2023-03-20T09:00:00', value: 66.97 },
  { date: '2023-03-20T10:00:00', value: 58.69 },
  { date: '2023-03-20T11:00:00', value: 66.61 },
  { date: '2023-03-20T12:00:00', value: 76.68 },
  { date: '2023-03-20T13:00:00', value: 73.65 },
  { date: '2023-03-20T14:00:00', value: 26.31 },
  { date: '2023-03-20T15:00:00', value: 42.92 },
  { date: '2023-03-20T16:00:00', value: 89.66 },
  { date: '2023-03-20T17:00:00', value: 5.8 },
  { date: '2023-03-20T18:00:00', value: 42.75 },
  { date: '2023-03-20T19:00:00', value: 47.03 },
  { date: '2023-03-20T20:00:00', value: 49.91 },
  { date: '2023-03-20T21:00:00', value: 4.1 },
  { date: '2023-03-20T22:00:00', value: 67.91 },
  { date: '2023-03-20T23:00:00', value: 92.93 },
  { date: '2023-03-21T00:00:00', value: 62.27 },
  { date: '2023-03-21T01:00:00', value: 40.33 },
  { date: '2023-03-21T02:00:00', value: 60.48 },
  { date: '2023-03-21T03:00:00', value: 16.93 },
  { date: '2023-03-21T04:00:00', value: 58.92 },
  { date: '2023-03-21T05:00:00', value: 61.78 },
  { date: '2023-03-21T06:00:00', value: 67.77 },
  { date: '2023-03-21T07:00:00', value: 1.08 },
  { date: '2023-03-21T08:00:00', value: 63.77 },
  { date: '2023-03-21T09:00:00', value: 40.32 },
  { date: '2023-03-21T10:00:00', value: 78.55 },
  { date: '2023-03-21T11:00:00', value: 23.7 },
  { date: '2023-03-21T12:00:00', value: 71.03 },
  { date: '2023-03-21T13:00:00', value: 96.56 },
  { date: '2023-03-21T14:00:00', value: 20.27 },
  { date: '2023-03-21T15:00:00', value: 62.19 },
  { date: '2023-03-21T16:00:00', value: 14.9 },
  { date: '2023-03-21T17:00:00', value: 77.93 },
  { date: '2023-03-21T18:00:00', value: 29.47 },
  { date: '2023-03-21T19:00:00', value: 15.98 },
  { date: '2023-03-21T20:00:00', value: 30.17 },
  { date: '2023-03-21T21:00:00', value: 20.87 },
  { date: '2023-03-21T22:00:00', value: 43.51 },
  { date: '2023-03-21T23:00:00', value: 53.83 },
  { date: '2023-03-22T00:00:00', value: 82.9 },
  { date: '2023-03-22T01:00:00', value: 28.55 },
  { date: '2023-03-22T02:00:00', value: 41.72 },
  { date: '2023-03-22T03:00:00', value: 74.14 },
  { date: '2023-03-22T04:00:00', value: 66.07 },
  { date: '2023-03-22T05:00:00', value: 6.47 },
  { date: '2023-03-22T06:00:00', value: 23.88 },
  { date: '2023-03-22T07:00:00', value: 86.0 },
  { date: '2023-03-22T08:00:00', value: 81.49 },
  { date: '2023-03-22T09:00:00', value: 38.2 },
  { date: '2023-03-22T10:00:00', value: 52.09 },
  { date: '2023-03-22T11:00:00', value: 77.58 },
  { date: '2023-03-22T12:00:00', value: 77.23 },
  { date: '2023-03-22T13:00:00', value: 23.16 },
  { date: '2023-03-22T14:00:00', value: 15.67 },
  { date: '2023-03-22T15:00:00', value: 82.8 },
  { date: '2023-03-22T16:00:00', value: 80.23 },
  { date: '2023-03-22T17:00:00', value: 29.57 },
  { date: '2023-03-22T18:00:00', value: 7.66 },
  { date: '2023-03-22T19:00:00', value: 74.26 },
  { date: '2023-03-22T20:00:00', value: 99.09 },
  { date: '2023-03-22T21:00:00', value: 37.84 },
  { date: '2023-03-22T22:00:00', value: 67.46 },
  { date: '2023-03-22T23:00:00', value: 31.09 },
  { date: '2023-03-23T00:00:00', value: 32.56 },
  { date: '2023-03-23T01:00:00', value: 27.25 },
  { date: '2023-03-23T02:00:00', value: 44.8 },
  { date: '2023-03-23T03:00:00', value: 73.93 },
  { date: '2023-03-23T04:00:00', value: 78.74 },
  { date: '2023-03-23T05:00:00', value: 84.17 },
  { date: '2023-03-23T06:00:00', value: 52.05 },
  { date: '2023-03-23T07:00:00', value: 15.94 },
  { date: '2023-03-23T08:00:00', value: 44.5 },
  { date: '2023-03-23T09:00:00', value: 7.11 },
  { date: '2023-03-23T10:00:00', value: 7.83 },
  { date: '2023-03-23T11:00:00', value: 38.35 },
  { date: '2023-03-23T12:00:00', value: 37.2 },
  { date: '2023-03-23T13:00:00', value: 43.97 },
  { date: '2023-03-23T14:00:00', value: 51.39 },
  { date: '2023-03-23T15:00:00', value: 46.06 },
  { date: '2023-03-23T16:00:00', value: 5.96 },
  { date: '2023-03-23T17:00:00', value: 92.33 },
  { date: '2023-03-23T18:00:00', value: 40.68 },
  { date: '2023-03-23T19:00:00', value: 98.56 },
  { date: '2023-03-23T20:00:00', value: 6.22 },
  { date: '2023-03-23T21:00:00', value: 86.89 },
  { date: '2023-03-23T22:00:00', value: 46.14 },
  { date: '2023-03-23T23:00:00', value: 94.55 },
  { date: '2023-03-24T00:00:00', value: 10.39 },
  { date: '2023-03-24T01:00:00', value: 41.99 },
  { date: '2023-03-24T02:00:00', value: 49.35 },
  { date: '2023-03-24T03:00:00', value: 17.15 },
  { date: '2023-03-24T04:00:00', value: 16.1 },
  { date: '2023-03-24T05:00:00', value: 83.2 },
  { date: '2023-03-24T06:00:00', value: 77.66 },
  { date: '2023-03-24T07:00:00', value: 63.11 },
  { date: '2023-03-24T08:00:00', value: 85.09 },
  { date: '2023-03-24T09:00:00', value: 5.24 },
  { date: '2023-03-24T10:00:00', value: 99.24 },
  { date: '2023-03-24T11:00:00', value: 91.62 },
  { date: '2023-03-24T12:00:00', value: 29.93 },
  { date: '2023-03-24T13:00:00', value: 70.96 },
  { date: '2023-03-24T14:00:00', value: 20.48 },
  { date: '2023-03-24T15:00:00', value: 76.79 },
  { date: '2023-03-24T16:00:00', value: 85.94 },
  { date: '2023-03-24T17:00:00', value: 54.5 },
  { date: '2023-03-24T18:00:00', value: 9.61 },
  { date: '2023-03-24T19:00:00', value: 4.9 },
  { date: '2023-03-24T20:00:00', value: 51.99 },
  { date: '2023-03-24T21:00:00', value: 21.68 },
  { date: '2023-03-24T22:00:00', value: 98.4 },
  { date: '2023-03-24T23:00:00', value: 95.64 },
  { date: '2023-03-25T00:00:00', value: 35.44 },
  { date: '2023-03-25T01:00:00', value: 11.12 },
  { date: '2023-03-25T02:00:00', value: 40.95 },
  { date: '2023-03-25T03:00:00', value: 69.37 },
  { date: '2023-03-25T04:00:00', value: 42.78 },
  { date: '2023-03-25T05:00:00', value: 52.77 },
  { date: '2023-03-25T06:00:00', value: 68.59 },
  { date: '2023-03-25T07:00:00', value: 91.92 },
  { date: '2023-03-25T08:00:00', value: 7.79 },
  { date: '2023-03-25T09:00:00', value: 99.15 },
  { date: '2023-03-25T10:00:00', value: 47.74 },
  { date: '2023-03-25T11:00:00', value: 70.59 },
  { date: '2023-03-25T12:00:00', value: 23.82 },
  { date: '2023-03-25T13:00:00', value: 3.17 },
  { date: '2023-03-25T14:00:00', value: 81.21 },
  { date: '2023-03-25T15:00:00', value: 33.1 },
  { date: '2023-03-25T16:00:00', value: 97.71 },
  { date: '2023-03-25T17:00:00', value: 56.11 },
  { date: '2023-03-25T18:00:00', value: 7.16 },
  { date: '2023-03-25T19:00:00', value: 50.53 },
  { date: '2023-03-25T20:00:00', value: 69.33 },
  { date: '2023-03-25T21:00:00', value: 63.87 },
  { date: '2023-03-25T22:00:00', value: 87.29 },
  { date: '2023-03-25T23:00:00', value: 76.23 },
  { date: '2023-03-26T00:00:00', value: 83.17 },
  { date: '2023-03-26T01:00:00', value: 23.64 },
  { date: '2023-03-26T02:00:00', value: 35.38 },
  { date: '2023-03-26T03:00:00', value: 5.23 },
  { date: '2023-03-26T04:00:00', value: 96.72 },
  { date: '2023-03-26T05:00:00', value: 71.76 },
  { date: '2023-03-26T06:00:00', value: 83.79 },
  { date: '2023-03-26T07:00:00', value: 79.24 },
  { date: '2023-03-26T08:00:00', value: 88.08 },
  { date: '2023-03-26T09:00:00', value: 15.27 },
  { date: '2023-03-26T10:00:00', value: 18.56 },
  { date: '2023-03-26T11:00:00', value: 90.69 },
  { date: '2023-03-26T12:00:00', value: 56.45 },
  { date: '2023-03-26T13:00:00', value: 92.99 },
  { date: '2023-03-26T14:00:00', value: 84.88 },
  { date: '2023-03-26T15:00:00', value: 83.82 },
  { date: '2023-03-26T16:00:00', value: 41.48 },
  { date: '2023-03-26T17:00:00', value: 45.41 },
  { date: '2023-03-26T18:00:00', value: 24.67 },
  { date: '2023-03-26T19:00:00', value: 95.57 },
  { date: '2023-03-26T20:00:00', value: 46.76 },
  { date: '2023-03-26T21:00:00', value: 73.08 },
  { date: '2023-03-26T22:00:00', value: 33.19 },
  { date: '2023-03-26T23:00:00', value: 60.64 },
  { date: '2023-03-27T00:00:00', value: 79.53 },
  { date: '2023-03-27T01:00:00', value: 39.95 },
  { date: '2023-03-27T02:00:00', value: 63.57 },
  { date: '2023-03-27T03:00:00', value: 60.1 },
  { date: '2023-03-27T04:00:00', value: 89.72 },
  { date: '2023-03-27T05:00:00', value: 48.33 },
  { date: '2023-03-27T06:00:00', value: 43.66 },
  { date: '2023-03-27T07:00:00', value: 46.63 },
  { date: '2023-03-27T08:00:00', value: 86.33 },
  { date: '2023-03-27T09:00:00', value: 7.17 },
  { date: '2023-03-27T10:00:00', value: 98.54 },
  { date: '2023-03-27T11:00:00', value: 41.76 },
  { date: '2023-03-27T12:00:00', value: 77.31 },
  { date: '2023-03-27T13:00:00', value: 41.23 },
  { date: '2023-03-27T14:00:00', value: 95.83 },
  { date: '2023-03-27T15:00:00', value: 4.6 },
  { date: '2023-03-27T16:00:00', value: 42.76 },
  { date: '2023-03-27T17:00:00', value: 46.3 },
  { date: '2023-03-27T18:00:00', value: 54.67 },
  { date: '2023-03-27T19:00:00', value: 51.49 },
  { date: '2023-03-27T20:00:00', value: 51.98 },
  { date: '2023-03-27T21:00:00', value: 54.0 },
  { date: '2023-03-27T22:00:00', value: 6.79 },
  { date: '2023-03-27T23:00:00', value: 51.01 },
  { date: '2023-03-28T00:00:00', value: 73.31 },
  { date: '2023-03-28T01:00:00', value: 29.87 },
  { date: '2023-03-28T02:00:00', value: 84.34 },
  { date: '2023-03-28T03:00:00', value: 38.69 },
  { date: '2023-03-28T04:00:00', value: 11.65 },
  { date: '2023-03-28T05:00:00', value: 8.78 },
  { date: '2023-03-28T06:00:00', value: 89.82 },
  { date: '2023-03-28T07:00:00', value: 20.61 },
  { date: '2023-03-28T08:00:00', value: 8.48 },
  { date: '2023-03-28T09:00:00', value: 82.75 },
  { date: '2023-03-28T10:00:00', value: 74.99 },
  { date: '2023-03-28T11:00:00', value: 67.62 },
  { date: '2023-03-28T12:00:00', value: 51.59 },
  { date: '2023-03-28T13:00:00', value: 79.2 },
  { date: '2023-03-28T14:00:00', value: 59.56 },
  { date: '2023-03-28T15:00:00', value: 53.41 },
  { date: '2023-03-28T16:00:00', value: 84.83 },
  { date: '2023-03-28T17:00:00', value: 93.14 },
  { date: '2023-03-28T18:00:00', value: 62.33 },
  { date: '2023-03-28T19:00:00', value: 28.26 },
  { date: '2023-03-28T20:00:00', value: 10.67 },
  { date: '2023-03-28T21:00:00', value: 79.73 },
  { date: '2023-03-28T22:00:00', value: 60.53 },
  { date: '2023-03-28T23:00:00', value: 60.75 },
  { date: '2023-03-29T00:00:00', value: 52.72 },
  { date: '2023-03-29T01:00:00', value: 44.71 },
  { date: '2023-03-29T02:00:00', value: 42.0 },
  { date: '2023-03-29T03:00:00', value: 8.15 },
  { date: '2023-03-29T04:00:00', value: 28.46 },
  { date: '2023-03-29T05:00:00', value: 45.72 },
  { date: '2023-03-29T06:00:00', value: 19.49 },
  { date: '2023-03-29T07:00:00', value: 45.46 },
  { date: '2023-03-29T08:00:00', value: 74.81 },
  { date: '2023-03-29T09:00:00', value: 96.68 },
  { date: '2023-03-29T10:00:00', value: 69.13 },
  { date: '2023-03-29T11:00:00', value: 25.01 },
  { date: '2023-03-29T12:00:00', value: 47.85 },
  { date: '2023-03-29T13:00:00', value: 32.59 },
  { date: '2023-03-29T14:00:00', value: 40.05 },
  { date: '2023-03-29T15:00:00', value: 19.2 },
  { date: '2023-03-29T16:00:00', value: 13.64 },
  { date: '2023-03-29T17:00:00', value: 83.13 },
  { date: '2023-03-29T18:00:00', value: 19.8 },
  { date: '2023-03-29T19:00:00', value: 84.6 },
  { date: '2023-03-29T20:00:00', value: 79.39 },
  { date: '2023-03-29T21:00:00', value: 13.14 },
  { date: '2023-03-29T22:00:00', value: 66.69 },
  { date: '2023-03-29T23:00:00', value: 56.18 },
  { date: '2023-03-30T00:00:00', value: 31.76 },
  { date: '2023-03-30T01:00:00', value: 42.62 },
  { date: '2023-03-30T02:00:00', value: 66.27 },
  { date: '2023-03-30T03:00:00', value: 29.9 },
  { date: '2023-03-30T04:00:00', value: 38.78 },
  { date: '2023-03-30T05:00:00', value: 88.76 },
  { date: '2023-03-30T06:00:00', value: 61.59 },
  { date: '2023-03-30T07:00:00', value: 56.12 },
  { date: '2023-03-30T08:00:00', value: 34.49 },
  { date: '2023-03-30T09:00:00', value: 57.98 },
  { date: '2023-03-30T10:00:00', value: 58.12 },
  { date: '2023-03-30T11:00:00', value: 15.21 },
  { date: '2023-03-30T12:00:00', value: 3.93 },
  { date: '2023-03-30T13:00:00', value: 31.86 },
  { date: '2023-03-30T14:00:00', value: 90.74 },
  { date: '2023-03-30T15:00:00', value: 51.74 },
  { date: '2023-03-30T16:00:00', value: 46.84 },
  { date: '2023-03-30T17:00:00', value: 41.91 },
  { date: '2023-03-30T18:00:00', value: 89.71 },
  { date: '2023-03-30T19:00:00', value: 83.59 },
  { date: '2023-03-30T20:00:00', value: 5.63 },
  { date: '2023-03-30T21:00:00', value: 51.07 },
  { date: '2023-03-30T22:00:00', value: 41.05 },
  { date: '2023-03-30T23:00:00', value: 17.3 },
  { date: '2023-03-31T00:00:00', value: 32.43 },
  { date: '2023-03-31T01:00:00', value: 46.86 },
  { date: '2023-03-31T02:00:00', value: 58.25 },
  { date: '2023-03-31T03:00:00', value: 27.41 },
  { date: '2023-03-31T04:00:00', value: 94.13 },
  { date: '2023-03-31T05:00:00', value: 78.09 },
  { date: '2023-03-31T06:00:00', value: 53.47 },
  { date: '2023-03-31T07:00:00', value: 52.39 },
  { date: '2023-03-31T08:00:00', value: 44.35 },
  { date: '2023-03-31T09:00:00', value: 8.79 },
  { date: '2023-03-31T10:00:00', value: 76.39 },
  { date: '2023-03-31T11:00:00', value: 28.84 },
  { date: '2023-03-31T12:00:00', value: 10.65 },
  { date: '2023-03-31T13:00:00', value: 88.95 },
  { date: '2023-03-31T14:00:00', value: 42.8 },
  { date: '2023-03-31T15:00:00', value: 8.68 },
  { date: '2023-03-31T16:00:00', value: 82.45 },
  { date: '2023-03-31T17:00:00', value: 93.73 },
  { date: '2023-03-31T18:00:00', value: 21.04 },
  { date: '2023-03-31T19:00:00', value: 54.67 },
  { date: '2023-03-31T20:00:00', value: 2.69 },
  { date: '2023-03-31T21:00:00', value: 19.99 },
  { date: '2023-03-31T22:00:00', value: 87.91 },
  { date: '2023-03-31T23:00:00', value: 40.54 },
  { date: '2023-04-01T00:00:00', value: 67.38 },
  { date: '2023-04-01T01:00:00', value: 31.61 },
  { date: '2023-04-01T02:00:00', value: 19.15 },
  { date: '2023-04-01T03:00:00', value: 26.86 },
  { date: '2023-04-01T04:00:00', value: 52.48 },
  { date: '2023-04-01T05:00:00', value: 37.0 },
  { date: '2023-04-01T06:00:00', value: 40.54 },
  { date: '2023-04-01T07:00:00', value: 50.23 },
  { date: '2023-04-01T08:00:00', value: 13.72 },
  { date: '2023-04-01T09:00:00', value: 65.73 },
  { date: '2023-04-01T10:00:00', value: 32.38 },
  { date: '2023-04-01T11:00:00', value: 10.9 },
  { date: '2023-04-01T12:00:00', value: 50.2 },
  { date: '2023-04-01T13:00:00', value: 74.37 },
  { date: '2023-04-01T14:00:00', value: 61.76 },
  { date: '2023-04-01T15:00:00', value: 23.28 },
  { date: '2023-04-01T16:00:00', value: 48.14 },
  { date: '2023-04-01T17:00:00', value: 58.69 },
  { date: '2023-04-01T18:00:00', value: 33.58 },
  { date: '2023-04-01T19:00:00', value: 80.26 },
  { date: '2023-04-01T20:00:00', value: 3.49 },
  { date: '2023-04-01T21:00:00', value: 81.04 },
  { date: '2023-04-01T22:00:00', value: 49.13 },
  { date: '2023-04-01T23:00:00', value: 61.7 },
  { date: '2023-04-02T00:00:00', value: 18.99 },
  { date: '2023-04-02T01:00:00', value: 87.55 },
  { date: '2023-04-02T02:00:00', value: 5.55 },
  { date: '2023-04-02T03:00:00', value: 50.31 },
  { date: '2023-04-02T04:00:00', value: 70.05 },
  { date: '2023-04-02T05:00:00', value: 66.17 },
  { date: '2023-04-02T06:00:00', value: 50.45 },
  { date: '2023-04-02T07:00:00', value: 14.24 },
  { date: '2023-04-02T08:00:00', value: 93.0 },
  { date: '2023-04-02T09:00:00', value: 96.08 },
  { date: '2023-04-02T10:00:00', value: 10.05 },
  { date: '2023-04-02T11:00:00', value: 93.63 },
  { date: '2023-04-02T12:00:00', value: 86.83 },
  { date: '2023-04-02T13:00:00', value: 77.57 },
  { date: '2023-04-02T14:00:00', value: 89.7 },
  { date: '2023-04-02T15:00:00', value: 71.58 },
  { date: '2023-04-02T16:00:00', value: 11.61 },
  { date: '2023-04-02T17:00:00', value: 19.98 },
  { date: '2023-04-02T18:00:00', value: 80.84 },
  { date: '2023-04-02T19:00:00', value: 96.94 },
  { date: '2023-04-02T20:00:00', value: 63.78 },
  { date: '2023-04-02T21:00:00', value: 39.32 },
  { date: '2023-04-02T22:00:00', value: 6.69 },
  { date: '2023-04-02T23:00:00', value: 28.65 },
  { date: '2023-04-03T00:00:00', value: 60.44 },
  { date: '2023-04-03T01:00:00', value: 32.39 },
  { date: '2023-04-03T02:00:00', value: 46.0 },
  { date: '2023-04-03T03:00:00', value: 31.5 },
  { date: '2023-04-03T04:00:00', value: 26.05 },
  { date: '2023-04-03T05:00:00', value: 36.24 },
  { date: '2023-04-03T06:00:00', value: 1.08 },
  { date: '2023-04-03T07:00:00', value: 3.95 },
  { date: '2023-04-03T08:00:00', value: 94.54 },
  { date: '2023-04-03T09:00:00', value: 86.48 },
  { date: '2023-04-03T10:00:00', value: 16.6 },
  { date: '2023-04-03T11:00:00', value: 64.84 },
  { date: '2023-04-03T12:00:00', value: 80.15 },
  { date: '2023-04-03T13:00:00', value: 58.71 },
  { date: '2023-04-03T14:00:00', value: 33.55 },
  { date: '2023-04-03T15:00:00', value: 82.35 },
  { date: '2023-04-03T16:00:00', value: 27.78 },
  { date: '2023-04-03T17:00:00', value: 53.16 },
  { date: '2023-04-03T18:00:00', value: 16.15 },
  { date: '2023-04-03T19:00:00', value: 33.32 },
  { date: '2023-04-03T20:00:00', value: 51.88 },
  { date: '2023-04-03T21:00:00', value: 6.98 },
  { date: '2023-04-03T22:00:00', value: 3.65 },
  { date: '2023-04-03T23:00:00', value: 78.27 },
  { date: '2023-04-04T00:00:00', value: 44.38 },
  { date: '2023-04-04T01:00:00', value: 69.99 },
  { date: '2023-04-04T02:00:00', value: 26.86 },
  { date: '2023-04-04T03:00:00', value: 66.94 },
  { date: '2023-04-04T04:00:00', value: 67.43 },
  { date: '2023-04-04T05:00:00', value: 80.39 },
  { date: '2023-04-04T06:00:00', value: 41.91 },
  { date: '2023-04-04T07:00:00', value: 13.79 },
  { date: '2023-04-04T08:00:00', value: 61.46 },
  { date: '2023-04-04T09:00:00', value: 71.81 },
  { date: '2023-04-04T10:00:00', value: 79.17 },
  { date: '2023-04-04T11:00:00', value: 23.08 },
  { date: '2023-04-04T12:00:00', value: 96.97 },
  { date: '2023-04-04T13:00:00', value: 78.31 },
  { date: '2023-04-04T14:00:00', value: 28.96 },
  { date: '2023-04-04T15:00:00', value: 39.1 },
  { date: '2023-04-04T16:00:00', value: 91.09 },
  { date: '2023-04-04T17:00:00', value: 49.81 },
  { date: '2023-04-04T18:00:00', value: 24.61 },
  { date: '2023-04-04T19:00:00', value: 7.65 },
  { date: '2023-04-04T20:00:00', value: 64.04 },
  { date: '2023-04-04T21:00:00', value: 86.19 },
  { date: '2023-04-04T22:00:00', value: 58.47 },
  { date: '2023-04-04T23:00:00', value: 84.28 },
  { date: '2023-04-05T00:00:00', value: 44.72 },
  { date: '2023-04-05T01:00:00', value: 49.51 },
  { date: '2023-04-05T02:00:00', value: 1.89 },
  { date: '2023-04-05T03:00:00', value: 9.61 },
  { date: '2023-04-05T04:00:00', value: 57.89 },
  { date: '2023-04-05T05:00:00', value: 11.59 },
  { date: '2023-04-05T06:00:00', value: 58.04 },
  { date: '2023-04-05T07:00:00', value: 29.38 },
  { date: '2023-04-05T08:00:00', value: 94.78 },
  { date: '2023-04-05T09:00:00', value: 48.32 },
  { date: '2023-04-05T10:00:00', value: 84.2 },
  { date: '2023-04-05T11:00:00', value: 87.93 },
  { date: '2023-04-05T12:00:00', value: 40.0 },
  { date: '2023-04-05T13:00:00', value: 94.87 },
  { date: '2023-04-05T14:00:00', value: 52.26 },
  { date: '2023-04-05T15:00:00', value: 4.2 },
  { date: '2023-04-05T16:00:00', value: 62.84 },
  { date: '2023-04-05T17:00:00', value: 51.09 },
  { date: '2023-04-05T18:00:00', value: 46.09 },
  { date: '2023-04-05T19:00:00', value: 22.01 },
  { date: '2023-04-05T20:00:00', value: 24.4 },
  { date: '2023-04-05T21:00:00', value: 74.67 },
  { date: '2023-04-05T22:00:00', value: 54.64 },
  { date: '2023-04-05T23:00:00', value: 49.92 },
  { date: '2023-04-06T00:00:00', value: 83.32 },
  { date: '2023-04-06T01:00:00', value: 42.57 },
  { date: '2023-04-06T02:00:00', value: 73.24 },
  { date: '2023-04-06T03:00:00', value: 59.66 },
  { date: '2023-04-06T04:00:00', value: 5.97 },
  { date: '2023-04-06T05:00:00', value: 76.9 },
  { date: '2023-04-06T06:00:00', value: 77.05 },
  { date: '2023-04-06T07:00:00', value: 30.73 },
  { date: '2023-04-06T08:00:00', value: 61.65 },
  { date: '2023-04-06T09:00:00', value: 10.92 },
  { date: '2023-04-06T10:00:00', value: 69.05 },
  { date: '2023-04-06T11:00:00', value: 85.62 },
  { date: '2023-04-06T12:00:00', value: 32.62 },
  { date: '2023-04-06T13:00:00', value: 23.28 },
  { date: '2023-04-06T14:00:00', value: 21.14 },
  { date: '2023-04-06T15:00:00', value: 96.32 },
  { date: '2023-04-06T16:00:00', value: 73.97 },
  { date: '2023-04-06T17:00:00', value: 5.55 },
  { date: '2023-04-06T18:00:00', value: 55.96 },
  { date: '2023-04-06T19:00:00', value: 84.86 },
  { date: '2023-04-06T20:00:00', value: 71.28 },
  { date: '2023-04-06T21:00:00', value: 80.44 },
  { date: '2023-04-06T22:00:00', value: 24.15 },
  { date: '2023-04-06T23:00:00', value: 14.88 },
  { date: '2023-04-07T00:00:00', value: 36.51 },
  { date: '2023-04-07T01:00:00', value: 13.36 },
  { date: '2023-04-07T02:00:00', value: 46.1 },
  { date: '2023-04-07T03:00:00', value: 42.98 },
  { date: '2023-04-07T04:00:00', value: 24.65 },
  { date: '2023-04-07T05:00:00', value: 97.58 },
  { date: '2023-04-07T06:00:00', value: 50.5 },
  { date: '2023-04-07T07:00:00', value: 26.79 },
  { date: '2023-04-07T08:00:00', value: 24.15 },
  { date: '2023-04-07T09:00:00', value: 35.92 },
  { date: '2023-04-07T10:00:00', value: 67.56 },
  { date: '2023-04-07T11:00:00', value: 17.21 },
  { date: '2023-04-07T12:00:00', value: 77.51 },
  { date: '2023-04-07T13:00:00', value: 86.18 },
  { date: '2023-04-07T14:00:00', value: 3.9 },
  { date: '2023-04-07T15:00:00', value: 24.65 },
  { date: '2023-04-07T16:00:00', value: 54.1 },
  { date: '2023-04-07T17:00:00', value: 92.33 },
  { date: '2023-04-07T18:00:00', value: 75.4 },
  { date: '2023-04-07T19:00:00', value: 54.62 },
  { date: '2023-04-07T20:00:00', value: 81.7 },
  { date: '2023-04-07T21:00:00', value: 44.41 },
  { date: '2023-04-07T22:00:00', value: 31.23 },
  { date: '2023-04-07T23:00:00', value: 30.35 },
  { date: '2023-04-08T00:00:00', value: 10.72 },
  { date: '2023-04-08T01:00:00', value: 90.52 },
  { date: '2023-04-08T02:00:00', value: 50.65 },
  { date: '2023-04-08T03:00:00', value: 58.44 },
  { date: '2023-04-08T04:00:00', value: 47.13 },
  { date: '2023-04-08T05:00:00', value: 26.69 },
  { date: '2023-04-08T06:00:00', value: 99.91 },
  { date: '2023-04-08T07:00:00', value: 11.44 },
  { date: '2023-04-08T08:00:00', value: 63.62 },
  { date: '2023-04-08T09:00:00', value: 78.67 },
  { date: '2023-04-08T10:00:00', value: 72.25 },
  { date: '2023-04-08T11:00:00', value: 1.91 },
  { date: '2023-04-08T12:00:00', value: 47.41 },
  { date: '2023-04-08T13:00:00', value: 29.71 },
  { date: '2023-04-08T14:00:00', value: 26.28 },
  { date: '2023-04-08T15:00:00', value: 35.89 },
  { date: '2023-04-08T16:00:00', value: 33.27 },
  { date: '2023-04-08T17:00:00', value: 69.68 },
  { date: '2023-04-08T18:00:00', value: 29.14 },
  { date: '2023-04-08T19:00:00', value: 57.29 },
  { date: '2023-04-08T20:00:00', value: 30.58 },
  { date: '2023-04-08T21:00:00', value: 16.0 },
  { date: '2023-04-08T22:00:00', value: 50.92 },
  { date: '2023-04-08T23:00:00', value: 93.98 },
  { date: '2023-04-09T00:00:00', value: 11.96 },
  { date: '2023-04-09T01:00:00', value: 29.8 },
  { date: '2023-04-09T02:00:00', value: 65.2 },
  { date: '2023-04-09T03:00:00', value: 21.19 },
  { date: '2023-04-09T04:00:00', value: 98.47 },
  { date: '2023-04-09T05:00:00', value: 43.96 },
  { date: '2023-04-09T06:00:00', value: 17.11 },
  { date: '2023-04-09T07:00:00', value: 10.28 },
  { date: '2023-04-09T08:00:00', value: 32.91 },
  { date: '2023-04-09T09:00:00', value: 54.66 },
  { date: '2023-04-09T10:00:00', value: 40.55 },
  { date: '2023-04-09T11:00:00', value: 33.43 },
  { date: '2023-04-09T12:00:00', value: 71.05 },
  { date: '2023-04-09T13:00:00', value: 51.03 },
  { date: '2023-04-09T14:00:00', value: 86.45 },
  { date: '2023-04-09T15:00:00', value: 23.81 },
  { date: '2023-04-09T16:00:00', value: 82.61 },
  { date: '2023-04-09T17:00:00', value: 3.1 },
  { date: '2023-04-09T18:00:00', value: 18.52 },
  { date: '2023-04-09T19:00:00', value: 65.0 },
  { date: '2023-04-09T20:00:00', value: 34.05 },
  { date: '2023-04-09T21:00:00', value: 24.39 },
  { date: '2023-04-09T22:00:00', value: 34.14 },
  { date: '2023-04-09T23:00:00', value: 78.44 },
  { date: '2023-04-10T00:00:00', value: 1.04 },
  { date: '2023-04-10T01:00:00', value: 29.79 },
  { date: '2023-04-10T02:00:00', value: 45.0 },
  { date: '2023-04-10T03:00:00', value: 53.13 },
  { date: '2023-04-10T04:00:00', value: 77.98 },
  { date: '2023-04-10T05:00:00', value: 69.98 },
  { date: '2023-04-10T06:00:00', value: 91.9 },
  { date: '2023-04-10T07:00:00', value: 4.86 },
  { date: '2023-04-10T08:00:00', value: 58.46 },
  { date: '2023-04-10T09:00:00', value: 22.31 },
  { date: '2023-04-10T10:00:00', value: 52.72 },
  { date: '2023-04-10T11:00:00', value: 25.87 },
  { date: '2023-04-10T12:00:00', value: 69.66 },
  { date: '2023-04-10T13:00:00', value: 47.51 },
  { date: '2023-04-10T14:00:00', value: 57.53 },
  { date: '2023-04-10T15:00:00', value: 64.29 },
  { date: '2023-04-10T16:00:00', value: 38.27 },
  { date: '2023-04-10T17:00:00', value: 52.97 },
  { date: '2023-04-10T18:00:00', value: 37.3 },
  { date: '2023-04-10T19:00:00', value: 18.58 },
  { date: '2023-04-10T20:00:00', value: 35.69 },
  { date: '2023-04-10T21:00:00', value: 46.87 },
  { date: '2023-04-10T22:00:00', value: 41.71 },
  { date: '2023-04-10T23:00:00', value: 72.92 },
  { date: '2023-04-11T00:00:00', value: 6.9 },
  { date: '2023-04-11T01:00:00', value: 81.53 },
  { date: '2023-04-11T02:00:00', value: 38.09 },
  { date: '2023-04-11T03:00:00', value: 78.22 },
  { date: '2023-04-11T04:00:00', value: 92.65 },
  { date: '2023-04-11T05:00:00', value: 77.59 },
  { date: '2023-04-11T06:00:00', value: 33.82 },
  { date: '2023-04-11T07:00:00', value: 69.17 },
  { date: '2023-04-11T08:00:00', value: 96.67 },
  { date: '2023-04-11T09:00:00', value: 8.94 },
  { date: '2023-04-11T10:00:00', value: 78.82 },
  { date: '2023-04-11T11:00:00', value: 18.8 },
  { date: '2023-04-11T12:00:00', value: 8.25 },
  { date: '2023-04-11T13:00:00', value: 82.65 },
  { date: '2023-04-11T14:00:00', value: 84.32 },
  { date: '2023-04-11T15:00:00', value: 34.36 },
  { date: '2023-04-11T16:00:00', value: 51.86 },
  { date: '2023-04-11T17:00:00', value: 59.17 },
  { date: '2023-04-11T18:00:00', value: 52.62 },
  { date: '2023-04-11T19:00:00', value: 45.89 },
  { date: '2023-04-11T20:00:00', value: 10.04 },
  { date: '2023-04-11T21:00:00', value: 70.58 },
  { date: '2023-04-11T22:00:00', value: 46.47 },
  { date: '2023-04-11T23:00:00', value: 94.98 },
  { date: '2023-04-12T00:00:00', value: 58.76 },
  { date: '2023-04-12T01:00:00', value: 13.57 },
  { date: '2023-04-12T02:00:00', value: 62.82 },
  { date: '2023-04-12T03:00:00', value: 65.88 },
  { date: '2023-04-12T04:00:00', value: 42.15 },
  { date: '2023-04-12T05:00:00', value: 84.78 },
  { date: '2023-04-12T06:00:00', value: 35.58 },
  { date: '2023-04-12T07:00:00', value: 2.22 },
  { date: '2023-04-12T08:00:00', value: 36.65 },
  { date: '2023-04-12T09:00:00', value: 12.56 },
  { date: '2023-04-12T10:00:00', value: 39.29 },
  { date: '2023-04-12T11:00:00', value: 8.08 },
  { date: '2023-04-12T12:00:00', value: 71.08 },
  { date: '2023-04-12T13:00:00', value: 47.68 },
  { date: '2023-04-12T14:00:00', value: 84.49 },
  { date: '2023-04-12T15:00:00', value: 12.27 },
  { date: '2023-04-12T16:00:00', value: 37.29 },
  { date: '2023-04-12T17:00:00', value: 16.93 },
  { date: '2023-04-12T18:00:00', value: 76.93 },
  { date: '2023-04-12T19:00:00', value: 30.05 },
  { date: '2023-04-12T20:00:00', value: 64.3 },
  { date: '2023-04-12T21:00:00', value: 17.91 },
  { date: '2023-04-12T22:00:00', value: 50.1 },
  { date: '2023-04-12T23:00:00', value: 5.8 },
  { date: '2023-04-13T00:00:00', value: 85.65 },
  { date: '2023-04-13T01:00:00', value: 67.09 },
  { date: '2023-04-13T02:00:00', value: 38.25 },
  { date: '2023-04-13T03:00:00', value: 60.08 },
  { date: '2023-04-13T04:00:00', value: 86.02 },
  { date: '2023-04-13T05:00:00', value: 24.64 },
  { date: '2023-04-13T06:00:00', value: 98.69 },
  { date: '2023-04-13T07:00:00', value: 28.37 },
  { date: '2023-04-13T08:00:00', value: 86.77 },
  { date: '2023-04-13T09:00:00', value: 51.71 },
  { date: '2023-04-13T10:00:00', value: 62.15 },
  { date: '2023-04-13T11:00:00', value: 30.36 },
  { date: '2023-04-13T12:00:00', value: 98.79 },
  { date: '2023-04-13T13:00:00', value: 85.54 },
  { date: '2023-04-13T14:00:00', value: 37.74 },
  { date: '2023-04-13T15:00:00', value: 78.99 },
  { date: '2023-04-13T16:00:00', value: 66.94 },
  { date: '2023-04-13T17:00:00', value: 82.73 },
  { date: '2023-04-13T18:00:00', value: 46.57 },
  { date: '2023-04-13T19:00:00', value: 4.33 },
  { date: '2023-04-13T20:00:00', value: 78.7 },
  { date: '2023-04-13T21:00:00', value: 81.81 },
  { date: '2023-04-13T22:00:00', value: 30.85 },
  { date: '2023-04-13T23:00:00', value: 83.88 },
  { date: '2023-04-14T00:00:00', value: 86.58 },
  { date: '2023-04-14T01:00:00', value: 56.68 },
  { date: '2023-04-14T02:00:00', value: 76.09 },
  { date: '2023-04-14T03:00:00', value: 20.25 },
  { date: '2023-04-14T04:00:00', value: 28.67 },
  { date: '2023-04-14T05:00:00', value: 9.75 },
  { date: '2023-04-14T06:00:00', value: 59.37 },
  { date: '2023-04-14T07:00:00', value: 77.63 },
  { date: '2023-04-14T08:00:00', value: 95.59 },
  { date: '2023-04-14T09:00:00', value: 50.36 },
  { date: '2023-04-14T10:00:00', value: 63.46 },
  { date: '2023-04-14T11:00:00', value: 34.44 },
  { date: '2023-04-14T12:00:00', value: 23.39 },
  { date: '2023-04-14T13:00:00', value: 93.73 },
  { date: '2023-04-14T14:00:00', value: 71.07 },
  { date: '2023-04-14T15:00:00', value: 17.43 },
  { date: '2023-04-14T16:00:00', value: 2.18 },
  { date: '2023-04-14T17:00:00', value: 79.99 },
  { date: '2023-04-14T18:00:00', value: 97.0 },
  { date: '2023-04-14T19:00:00', value: 11.7 },
  { date: '2023-04-14T20:00:00', value: 83.36 },
  { date: '2023-04-14T21:00:00', value: 29.66 },
  { date: '2023-04-14T22:00:00', value: 88.44 },
  { date: '2023-04-14T23:00:00', value: 43.54 },
  { date: '2023-04-15T00:00:00', value: 87.08 },
  { date: '2023-04-15T01:00:00', value: 91.02 },
  { date: '2023-04-15T02:00:00', value: 76.98 },
  { date: '2023-04-15T03:00:00', value: 69.31 },
  { date: '2023-04-15T04:00:00', value: 97.72 },
  { date: '2023-04-15T05:00:00', value: 35.86 },
  { date: '2023-04-15T06:00:00', value: 5.14 },
  { date: '2023-04-15T07:00:00', value: 23.92 },
  { date: '2023-04-15T08:00:00', value: 17.3 },
  { date: '2023-04-15T09:00:00', value: 75.19 },
  { date: '2023-04-15T10:00:00', value: 65.33 },
  { date: '2023-04-15T11:00:00', value: 71.27 },
  { date: '2023-04-15T12:00:00', value: 99.2 },
  { date: '2023-04-15T13:00:00', value: 1.58 },
  { date: '2023-04-15T14:00:00', value: 41.09 },
  { date: '2023-04-15T15:00:00', value: 51.69 },
  { date: '2023-04-15T16:00:00', value: 28.32 },
  { date: '2023-04-15T17:00:00', value: 11.75 },
  { date: '2023-04-15T18:00:00', value: 33.66 },
  { date: '2023-04-15T19:00:00', value: 1.86 },
  { date: '2023-04-15T20:00:00', value: 57.17 },
  { date: '2023-04-15T21:00:00', value: 40.52 },
  { date: '2023-04-15T22:00:00', value: 24.49 },
  { date: '2023-04-15T23:00:00', value: 61.81 },
  { date: '2023-04-16T00:00:00', value: 55.69 },
  { date: '2023-04-16T01:00:00', value: 28.7 },
  { date: '2023-04-16T02:00:00', value: 97.44 },
  { date: '2023-04-16T03:00:00', value: 23.58 },
  { date: '2023-04-16T04:00:00', value: 43.46 },
  { date: '2023-04-16T05:00:00', value: 46.74 },
  { date: '2023-04-16T06:00:00', value: 86.32 },
  { date: '2023-04-16T07:00:00', value: 45.44 },
  { date: '2023-04-16T08:00:00', value: 27.8 },
  { date: '2023-04-16T09:00:00', value: 69.38 },
  { date: '2023-04-16T10:00:00', value: 77.26 },
  { date: '2023-04-16T11:00:00', value: 34.62 },
  { date: '2023-04-16T12:00:00', value: 58.81 },
  { date: '2023-04-16T13:00:00', value: 13.81 },
  { date: '2023-04-16T14:00:00', value: 9.54 },
  { date: '2023-04-16T15:00:00', value: 97.38 },
  { date: '2023-04-16T16:00:00', value: 63.14 },
  { date: '2023-04-16T17:00:00', value: 12.31 },
  { date: '2023-04-16T18:00:00', value: 80.81 },
  { date: '2023-04-16T19:00:00', value: 56.74 },
  { date: '2023-04-16T20:00:00', value: 68.77 },
  { date: '2023-04-16T21:00:00', value: 43.93 },
  { date: '2023-04-16T22:00:00', value: 93.09 },
  { date: '2023-04-16T23:00:00', value: 70.5 },
  { date: '2023-04-17T00:00:00', value: 36.63 },
  { date: '2023-04-17T01:00:00', value: 60.67 },
  { date: '2023-04-17T02:00:00', value: 54.65 },
  { date: '2023-04-17T03:00:00', value: 19.86 },
  { date: '2023-04-17T04:00:00', value: 51.51 },
  { date: '2023-04-17T05:00:00', value: 72.69 },
  { date: '2023-04-17T06:00:00', value: 49.02 },
  { date: '2023-04-17T07:00:00', value: 64.34 },
  { date: '2023-04-17T08:00:00', value: 34.62 },
  { date: '2023-04-17T09:00:00', value: 1.42 },
  { date: '2023-04-17T10:00:00', value: 98.17 },
  { date: '2023-04-17T11:00:00', value: 59.38 },
  { date: '2023-04-17T12:00:00', value: 17.13 },
  { date: '2023-04-17T13:00:00', value: 5.22 },
  { date: '2023-04-17T14:00:00', value: 89.72 },
  { date: '2023-04-17T15:00:00', value: 62.14 },
  { date: '2023-04-17T16:00:00', value: 12.94 },
  { date: '2023-04-17T17:00:00', value: 74.45 },
  { date: '2023-04-17T18:00:00', value: 53.23 },
  { date: '2023-04-17T19:00:00', value: 95.1 },
  { date: '2023-04-17T20:00:00', value: 68.19 },
  { date: '2023-04-17T21:00:00', value: 62.4 },
  { date: '2023-04-17T22:00:00', value: 37.37 },
  { date: '2023-04-17T23:00:00', value: 14.53 },
  { date: '2023-04-18T00:00:00', value: 73.99 },
  { date: '2023-04-18T01:00:00', value: 27.7 },
  { date: '2023-04-18T02:00:00', value: 84.58 },
  { date: '2023-04-18T03:00:00', value: 23.11 },
  { date: '2023-04-18T04:00:00', value: 90.46 },
  { date: '2023-04-18T05:00:00', value: 75.35 },
  { date: '2023-04-18T06:00:00', value: 1.93 },
  { date: '2023-04-18T07:00:00', value: 3.98 },
  { date: '2023-04-18T08:00:00', value: 63.08 },
  { date: '2023-04-18T09:00:00', value: 4.45 },
  { date: '2023-04-18T10:00:00', value: 56.19 },
  { date: '2023-04-18T11:00:00', value: 90.09 },
  { date: '2023-04-18T12:00:00', value: 64.03 },
  { date: '2023-04-18T13:00:00', value: 97.32 },
  { date: '2023-04-18T14:00:00', value: 33.27 },
  { date: '2023-04-18T15:00:00', value: 68.44 },
  { date: '2023-04-18T16:00:00', value: 77.84 },
  { date: '2023-04-18T17:00:00', value: 20.16 },
  { date: '2023-04-18T18:00:00', value: 19.31 },
  { date: '2023-04-18T19:00:00', value: 87.78 },
  { date: '2023-04-18T20:00:00', value: 47.54 },
  { date: '2023-04-18T21:00:00', value: 2.23 },
  { date: '2023-04-18T22:00:00', value: 11.34 },
  { date: '2023-04-18T23:00:00', value: 96.28 },
  { date: '2023-04-19T00:00:00', value: 74.85 },
  { date: '2023-04-19T01:00:00', value: 59.52 },
  { date: '2023-04-19T02:00:00', value: 29.92 },
  { date: '2023-04-19T03:00:00', value: 54.32 },
  { date: '2023-04-19T04:00:00', value: 18.9 },
  { date: '2023-04-19T05:00:00', value: 74.06 },
  { date: '2023-04-19T06:00:00', value: 68.43 },
  { date: '2023-04-19T07:00:00', value: 63.05 },
  { date: '2023-04-19T08:00:00', value: 91.33 },
  { date: '2023-04-19T09:00:00', value: 81.69 },
  { date: '2023-04-19T10:00:00', value: 6.92 },
  { date: '2023-04-19T11:00:00', value: 14.08 },
  { date: '2023-04-19T12:00:00', value: 55.76 },
  { date: '2023-04-19T13:00:00', value: 43.88 },
  { date: '2023-04-19T14:00:00', value: 54.21 },
  { date: '2023-04-19T15:00:00', value: 53.16 },
  { date: '2023-04-19T16:00:00', value: 91.03 },
  { date: '2023-04-19T17:00:00', value: 61.73 },
  { date: '2023-04-19T18:00:00', value: 48.9 },
  { date: '2023-04-19T19:00:00', value: 93.09 },
  { date: '2023-04-19T20:00:00', value: 17.32 },
  { date: '2023-04-19T21:00:00', value: 88.17 },
  { date: '2023-04-19T22:00:00', value: 55.41 },
  { date: '2023-04-19T23:00:00', value: 88.9 },
  { date: '2023-04-20T00:00:00', value: 53.14 },
  { date: '2023-04-20T01:00:00', value: 95.39 },
  { date: '2023-04-20T02:00:00', value: 4.39 },
  { date: '2023-04-20T03:00:00', value: 22.95 },
  { date: '2023-04-20T04:00:00', value: 10.36 },
  { date: '2023-04-20T05:00:00', value: 52.71 },
  { date: '2023-04-20T06:00:00', value: 68.55 },
  { date: '2023-04-20T07:00:00', value: 28.93 },
  { date: '2023-04-20T08:00:00', value: 58.68 },
  { date: '2023-04-20T09:00:00', value: 53.36 },
  { date: '2023-04-20T10:00:00', value: 75.34 },
  { date: '2023-04-20T11:00:00', value: 57.35 },
  { date: '2023-04-20T12:00:00', value: 1.65 },
  { date: '2023-04-20T13:00:00', value: 64.22 },
  { date: '2023-04-20T14:00:00', value: 81.59 },
  { date: '2023-04-20T15:00:00', value: 66.31 },
  { date: '2023-04-20T16:00:00', value: 16.61 },
  { date: '2023-04-20T17:00:00', value: 99.82 },
  { date: '2023-04-20T18:00:00', value: 61.95 },
  { date: '2023-04-20T19:00:00', value: 48.09 },
  { date: '2023-04-20T20:00:00', value: 9.94 },
  { date: '2023-04-20T21:00:00', value: 68.32 },
  { date: '2023-04-20T22:00:00', value: 31.51 },
  { date: '2023-04-20T23:00:00', value: 89.68 },
  { date: '2023-04-21T00:00:00', value: 67.78 },
  { date: '2023-04-21T01:00:00', value: 17.87 },
  { date: '2023-04-21T02:00:00', value: 8.01 },
  { date: '2023-04-21T03:00:00', value: 95.6 },
  { date: '2023-04-21T04:00:00', value: 75.9 },
  { date: '2023-04-21T05:00:00', value: 55.35 },
  { date: '2023-04-21T06:00:00', value: 31.41 },
  { date: '2023-04-21T07:00:00', value: 26.54 },
  { date: '2023-04-21T08:00:00', value: 26.32 },
  { date: '2023-04-21T09:00:00', value: 74.52 },
  { date: '2023-04-21T10:00:00', value: 19.09 },
  { date: '2023-04-21T11:00:00', value: 81.82 },
  { date: '2023-04-21T12:00:00', value: 58.71 },
  { date: '2023-04-21T13:00:00', value: 90.43 },
  { date: '2023-04-21T14:00:00', value: 80.94 },
  { date: '2023-04-21T15:00:00', value: 51.52 },
  { date: '2023-04-21T16:00:00', value: 84.85 },
  { date: '2023-04-21T17:00:00', value: 24.08 },
  { date: '2023-04-21T18:00:00', value: 34.68 },
  { date: '2023-04-21T19:00:00', value: 45.28 },
  { date: '2023-04-21T20:00:00', value: 41.56 },
  { date: '2023-04-21T21:00:00', value: 55.18 },
  { date: '2023-04-21T22:00:00', value: 32.35 },
  { date: '2023-04-21T23:00:00', value: 37.46 },
  { date: '2023-04-22T00:00:00', value: 14.51 },
  { date: '2023-04-22T01:00:00', value: 68.1 },
  { date: '2023-04-22T02:00:00', value: 77.23 },
  { date: '2023-04-22T03:00:00', value: 87.43 },
  { date: '2023-04-22T04:00:00', value: 17.97 },
  { date: '2023-04-22T05:00:00', value: 67.74 },
  { date: '2023-04-22T06:00:00', value: 79.56 },
  { date: '2023-04-22T07:00:00', value: 24.8 },
  { date: '2023-04-22T08:00:00', value: 51.1 },
  { date: '2023-04-22T09:00:00', value: 21.24 },
  { date: '2023-04-22T10:00:00', value: 68.63 },
  { date: '2023-04-22T11:00:00', value: 67.72 },
  { date: '2023-04-22T12:00:00', value: 27.35 },
  { date: '2023-04-22T13:00:00', value: 88.61 },
  { date: '2023-04-22T14:00:00', value: 13.56 },
  { date: '2023-04-22T15:00:00', value: 15.49 },
  { date: '2023-04-22T16:00:00', value: 93.07 },
  { date: '2023-04-22T17:00:00', value: 45.35 },
  { date: '2023-04-22T18:00:00', value: 19.21 },
  { date: '2023-04-22T19:00:00', value: 59.48 },
  { date: '2023-04-22T20:00:00', value: 53.33 },
  { date: '2023-04-22T21:00:00', value: 50.52 },
  { date: '2023-04-22T22:00:00', value: 50.12 },
  { date: '2023-04-22T23:00:00', value: 5.69 },
  { date: '2023-04-23T00:00:00', value: 94.01 },
  { date: '2023-04-23T01:00:00', value: 78.19 },
  { date: '2023-04-23T02:00:00', value: 43.19 },
  { date: '2023-04-23T03:00:00', value: 65.33 },
  { date: '2023-04-23T04:00:00', value: 3.94 },
  { date: '2023-04-23T05:00:00', value: 3.23 },
  { date: '2023-04-23T06:00:00', value: 9.41 },
  { date: '2023-04-23T07:00:00', value: 77.06 },
  { date: '2023-04-23T08:00:00', value: 47.89 },
  { date: '2023-04-23T09:00:00', value: 29.18 },
  { date: '2023-04-23T10:00:00', value: 39.26 },
  { date: '2023-04-23T11:00:00', value: 53.94 },
  { date: '2023-04-23T12:00:00', value: 96.01 },
  { date: '2023-04-23T13:00:00', value: 53.37 },
  { date: '2023-04-23T14:00:00', value: 97.76 },
  { date: '2023-04-23T15:00:00', value: 16.23 },
  { date: '2023-04-23T16:00:00', value: 50.99 },
  { date: '2023-04-23T17:00:00', value: 90.54 },
  { date: '2023-04-23T18:00:00', value: 23.71 },
  { date: '2023-04-23T19:00:00', value: 47.51 },
  { date: '2023-04-23T20:00:00', value: 92.14 },
  { date: '2023-04-23T21:00:00', value: 40.37 },
  { date: '2023-04-23T22:00:00', value: 92.47 },
  { date: '2023-04-23T23:00:00', value: 73.19 },
  { date: '2023-04-24T00:00:00', value: 27.36 },
  { date: '2023-04-24T01:00:00', value: 27.93 },
  { date: '2023-04-24T02:00:00', value: 99.32 },
  { date: '2023-04-24T03:00:00', value: 54.11 },
  { date: '2023-04-24T04:00:00', value: 54.79 },
  { date: '2023-04-24T05:00:00', value: 51.52 },
  { date: '2023-04-24T06:00:00', value: 85.96 },
  { date: '2023-04-24T07:00:00', value: 47.07 },
  { date: '2023-04-24T08:00:00', value: 97.98 },
  { date: '2023-04-24T09:00:00', value: 50.89 },
  { date: '2023-04-24T10:00:00', value: 54.09 },
  { date: '2023-04-24T11:00:00', value: 47.19 },
  { date: '2023-04-24T12:00:00', value: 65.61 },
  { date: '2023-04-24T13:00:00', value: 14.16 },
  { date: '2023-04-24T14:00:00', value: 67.62 },
  { date: '2023-04-24T15:00:00', value: 48.34 },
  { date: '2023-04-24T16:00:00', value: 20.18 },
  { date: '2023-04-24T17:00:00', value: 25.85 },
  { date: '2023-04-24T18:00:00', value: 64.46 },
  { date: '2023-04-24T19:00:00', value: 35.72 },
  { date: '2023-04-24T20:00:00', value: 57.33 },
  { date: '2023-04-24T21:00:00', value: 84.96 },
  { date: '2023-04-24T22:00:00', value: 75.78 },
  { date: '2023-04-24T23:00:00', value: 66.86 },
  { date: '2023-04-25T00:00:00', value: 64.05 },
  { date: '2023-04-25T01:00:00', value: 57.5 },
  { date: '2023-04-25T02:00:00', value: 69.78 },
  { date: '2023-04-25T03:00:00', value: 59.98 },
  { date: '2023-04-25T04:00:00', value: 91.48 },
  { date: '2023-04-25T05:00:00', value: 83.22 },
  { date: '2023-04-25T06:00:00', value: 53.04 },
  { date: '2023-04-25T07:00:00', value: 47.1 },
  { date: '2023-04-25T08:00:00', value: 53.5 },
  { date: '2023-04-25T09:00:00', value: 35.03 },
  { date: '2023-04-25T10:00:00', value: 91.9 },
  { date: '2023-04-25T11:00:00', value: 1.58 },
  { date: '2023-04-25T12:00:00', value: 94.53 },
  { date: '2023-04-25T13:00:00', value: 57.46 },
  { date: '2023-04-25T14:00:00', value: 74.67 },
  { date: '2023-04-25T15:00:00', value: 86.49 },
  { date: '2023-04-25T16:00:00', value: 55.59 },
  { date: '2023-04-25T17:00:00', value: 73.08 },
  { date: '2023-04-25T18:00:00', value: 14.59 },
  { date: '2023-04-25T19:00:00', value: 6.16 },
  { date: '2023-04-25T20:00:00', value: 58.04 },
  { date: '2023-04-25T21:00:00', value: 69.57 },
  { date: '2023-04-25T22:00:00', value: 70.27 },
  { date: '2023-04-25T23:00:00', value: 26.08 },
  { date: '2023-04-26T00:00:00', value: 22.34 },
  { date: '2023-04-26T01:00:00', value: 99.68 },
  { date: '2023-04-26T02:00:00', value: 70.86 },
  { date: '2023-04-26T03:00:00', value: 97.39 },
  { date: '2023-04-26T04:00:00', value: 4.13 },
  { date: '2023-04-26T05:00:00', value: 97.26 },
  { date: '2023-04-26T06:00:00', value: 30.13 },
  { date: '2023-04-26T07:00:00', value: 22.87 },
  { date: '2023-04-26T08:00:00', value: 75.58 },
  { date: '2023-04-26T09:00:00', value: 15.0 },
  { date: '2023-04-26T10:00:00', value: 94.71 },
  { date: '2023-04-26T11:00:00', value: 14.14 },
  { date: '2023-04-26T12:00:00', value: 81.49 },
  { date: '2023-04-26T13:00:00', value: 31.36 },
  { date: '2023-04-26T14:00:00', value: 73.59 },
  { date: '2023-04-26T15:00:00', value: 96.08 },
  { date: '2023-04-26T16:00:00', value: 91.18 },
  { date: '2023-04-26T17:00:00', value: 72.06 },
  { date: '2023-04-26T18:00:00', value: 20.43 },
  { date: '2023-04-26T19:00:00', value: 12.42 },
  { date: '2023-04-26T20:00:00', value: 72.18 },
  { date: '2023-04-26T21:00:00', value: 5.25 },
  { date: '2023-04-26T22:00:00', value: 11.62 },
  { date: '2023-04-26T23:00:00', value: 28.35 },
  { date: '2023-04-27T00:00:00', value: 4.34 },
  { date: '2023-04-27T01:00:00', value: 90.82 },
  { date: '2023-04-27T02:00:00', value: 52.45 },
  { date: '2023-04-27T03:00:00', value: 66.51 },
  { date: '2023-04-27T04:00:00', value: 18.84 },
  { date: '2023-04-27T05:00:00', value: 52.76 },
  { date: '2023-04-27T06:00:00', value: 84.72 },
  { date: '2023-04-27T07:00:00', value: 35.24 },
  { date: '2023-04-27T08:00:00', value: 39.4 },
  { date: '2023-04-27T09:00:00', value: 85.11 },
  { date: '2023-04-27T10:00:00', value: 84.68 },
  { date: '2023-04-27T11:00:00', value: 94.71 },
  { date: '2023-04-27T12:00:00', value: 5.51 },
  { date: '2023-04-27T13:00:00', value: 34.79 },
  { date: '2023-04-27T14:00:00', value: 1.05 },
  { date: '2023-04-27T15:00:00', value: 8.85 },
  { date: '2023-04-27T16:00:00', value: 19.19 },
  { date: '2023-04-27T17:00:00', value: 58.38 },
  { date: '2023-04-27T18:00:00', value: 42.92 },
  { date: '2023-04-27T19:00:00', value: 8.4 },
  { date: '2023-04-27T20:00:00', value: 34.88 },
  { date: '2023-04-27T21:00:00', value: 24.94 },
  { date: '2023-04-27T22:00:00', value: 86.56 },
  { date: '2023-04-27T23:00:00', value: 44.31 },
  { date: '2023-04-28T00:00:00', value: 79.69 },
  { date: '2023-04-28T01:00:00', value: 12.7 },
  { date: '2023-04-28T02:00:00', value: 56.2 },
  { date: '2023-04-28T03:00:00', value: 93.97 },
  { date: '2023-04-28T04:00:00', value: 19.79 },
  { date: '2023-04-28T05:00:00', value: 1.62 },
  { date: '2023-04-28T06:00:00', value: 89.84 },
  { date: '2023-04-28T07:00:00', value: 35.61 },
  { date: '2023-04-28T08:00:00', value: 17.22 },
  { date: '2023-04-28T09:00:00', value: 50.7 },
  { date: '2023-04-28T10:00:00', value: 2.67 },
  { date: '2023-04-28T11:00:00', value: 97.61 },
  { date: '2023-04-28T12:00:00', value: 30.17 },
  { date: '2023-04-28T13:00:00', value: 1.26 },
  { date: '2023-04-28T14:00:00', value: 90.1 },
  { date: '2023-04-28T15:00:00', value: 64.56 },
  { date: '2023-04-28T16:00:00', value: 54.01 },
  { date: '2023-04-28T17:00:00', value: 93.92 },
  { date: '2023-04-28T18:00:00', value: 46.25 },
  { date: '2023-04-28T19:00:00', value: 61.58 },
  { date: '2023-04-28T20:00:00', value: 63.29 },
  { date: '2023-04-28T21:00:00', value: 38.13 },
  { date: '2023-04-28T22:00:00', value: 66.67 },
  { date: '2023-04-28T23:00:00', value: 82.9 },
  { date: '2023-04-29T00:00:00', value: 41.06 },
  { date: '2023-04-29T01:00:00', value: 44.14 },
  { date: '2023-04-29T02:00:00', value: 55.48 },
  { date: '2023-04-29T03:00:00', value: 88.44 },
  { date: '2023-04-29T04:00:00', value: 15.98 },
  { date: '2023-04-29T05:00:00', value: 37.24 },
  { date: '2023-04-29T06:00:00', value: 81.95 },
  { date: '2023-04-29T07:00:00', value: 87.54 },
  { date: '2023-04-29T08:00:00', value: 94.6 },
  { date: '2023-04-29T09:00:00', value: 6.33 },
  { date: '2023-04-29T10:00:00', value: 19.64 },
  { date: '2023-04-29T11:00:00', value: 43.85 },
  { date: '2023-04-29T12:00:00', value: 7.8 },
  { date: '2023-04-29T13:00:00', value: 93.39 },
  { date: '2023-04-29T14:00:00', value: 60.33 },
  { date: '2023-04-29T15:00:00', value: 12.39 },
  { date: '2023-04-29T16:00:00', value: 95.78 },
  { date: '2023-04-29T17:00:00', value: 39.26 },
  { date: '2023-04-29T18:00:00', value: 67.59 },
  { date: '2023-04-29T19:00:00', value: 26.04 },
  { date: '2023-04-29T20:00:00', value: 40.35 },
  { date: '2023-04-29T21:00:00', value: 17.11 },
  { date: '2023-04-29T22:00:00', value: 14.04 },
  { date: '2023-04-29T23:00:00', value: 6.26 },
  { date: '2023-04-30T00:00:00', value: 86.64 },
  { date: '2023-04-30T01:00:00', value: 54.07 },
  { date: '2023-04-30T02:00:00', value: 72.77 },
  { date: '2023-04-30T03:00:00', value: 7.42 },
  { date: '2023-04-30T04:00:00', value: 91.69 },
  { date: '2023-04-30T05:00:00', value: 55.2 },
  { date: '2023-04-30T06:00:00', value: 41.59 },
  { date: '2023-04-30T07:00:00', value: 12.46 },
  { date: '2023-04-30T08:00:00', value: 76.35 },
  { date: '2023-04-30T09:00:00', value: 52.37 },
  { date: '2023-04-30T10:00:00', value: 36.61 },
  { date: '2023-04-30T11:00:00', value: 29.14 },
  { date: '2023-04-30T12:00:00', value: 30.74 },
  { date: '2023-04-30T13:00:00', value: 28.94 },
  { date: '2023-04-30T14:00:00', value: 89.62 },
  { date: '2023-04-30T15:00:00', value: 3.67 },
  { date: '2023-04-30T16:00:00', value: 54.49 },
  { date: '2023-04-30T17:00:00', value: 17.08 },
  { date: '2023-04-30T18:00:00', value: 49.38 },
  { date: '2023-04-30T19:00:00', value: 51.97 },
  { date: '2023-04-30T20:00:00', value: 94.51 },
  { date: '2023-04-30T21:00:00', value: 19.38 },
  { date: '2023-04-30T22:00:00', value: 62.68 },
  { date: '2023-04-30T23:00:00', value: 14.98 },
  { date: '2023-05-01T00:00:00', value: 97.01 },
  { date: '2023-05-01T01:00:00', value: 30.04 },
  { date: '2023-05-01T02:00:00', value: 45.82 },
  { date: '2023-05-01T03:00:00', value: 32.35 },
  { date: '2023-05-01T04:00:00', value: 39.77 },
  { date: '2023-05-01T05:00:00', value: 94.95 },
  { date: '2023-05-01T06:00:00', value: 76.25 },
  { date: '2023-05-01T07:00:00', value: 23.88 },
  { date: '2023-05-01T08:00:00', value: 81.35 },
  { date: '2023-05-01T09:00:00', value: 75.12 },
  { date: '2023-05-01T10:00:00', value: 76.0 },
  { date: '2023-05-01T11:00:00', value: 98.44 },
  { date: '2023-05-01T12:00:00', value: 44.31 },
  { date: '2023-05-01T13:00:00', value: 74.88 },
  { date: '2023-05-01T14:00:00', value: 49.98 },
  { date: '2023-05-01T15:00:00', value: 7.55 },
  { date: '2023-05-01T16:00:00', value: 27.74 },
  { date: '2023-05-01T17:00:00', value: 77.83 },
  { date: '2023-05-01T18:00:00', value: 37.0 },
  { date: '2023-05-01T19:00:00', value: 85.21 },
  { date: '2023-05-01T20:00:00', value: 1.24 },
  { date: '2023-05-01T21:00:00', value: 39.64 },
  { date: '2023-05-01T22:00:00', value: 26.15 },
  { date: '2023-05-01T23:00:00', value: 85.09 },
  { date: '2023-05-02T00:00:00', value: 68.41 },
  { date: '2023-05-02T01:00:00', value: 78.72 },
  { date: '2023-05-02T02:00:00', value: 47.46 },
  { date: '2023-05-02T03:00:00', value: 67.5 },
  { date: '2023-05-02T04:00:00', value: 72.96 },
  { date: '2023-05-02T05:00:00', value: 51.91 },
  { date: '2023-05-02T06:00:00', value: 39.85 },
  { date: '2023-05-02T07:00:00', value: 89.13 },
  { date: '2023-05-02T08:00:00', value: 35.35 },
  { date: '2023-05-02T09:00:00', value: 35.51 },
  { date: '2023-05-02T10:00:00', value: 44.01 },
  { date: '2023-05-02T11:00:00', value: 7.58 },
  { date: '2023-05-02T12:00:00', value: 25.65 },
  { date: '2023-05-02T13:00:00', value: 27.29 },
  { date: '2023-05-02T14:00:00', value: 91.05 },
  { date: '2023-05-02T15:00:00', value: 75.59 },
  { date: '2023-05-02T16:00:00', value: 76.95 },
  { date: '2023-05-02T17:00:00', value: 82.49 },
  { date: '2023-05-02T18:00:00', value: 63.0 },
  { date: '2023-05-02T19:00:00', value: 59.75 },
  { date: '2023-05-02T20:00:00', value: 93.37 },
  { date: '2023-05-02T21:00:00', value: 68.25 },
  { date: '2023-05-02T22:00:00', value: 30.58 },
  { date: '2023-05-02T23:00:00', value: 54.7 },
  { date: '2023-05-03T00:00:00', value: 31.72 },
  { date: '2023-05-03T01:00:00', value: 83.71 },
  { date: '2023-05-03T02:00:00', value: 80.48 },
  { date: '2023-05-03T03:00:00', value: 1.58 },
  { date: '2023-05-03T04:00:00', value: 49.83 },
  { date: '2023-05-03T05:00:00', value: 98.78 },
  { date: '2023-05-03T06:00:00', value: 99.96 },
  { date: '2023-05-03T07:00:00', value: 11.86 },
  { date: '2023-05-03T08:00:00', value: 36.9 },
  { date: '2023-05-03T09:00:00', value: 78.07 },
  { date: '2023-05-03T10:00:00', value: 91.85 },
  { date: '2023-05-03T11:00:00', value: 14.05 },
  { date: '2023-05-03T12:00:00', value: 20.93 },
  { date: '2023-05-03T13:00:00', value: 90.84 },
  { date: '2023-05-03T14:00:00', value: 31.52 },
  { date: '2023-05-03T15:00:00', value: 50.89 },
  { date: '2023-05-03T16:00:00', value: 10.96 },
  { date: '2023-05-03T17:00:00', value: 24.64 },
  { date: '2023-05-03T18:00:00', value: 78.96 },
  { date: '2023-05-03T19:00:00', value: 93.43 },
  { date: '2023-05-03T20:00:00', value: 87.05 },
  { date: '2023-05-03T21:00:00', value: 13.41 },
  { date: '2023-05-03T22:00:00', value: 88.82 },
  { date: '2023-05-03T23:00:00', value: 44.74 },
  { date: '2023-05-04T00:00:00', value: 96.07 },
  { date: '2023-05-04T01:00:00', value: 24.95 },
  { date: '2023-05-04T02:00:00', value: 25.66 },
  { date: '2023-05-04T03:00:00', value: 23.99 },
  { date: '2023-05-04T04:00:00', value: 32.06 },
  { date: '2023-05-04T05:00:00', value: 15.32 },
  { date: '2023-05-04T06:00:00', value: 69.59 },
  { date: '2023-05-04T07:00:00', value: 75.29 },
  { date: '2023-05-04T08:00:00', value: 98.14 },
  { date: '2023-05-04T09:00:00', value: 53.36 },
  { date: '2023-05-04T10:00:00', value: 81.02 },
  { date: '2023-05-04T11:00:00', value: 19.2 },
  { date: '2023-05-04T12:00:00', value: 96.37 },
  { date: '2023-05-04T13:00:00', value: 43.36 },
  { date: '2023-05-04T14:00:00', value: 2.67 },
  { date: '2023-05-04T15:00:00', value: 84.76 },
  { date: '2023-05-04T16:00:00', value: 23.9 },
  { date: '2023-05-04T17:00:00', value: 85.35 },
  { date: '2023-05-04T18:00:00', value: 95.53 },
  { date: '2023-05-04T19:00:00', value: 17.98 },
  { date: '2023-05-04T20:00:00', value: 95.18 },
  { date: '2023-05-04T21:00:00', value: 47.76 },
  { date: '2023-05-04T22:00:00', value: 8.03 },
  { date: '2023-05-04T23:00:00', value: 7.9 },
  { date: '2023-05-05T00:00:00', value: 66.18 },
  { date: '2023-05-05T01:00:00', value: 91.49 },
  { date: '2023-05-05T02:00:00', value: 19.61 },
  { date: '2023-05-05T03:00:00', value: 70.91 },
  { date: '2023-05-05T04:00:00', value: 90.4 },
  { date: '2023-05-05T05:00:00', value: 51.27 },
  { date: '2023-05-05T06:00:00', value: 9.77 },
  { date: '2023-05-05T07:00:00', value: 43.71 },
  { date: '2023-05-05T08:00:00', value: 56.57 },
  { date: '2023-05-05T09:00:00', value: 85.37 },
  { date: '2023-05-05T10:00:00', value: 37.28 },
  { date: '2023-05-05T11:00:00', value: 72.36 },
  { date: '2023-05-05T12:00:00', value: 99.05 },
  { date: '2023-05-05T13:00:00', value: 56.05 },
  { date: '2023-05-05T14:00:00', value: 53.88 },
  { date: '2023-05-05T15:00:00', value: 21.46 },
  { date: '2023-05-05T16:00:00', value: 6.71 },
  { date: '2023-05-05T17:00:00', value: 81.07 },
  { date: '2023-05-05T18:00:00', value: 73.05 },
  { date: '2023-05-05T19:00:00', value: 81.87 },
  { date: '2023-05-05T20:00:00', value: 96.67 },
  { date: '2023-05-05T21:00:00', value: 32.17 },
  { date: '2023-05-05T22:00:00', value: 81.11 },
  { date: '2023-05-05T23:00:00', value: 90.26 },
  { date: '2023-05-06T00:00:00', value: 49.93 },
  { date: '2023-05-06T01:00:00', value: 36.19 },
  { date: '2023-05-06T02:00:00', value: 51.12 },
  { date: '2023-05-06T03:00:00', value: 36.41 },
  { date: '2023-05-06T04:00:00', value: 60.75 },
  { date: '2023-05-06T05:00:00', value: 71.03 },
  { date: '2023-05-06T06:00:00', value: 7.41 },
  { date: '2023-05-06T07:00:00', value: 39.98 },
  { date: '2023-05-06T08:00:00', value: 51.66 },
  { date: '2023-05-06T09:00:00', value: 99.46 },
  { date: '2023-05-06T10:00:00', value: 66.6 },
  { date: '2023-05-06T11:00:00', value: 15.94 },
  { date: '2023-05-06T12:00:00', value: 36.32 },
  { date: '2023-05-06T13:00:00', value: 3.81 },
  { date: '2023-05-06T14:00:00', value: 50.38 },
  { date: '2023-05-06T15:00:00', value: 67.17 },
  { date: '2023-05-06T16:00:00', value: 10.12 },
  { date: '2023-05-06T17:00:00', value: 74.91 },
  { date: '2023-05-06T18:00:00', value: 58.87 },
  { date: '2023-05-06T19:00:00', value: 83.81 },
  { date: '2023-05-06T20:00:00', value: 10.36 },
  { date: '2023-05-06T21:00:00', value: 49.46 },
  { date: '2023-05-06T22:00:00', value: 43.53 },
  { date: '2023-05-06T23:00:00', value: 38.6 },
  { date: '2023-05-07T00:00:00', value: 95.24 },
  { date: '2023-05-07T01:00:00', value: 34.9 },
  { date: '2023-05-07T02:00:00', value: 1.4 },
  { date: '2023-05-07T03:00:00', value: 26.1 },
  { date: '2023-05-07T04:00:00', value: 55.5 },
  { date: '2023-05-07T05:00:00', value: 44.69 },
  { date: '2023-05-07T06:00:00', value: 47.42 },
  { date: '2023-05-07T07:00:00', value: 70.39 },
  { date: '2023-05-07T08:00:00', value: 62.32 },
  { date: '2023-05-07T09:00:00', value: 10.56 },
  { date: '2023-05-07T10:00:00', value: 11.6 },
  { date: '2023-05-07T11:00:00', value: 15.04 },
  { date: '2023-05-07T12:00:00', value: 17.33 },
  { date: '2023-05-07T13:00:00', value: 79.6 },
  { date: '2023-05-07T14:00:00', value: 60.74 },
  { date: '2023-05-07T15:00:00', value: 92.09 },
  { date: '2023-05-07T16:00:00', value: 50.17 },
  { date: '2023-05-07T17:00:00', value: 23.31 },
  { date: '2023-05-07T18:00:00', value: 43.68 },
  { date: '2023-05-07T19:00:00', value: 84.81 },
  { date: '2023-05-07T20:00:00', value: 70.16 },
  { date: '2023-05-07T21:00:00', value: 52.39 },
  { date: '2023-05-07T22:00:00', value: 46.39 },
  { date: '2023-05-07T23:00:00', value: 6.71 },
  { date: '2023-05-08T00:00:00', value: 24.74 },
  { date: '2023-05-08T01:00:00', value: 78.07 },
  { date: '2023-05-08T02:00:00', value: 3.67 },
  { date: '2023-05-08T03:00:00', value: 75.12 },
  { date: '2023-05-08T04:00:00', value: 91.43 },
  { date: '2023-05-08T05:00:00', value: 20.94 },
  { date: '2023-05-08T06:00:00', value: 54.33 },
  { date: '2023-05-08T07:00:00', value: 10.82 },
  { date: '2023-05-08T08:00:00', value: 85.53 },
  { date: '2023-05-08T09:00:00', value: 17.32 },
  { date: '2023-05-08T10:00:00', value: 22.61 },
  { date: '2023-05-08T11:00:00', value: 5.63 },
  { date: '2023-05-08T12:00:00', value: 21.31 },
  { date: '2023-05-08T13:00:00', value: 55.33 },
  { date: '2023-05-08T14:00:00', value: 78.36 },
  { date: '2023-05-08T15:00:00', value: 44.59 },
  { date: '2023-05-08T16:00:00', value: 36.2 },
  { date: '2023-05-08T17:00:00', value: 45.65 },
  { date: '2023-05-08T18:00:00', value: 29.33 },
  { date: '2023-05-08T19:00:00', value: 80.28 },
  { date: '2023-05-08T20:00:00', value: 23.85 },
  { date: '2023-05-08T21:00:00', value: 51.43 },
  { date: '2023-05-08T22:00:00', value: 30.84 },
  { date: '2023-05-08T23:00:00', value: 28.95 },
  { date: '2023-05-09T00:00:00', value: 3.1 },
  { date: '2023-05-09T01:00:00', value: 14.21 },
  { date: '2023-05-09T02:00:00', value: 19.68 },
  { date: '2023-05-09T03:00:00', value: 12.57 },
  { date: '2023-05-09T04:00:00', value: 87.59 },
  { date: '2023-05-09T05:00:00', value: 99.81 },
  { date: '2023-05-09T06:00:00', value: 55.72 },
  { date: '2023-05-09T07:00:00', value: 55.95 },
  { date: '2023-05-09T08:00:00', value: 54.24 },
  { date: '2023-05-09T09:00:00', value: 16.03 },
  { date: '2023-05-09T10:00:00', value: 87.83 },
  { date: '2023-05-09T11:00:00', value: 43.44 },
  { date: '2023-05-09T12:00:00', value: 23.21 },
  { date: '2023-05-09T13:00:00', value: 52.44 },
  { date: '2023-05-09T14:00:00', value: 3.3 },
  { date: '2023-05-09T15:00:00', value: 76.62 },
  { date: '2023-05-09T16:00:00', value: 7.31 },
  { date: '2023-05-09T17:00:00', value: 77.08 },
  { date: '2023-05-09T18:00:00', value: 31.66 },
  { date: '2023-05-09T19:00:00', value: 18.66 },
  { date: '2023-05-09T20:00:00', value: 28.82 },
  { date: '2023-05-09T21:00:00', value: 62.46 },
  { date: '2023-05-09T22:00:00', value: 73.52 },
  { date: '2023-05-09T23:00:00', value: 79.41 },
  { date: '2023-05-10T00:00:00', value: 93.96 },
  { date: '2023-05-10T01:00:00', value: 4.77 },
  { date: '2023-05-10T02:00:00', value: 75.97 },
  { date: '2023-05-10T03:00:00', value: 68.03 },
  { date: '2023-05-10T04:00:00', value: 81.49 },
  { date: '2023-05-10T05:00:00', value: 72.33 },
  { date: '2023-05-10T06:00:00', value: 86.75 },
  { date: '2023-05-10T07:00:00', value: 89.85 },
  { date: '2023-05-10T08:00:00', value: 84.5 },
  { date: '2023-05-10T09:00:00', value: 47.22 },
  { date: '2023-05-10T10:00:00', value: 44.58 },
  { date: '2023-05-10T11:00:00', value: 83.09 },
  { date: '2023-05-10T12:00:00', value: 24.85 },
  { date: '2023-05-10T13:00:00', value: 85.5 },
  { date: '2023-05-10T14:00:00', value: 21.54 },
  { date: '2023-05-10T15:00:00', value: 30.13 },
  { date: '2023-05-10T16:00:00', value: 75.68 },
  { date: '2023-05-10T17:00:00', value: 86.78 },
  { date: '2023-05-10T18:00:00', value: 96.07 },
  { date: '2023-05-10T19:00:00', value: 59.77 },
  { date: '2023-05-10T20:00:00', value: 94.42 },
  { date: '2023-05-10T21:00:00', value: 32.45 },
  { date: '2023-05-10T22:00:00', value: 17.01 },
  { date: '2023-05-10T23:00:00', value: 39.1 },
  { date: '2023-05-11T00:00:00', value: 97.72 },
  { date: '2023-05-11T01:00:00', value: 22.11 },
  { date: '2023-05-11T02:00:00', value: 13.08 },
  { date: '2023-05-11T03:00:00', value: 35.01 },
  { date: '2023-05-11T04:00:00', value: 77.24 },
  { date: '2023-05-11T05:00:00', value: 14.73 },
  { date: '2023-05-11T06:00:00', value: 80.94 },
  { date: '2023-05-11T07:00:00', value: 57.84 },
  { date: '2023-05-11T08:00:00', value: 64.98 },
  { date: '2023-05-11T09:00:00', value: 43.95 },
  { date: '2023-05-11T10:00:00', value: 95.26 },
  { date: '2023-05-11T11:00:00', value: 83.13 },
  { date: '2023-05-11T12:00:00', value: 72.38 },
  { date: '2023-05-11T13:00:00', value: 10.41 },
  { date: '2023-05-11T14:00:00', value: 83.14 },
  { date: '2023-05-11T15:00:00', value: 73.16 },
  { date: '2023-05-11T16:00:00', value: 43.91 },
  { date: '2023-05-11T17:00:00', value: 6.24 },
  { date: '2023-05-11T18:00:00', value: 60.15 },
  { date: '2023-05-11T19:00:00', value: 4.77 },
  { date: '2023-05-11T20:00:00', value: 18.65 },
  { date: '2023-05-11T21:00:00', value: 75.34 },
  { date: '2023-05-11T22:00:00', value: 99.2 },
  { date: '2023-05-11T23:00:00', value: 29.18 },
  { date: '2023-05-12T00:00:00', value: 8.53 },
  { date: '2023-05-12T01:00:00', value: 80.11 },
  { date: '2023-05-12T02:00:00', value: 7.41 },
  { date: '2023-05-12T03:00:00', value: 36.41 },
  { date: '2023-05-12T04:00:00', value: 18.01 },
  { date: '2023-05-12T05:00:00', value: 96.46 },
  { date: '2023-05-12T06:00:00', value: 91.4 },
  { date: '2023-05-12T07:00:00', value: 83.78 },
  { date: '2023-05-12T08:00:00', value: 48.27 },
  { date: '2023-05-12T09:00:00', value: 61.99 },
  { date: '2023-05-12T10:00:00', value: 13.37 },
  { date: '2023-05-12T11:00:00', value: 38.85 },
  { date: '2023-05-12T12:00:00', value: 9.03 },
  { date: '2023-05-12T13:00:00', value: 4.1 },
  { date: '2023-05-12T14:00:00', value: 30.82 },
  { date: '2023-05-12T15:00:00', value: 70.18 },
  { date: '2023-05-12T16:00:00', value: 87.46 },
  { date: '2023-05-12T17:00:00', value: 96.3 },
  { date: '2023-05-12T18:00:00', value: 78.87 },
  { date: '2023-05-12T19:00:00', value: 86.22 },
  { date: '2023-05-12T20:00:00', value: 57.59 },
  { date: '2023-05-12T21:00:00', value: 36.63 },
  { date: '2023-05-12T22:00:00', value: 96.74 },
  { date: '2023-05-12T23:00:00', value: 90.26 },
  { date: '2023-05-13T00:00:00', value: 4.52 },
  { date: '2023-05-13T01:00:00', value: 73.52 },
  { date: '2023-05-13T02:00:00', value: 73.18 },
  { date: '2023-05-13T03:00:00', value: 67.19 },
  { date: '2023-05-13T04:00:00', value: 26.07 },
  { date: '2023-05-13T05:00:00', value: 46.42 },
  { date: '2023-05-13T06:00:00', value: 34.56 },
  { date: '2023-05-13T07:00:00', value: 94.92 },
  { date: '2023-05-13T08:00:00', value: 20.56 },
  { date: '2023-05-13T09:00:00', value: 35.94 },
  { date: '2023-05-13T10:00:00', value: 48.38 },
  { date: '2023-05-13T11:00:00', value: 75.79 },
  { date: '2023-05-13T12:00:00', value: 21.63 },
  { date: '2023-05-13T13:00:00', value: 39.53 },
  { date: '2023-05-13T14:00:00', value: 61.03 },
  { date: '2023-05-13T15:00:00', value: 49.35 },
  { date: '2023-05-13T16:00:00', value: 59.23 },
  { date: '2023-05-13T17:00:00', value: 17.6 },
  { date: '2023-05-13T18:00:00', value: 33.74 },
  { date: '2023-05-13T19:00:00', value: 39.12 },
  { date: '2023-05-13T20:00:00', value: 48.41 },
  { date: '2023-05-13T21:00:00', value: 40.92 },
  { date: '2023-05-13T22:00:00', value: 58.59 },
  { date: '2023-05-13T23:00:00', value: 15.51 },
  { date: '2023-05-14T00:00:00', value: 67.29 },
  { date: '2023-05-14T01:00:00', value: 46.52 },
  { date: '2023-05-14T02:00:00', value: 90.47 },
  { date: '2023-05-14T03:00:00', value: 95.41 },
  { date: '2023-05-14T04:00:00', value: 69.52 },
  { date: '2023-05-14T05:00:00', value: 5.12 },
  { date: '2023-05-14T06:00:00', value: 35.52 },
  { date: '2023-05-14T07:00:00', value: 6.14 },
  { date: '2023-05-14T08:00:00', value: 74.63 },
  { date: '2023-05-14T09:00:00', value: 93.74 },
  { date: '2023-05-14T10:00:00', value: 89.09 },
  { date: '2023-05-14T11:00:00', value: 81.99 },
  { date: '2023-05-14T12:00:00', value: 65.03 },
  { date: '2023-05-14T13:00:00', value: 51.55 },
  { date: '2023-05-14T14:00:00', value: 6.27 },
  { date: '2023-05-14T15:00:00', value: 79.16 },
  { date: '2023-05-14T16:00:00', value: 16.39 },
  { date: '2023-05-14T17:00:00', value: 89.25 },
  { date: '2023-05-14T18:00:00', value: 74.1 },
  { date: '2023-05-14T19:00:00', value: 29.54 },
  { date: '2023-05-14T20:00:00', value: 95.05 },
  { date: '2023-05-14T21:00:00', value: 50.73 },
  { date: '2023-05-14T22:00:00', value: 68.43 },
  { date: '2023-05-14T23:00:00', value: 85.38 },
  { date: '2023-05-15T00:00:00', value: 82.99 },
  { date: '2023-05-15T01:00:00', value: 45.28 },
  { date: '2023-05-15T02:00:00', value: 18.72 },
  { date: '2023-05-15T03:00:00', value: 10.61 },
  { date: '2023-05-15T04:00:00', value: 9.51 },
  { date: '2023-05-15T05:00:00', value: 62.51 },
  { date: '2023-05-15T06:00:00', value: 45.88 },
  { date: '2023-05-15T07:00:00', value: 87.66 },
  { date: '2023-05-15T08:00:00', value: 86.14 },
  { date: '2023-05-15T09:00:00', value: 35.63 },
  { date: '2023-05-15T10:00:00', value: 54.28 },
  { date: '2023-05-15T11:00:00', value: 37.61 },
  { date: '2023-05-15T12:00:00', value: 41.78 },
  { date: '2023-05-15T13:00:00', value: 22.72 },
  { date: '2023-05-15T14:00:00', value: 5.92 },
  { date: '2023-05-15T15:00:00', value: 88.52 },
  { date: '2023-05-15T16:00:00', value: 84.22 },
  { date: '2023-05-15T17:00:00', value: 33.31 },
  { date: '2023-05-15T18:00:00', value: 51.99 },
  { date: '2023-05-15T19:00:00', value: 6.93 },
  { date: '2023-05-15T20:00:00', value: 52.55 },
  { date: '2023-05-15T21:00:00', value: 85.95 },
  { date: '2023-05-15T22:00:00', value: 75.87 },
  { date: '2023-05-15T23:00:00', value: 48.16 },
  { date: '2023-05-16T00:00:00', value: 57.2 },
  { date: '2023-05-16T01:00:00', value: 70.58 },
  { date: '2023-05-16T02:00:00', value: 71.71 },
  { date: '2023-05-16T03:00:00', value: 55.34 },
  { date: '2023-05-16T04:00:00', value: 14.78 },
  { date: '2023-05-16T05:00:00', value: 41.29 },
  { date: '2023-05-16T06:00:00', value: 89.33 },
  { date: '2023-05-16T07:00:00', value: 58.74 },
  { date: '2023-05-16T08:00:00', value: 51.92 },
  { date: '2023-05-16T09:00:00', value: 28.04 },
  { date: '2023-05-16T10:00:00', value: 36.74 },
  { date: '2023-05-16T11:00:00', value: 66.9 },
  { date: '2023-05-16T12:00:00', value: 17.05 },
  { date: '2023-05-16T13:00:00', value: 90.8 },
  { date: '2023-05-16T14:00:00', value: 90.07 },
  { date: '2023-05-16T15:00:00', value: 58.36 },
  { date: '2023-05-16T16:00:00', value: 90.3 },
  { date: '2023-05-16T17:00:00', value: 90.37 },
  { date: '2023-05-16T18:00:00', value: 36.01 },
  { date: '2023-05-16T19:00:00', value: 76.93 },
  { date: '2023-05-16T20:00:00', value: 44.63 },
  { date: '2023-05-16T21:00:00', value: 40.87 },
  { date: '2023-05-16T22:00:00', value: 5.51 },
  { date: '2023-05-16T23:00:00', value: 83.71 },
  { date: '2023-05-17T00:00:00', value: 35.57 },
  { date: '2023-05-17T01:00:00', value: 96.72 },
  { date: '2023-05-17T02:00:00', value: 73.29 },
  { date: '2023-05-17T03:00:00', value: 4.16 },
  { date: '2023-05-17T04:00:00', value: 91.99 },
  { date: '2023-05-17T05:00:00', value: 34.56 },
  { date: '2023-05-17T06:00:00', value: 57.66 },
  { date: '2023-05-17T07:00:00', value: 52.96 },
  { date: '2023-05-17T08:00:00', value: 31.97 },
  { date: '2023-05-17T09:00:00', value: 85.52 },
  { date: '2023-05-17T10:00:00', value: 18.07 },
  { date: '2023-05-17T11:00:00', value: 44.88 },
  { date: '2023-05-17T12:00:00', value: 21.19 },
  { date: '2023-05-17T13:00:00', value: 15.08 },
  { date: '2023-05-17T14:00:00', value: 42.34 },
  { date: '2023-05-17T15:00:00', value: 20.88 },
  { date: '2023-05-17T16:00:00', value: 52.43 },
  { date: '2023-05-17T17:00:00', value: 23.4 },
  { date: '2023-05-17T18:00:00', value: 26.92 },
  { date: '2023-05-17T19:00:00', value: 11.08 },
  { date: '2023-05-17T20:00:00', value: 92.73 },
  { date: '2023-05-17T21:00:00', value: 90.64 },
  { date: '2023-05-17T22:00:00', value: 29.31 },
  { date: '2023-05-17T23:00:00', value: 41.1 },
  { date: '2023-05-18T00:00:00', value: 90.48 },
  { date: '2023-05-18T01:00:00', value: 97.39 },
  { date: '2023-05-18T02:00:00', value: 21.48 },
  { date: '2023-05-18T03:00:00', value: 1.21 },
  { date: '2023-05-18T04:00:00', value: 44.3 },
  { date: '2023-05-18T05:00:00', value: 35.04 },
  { date: '2023-05-18T06:00:00', value: 62.03 },
  { date: '2023-05-18T07:00:00', value: 95.99 },
  { date: '2023-05-18T08:00:00', value: 39.56 },
  { date: '2023-05-18T09:00:00', value: 38.07 },
  { date: '2023-05-18T10:00:00', value: 19.66 },
  { date: '2023-05-18T11:00:00', value: 94.26 },
  { date: '2023-05-18T12:00:00', value: 70.84 },
  { date: '2023-05-18T13:00:00', value: 62.6 },
  { date: '2023-05-18T14:00:00', value: 4.46 },
  { date: '2023-05-18T15:00:00', value: 43.29 },
  { date: '2023-05-18T16:00:00', value: 6.88 },
  { date: '2023-05-18T17:00:00', value: 38.39 },
  { date: '2023-05-18T18:00:00', value: 46.65 },
  { date: '2023-05-18T19:00:00', value: 15.34 },
  { date: '2023-05-18T20:00:00', value: 46.8 },
  { date: '2023-05-18T21:00:00', value: 45.16 },
  { date: '2023-05-18T22:00:00', value: 24.21 },
  { date: '2023-05-18T23:00:00', value: 43.31 },
  { date: '2023-05-19T00:00:00', value: 33.21 },
  { date: '2023-05-19T01:00:00', value: 39.59 },
  { date: '2023-05-19T02:00:00', value: 17.54 },
  { date: '2023-05-19T03:00:00', value: 53.01 },
  { date: '2023-05-19T04:00:00', value: 21.4 },
  { date: '2023-05-19T05:00:00', value: 31.71 },
  { date: '2023-05-19T06:00:00', value: 80.39 },
  { date: '2023-05-19T07:00:00', value: 44.32 },
  { date: '2023-05-19T08:00:00', value: 7.04 },
  { date: '2023-05-19T09:00:00', value: 69.22 },
  { date: '2023-05-19T10:00:00', value: 71.12 },
  { date: '2023-05-19T11:00:00', value: 45.23 },
  { date: '2023-05-19T12:00:00', value: 80.3 },
  { date: '2023-05-19T13:00:00', value: 49.33 },
  { date: '2023-05-19T14:00:00', value: 77.46 },
  { date: '2023-05-19T15:00:00', value: 57.57 },
  { date: '2023-05-19T16:00:00', value: 49.02 },
  { date: '2023-05-19T17:00:00', value: 33.87 },
  { date: '2023-05-19T18:00:00', value: 51.1 },
  { date: '2023-05-19T19:00:00', value: 31.08 },
  { date: '2023-05-19T20:00:00', value: 49.51 },
  { date: '2023-05-19T21:00:00', value: 32.95 },
  { date: '2023-05-19T22:00:00', value: 46.32 },
  { date: '2023-05-19T23:00:00', value: 48.76 },
  { date: '2023-05-20T00:00:00', value: 43.1 },
  { date: '2023-05-20T01:00:00', value: 15.43 },
  { date: '2023-05-20T02:00:00', value: 95.38 },
  { date: '2023-05-20T03:00:00', value: 20.05 },
  { date: '2023-05-20T04:00:00', value: 41.99 },
  { date: '2023-05-20T05:00:00', value: 30.55 },
  { date: '2023-05-20T06:00:00', value: 34.07 },
  { date: '2023-05-20T07:00:00', value: 22.93 },
  { date: '2023-05-20T08:00:00', value: 64.12 },
  { date: '2023-05-20T09:00:00', value: 66.8 },
  { date: '2023-05-20T10:00:00', value: 31.46 },
  { date: '2023-05-20T11:00:00', value: 15.54 },
  { date: '2023-05-20T12:00:00', value: 56.69 },
  { date: '2023-05-20T13:00:00', value: 85.27 },
  { date: '2023-05-20T14:00:00', value: 78.48 },
  { date: '2023-05-20T15:00:00', value: 39.71 },
  { date: '2023-05-20T16:00:00', value: 89.05 },
  { date: '2023-05-20T17:00:00', value: 2.38 },
  { date: '2023-05-20T18:00:00', value: 4.08 },
  { date: '2023-05-20T19:00:00', value: 70.03 },
  { date: '2023-05-20T20:00:00', value: 93.05 },
  { date: '2023-05-20T21:00:00', value: 76.83 },
  { date: '2023-05-20T22:00:00', value: 54.81 },
  { date: '2023-05-20T23:00:00', value: 69.76 },
  { date: '2023-05-21T00:00:00', value: 51.62 },
  { date: '2023-05-21T01:00:00', value: 96.92 },
  { date: '2023-05-21T02:00:00', value: 50.56 },
  { date: '2023-05-21T03:00:00', value: 48.28 },
  { date: '2023-05-21T04:00:00', value: 3.01 },
  { date: '2023-05-21T05:00:00', value: 48.52 },
  { date: '2023-05-21T06:00:00', value: 40.86 },
  { date: '2023-05-21T07:00:00', value: 5.07 },
  { date: '2023-05-21T08:00:00', value: 17.29 },
  { date: '2023-05-21T09:00:00', value: 74.06 },
  { date: '2023-05-21T10:00:00', value: 19.03 },
  { date: '2023-05-21T11:00:00', value: 76.95 },
  { date: '2023-05-21T12:00:00', value: 89.89 },
  { date: '2023-05-21T13:00:00', value: 80.5 },
  { date: '2023-05-21T14:00:00', value: 99.14 },
  { date: '2023-05-21T15:00:00', value: 42.26 },
  { date: '2023-05-21T16:00:00', value: 93.66 },
  { date: '2023-05-21T17:00:00', value: 44.41 },
  { date: '2023-05-21T18:00:00', value: 29.55 },
  { date: '2023-05-21T19:00:00', value: 8.64 },
  { date: '2023-05-21T20:00:00', value: 23.06 },
  { date: '2023-05-21T21:00:00', value: 10.44 },
  { date: '2023-05-21T22:00:00', value: 5.64 },
  { date: '2023-05-21T23:00:00', value: 12.6 },
  { date: '2023-05-22T00:00:00', value: 58.34 },
  { date: '2023-05-22T01:00:00', value: 20.61 },
  { date: '2023-05-22T02:00:00', value: 41.37 },
  { date: '2023-05-22T03:00:00', value: 46.46 },
  { date: '2023-05-22T04:00:00', value: 83.83 },
  { date: '2023-05-22T05:00:00', value: 10.85 },
  { date: '2023-05-22T06:00:00', value: 5.92 },
  { date: '2023-05-22T07:00:00', value: 94.03 },
  { date: '2023-05-22T08:00:00', value: 13.32 },
  { date: '2023-05-22T09:00:00', value: 31.29 },
  { date: '2023-05-22T10:00:00', value: 16.92 },
  { date: '2023-05-22T11:00:00', value: 31.1 },
  { date: '2023-05-22T12:00:00', value: 84.17 },
  { date: '2023-05-22T13:00:00', value: 75.4 },
  { date: '2023-05-22T14:00:00', value: 98.39 },
  { date: '2023-05-22T15:00:00', value: 65.4 },
  { date: '2023-05-22T16:00:00', value: 18.06 },
  { date: '2023-05-22T17:00:00', value: 94.82 },
  { date: '2023-05-22T18:00:00', value: 67.91 },
  { date: '2023-05-22T19:00:00', value: 46.3 },
  { date: '2023-05-22T20:00:00', value: 55.85 },
  { date: '2023-05-22T21:00:00', value: 3.64 },
  { date: '2023-05-22T22:00:00', value: 50.19 },
  { date: '2023-05-22T23:00:00', value: 96.27 },
  { date: '2023-05-23T00:00:00', value: 61.58 },
  { date: '2023-05-23T01:00:00', value: 59.96 },
  { date: '2023-05-23T02:00:00', value: 28.41 },
  { date: '2023-05-23T03:00:00', value: 94.17 },
  { date: '2023-05-23T04:00:00', value: 57.45 },
  { date: '2023-05-23T05:00:00', value: 97.86 },
  { date: '2023-05-23T06:00:00', value: 78.09 },
  { date: '2023-05-23T07:00:00', value: 29.93 },
  { date: '2023-05-23T08:00:00', value: 61.35 },
  { date: '2023-05-23T09:00:00', value: 24.73 },
  { date: '2023-05-23T10:00:00', value: 51.01 },
  { date: '2023-05-23T11:00:00', value: 61.77 },
  { date: '2023-05-23T12:00:00', value: 89.11 },
  { date: '2023-05-23T13:00:00', value: 88.71 },
  { date: '2023-05-23T14:00:00', value: 33.13 },
  { date: '2023-05-23T15:00:00', value: 49.32 },
  { date: '2023-05-23T16:00:00', value: 89.92 },
  { date: '2023-05-23T17:00:00', value: 60.3 },
  { date: '2023-05-23T18:00:00', value: 42.3 },
  { date: '2023-05-23T19:00:00', value: 50.63 },
  { date: '2023-05-23T20:00:00', value: 25.57 },
  { date: '2023-05-23T21:00:00', value: 35.4 },
  { date: '2023-05-23T22:00:00', value: 41.47 },
  { date: '2023-05-23T23:00:00', value: 90.28 },
  { date: '2023-05-24T00:00:00', value: 84.63 },
  { date: '2023-05-24T01:00:00', value: 28.35 },
  { date: '2023-05-24T02:00:00', value: 31.52 },
  { date: '2023-05-24T03:00:00', value: 78.61 },
  { date: '2023-05-24T04:00:00', value: 64.3 },
  { date: '2023-05-24T05:00:00', value: 23.08 },
  { date: '2023-05-24T06:00:00', value: 77.01 },
  { date: '2023-05-24T07:00:00', value: 98.58 },
  { date: '2023-05-24T08:00:00', value: 93.09 },
  { date: '2023-05-24T09:00:00', value: 31.55 },
  { date: '2023-05-24T10:00:00', value: 36.78 },
  { date: '2023-05-24T11:00:00', value: 59.7 },
  { date: '2023-05-24T12:00:00', value: 38.18 },
  { date: '2023-05-24T13:00:00', value: 93.35 },
  { date: '2023-05-24T14:00:00', value: 19.53 },
  { date: '2023-05-24T15:00:00', value: 63.18 },
  { date: '2023-05-24T16:00:00', value: 80.07 },
  { date: '2023-05-24T17:00:00', value: 71.12 },
  { date: '2023-05-24T18:00:00', value: 11.99 },
  { date: '2023-05-24T19:00:00', value: 97.92 },
  { date: '2023-05-24T20:00:00', value: 39.34 },
  { date: '2023-05-24T21:00:00', value: 69.07 },
  { date: '2023-05-24T22:00:00', value: 30.41 },
  { date: '2023-05-24T23:00:00', value: 83.42 },
  { date: '2023-05-25T00:00:00', value: 87.18 },
  { date: '2023-05-25T01:00:00', value: 11.96 },
  { date: '2023-05-25T02:00:00', value: 67.78 },
  { date: '2023-05-25T03:00:00', value: 24.66 },
  { date: '2023-05-25T04:00:00', value: 82.61 },
  { date: '2023-05-25T05:00:00', value: 31.81 },
  { date: '2023-05-25T06:00:00', value: 20.79 },
  { date: '2023-05-25T07:00:00', value: 28.72 },
  { date: '2023-05-25T08:00:00', value: 88.58 },
  { date: '2023-05-25T09:00:00', value: 92.63 },
  { date: '2023-05-25T10:00:00', value: 55.44 },
  { date: '2023-05-25T11:00:00', value: 42.09 },
  { date: '2023-05-25T12:00:00', value: 6.04 },
  { date: '2023-05-25T13:00:00', value: 39.43 },
  { date: '2023-05-25T14:00:00', value: 97.06 },
  { date: '2023-05-25T15:00:00', value: 64.99 },
  { date: '2023-05-25T16:00:00', value: 52.83 },
  { date: '2023-05-25T17:00:00', value: 82.82 },
  { date: '2023-05-25T18:00:00', value: 51.92 },
  { date: '2023-05-25T19:00:00', value: 55.82 },
  { date: '2023-05-25T20:00:00', value: 26.31 },
  { date: '2023-05-25T21:00:00', value: 81.39 },
  { date: '2023-05-25T22:00:00', value: 8.28 },
  { date: '2023-05-25T23:00:00', value: 15.64 },
  { date: '2023-05-26T00:00:00', value: 7.92 },
  { date: '2023-05-26T01:00:00', value: 32.48 },
  { date: '2023-05-26T02:00:00', value: 33.48 },
  { date: '2023-05-26T03:00:00', value: 40.42 },
  { date: '2023-05-26T04:00:00', value: 35.62 },
  { date: '2023-05-26T05:00:00', value: 53.27 },
  { date: '2023-05-26T06:00:00', value: 3.98 },
  { date: '2023-05-26T07:00:00', value: 73.51 },
  { date: '2023-05-26T08:00:00', value: 94.77 },
  { date: '2023-05-26T09:00:00', value: 17.31 },
  { date: '2023-05-26T10:00:00', value: 9.93 },
  { date: '2023-05-26T11:00:00', value: 15.78 },
  { date: '2023-05-26T12:00:00', value: 66.15 },
  { date: '2023-05-26T13:00:00', value: 91.61 },
  { date: '2023-05-26T14:00:00', value: 41.48 },
  { date: '2023-05-26T15:00:00', value: 8.01 },
  { date: '2023-05-26T16:00:00', value: 50.37 },
  { date: '2023-05-26T17:00:00', value: 36.78 },
  { date: '2023-05-26T18:00:00', value: 49.25 },
  { date: '2023-05-26T19:00:00', value: 44.31 },
  { date: '2023-05-26T20:00:00', value: 96.36 },
  { date: '2023-05-26T21:00:00', value: 55.2 },
  { date: '2023-05-26T22:00:00', value: 47.08 },
  { date: '2023-05-26T23:00:00', value: 25.34 },
  { date: '2023-05-27T00:00:00', value: 70.9 },
  { date: '2023-05-27T01:00:00', value: 69.28 },
  { date: '2023-05-27T02:00:00', value: 24.37 },
  { date: '2023-05-27T03:00:00', value: 91.08 },
  { date: '2023-05-27T04:00:00', value: 11.62 },
  { date: '2023-05-27T05:00:00', value: 65.05 },
  { date: '2023-05-27T06:00:00', value: 78.54 },
  { date: '2023-05-27T07:00:00', value: 12.45 },
  { date: '2023-05-27T08:00:00', value: 97.16 },
  { date: '2023-05-27T09:00:00', value: 52.45 },
  { date: '2023-05-27T10:00:00', value: 77.45 },
  { date: '2023-05-27T11:00:00', value: 77.25 },
  { date: '2023-05-27T12:00:00', value: 28.94 },
  { date: '2023-05-27T13:00:00', value: 61.84 },
  { date: '2023-05-27T14:00:00', value: 49.17 },
  { date: '2023-05-27T15:00:00', value: 72.72 },
  { date: '2023-05-27T16:00:00', value: 70.94 },
  { date: '2023-05-27T17:00:00', value: 21.22 },
  { date: '2023-05-27T18:00:00', value: 8.88 },
  { date: '2023-05-27T19:00:00', value: 82.83 },
  { date: '2023-05-27T20:00:00', value: 81.11 },
  { date: '2023-05-27T21:00:00', value: 64.14 },
  { date: '2023-05-27T22:00:00', value: 56.29 },
  { date: '2023-05-27T23:00:00', value: 28.47 },
  { date: '2023-05-28T00:00:00', value: 19.89 },
  { date: '2023-05-28T01:00:00', value: 45.26 },
  { date: '2023-05-28T02:00:00', value: 7.75 },
  { date: '2023-05-28T03:00:00', value: 4.12 },
  { date: '2023-05-28T04:00:00', value: 36.21 },
  { date: '2023-05-28T05:00:00', value: 53.48 },
  { date: '2023-05-28T06:00:00', value: 18.54 },
  { date: '2023-05-28T07:00:00', value: 88.58 },
  { date: '2023-05-28T08:00:00', value: 68.21 },
  { date: '2023-05-28T09:00:00', value: 96.52 },
  { date: '2023-05-28T10:00:00', value: 50.84 },
  { date: '2023-05-28T11:00:00', value: 67.82 },
  { date: '2023-05-28T12:00:00', value: 93.51 },
  { date: '2023-05-28T13:00:00', value: 55.75 },
  { date: '2023-05-28T14:00:00', value: 1.39 },
  { date: '2023-05-28T15:00:00', value: 57.79 },
  { date: '2023-05-28T16:00:00', value: 62.85 },
  { date: '2023-05-28T17:00:00', value: 79.59 },
  { date: '2023-05-28T18:00:00', value: 58.77 },
  { date: '2023-05-28T19:00:00', value: 7.61 },
  { date: '2023-05-28T20:00:00', value: 51.18 },
  { date: '2023-05-28T21:00:00', value: 53.9 },
  { date: '2023-05-28T22:00:00', value: 52.27 },
  { date: '2023-05-28T23:00:00', value: 48.17 },
  { date: '2023-05-29T00:00:00', value: 35.83 },
  { date: '2023-05-29T01:00:00', value: 16.3 },
  { date: '2023-05-29T02:00:00', value: 49.57 },
  { date: '2023-05-29T03:00:00', value: 46.49 },
  { date: '2023-05-29T04:00:00', value: 7.29 },
  { date: '2023-05-29T05:00:00', value: 79.76 },
  { date: '2023-05-29T06:00:00', value: 91.46 },
  { date: '2023-05-29T07:00:00', value: 7.47 },
  { date: '2023-05-29T08:00:00', value: 14.66 },
  { date: '2023-05-29T09:00:00', value: 74.56 },
  { date: '2023-05-29T10:00:00', value: 40.17 },
  { date: '2023-05-29T11:00:00', value: 47.79 },
  { date: '2023-05-29T12:00:00', value: 73.38 },
  { date: '2023-05-29T13:00:00', value: 99.26 },
  { date: '2023-05-29T14:00:00', value: 56.12 },
  { date: '2023-05-29T15:00:00', value: 48.28 },
  { date: '2023-05-29T16:00:00', value: 8.75 },
  { date: '2023-05-29T17:00:00', value: 98.5 },
  { date: '2023-05-29T18:00:00', value: 49.4 },
  { date: '2023-05-29T19:00:00', value: 89.73 },
  { date: '2023-05-29T20:00:00', value: 80.75 },
  { date: '2023-05-29T21:00:00', value: 92.84 },
  { date: '2023-05-29T22:00:00', value: 15.02 },
  { date: '2023-05-29T23:00:00', value: 55.16 },
  { date: '2023-05-30T00:00:00', value: 33.5 },
  { date: '2023-05-30T01:00:00', value: 13.62 },
  { date: '2023-05-30T02:00:00', value: 13.48 },
  { date: '2023-05-30T03:00:00', value: 44.77 },
  { date: '2023-05-30T04:00:00', value: 79.26 },
  { date: '2023-05-30T05:00:00', value: 77.05 },
  { date: '2023-05-30T06:00:00', value: 5.27 },
  { date: '2023-05-30T07:00:00', value: 87.19 },
  { date: '2023-05-30T08:00:00', value: 56.81 },
  { date: '2023-05-30T09:00:00', value: 18.9 },
  { date: '2023-05-30T10:00:00', value: 15.75 },
  { date: '2023-05-30T11:00:00', value: 22.54 },
  { date: '2023-05-30T12:00:00', value: 85.92 },
  { date: '2023-05-30T13:00:00', value: 11.49 },
  { date: '2023-05-30T14:00:00', value: 62.74 },
  { date: '2023-05-30T15:00:00', value: 83.0 },
  { date: '2023-05-30T16:00:00', value: 31.15 },
  { date: '2023-05-30T17:00:00', value: 86.64 },
  { date: '2023-05-30T18:00:00', value: 90.26 },
  { date: '2023-05-30T19:00:00', value: 89.38 },
  { date: '2023-05-30T20:00:00', value: 26.64 },
  { date: '2023-05-30T21:00:00', value: 45.1 },
  { date: '2023-05-30T22:00:00', value: 20.06 },
  { date: '2023-05-30T23:00:00', value: 31.69 },
  { date: '2023-05-31T00:00:00', value: 75.91 },
  { date: '2023-05-31T01:00:00', value: 55.47 },
  { date: '2023-05-31T02:00:00', value: 98.8 },
  { date: '2023-05-31T03:00:00', value: 75.63 },
  { date: '2023-05-31T04:00:00', value: 14.35 },
  { date: '2023-05-31T05:00:00', value: 55.42 },
  { date: '2023-05-31T06:00:00', value: 58.75 },
  { date: '2023-05-31T07:00:00', value: 59.66 },
  { date: '2023-05-31T08:00:00', value: 95.1 },
  { date: '2023-05-31T09:00:00', value: 15.19 },
  { date: '2023-05-31T10:00:00', value: 65.16 },
  { date: '2023-05-31T11:00:00', value: 33.71 },
  { date: '2023-05-31T12:00:00', value: 52.95 },
  { date: '2023-05-31T13:00:00', value: 75.12 },
  { date: '2023-05-31T14:00:00', value: 91.36 },
  { date: '2023-05-31T15:00:00', value: 47.22 },
  { date: '2023-05-31T16:00:00', value: 59.3 },
  { date: '2023-05-31T17:00:00', value: 63.83 },
  { date: '2023-05-31T18:00:00', value: 43.31 },
  { date: '2023-05-31T19:00:00', value: 50.55 },
  { date: '2023-05-31T20:00:00', value: 45.14 },
  { date: '2023-05-31T21:00:00', value: 64.95 },
  { date: '2023-05-31T22:00:00', value: 18.72 },
  { date: '2023-05-31T23:00:00', value: 10.79 },
  { date: '2023-06-01T00:00:00', value: 66.63 },
  { date: '2023-06-01T01:00:00', value: 66.62 },
  { date: '2023-06-01T02:00:00', value: 18.82 },
  { date: '2023-06-01T03:00:00', value: 5.62 },
  { date: '2023-06-01T04:00:00', value: 17.76 },
  { date: '2023-06-01T05:00:00', value: 88.63 },
  { date: '2023-06-01T06:00:00', value: 86.67 },
  { date: '2023-06-01T07:00:00', value: 47.17 },
  { date: '2023-06-01T08:00:00', value: 21.7 },
  { date: '2023-06-01T09:00:00', value: 55.06 },
  { date: '2023-06-01T10:00:00', value: 5.82 },
  { date: '2023-06-01T11:00:00', value: 71.62 },
  { date: '2023-06-01T12:00:00', value: 24.82 },
  { date: '2023-06-01T13:00:00', value: 45.52 },
  { date: '2023-06-01T14:00:00', value: 62.37 },
  { date: '2023-06-01T15:00:00', value: 16.72 },
  { date: '2023-06-01T16:00:00', value: 66.76 },
  { date: '2023-06-01T17:00:00', value: 37.37 },
  { date: '2023-06-01T18:00:00', value: 29.88 },
  { date: '2023-06-01T19:00:00', value: 82.35 },
  { date: '2023-06-01T20:00:00', value: 74.92 },
  { date: '2023-06-01T21:00:00', value: 43.63 },
  { date: '2023-06-01T22:00:00', value: 95.31 },
  { date: '2023-06-01T23:00:00', value: 72.68 },
  { date: '2023-06-02T00:00:00', value: 59.8 },
  { date: '2023-06-02T01:00:00', value: 24.8 },
  { date: '2023-06-02T02:00:00', value: 31.0 },
  { date: '2023-06-02T03:00:00', value: 45.4 },
  { date: '2023-06-02T04:00:00', value: 47.89 },
  { date: '2023-06-02T05:00:00', value: 18.49 },
  { date: '2023-06-02T06:00:00', value: 5.09 },
  { date: '2023-06-02T07:00:00', value: 62.16 },
  { date: '2023-06-02T08:00:00', value: 63.14 },
  { date: '2023-06-02T09:00:00', value: 43.11 },
  { date: '2023-06-02T10:00:00', value: 39.78 },
  { date: '2023-06-02T11:00:00', value: 62.44 },
  { date: '2023-06-02T12:00:00', value: 83.37 },
  { date: '2023-06-02T13:00:00', value: 88.35 },
  { date: '2023-06-02T14:00:00', value: 92.36 },
  { date: '2023-06-02T15:00:00', value: 99.01 },
  { date: '2023-06-02T16:00:00', value: 96.66 },
  { date: '2023-06-02T17:00:00', value: 43.34 },
  { date: '2023-06-02T18:00:00', value: 27.21 },
  { date: '2023-06-02T19:00:00', value: 91.24 },
  { date: '2023-06-02T20:00:00', value: 50.34 },
  { date: '2023-06-02T21:00:00', value: 16.64 },
  { date: '2023-06-02T22:00:00', value: 98.05 },
  { date: '2023-06-02T23:00:00', value: 89.8 },
  { date: '2023-06-03T00:00:00', value: 28.82 },
  { date: '2023-06-03T01:00:00', value: 96.75 },
  { date: '2023-06-03T02:00:00', value: 94.08 },
  { date: '2023-06-03T03:00:00', value: 34.58 },
  { date: '2023-06-03T04:00:00', value: 45.96 },
  { date: '2023-06-03T05:00:00', value: 31.42 },
  { date: '2023-06-03T06:00:00', value: 3.53 },
  { date: '2023-06-03T07:00:00', value: 52.74 },
  { date: '2023-06-03T08:00:00', value: 71.72 },
  { date: '2023-06-03T09:00:00', value: 72.68 },
  { date: '2023-06-03T10:00:00', value: 39.12 },
  { date: '2023-06-03T11:00:00', value: 9.12 },
  { date: '2023-06-03T12:00:00', value: 36.27 },
  { date: '2023-06-03T13:00:00', value: 36.39 },
  { date: '2023-06-03T14:00:00', value: 8.58 },
  { date: '2023-06-03T15:00:00', value: 69.84 },
  { date: '2023-06-03T16:00:00', value: 2.99 },
  { date: '2023-06-03T17:00:00', value: 48.26 },
  { date: '2023-06-03T18:00:00', value: 62.04 },
  { date: '2023-06-03T19:00:00', value: 86.51 },
  { date: '2023-06-03T20:00:00', value: 91.49 },
  { date: '2023-06-03T21:00:00', value: 28.4 },
  { date: '2023-06-03T22:00:00', value: 17.59 },
  { date: '2023-06-03T23:00:00', value: 42.34 },
  { date: '2023-06-04T00:00:00', value: 94.65 },
  { date: '2023-06-04T01:00:00', value: 42.46 },
  { date: '2023-06-04T02:00:00', value: 7.41 },
  { date: '2023-06-04T03:00:00', value: 52.29 },
  { date: '2023-06-04T04:00:00', value: 76.66 },
  { date: '2023-06-04T05:00:00', value: 9.32 },
  { date: '2023-06-04T06:00:00', value: 89.59 },
  { date: '2023-06-04T07:00:00', value: 76.25 },
  { date: '2023-06-04T08:00:00', value: 61.93 },
  { date: '2023-06-04T09:00:00', value: 34.62 },
  { date: '2023-06-04T10:00:00', value: 60.88 },
  { date: '2023-06-04T11:00:00', value: 90.96 },
  { date: '2023-06-04T12:00:00', value: 74.81 },
  { date: '2023-06-04T13:00:00', value: 11.9 },
  { date: '2023-06-04T14:00:00', value: 76.26 },
  { date: '2023-06-04T15:00:00', value: 22.65 },
  { date: '2023-06-04T16:00:00', value: 7.24 },
  { date: '2023-06-04T17:00:00', value: 71.8 },
  { date: '2023-06-04T18:00:00', value: 16.93 },
  { date: '2023-06-04T19:00:00', value: 86.24 },
  { date: '2023-06-04T20:00:00', value: 74.91 },
  { date: '2023-06-04T21:00:00', value: 28.43 },
  { date: '2023-06-04T22:00:00', value: 43.12 },
  { date: '2023-06-04T23:00:00', value: 70.68 },
  { date: '2023-06-05T00:00:00', value: 99.92 },
  { date: '2023-06-05T01:00:00', value: 50.09 },
  { date: '2023-06-05T02:00:00', value: 33.16 },
  { date: '2023-06-05T03:00:00', value: 75.68 },
  { date: '2023-06-05T04:00:00', value: 27.5 },
  { date: '2023-06-05T05:00:00', value: 45.16 },
  { date: '2023-06-05T06:00:00', value: 71.66 },
  { date: '2023-06-05T07:00:00', value: 60.14 },
  { date: '2023-06-05T08:00:00', value: 54.4 },
  { date: '2023-06-05T09:00:00', value: 5.84 },
  { date: '2023-06-05T10:00:00', value: 71.36 },
  { date: '2023-06-05T11:00:00', value: 20.28 },
  { date: '2023-06-05T12:00:00', value: 28.08 },
  { date: '2023-06-05T13:00:00', value: 87.89 },
  { date: '2023-06-05T14:00:00', value: 82.62 },
  { date: '2023-06-05T15:00:00', value: 97.14 },
  { date: '2023-06-05T16:00:00', value: 38.49 },
  { date: '2023-06-05T17:00:00', value: 17.4 },
  { date: '2023-06-05T18:00:00', value: 49.75 },
  { date: '2023-06-05T19:00:00', value: 94.36 },
  { date: '2023-06-05T20:00:00', value: 70.67 },
  { date: '2023-06-05T21:00:00', value: 26.02 },
  { date: '2023-06-05T22:00:00', value: 16.36 },
  { date: '2023-06-05T23:00:00', value: 67.28 },
  { date: '2023-06-06T00:00:00', value: 20.51 },
  { date: '2023-06-06T01:00:00', value: 88.99 },
  { date: '2023-06-06T02:00:00', value: 3.77 },
  { date: '2023-06-06T03:00:00', value: 10.78 },
  { date: '2023-06-06T04:00:00', value: 56.07 },
  { date: '2023-06-06T05:00:00', value: 58.28 },
  { date: '2023-06-06T06:00:00', value: 86.03 },
  { date: '2023-06-06T07:00:00', value: 14.59 },
  { date: '2023-06-06T08:00:00', value: 1.53 },
  { date: '2023-06-06T09:00:00', value: 76.36 },
  { date: '2023-06-06T10:00:00', value: 31.0 },
  { date: '2023-06-06T11:00:00', value: 8.16 },
  { date: '2023-06-06T12:00:00', value: 26.7 },
  { date: '2023-06-06T13:00:00', value: 5.89 },
  { date: '2023-06-06T14:00:00', value: 96.2 },
  { date: '2023-06-06T15:00:00', value: 50.56 },
  { date: '2023-06-06T16:00:00', value: 61.48 },
  { date: '2023-06-06T17:00:00', value: 92.98 },
  { date: '2023-06-06T18:00:00', value: 68.92 },
  { date: '2023-06-06T19:00:00', value: 58.34 },
  { date: '2023-06-06T20:00:00', value: 23.52 },
  { date: '2023-06-06T21:00:00', value: 9.92 },
  { date: '2023-06-06T22:00:00', value: 13.57 },
  { date: '2023-06-06T23:00:00', value: 56.34 },
  { date: '2023-06-07T00:00:00', value: 70.09 },
  { date: '2023-06-07T01:00:00', value: 13.05 },
  { date: '2023-06-07T02:00:00', value: 76.89 },
  { date: '2023-06-07T03:00:00', value: 24.29 },
  { date: '2023-06-07T04:00:00', value: 94.57 },
  { date: '2023-06-07T05:00:00', value: 60.32 },
  { date: '2023-06-07T06:00:00', value: 92.76 },
  { date: '2023-06-07T07:00:00', value: 27.36 },
  { date: '2023-06-07T08:00:00', value: 18.86 },
  { date: '2023-06-07T09:00:00', value: 66.71 },
  { date: '2023-06-07T10:00:00', value: 98.76 },
  { date: '2023-06-07T11:00:00', value: 9.61 },
  { date: '2023-06-07T12:00:00', value: 9.01 },
  { date: '2023-06-07T13:00:00', value: 77.4 },
  { date: '2023-06-07T14:00:00', value: 27.81 },
  { date: '2023-06-07T15:00:00', value: 11.67 },
  { date: '2023-06-07T16:00:00', value: 61.41 },
  { date: '2023-06-07T17:00:00', value: 33.97 },
  { date: '2023-06-07T18:00:00', value: 42.01 },
  { date: '2023-06-07T19:00:00', value: 85.37 },
  { date: '2023-06-07T20:00:00', value: 17.72 },
  { date: '2023-06-07T21:00:00', value: 39.07 },
  { date: '2023-06-07T22:00:00', value: 56.03 },
  { date: '2023-06-07T23:00:00', value: 53.34 },
  { date: '2023-06-08T00:00:00', value: 81.95 },
  { date: '2023-06-08T01:00:00', value: 57.76 },
  { date: '2023-06-08T02:00:00', value: 89.35 },
  { date: '2023-06-08T03:00:00', value: 92.63 },
  { date: '2023-06-08T04:00:00', value: 81.15 },
  { date: '2023-06-08T05:00:00', value: 42.2 },
  { date: '2023-06-08T06:00:00', value: 8.89 },
  { date: '2023-06-08T07:00:00', value: 29.28 },
  { date: '2023-06-08T08:00:00', value: 83.78 },
  { date: '2023-06-08T09:00:00', value: 91.37 },
  { date: '2023-06-08T10:00:00', value: 44.53 },
  { date: '2023-06-08T11:00:00', value: 83.35 },
  { date: '2023-06-08T12:00:00', value: 27.13 },
  { date: '2023-06-08T13:00:00', value: 37.15 },
  { date: '2023-06-08T14:00:00', value: 82.29 },
  { date: '2023-06-08T15:00:00', value: 7.59 },
  { date: '2023-06-08T16:00:00', value: 9.6 },
  { date: '2023-06-08T17:00:00', value: 65.09 },
  { date: '2023-06-08T18:00:00', value: 23.11 },
  { date: '2023-06-08T19:00:00', value: 91.92 },
  { date: '2023-06-08T20:00:00', value: 85.96 },
  { date: '2023-06-08T21:00:00', value: 16.04 },
  { date: '2023-06-08T22:00:00', value: 42.08 },
  { date: '2023-06-08T23:00:00', value: 22.67 },
  { date: '2023-06-09T00:00:00', value: 13.15 },
  { date: '2023-06-09T01:00:00', value: 38.28 },
  { date: '2023-06-09T02:00:00', value: 7.16 },
  { date: '2023-06-09T03:00:00', value: 72.31 },
  { date: '2023-06-09T04:00:00', value: 33.35 },
  { date: '2023-06-09T05:00:00', value: 69.51 },
  { date: '2023-06-09T06:00:00', value: 38.42 },
  { date: '2023-06-09T07:00:00', value: 17.97 },
  { date: '2023-06-09T08:00:00', value: 59.49 },
  { date: '2023-06-09T09:00:00', value: 72.1 },
  { date: '2023-06-09T10:00:00', value: 54.49 },
  { date: '2023-06-09T11:00:00', value: 95.55 },
  { date: '2023-06-09T12:00:00', value: 85.87 },
  { date: '2023-06-09T13:00:00', value: 23.0 },
  { date: '2023-06-09T14:00:00', value: 61.35 },
  { date: '2023-06-09T15:00:00', value: 4.96 },
  { date: '2023-06-09T16:00:00', value: 37.89 },
  { date: '2023-06-09T17:00:00', value: 25.5 },
  { date: '2023-06-09T18:00:00', value: 95.26 },
  { date: '2023-06-09T19:00:00', value: 46.39 },
  { date: '2023-06-09T20:00:00', value: 48.16 },
  { date: '2023-06-09T21:00:00', value: 59.57 },
  { date: '2023-06-09T22:00:00', value: 38.21 },
  { date: '2023-06-09T23:00:00', value: 69.43 },
  { date: '2023-06-10T00:00:00', value: 22.78 },
  { date: '2023-06-10T01:00:00', value: 39.14 },
  { date: '2023-06-10T02:00:00', value: 51.13 },
  { date: '2023-06-10T03:00:00', value: 34.89 },
  { date: '2023-06-10T04:00:00', value: 38.46 },
  { date: '2023-06-10T05:00:00', value: 67.31 },
  { date: '2023-06-10T06:00:00', value: 97.15 },
  { date: '2023-06-10T07:00:00', value: 83.66 },
  { date: '2023-06-10T08:00:00', value: 8.13 },
  { date: '2023-06-10T09:00:00', value: 47.89 },
  { date: '2023-06-10T10:00:00', value: 12.75 },
  { date: '2023-06-10T11:00:00', value: 56.56 },
  { date: '2023-06-10T12:00:00', value: 53.49 },
  { date: '2023-06-10T13:00:00', value: 61.03 },
  { date: '2023-06-10T14:00:00', value: 2.01 },
  { date: '2023-06-10T15:00:00', value: 14.93 },
  { date: '2023-06-10T16:00:00', value: 48.05 },
  { date: '2023-06-10T17:00:00', value: 21.96 },
  { date: '2023-06-10T18:00:00', value: 73.41 },
  { date: '2023-06-10T19:00:00', value: 83.72 },
  { date: '2023-06-10T20:00:00', value: 89.05 },
  { date: '2023-06-10T21:00:00', value: 44.94 },
  { date: '2023-06-10T22:00:00', value: 70.81 },
  { date: '2023-06-10T23:00:00', value: 10.66 },
  { date: '2023-06-11T00:00:00', value: 96.24 },
  { date: '2023-06-11T01:00:00', value: 37.63 },
  { date: '2023-06-11T02:00:00', value: 91.74 },
  { date: '2023-06-11T03:00:00', value: 43.96 },
  { date: '2023-06-11T04:00:00', value: 27.5 },
  { date: '2023-06-11T05:00:00', value: 77.2 },
  { date: '2023-06-11T06:00:00', value: 2.78 },
  { date: '2023-06-11T07:00:00', value: 38.69 },
  { date: '2023-06-11T08:00:00', value: 20.53 },
  { date: '2023-06-11T09:00:00', value: 30.77 },
  { date: '2023-06-11T10:00:00', value: 11.59 },
  { date: '2023-06-11T11:00:00', value: 87.14 },
  { date: '2023-06-11T12:00:00', value: 84.01 },
  { date: '2023-06-11T13:00:00', value: 68.26 },
  { date: '2023-06-11T14:00:00', value: 10.59 },
  { date: '2023-06-11T15:00:00', value: 13.53 },
  { date: '2023-06-11T16:00:00', value: 96.8 },
  { date: '2023-06-11T17:00:00', value: 55.08 },
  { date: '2023-06-11T18:00:00', value: 68.74 },
  { date: '2023-06-11T19:00:00', value: 29.18 },
  { date: '2023-06-11T20:00:00', value: 22.99 },
  { date: '2023-06-11T21:00:00', value: 62.94 },
  { date: '2023-06-11T22:00:00', value: 66.34 },
  { date: '2023-06-11T23:00:00', value: 5.07 },
  { date: '2023-06-12T00:00:00', value: 67.25 },
  { date: '2023-06-12T01:00:00', value: 86.82 },
  { date: '2023-06-12T02:00:00', value: 50.25 },
  { date: '2023-06-12T03:00:00', value: 85.09 },
  { date: '2023-06-12T04:00:00', value: 26.49 },
  { date: '2023-06-12T05:00:00', value: 39.63 },
  { date: '2023-06-12T06:00:00', value: 63.18 },
  { date: '2023-06-12T07:00:00', value: 19.87 },
  { date: '2023-06-12T08:00:00', value: 41.64 },
  { date: '2023-06-12T09:00:00', value: 73.96 },
  { date: '2023-06-12T10:00:00', value: 18.06 },
  { date: '2023-06-12T11:00:00', value: 35.22 },
  { date: '2023-06-12T12:00:00', value: 42.52 },
  { date: '2023-06-12T13:00:00', value: 8.59 },
  { date: '2023-06-12T14:00:00', value: 29.99 },
  { date: '2023-06-12T15:00:00', value: 55.71 },
  { date: '2023-06-12T16:00:00', value: 33.06 },
  { date: '2023-06-12T17:00:00', value: 57.76 },
  { date: '2023-06-12T18:00:00', value: 92.92 },
  { date: '2023-06-12T19:00:00', value: 3.23 },
  { date: '2023-06-12T20:00:00', value: 50.32 },
  { date: '2023-06-12T21:00:00', value: 47.24 },
  { date: '2023-06-12T22:00:00', value: 2.65 },
  { date: '2023-06-12T23:00:00', value: 67.15 },
  { date: '2023-06-13T00:00:00', value: 6.59 },
  { date: '2023-06-13T01:00:00', value: 48.6 },
  { date: '2023-06-13T02:00:00', value: 73.07 },
  { date: '2023-06-13T03:00:00', value: 8.77 },
  { date: '2023-06-13T04:00:00', value: 81.93 },
  { date: '2023-06-13T05:00:00', value: 84.25 },
  { date: '2023-06-13T06:00:00', value: 42.74 },
  { date: '2023-06-13T07:00:00', value: 69.4 },
  { date: '2023-06-13T08:00:00', value: 73.56 },
  { date: '2023-06-13T09:00:00', value: 35.46 },
  { date: '2023-06-13T10:00:00', value: 85.14 },
  { date: '2023-06-13T11:00:00', value: 45.03 },
  { date: '2023-06-13T12:00:00', value: 11.85 },
  { date: '2023-06-13T13:00:00', value: 36.58 },
  { date: '2023-06-13T14:00:00', value: 70.78 },
  { date: '2023-06-13T15:00:00', value: 52.54 },
  { date: '2023-06-13T16:00:00', value: 33.23 },
  { date: '2023-06-13T17:00:00', value: 79.68 },
  { date: '2023-06-13T18:00:00', value: 84.56 },
  { date: '2023-06-13T19:00:00', value: 7.59 },
  { date: '2023-06-13T20:00:00', value: 88.58 },
  { date: '2023-06-13T21:00:00', value: 81.39 },
  { date: '2023-06-13T22:00:00', value: 30.71 },
  { date: '2023-06-13T23:00:00', value: 21.75 },
  { date: '2023-06-14T00:00:00', value: 47.84 },
  { date: '2023-06-14T01:00:00', value: 70.72 },
  { date: '2023-06-14T02:00:00', value: 5.65 },
  { date: '2023-06-14T03:00:00', value: 6.0 },
  { date: '2023-06-14T04:00:00', value: 46.57 },
  { date: '2023-06-14T05:00:00', value: 4.12 },
  { date: '2023-06-14T06:00:00', value: 19.21 },
  { date: '2023-06-14T07:00:00', value: 81.86 },
  { date: '2023-06-14T08:00:00', value: 86.58 },
  { date: '2023-06-14T09:00:00', value: 40.66 },
  { date: '2023-06-14T10:00:00', value: 32.13 },
  { date: '2023-06-14T11:00:00', value: 54.37 },
  { date: '2023-06-14T12:00:00', value: 45.87 },
  { date: '2023-06-14T13:00:00', value: 11.29 },
  { date: '2023-06-14T14:00:00', value: 51.36 },
  { date: '2023-06-14T15:00:00', value: 26.47 },
  { date: '2023-06-14T16:00:00', value: 80.23 },
  { date: '2023-06-14T17:00:00', value: 60.66 },
  { date: '2023-06-14T18:00:00', value: 61.34 },
  { date: '2023-06-14T19:00:00', value: 39.17 },
  { date: '2023-06-14T20:00:00', value: 67.33 },
  { date: '2023-06-14T21:00:00', value: 32.89 },
  { date: '2023-06-14T22:00:00', value: 92.78 },
  { date: '2023-06-14T23:00:00', value: 10.18 },
  { date: '2023-06-15T00:00:00', value: 83.53 },
  { date: '2023-06-15T01:00:00', value: 71.8 },
  { date: '2023-06-15T02:00:00', value: 40.81 },
  { date: '2023-06-15T03:00:00', value: 48.67 },
  { date: '2023-06-15T04:00:00', value: 30.83 },
  { date: '2023-06-15T05:00:00', value: 2.03 },
  { date: '2023-06-15T06:00:00', value: 35.1 },
  { date: '2023-06-15T07:00:00', value: 99.81 },
  { date: '2023-06-15T08:00:00', value: 98.35 },
  { date: '2023-06-15T09:00:00', value: 78.0 },
  { date: '2023-06-15T10:00:00', value: 24.87 },
  { date: '2023-06-15T11:00:00', value: 1.87 },
  { date: '2023-06-15T12:00:00', value: 73.6 },
  { date: '2023-06-15T13:00:00', value: 27.11 },
  { date: '2023-06-15T14:00:00', value: 71.55 },
  { date: '2023-06-15T15:00:00', value: 84.95 },
  { date: '2023-06-15T16:00:00', value: 66.87 },
  { date: '2023-06-15T17:00:00', value: 34.24 },
  { date: '2023-06-15T18:00:00', value: 85.16 },
  { date: '2023-06-15T19:00:00', value: 93.03 },
  { date: '2023-06-15T20:00:00', value: 11.11 },
  { date: '2023-06-15T21:00:00', value: 54.69 },
  { date: '2023-06-15T22:00:00', value: 16.03 },
  { date: '2023-06-15T23:00:00', value: 23.02 },
  { date: '2023-06-16T00:00:00', value: 41.88 },
  { date: '2023-06-16T01:00:00', value: 66.44 },
  { date: '2023-06-16T02:00:00', value: 48.4 },
  { date: '2023-06-16T03:00:00', value: 21.3 },
  { date: '2023-06-16T04:00:00', value: 96.12 },
  { date: '2023-06-16T05:00:00', value: 68.86 },
  { date: '2023-06-16T06:00:00', value: 48.03 },
  { date: '2023-06-16T07:00:00', value: 2.14 },
  { date: '2023-06-16T08:00:00', value: 86.86 },
  { date: '2023-06-16T09:00:00', value: 83.14 },
  { date: '2023-06-16T10:00:00', value: 99.66 },
  { date: '2023-06-16T11:00:00', value: 91.07 },
  { date: '2023-06-16T12:00:00', value: 4.53 },
  { date: '2023-06-16T13:00:00', value: 11.57 },
  { date: '2023-06-16T14:00:00', value: 68.15 },
  { date: '2023-06-16T15:00:00', value: 95.95 },
  { date: '2023-06-16T16:00:00', value: 30.66 },
  { date: '2023-06-16T17:00:00', value: 80.53 },
  { date: '2023-06-16T18:00:00', value: 27.69 },
  { date: '2023-06-16T19:00:00', value: 37.06 },
  { date: '2023-06-16T20:00:00', value: 68.93 },
  { date: '2023-06-16T21:00:00', value: 76.02 },
  { date: '2023-06-16T22:00:00', value: 77.92 },
  { date: '2023-06-16T23:00:00', value: 45.27 },
  { date: '2023-06-17T00:00:00', value: 21.14 },
  { date: '2023-06-17T01:00:00', value: 49.95 },
  { date: '2023-06-17T02:00:00', value: 21.2 },
  { date: '2023-06-17T03:00:00', value: 75.89 },
  { date: '2023-06-17T04:00:00', value: 36.16 },
  { date: '2023-06-17T05:00:00', value: 39.36 },
  { date: '2023-06-17T06:00:00', value: 40.75 },
  { date: '2023-06-17T07:00:00', value: 25.95 },
  { date: '2023-06-17T08:00:00', value: 94.38 },
  { date: '2023-06-17T09:00:00', value: 37.09 },
  { date: '2023-06-17T10:00:00', value: 75.38 },
  { date: '2023-06-17T11:00:00', value: 74.01 },
  { date: '2023-06-17T12:00:00', value: 78.57 },
  { date: '2023-06-17T13:00:00', value: 32.78 },
  { date: '2023-06-17T14:00:00', value: 69.02 },
  { date: '2023-06-17T15:00:00', value: 36.61 },
  { date: '2023-06-17T16:00:00', value: 82.18 },
  { date: '2023-06-17T17:00:00', value: 90.97 },
  { date: '2023-06-17T18:00:00', value: 94.01 },
  { date: '2023-06-17T19:00:00', value: 50.81 },
  { date: '2023-06-17T20:00:00', value: 15.4 },
  { date: '2023-06-17T21:00:00', value: 57.82 },
  { date: '2023-06-17T22:00:00', value: 80.35 },
  { date: '2023-06-17T23:00:00', value: 17.47 },
  { date: '2023-06-18T00:00:00', value: 31.93 },
  { date: '2023-06-18T01:00:00', value: 42.92 },
  { date: '2023-06-18T02:00:00', value: 99.19 },
  { date: '2023-06-18T03:00:00', value: 21.78 },
  { date: '2023-06-18T04:00:00', value: 5.98 },
  { date: '2023-06-18T05:00:00', value: 92.17 },
  { date: '2023-06-18T06:00:00', value: 91.0 },
  { date: '2023-06-18T07:00:00', value: 88.94 },
  { date: '2023-06-18T08:00:00', value: 75.87 },
  { date: '2023-06-18T09:00:00', value: 42.71 },
  { date: '2023-06-18T10:00:00', value: 72.46 },
  { date: '2023-06-18T11:00:00', value: 46.26 },
  { date: '2023-06-18T12:00:00', value: 97.12 },
  { date: '2023-06-18T13:00:00', value: 82.15 },
  { date: '2023-06-18T14:00:00', value: 68.41 },
  { date: '2023-06-18T15:00:00', value: 69.43 },
  { date: '2023-06-18T16:00:00', value: 16.06 },
  { date: '2023-06-18T17:00:00', value: 43.07 },
  { date: '2023-06-18T18:00:00', value: 93.69 },
  { date: '2023-06-18T19:00:00', value: 38.47 },
  { date: '2023-06-18T20:00:00', value: 60.66 },
  { date: '2023-06-18T21:00:00', value: 62.2 },
  { date: '2023-06-18T22:00:00', value: 67.91 },
  { date: '2023-06-18T23:00:00', value: 5.54 },
  { date: '2023-06-19T00:00:00', value: 36.58 },
  { date: '2023-06-19T01:00:00', value: 30.02 },
  { date: '2023-06-19T02:00:00', value: 21.77 },
  { date: '2023-06-19T03:00:00', value: 66.1 },
  { date: '2023-06-19T04:00:00', value: 23.53 },
  { date: '2023-06-19T05:00:00', value: 9.46 },
  { date: '2023-06-19T06:00:00', value: 19.78 },
  { date: '2023-06-19T07:00:00', value: 8.43 },
  { date: '2023-06-19T08:00:00', value: 42.26 },
  { date: '2023-06-19T09:00:00', value: 35.34 },
  { date: '2023-06-19T10:00:00', value: 49.89 },
  { date: '2023-06-19T11:00:00', value: 6.15 },
  { date: '2023-06-19T12:00:00', value: 29.91 },
  { date: '2023-06-19T13:00:00', value: 7.99 },
  { date: '2023-06-19T14:00:00', value: 10.83 },
  { date: '2023-06-19T15:00:00', value: 13.29 },
  { date: '2023-06-19T16:00:00', value: 81.32 },
  { date: '2023-06-19T17:00:00', value: 67.74 },
  { date: '2023-06-19T18:00:00', value: 58.84 },
  { date: '2023-06-19T19:00:00', value: 72.69 },
  { date: '2023-06-19T20:00:00', value: 77.73 },
  { date: '2023-06-19T21:00:00', value: 71.64 },
  { date: '2023-06-19T22:00:00', value: 53.05 },
  { date: '2023-06-19T23:00:00', value: 13.19 },
  { date: '2023-06-20T00:00:00', value: 74.23 },
  { date: '2023-06-20T01:00:00', value: 70.33 },
  { date: '2023-06-20T02:00:00', value: 18.17 },
  { date: '2023-06-20T03:00:00', value: 78.74 },
  { date: '2023-06-20T04:00:00', value: 51.64 },
  { date: '2023-06-20T05:00:00', value: 99.78 },
  { date: '2023-06-20T06:00:00', value: 78.52 },
  { date: '2023-06-20T07:00:00', value: 52.41 },
  { date: '2023-06-20T08:00:00', value: 11.94 },
  { date: '2023-06-20T09:00:00', value: 28.28 },
  { date: '2023-06-20T10:00:00', value: 44.49 },
  { date: '2023-06-20T11:00:00', value: 3.14 },
  { date: '2023-06-20T12:00:00', value: 92.9 },
  { date: '2023-06-20T13:00:00', value: 65.54 },
  { date: '2023-06-20T14:00:00', value: 97.49 },
  { date: '2023-06-20T15:00:00', value: 63.03 },
  { date: '2023-06-20T16:00:00', value: 3.1 },
  { date: '2023-06-20T17:00:00', value: 70.37 },
  { date: '2023-06-20T18:00:00', value: 90.56 },
  { date: '2023-06-20T19:00:00', value: 94.5 },
  { date: '2023-06-20T20:00:00', value: 31.93 },
  { date: '2023-06-20T21:00:00', value: 78.35 },
  { date: '2023-06-20T22:00:00', value: 53.0 },
  { date: '2023-06-20T23:00:00', value: 6.98 },
  { date: '2023-06-21T00:00:00', value: 8.53 },
  { date: '2023-06-21T01:00:00', value: 88.09 },
  { date: '2023-06-21T02:00:00', value: 52.57 },
  { date: '2023-06-21T03:00:00', value: 91.41 },
  { date: '2023-06-21T04:00:00', value: 69.76 },
  { date: '2023-06-21T05:00:00', value: 84.19 },
  { date: '2023-06-21T06:00:00', value: 74.99 },
  { date: '2023-06-21T07:00:00', value: 98.03 },
  { date: '2023-06-21T08:00:00', value: 1.28 },
  { date: '2023-06-21T09:00:00', value: 86.98 },
  { date: '2023-06-21T10:00:00', value: 54.12 },
  { date: '2023-06-21T11:00:00', value: 34.38 },
  { date: '2023-06-21T12:00:00', value: 90.3 },
  { date: '2023-06-21T13:00:00', value: 47.05 },
  { date: '2023-06-21T14:00:00', value: 44.21 },
  { date: '2023-06-21T15:00:00', value: 3.69 },
  { date: '2023-06-21T16:00:00', value: 77.76 },
  { date: '2023-06-21T17:00:00', value: 32.59 },
  { date: '2023-06-21T18:00:00', value: 21.44 },
  { date: '2023-06-21T19:00:00', value: 59.05 },
  { date: '2023-06-21T20:00:00', value: 9.16 },
  { date: '2023-06-21T21:00:00', value: 56.55 },
  { date: '2023-06-21T22:00:00', value: 68.55 },
  { date: '2023-06-21T23:00:00', value: 79.37 },
  { date: '2023-06-22T00:00:00', value: 44.19 },
  { date: '2023-06-22T01:00:00', value: 1.38 },
  { date: '2023-06-22T02:00:00', value: 77.18 },
  { date: '2023-06-22T03:00:00', value: 50.3 },
  { date: '2023-06-22T04:00:00', value: 89.35 },
  { date: '2023-06-22T05:00:00', value: 41.4 },
  { date: '2023-06-22T06:00:00', value: 37.2 },
  { date: '2023-06-22T07:00:00', value: 31.78 },
  { date: '2023-06-22T08:00:00', value: 5.98 },
  { date: '2023-06-22T09:00:00', value: 89.76 },
  { date: '2023-06-22T10:00:00', value: 45.51 },
  { date: '2023-06-22T11:00:00', value: 2.13 },
  { date: '2023-06-22T12:00:00', value: 70.42 },
  { date: '2023-06-22T13:00:00', value: 43.36 },
  { date: '2023-06-22T14:00:00', value: 95.17 },
  { date: '2023-06-22T15:00:00', value: 97.25 },
  { date: '2023-06-22T16:00:00', value: 20.17 },
  { date: '2023-06-22T17:00:00', value: 84.97 },
  { date: '2023-06-22T18:00:00', value: 88.3 },
  { date: '2023-06-22T19:00:00', value: 1.38 },
  { date: '2023-06-22T20:00:00', value: 4.64 },
  { date: '2023-06-22T21:00:00', value: 27.98 },
  { date: '2023-06-22T22:00:00', value: 16.46 },
  { date: '2023-06-22T23:00:00', value: 93.01 },
  { date: '2023-06-23T00:00:00', value: 32.49 },
  { date: '2023-06-23T01:00:00', value: 82.68 },
  { date: '2023-06-23T02:00:00', value: 62.49 },
  { date: '2023-06-23T03:00:00', value: 5.46 },
  { date: '2023-06-23T04:00:00', value: 45.67 },
  { date: '2023-06-23T05:00:00', value: 73.33 },
  { date: '2023-06-23T06:00:00', value: 11.36 },
  { date: '2023-06-23T07:00:00', value: 84.77 },
  { date: '2023-06-23T08:00:00', value: 52.4 },
  { date: '2023-06-23T09:00:00', value: 64.29 },
  { date: '2023-06-23T10:00:00', value: 92.57 },
  { date: '2023-06-23T11:00:00', value: 42.0 },
  { date: '2023-06-23T12:00:00', value: 37.24 },
  { date: '2023-06-23T13:00:00', value: 16.42 },
  { date: '2023-06-23T14:00:00', value: 23.88 },
  { date: '2023-06-23T15:00:00', value: 40.09 },
  { date: '2023-06-23T16:00:00', value: 65.6 },
  { date: '2023-06-23T17:00:00', value: 69.89 },
  { date: '2023-06-23T18:00:00', value: 76.88 },
  { date: '2023-06-23T19:00:00', value: 80.91 },
  { date: '2023-06-23T20:00:00', value: 42.07 },
  { date: '2023-06-23T21:00:00', value: 90.45 },
  { date: '2023-06-23T22:00:00', value: 36.04 },
  { date: '2023-06-23T23:00:00', value: 78.22 },
  { date: '2023-06-24T00:00:00', value: 8.24 },
  { date: '2023-06-24T01:00:00', value: 26.82 },
  { date: '2023-06-24T02:00:00', value: 53.91 },
  { date: '2023-06-24T03:00:00', value: 9.06 },
  { date: '2023-06-24T04:00:00', value: 6.73 },
  { date: '2023-06-24T05:00:00', value: 2.81 },
  { date: '2023-06-24T06:00:00', value: 49.02 },
  { date: '2023-06-24T07:00:00', value: 24.25 },
  { date: '2023-06-24T08:00:00', value: 13.22 },
  { date: '2023-06-24T09:00:00', value: 99.49 },
  { date: '2023-06-24T10:00:00', value: 23.22 },
  { date: '2023-06-24T11:00:00', value: 1.51 },
  { date: '2023-06-24T12:00:00', value: 75.88 },
  { date: '2023-06-24T13:00:00', value: 66.13 },
  { date: '2023-06-24T14:00:00', value: 23.55 },
  { date: '2023-06-24T15:00:00', value: 91.16 },
  { date: '2023-06-24T16:00:00', value: 70.5 },
  { date: '2023-06-24T17:00:00', value: 82.47 },
  { date: '2023-06-24T18:00:00', value: 20.01 },
  { date: '2023-06-24T19:00:00', value: 33.15 },
  { date: '2023-06-24T20:00:00', value: 54.94 },
  { date: '2023-06-24T21:00:00', value: 41.21 },
  { date: '2023-06-24T22:00:00', value: 71.13 },
  { date: '2023-06-24T23:00:00', value: 24.09 },
  { date: '2023-06-25T00:00:00', value: 76.45 },
  { date: '2023-06-25T01:00:00', value: 74.92 },
  { date: '2023-06-25T02:00:00', value: 66.18 },
  { date: '2023-06-25T03:00:00', value: 20.0 },
  { date: '2023-06-25T04:00:00', value: 19.23 },
  { date: '2023-06-25T05:00:00', value: 86.03 },
  { date: '2023-06-25T06:00:00', value: 85.05 },
  { date: '2023-06-25T07:00:00', value: 63.69 },
  { date: '2023-06-25T08:00:00', value: 3.59 },
  { date: '2023-06-25T09:00:00', value: 16.8 },
  { date: '2023-06-25T10:00:00', value: 43.82 },
  { date: '2023-06-25T11:00:00', value: 77.28 },
  { date: '2023-06-25T12:00:00', value: 49.42 },
  { date: '2023-06-25T13:00:00', value: 26.18 },
  { date: '2023-06-25T14:00:00', value: 80.49 },
  { date: '2023-06-25T15:00:00', value: 17.55 },
  { date: '2023-06-25T16:00:00', value: 25.5 },
  { date: '2023-06-25T17:00:00', value: 28.79 },
  { date: '2023-06-25T18:00:00', value: 9.09 },
  { date: '2023-06-25T19:00:00', value: 79.28 },
  { date: '2023-06-25T20:00:00', value: 3.32 },
  { date: '2023-06-25T21:00:00', value: 75.34 },
  { date: '2023-06-25T22:00:00', value: 47.16 },
  { date: '2023-06-25T23:00:00', value: 27.57 },
  { date: '2023-06-26T00:00:00', value: 72.73 },
  { date: '2023-06-26T01:00:00', value: 65.69 },
  { date: '2023-06-26T02:00:00', value: 43.57 },
  { date: '2023-06-26T03:00:00', value: 75.78 },
  { date: '2023-06-26T04:00:00', value: 69.52 },
  { date: '2023-06-26T05:00:00', value: 83.24 },
  { date: '2023-06-26T06:00:00', value: 97.63 },
  { date: '2023-06-26T07:00:00', value: 1.93 },
  { date: '2023-06-26T08:00:00', value: 98.45 },
  { date: '2023-06-26T09:00:00', value: 60.95 },
  { date: '2023-06-26T10:00:00', value: 54.81 },
  { date: '2023-06-26T11:00:00', value: 93.44 },
  { date: '2023-06-26T12:00:00', value: 96.84 },
  { date: '2023-06-26T13:00:00', value: 89.66 },
  { date: '2023-06-26T14:00:00', value: 51.98 },
  { date: '2023-06-26T15:00:00', value: 2.34 },
  { date: '2023-06-26T16:00:00', value: 31.35 },
  { date: '2023-06-26T17:00:00', value: 33.56 },
  { date: '2023-06-26T18:00:00', value: 26.16 },
  { date: '2023-06-26T19:00:00', value: 76.19 },
  { date: '2023-06-26T20:00:00', value: 41.63 },
  { date: '2023-06-26T21:00:00', value: 50.25 },
  { date: '2023-06-26T22:00:00', value: 85.95 },
  { date: '2023-06-26T23:00:00', value: 81.31 },
  { date: '2023-06-27T00:00:00', value: 74.83 },
  { date: '2023-06-27T01:00:00', value: 66.38 },
  { date: '2023-06-27T02:00:00', value: 61.02 },
  { date: '2023-06-27T03:00:00', value: 8.67 },
  { date: '2023-06-27T04:00:00', value: 58.55 },
  { date: '2023-06-27T05:00:00', value: 52.02 },
  { date: '2023-06-27T06:00:00', value: 46.82 },
  { date: '2023-06-27T07:00:00', value: 45.45 },
  { date: '2023-06-27T08:00:00', value: 53.77 },
  { date: '2023-06-27T09:00:00', value: 2.07 },
  { date: '2023-06-27T10:00:00', value: 86.81 },
  { date: '2023-06-27T11:00:00', value: 80.96 },
  { date: '2023-06-27T12:00:00', value: 89.13 },
  { date: '2023-06-27T13:00:00', value: 83.5 },
  { date: '2023-06-27T14:00:00', value: 86.54 },
  { date: '2023-06-27T15:00:00', value: 96.7 },
  { date: '2023-06-27T16:00:00', value: 62.5 },
  { date: '2023-06-27T17:00:00', value: 69.7 },
  { date: '2023-06-27T18:00:00', value: 42.37 },
  { date: '2023-06-27T19:00:00', value: 54.17 },
  { date: '2023-06-27T20:00:00', value: 40.2 },
  { date: '2023-06-27T21:00:00', value: 29.52 },
  { date: '2023-06-27T22:00:00', value: 26.5 },
  { date: '2023-06-27T23:00:00', value: 8.54 },
  { date: '2023-06-28T00:00:00', value: 99.55 },
  { date: '2023-06-28T01:00:00', value: 63.61 },
  { date: '2023-06-28T02:00:00', value: 53.81 },
  { date: '2023-06-28T03:00:00', value: 49.4 },
  { date: '2023-06-28T04:00:00', value: 55.32 },
  { date: '2023-06-28T05:00:00', value: 5.5 },
  { date: '2023-06-28T06:00:00', value: 79.93 },
  { date: '2023-06-28T07:00:00', value: 7.6 },
  { date: '2023-06-28T08:00:00', value: 23.75 },
  { date: '2023-06-28T09:00:00', value: 94.59 },
  { date: '2023-06-28T10:00:00', value: 91.34 },
  { date: '2023-06-28T11:00:00', value: 56.93 },
  { date: '2023-06-28T12:00:00', value: 97.62 },
  { date: '2023-06-28T13:00:00', value: 49.09 },
  { date: '2023-06-28T14:00:00', value: 26.12 },
  { date: '2023-06-28T15:00:00', value: 63.42 },
  { date: '2023-06-28T16:00:00', value: 84.81 },
  { date: '2023-06-28T17:00:00', value: 8.82 },
  { date: '2023-06-28T18:00:00', value: 20.5 },
  { date: '2023-06-28T19:00:00', value: 44.57 },
  { date: '2023-06-28T20:00:00', value: 87.62 },
  { date: '2023-06-28T21:00:00', value: 31.05 },
  { date: '2023-06-28T22:00:00', value: 22.28 },
  { date: '2023-06-28T23:00:00', value: 63.97 },
  { date: '2023-06-29T00:00:00', value: 30.04 },
  { date: '2023-06-29T01:00:00', value: 73.78 },
  { date: '2023-06-29T02:00:00', value: 55.97 },
  { date: '2023-06-29T03:00:00', value: 24.68 },
  { date: '2023-06-29T04:00:00', value: 22.68 },
  { date: '2023-06-29T05:00:00', value: 51.83 },
  { date: '2023-06-29T06:00:00', value: 22.58 },
  { date: '2023-06-29T07:00:00', value: 82.16 },
  { date: '2023-06-29T08:00:00', value: 56.22 },
  { date: '2023-06-29T09:00:00', value: 49.22 },
  { date: '2023-06-29T10:00:00', value: 17.54 },
  { date: '2023-06-29T11:00:00', value: 15.43 },
  { date: '2023-06-29T12:00:00', value: 61.26 },
  { date: '2023-06-29T13:00:00', value: 60.03 },
  { date: '2023-06-29T14:00:00', value: 79.87 },
  { date: '2023-06-29T15:00:00', value: 27.34 },
  { date: '2023-06-29T16:00:00', value: 21.26 },
  { date: '2023-06-29T17:00:00', value: 16.71 },
  { date: '2023-06-29T18:00:00', value: 62.0 },
  { date: '2023-06-29T19:00:00', value: 72.03 },
  { date: '2023-06-29T20:00:00', value: 28.38 },
  { date: '2023-06-29T21:00:00', value: 72.08 },
  { date: '2023-06-29T22:00:00', value: 32.54 },
  { date: '2023-06-29T23:00:00', value: 93.12 },
  { date: '2023-06-30T00:00:00', value: 72.9 },
  { date: '2023-06-30T01:00:00', value: 35.03 },
  { date: '2023-06-30T02:00:00', value: 8.45 },
  { date: '2023-06-30T03:00:00', value: 87.57 },
  { date: '2023-06-30T04:00:00', value: 99.62 },
  { date: '2023-06-30T05:00:00', value: 26.59 },
  { date: '2023-06-30T06:00:00', value: 46.44 },
  { date: '2023-06-30T07:00:00', value: 19.22 },
  { date: '2023-06-30T08:00:00', value: 88.13 },
  { date: '2023-06-30T09:00:00', value: 72.89 },
  { date: '2023-06-30T10:00:00', value: 87.75 },
  { date: '2023-06-30T11:00:00', value: 62.47 },
  { date: '2023-06-30T12:00:00', value: 35.88 },
  { date: '2023-06-30T13:00:00', value: 99.04 },
  { date: '2023-06-30T14:00:00', value: 41.64 },
  { date: '2023-06-30T15:00:00', value: 58.88 },
  { date: '2023-06-30T16:00:00', value: 89.23 },
  { date: '2023-06-30T17:00:00', value: 21.38 },
  { date: '2023-06-30T18:00:00', value: 30.66 },
  { date: '2023-06-30T19:00:00', value: 89.58 },
  { date: '2023-06-30T20:00:00', value: 79.53 },
  { date: '2023-06-30T21:00:00', value: 68.74 },
  { date: '2023-06-30T22:00:00', value: 24.15 },
  { date: '2023-06-30T23:00:00', value: 85.56 },
  { date: '2023-07-01T00:00:00', value: 29.69 },
  { date: '2023-07-01T01:00:00', value: 89.96 },
  { date: '2023-07-01T02:00:00', value: 63.93 },
  { date: '2023-07-01T03:00:00', value: 20.35 },
  { date: '2023-07-01T04:00:00', value: 17.22 },
  { date: '2023-07-01T05:00:00', value: 66.15 },
  { date: '2023-07-01T06:00:00', value: 52.82 },
  { date: '2023-07-01T07:00:00', value: 12.23 },
  { date: '2023-07-01T08:00:00', value: 41.86 },
  { date: '2023-07-01T09:00:00', value: 81.46 },
  { date: '2023-07-01T10:00:00', value: 60.98 },
  { date: '2023-07-01T11:00:00', value: 70.06 },
  { date: '2023-07-01T12:00:00', value: 82.72 },
  { date: '2023-07-01T13:00:00', value: 86.48 },
  { date: '2023-07-01T14:00:00', value: 78.36 },
  { date: '2023-07-01T15:00:00', value: 67.55 },
  { date: '2023-07-01T16:00:00', value: 89.34 },
  { date: '2023-07-01T17:00:00', value: 52.91 },
  { date: '2023-07-01T18:00:00', value: 64.46 },
  { date: '2023-07-01T19:00:00', value: 17.87 },
  { date: '2023-07-01T20:00:00', value: 41.25 },
  { date: '2023-07-01T21:00:00', value: 97.77 },
  { date: '2023-07-01T22:00:00', value: 90.02 },
  { date: '2023-07-01T23:00:00', value: 5.45 },
  { date: '2023-07-02T00:00:00', value: 22.69 },
  { date: '2023-07-02T01:00:00', value: 83.13 },
  { date: '2023-07-02T02:00:00', value: 61.44 },
  { date: '2023-07-02T03:00:00', value: 37.03 },
  { date: '2023-07-02T04:00:00', value: 45.86 },
  { date: '2023-07-02T05:00:00', value: 29.92 },
  { date: '2023-07-02T06:00:00', value: 32.39 },
  { date: '2023-07-02T07:00:00', value: 51.6 },
  { date: '2023-07-02T08:00:00', value: 8.21 },
  { date: '2023-07-02T09:00:00', value: 68.58 },
  { date: '2023-07-02T10:00:00', value: 3.54 },
  { date: '2023-07-02T11:00:00', value: 76.85 },
  { date: '2023-07-02T12:00:00', value: 64.95 },
  { date: '2023-07-02T13:00:00', value: 94.62 },
  { date: '2023-07-02T14:00:00', value: 3.07 },
  { date: '2023-07-02T15:00:00', value: 82.4 },
  { date: '2023-07-02T16:00:00', value: 24.52 },
  { date: '2023-07-02T17:00:00', value: 59.21 },
  { date: '2023-07-02T18:00:00', value: 48.26 },
  { date: '2023-07-02T19:00:00', value: 93.64 },
  { date: '2023-07-02T20:00:00', value: 76.46 },
  { date: '2023-07-02T21:00:00', value: 45.43 },
  { date: '2023-07-02T22:00:00', value: 73.72 },
  { date: '2023-07-02T23:00:00', value: 45.02 },
  { date: '2023-07-03T00:00:00', value: 50.64 },
  { date: '2023-07-03T01:00:00', value: 32.02 },
  { date: '2023-07-03T02:00:00', value: 98.63 },
  { date: '2023-07-03T03:00:00', value: 71.84 },
  { date: '2023-07-03T04:00:00', value: 88.71 },
  { date: '2023-07-03T05:00:00', value: 88.11 },
  { date: '2023-07-03T06:00:00', value: 86.96 },
  { date: '2023-07-03T07:00:00', value: 41.02 },
  { date: '2023-07-03T08:00:00', value: 29.77 },
  { date: '2023-07-03T09:00:00', value: 77.12 },
  { date: '2023-07-03T10:00:00', value: 36.24 },
  { date: '2023-07-03T11:00:00', value: 18.89 },
  { date: '2023-07-03T12:00:00', value: 92.44 },
  { date: '2023-07-03T13:00:00', value: 84.76 },
  { date: '2023-07-03T14:00:00', value: 1.09 },
  { date: '2023-07-03T15:00:00', value: 23.77 },
  { date: '2023-07-03T16:00:00', value: 39.54 },
  { date: '2023-07-03T17:00:00', value: 39.88 },
  { date: '2023-07-03T18:00:00', value: 35.36 },
  { date: '2023-07-03T19:00:00', value: 63.2 },
  { date: '2023-07-03T20:00:00', value: 41.74 },
  { date: '2023-07-03T21:00:00', value: 99.12 },
  { date: '2023-07-03T22:00:00', value: 98.81 },
  { date: '2023-07-03T23:00:00', value: 83.68 },
  { date: '2023-07-04T00:00:00', value: 20.7 },
  { date: '2023-07-04T01:00:00', value: 64.41 },
  { date: '2023-07-04T02:00:00', value: 65.65 },
  { date: '2023-07-04T03:00:00', value: 22.15 },
  { date: '2023-07-04T04:00:00', value: 33.37 },
  { date: '2023-07-04T05:00:00', value: 16.65 },
  { date: '2023-07-04T06:00:00', value: 46.55 },
  { date: '2023-07-04T07:00:00', value: 63.29 },
  { date: '2023-07-04T08:00:00', value: 68.56 },
  { date: '2023-07-04T09:00:00', value: 96.19 },
  { date: '2023-07-04T10:00:00', value: 61.31 },
  { date: '2023-07-04T11:00:00', value: 4.34 },
  { date: '2023-07-04T12:00:00', value: 46.58 },
  { date: '2023-07-04T13:00:00', value: 66.91 },
  { date: '2023-07-04T14:00:00', value: 53.57 },
  { date: '2023-07-04T15:00:00', value: 77.86 },
  { date: '2023-07-04T16:00:00', value: 70.13 },
  { date: '2023-07-04T17:00:00', value: 43.25 },
  { date: '2023-07-04T18:00:00', value: 2.09 },
  { date: '2023-07-04T19:00:00', value: 17.56 },
  { date: '2023-07-04T20:00:00', value: 93.44 },
  { date: '2023-07-04T21:00:00', value: 9.06 },
  { date: '2023-07-04T22:00:00', value: 93.44 },
  { date: '2023-07-04T23:00:00', value: 83.43 },
  { date: '2023-07-05T00:00:00', value: 33.31 },
  { date: '2023-07-05T01:00:00', value: 49.11 },
  { date: '2023-07-05T02:00:00', value: 90.8 },
  { date: '2023-07-05T03:00:00', value: 55.7 },
  { date: '2023-07-05T04:00:00', value: 73.68 },
  { date: '2023-07-05T05:00:00', value: 72.7 },
  { date: '2023-07-05T06:00:00', value: 96.81 },
  { date: '2023-07-05T07:00:00', value: 64.02 },
  { date: '2023-07-05T08:00:00', value: 17.42 },
  { date: '2023-07-05T09:00:00', value: 99.1 },
  { date: '2023-07-05T10:00:00', value: 95.53 },
  { date: '2023-07-05T11:00:00', value: 38.01 },
  { date: '2023-07-05T12:00:00', value: 76.3 },
  { date: '2023-07-05T13:00:00', value: 54.5 },
  { date: '2023-07-05T14:00:00', value: 11.65 },
  { date: '2023-07-05T15:00:00', value: 73.13 },
  { date: '2023-07-05T16:00:00', value: 64.8 },
  { date: '2023-07-05T17:00:00', value: 72.46 },
  { date: '2023-07-05T18:00:00', value: 1.42 },
  { date: '2023-07-05T19:00:00', value: 49.49 },
  { date: '2023-07-05T20:00:00', value: 5.08 },
  { date: '2023-07-05T21:00:00', value: 41.63 },
  { date: '2023-07-05T22:00:00', value: 90.43 },
  { date: '2023-07-05T23:00:00', value: 76.28 },
  { date: '2023-07-06T00:00:00', value: 85.84 },
  { date: '2023-07-06T01:00:00', value: 35.48 },
  { date: '2023-07-06T02:00:00', value: 9.12 },
  { date: '2023-07-06T03:00:00', value: 85.03 },
  { date: '2023-07-06T04:00:00', value: 67.08 },
  { date: '2023-07-06T05:00:00', value: 63.1 },
  { date: '2023-07-06T06:00:00', value: 12.19 },
  { date: '2023-07-06T07:00:00', value: 35.13 },
  { date: '2023-07-06T08:00:00', value: 75.3 },
  { date: '2023-07-06T09:00:00', value: 28.63 },
  { date: '2023-07-06T10:00:00', value: 59.97 },
  { date: '2023-07-06T11:00:00', value: 21.24 },
  { date: '2023-07-06T12:00:00', value: 69.65 },
  { date: '2023-07-06T13:00:00', value: 94.03 },
  { date: '2023-07-06T14:00:00', value: 27.08 },
  { date: '2023-07-06T15:00:00', value: 84.65 },
  { date: '2023-07-06T16:00:00', value: 20.75 },
  { date: '2023-07-06T17:00:00', value: 34.61 },
  { date: '2023-07-06T18:00:00', value: 44.9 },
  { date: '2023-07-06T19:00:00', value: 21.04 },
  { date: '2023-07-06T20:00:00', value: 33.32 },
  { date: '2023-07-06T21:00:00', value: 83.81 },
  { date: '2023-07-06T22:00:00', value: 30.74 },
  { date: '2023-07-06T23:00:00', value: 15.97 },
  { date: '2023-07-07T00:00:00', value: 84.05 },
  { date: '2023-07-07T01:00:00', value: 14.48 },
  { date: '2023-07-07T02:00:00', value: 42.13 },
  { date: '2023-07-07T03:00:00', value: 74.54 },
  { date: '2023-07-07T04:00:00', value: 74.55 },
  { date: '2023-07-07T05:00:00', value: 14.73 },
  { date: '2023-07-07T06:00:00', value: 53.66 },
  { date: '2023-07-07T07:00:00', value: 60.49 },
  { date: '2023-07-07T08:00:00', value: 43.29 },
  { date: '2023-07-07T09:00:00', value: 88.53 },
  { date: '2023-07-07T10:00:00', value: 77.27 },
  { date: '2023-07-07T11:00:00', value: 63.51 },
  { date: '2023-07-07T12:00:00', value: 82.35 },
  { date: '2023-07-07T13:00:00', value: 59.7 },
  { date: '2023-07-07T14:00:00', value: 57.04 },
  { date: '2023-07-07T15:00:00', value: 23.54 },
  { date: '2023-07-07T16:00:00', value: 18.02 },
  { date: '2023-07-07T17:00:00', value: 91.07 },
  { date: '2023-07-07T18:00:00', value: 36.48 },
  { date: '2023-07-07T19:00:00', value: 31.86 },
  { date: '2023-07-07T20:00:00', value: 15.48 },
  { date: '2023-07-07T21:00:00', value: 37.94 },
  { date: '2023-07-07T22:00:00', value: 84.33 },
  { date: '2023-07-07T23:00:00', value: 45.9 },
  { date: '2023-07-08T00:00:00', value: 97.72 },
  { date: '2023-07-08T01:00:00', value: 57.29 },
  { date: '2023-07-08T02:00:00', value: 70.67 },
  { date: '2023-07-08T03:00:00', value: 51.29 },
  { date: '2023-07-08T04:00:00', value: 77.54 },
  { date: '2023-07-08T05:00:00', value: 27.0 },
  { date: '2023-07-08T06:00:00', value: 68.63 },
  { date: '2023-07-08T07:00:00', value: 72.84 },
  { date: '2023-07-08T08:00:00', value: 41.38 },
  { date: '2023-07-08T09:00:00', value: 86.34 },
  { date: '2023-07-08T10:00:00', value: 14.38 },
  { date: '2023-07-08T11:00:00', value: 92.67 },
  { date: '2023-07-08T12:00:00', value: 88.45 },
  { date: '2023-07-08T13:00:00', value: 51.55 },
  { date: '2023-07-08T14:00:00', value: 86.54 },
  { date: '2023-07-08T15:00:00', value: 68.86 },
  { date: '2023-07-08T16:00:00', value: 52.57 },
  { date: '2023-07-08T17:00:00', value: 52.22 },
  { date: '2023-07-08T18:00:00', value: 98.85 },
  { date: '2023-07-08T19:00:00', value: 65.59 },
  { date: '2023-07-08T20:00:00', value: 88.29 },
  { date: '2023-07-08T21:00:00', value: 54.18 },
  { date: '2023-07-08T22:00:00', value: 90.14 },
  { date: '2023-07-08T23:00:00', value: 2.81 },
  { date: '2023-07-09T00:00:00', value: 23.7 },
  { date: '2023-07-09T01:00:00', value: 45.65 },
  { date: '2023-07-09T02:00:00', value: 5.75 },
  { date: '2023-07-09T03:00:00', value: 24.1 },
  { date: '2023-07-09T04:00:00', value: 63.23 },
  { date: '2023-07-09T05:00:00', value: 50.42 },
  { date: '2023-07-09T06:00:00', value: 11.8 },
  { date: '2023-07-09T07:00:00', value: 80.73 },
  { date: '2023-07-09T08:00:00', value: 79.98 },
  { date: '2023-07-09T09:00:00', value: 52.87 },
  { date: '2023-07-09T10:00:00', value: 7.14 },
  { date: '2023-07-09T11:00:00', value: 19.08 },
  { date: '2023-07-09T12:00:00', value: 59.8 },
  { date: '2023-07-09T13:00:00', value: 28.14 },
  { date: '2023-07-09T14:00:00', value: 24.96 },
  { date: '2023-07-09T15:00:00', value: 84.52 },
  { date: '2023-07-09T16:00:00', value: 61.81 },
  { date: '2023-07-09T17:00:00', value: 25.8 },
  { date: '2023-07-09T18:00:00', value: 67.35 },
  { date: '2023-07-09T19:00:00', value: 42.13 },
  { date: '2023-07-09T20:00:00', value: 59.33 },
  { date: '2023-07-09T21:00:00', value: 41.32 },
  { date: '2023-07-09T22:00:00', value: 24.46 },
  { date: '2023-07-09T23:00:00', value: 89.32 },
  { date: '2023-07-10T00:00:00', value: 37.53 },
  { date: '2023-07-10T01:00:00', value: 95.32 },
  { date: '2023-07-10T02:00:00', value: 74.75 },
  { date: '2023-07-10T03:00:00', value: 40.14 },
  { date: '2023-07-10T04:00:00', value: 40.04 },
  { date: '2023-07-10T05:00:00', value: 6.12 },
  { date: '2023-07-10T06:00:00', value: 16.3 },
  { date: '2023-07-10T07:00:00', value: 87.84 },
  { date: '2023-07-10T08:00:00', value: 56.62 },
  { date: '2023-07-10T09:00:00', value: 27.5 },
  { date: '2023-07-10T10:00:00', value: 11.06 },
  { date: '2023-07-10T11:00:00', value: 80.82 },
  { date: '2023-07-10T12:00:00', value: 28.48 },
  { date: '2023-07-10T13:00:00', value: 72.32 },
  { date: '2023-07-10T14:00:00', value: 88.76 },
  { date: '2023-07-10T15:00:00', value: 71.06 },
  { date: '2023-07-10T16:00:00', value: 82.81 },
  { date: '2023-07-10T17:00:00', value: 10.97 },
  { date: '2023-07-10T18:00:00', value: 11.09 },
  { date: '2023-07-10T19:00:00', value: 68.04 },
  { date: '2023-07-10T20:00:00', value: 36.53 },
  { date: '2023-07-10T21:00:00', value: 57.54 },
  { date: '2023-07-10T22:00:00', value: 22.66 },
  { date: '2023-07-10T23:00:00', value: 55.61 },
  { date: '2023-07-11T00:00:00', value: 62.88 },
  { date: '2023-07-11T01:00:00', value: 13.73 },
  { date: '2023-07-11T02:00:00', value: 86.9 },
  { date: '2023-07-11T03:00:00', value: 99.72 },
  { date: '2023-07-11T04:00:00', value: 67.14 },
  { date: '2023-07-11T05:00:00', value: 45.46 },
  { date: '2023-07-11T06:00:00', value: 20.17 },
  { date: '2023-07-11T07:00:00', value: 95.58 },
  { date: '2023-07-11T08:00:00', value: 87.17 },
  { date: '2023-07-11T09:00:00', value: 82.95 },
  { date: '2023-07-11T10:00:00', value: 88.77 },
  { date: '2023-07-11T11:00:00', value: 99.58 },
  { date: '2023-07-11T12:00:00', value: 77.43 },
  { date: '2023-07-11T13:00:00', value: 55.71 },
  { date: '2023-07-11T14:00:00', value: 3.59 },
  { date: '2023-07-11T15:00:00', value: 50.86 },
  { date: '2023-07-11T16:00:00', value: 18.76 },
  { date: '2023-07-11T17:00:00', value: 52.26 },
  { date: '2023-07-11T18:00:00', value: 76.7 },
  { date: '2023-07-11T19:00:00', value: 66.21 },
  { date: '2023-07-11T20:00:00', value: 77.8 },
  { date: '2023-07-11T21:00:00', value: 35.55 },
  { date: '2023-07-11T22:00:00', value: 27.96 },
  { date: '2023-07-11T23:00:00', value: 70.57 },
  { date: '2023-07-12T00:00:00', value: 30.15 },
  { date: '2023-07-12T01:00:00', value: 35.99 },
  { date: '2023-07-12T02:00:00', value: 69.59 },
  { date: '2023-07-12T03:00:00', value: 98.04 },
  { date: '2023-07-12T04:00:00', value: 47.71 },
  { date: '2023-07-12T05:00:00', value: 75.58 },
  { date: '2023-07-12T06:00:00', value: 43.99 },
  { date: '2023-07-12T07:00:00', value: 22.79 },
  { date: '2023-07-12T08:00:00', value: 85.78 },
  { date: '2023-07-12T09:00:00', value: 48.46 },
  { date: '2023-07-12T10:00:00', value: 83.58 },
  { date: '2023-07-12T11:00:00', value: 51.5 },
  { date: '2023-07-12T12:00:00', value: 58.45 },
  { date: '2023-07-12T13:00:00', value: 79.04 },
  { date: '2023-07-12T14:00:00', value: 38.38 },
  { date: '2023-07-12T15:00:00', value: 35.98 },
  { date: '2023-07-12T16:00:00', value: 93.03 },
  { date: '2023-07-12T17:00:00', value: 29.14 },
  { date: '2023-07-12T18:00:00', value: 7.72 },
  { date: '2023-07-12T19:00:00', value: 85.77 },
  { date: '2023-07-12T20:00:00', value: 8.78 },
  { date: '2023-07-12T21:00:00', value: 93.37 },
  { date: '2023-07-12T22:00:00', value: 15.37 },
  { date: '2023-07-12T23:00:00', value: 14.34 },
  { date: '2023-07-13T00:00:00', value: 54.62 },
  { date: '2023-07-13T01:00:00', value: 21.21 },
  { date: '2023-07-13T02:00:00', value: 76.74 },
  { date: '2023-07-13T03:00:00', value: 98.44 },
  { date: '2023-07-13T04:00:00', value: 9.79 },
  { date: '2023-07-13T05:00:00', value: 37.89 },
  { date: '2023-07-13T06:00:00', value: 88.74 },
  { date: '2023-07-13T07:00:00', value: 16.25 },
  { date: '2023-07-13T08:00:00', value: 61.76 },
  { date: '2023-07-13T09:00:00', value: 48.68 },
  { date: '2023-07-13T10:00:00', value: 82.59 },
  { date: '2023-07-13T11:00:00', value: 83.22 },
  { date: '2023-07-13T12:00:00', value: 20.13 },
  { date: '2023-07-13T13:00:00', value: 18.8 },
  { date: '2023-07-13T14:00:00', value: 4.78 },
  { date: '2023-07-13T15:00:00', value: 82.35 },
  { date: '2023-07-13T16:00:00', value: 37.23 },
  { date: '2023-07-13T17:00:00', value: 86.96 },
  { date: '2023-07-13T18:00:00', value: 66.68 },
  { date: '2023-07-13T19:00:00', value: 42.68 },
  { date: '2023-07-13T20:00:00', value: 19.97 },
  { date: '2023-07-13T21:00:00', value: 26.35 },
  { date: '2023-07-13T22:00:00', value: 46.07 },
  { date: '2023-07-13T23:00:00', value: 10.03 },
  { date: '2023-07-14T00:00:00', value: 31.2 },
  { date: '2023-07-14T01:00:00', value: 15.06 },
  { date: '2023-07-14T02:00:00', value: 72.48 },
  { date: '2023-07-14T03:00:00', value: 55.37 },
  { date: '2023-07-14T04:00:00', value: 40.13 },
  { date: '2023-07-14T05:00:00', value: 42.68 },
  { date: '2023-07-14T06:00:00', value: 46.22 },
  { date: '2023-07-14T07:00:00', value: 29.28 },
  { date: '2023-07-14T08:00:00', value: 95.27 },
  { date: '2023-07-14T09:00:00', value: 25.65 },
  { date: '2023-07-14T10:00:00', value: 92.85 },
  { date: '2023-07-14T11:00:00', value: 56.77 },
  { date: '2023-07-14T12:00:00', value: 3.21 },
  { date: '2023-07-14T13:00:00', value: 80.01 },
  { date: '2023-07-14T14:00:00', value: 44.93 },
  { date: '2023-07-14T15:00:00', value: 88.34 },
  { date: '2023-07-14T16:00:00', value: 97.67 },
  { date: '2023-07-14T17:00:00', value: 93.15 },
  { date: '2023-07-14T18:00:00', value: 16.04 },
  { date: '2023-07-14T19:00:00', value: 19.71 },
  { date: '2023-07-14T20:00:00', value: 92.14 },
  { date: '2023-07-14T21:00:00', value: 32.89 },
  { date: '2023-07-14T22:00:00', value: 35.12 },
  { date: '2023-07-14T23:00:00', value: 5.85 },
  { date: '2023-07-15T00:00:00', value: 73.45 },
  { date: '2023-07-15T01:00:00', value: 73.46 },
  { date: '2023-07-15T02:00:00', value: 99.36 },
  { date: '2023-07-15T03:00:00', value: 87.55 },
  { date: '2023-07-15T04:00:00', value: 62.83 },
  { date: '2023-07-15T05:00:00', value: 87.33 },
  { date: '2023-07-15T06:00:00', value: 2.43 },
  { date: '2023-07-15T07:00:00', value: 52.44 },
  { date: '2023-07-15T08:00:00', value: 45.72 },
  { date: '2023-07-15T09:00:00', value: 84.73 },
  { date: '2023-07-15T10:00:00', value: 48.54 },
  { date: '2023-07-15T11:00:00', value: 98.53 },
  { date: '2023-07-15T12:00:00', value: 34.09 },
  { date: '2023-07-15T13:00:00', value: 89.36 },
  { date: '2023-07-15T14:00:00', value: 66.94 },
  { date: '2023-07-15T15:00:00', value: 87.51 },
  { date: '2023-07-15T16:00:00', value: 14.21 },
  { date: '2023-07-15T17:00:00', value: 72.25 },
  { date: '2023-07-15T18:00:00', value: 35.93 },
  { date: '2023-07-15T19:00:00', value: 14.57 },
  { date: '2023-07-15T20:00:00', value: 47.88 },
  { date: '2023-07-15T21:00:00', value: 6.61 },
  { date: '2023-07-15T22:00:00', value: 24.31 },
  { date: '2023-07-15T23:00:00', value: 56.16 },
  { date: '2023-07-16T00:00:00', value: 95.5 },
  { date: '2023-07-16T01:00:00', value: 14.63 },
  { date: '2023-07-16T02:00:00', value: 23.0 },
  { date: '2023-07-16T03:00:00', value: 17.01 },
  { date: '2023-07-16T04:00:00', value: 20.8 },
  { date: '2023-07-16T05:00:00', value: 13.13 },
  { date: '2023-07-16T06:00:00', value: 83.51 },
  { date: '2023-07-16T07:00:00', value: 58.28 },
  { date: '2023-07-16T08:00:00', value: 26.01 },
  { date: '2023-07-16T09:00:00', value: 71.0 },
  { date: '2023-07-16T10:00:00', value: 1.08 },
  { date: '2023-07-16T11:00:00', value: 92.74 },
  { date: '2023-07-16T12:00:00', value: 43.2 },
  { date: '2023-07-16T13:00:00', value: 68.74 },
  { date: '2023-07-16T14:00:00', value: 10.06 },
  { date: '2023-07-16T15:00:00', value: 15.57 },
  { date: '2023-07-16T16:00:00', value: 21.2 },
  { date: '2023-07-16T17:00:00', value: 88.55 },
  { date: '2023-07-16T18:00:00', value: 66.22 },
  { date: '2023-07-16T19:00:00', value: 60.1 },
  { date: '2023-07-16T20:00:00', value: 34.24 },
  { date: '2023-07-16T21:00:00', value: 85.69 },
  { date: '2023-07-16T22:00:00', value: 16.5 },
  { date: '2023-07-16T23:00:00', value: 22.07 },
  { date: '2023-07-17T00:00:00', value: 92.13 },
  { date: '2023-07-17T01:00:00', value: 23.08 },
  { date: '2023-07-17T02:00:00', value: 82.52 },
  { date: '2023-07-17T03:00:00', value: 7.02 },
  { date: '2023-07-17T04:00:00', value: 88.04 },
  { date: '2023-07-17T05:00:00', value: 88.43 },
  { date: '2023-07-17T06:00:00', value: 1.16 },
  { date: '2023-07-17T07:00:00', value: 88.01 },
  { date: '2023-07-17T08:00:00', value: 22.45 },
  { date: '2023-07-17T09:00:00', value: 71.72 },
  { date: '2023-07-17T10:00:00', value: 26.22 },
  { date: '2023-07-17T11:00:00', value: 67.37 },
  { date: '2023-07-17T12:00:00', value: 34.21 },
  { date: '2023-07-17T13:00:00', value: 68.74 },
  { date: '2023-07-17T14:00:00', value: 90.34 },
  { date: '2023-07-17T15:00:00', value: 13.07 },
  { date: '2023-07-17T16:00:00', value: 47.4 },
  { date: '2023-07-17T17:00:00', value: 98.24 },
  { date: '2023-07-17T18:00:00', value: 19.19 },
  { date: '2023-07-17T19:00:00', value: 72.61 },
  { date: '2023-07-17T20:00:00', value: 42.25 },
  { date: '2023-07-17T21:00:00', value: 46.02 },
  { date: '2023-07-17T22:00:00', value: 94.38 },
  { date: '2023-07-17T23:00:00', value: 63.5 },
  { date: '2023-07-18T00:00:00', value: 51.16 },
  { date: '2023-07-18T01:00:00', value: 44.82 },
  { date: '2023-07-18T02:00:00', value: 2.54 },
  { date: '2023-07-18T03:00:00', value: 46.64 },
  { date: '2023-07-18T04:00:00', value: 51.08 },
  { date: '2023-07-18T05:00:00', value: 73.37 },
  { date: '2023-07-18T06:00:00', value: 90.69 },
  { date: '2023-07-18T07:00:00', value: 37.13 },
  { date: '2023-07-18T08:00:00', value: 90.16 },
  { date: '2023-07-18T09:00:00', value: 91.67 },
  { date: '2023-07-18T10:00:00', value: 23.12 },
  { date: '2023-07-18T11:00:00', value: 89.54 },
  { date: '2023-07-18T12:00:00', value: 9.62 },
  { date: '2023-07-18T13:00:00', value: 17.47 },
  { date: '2023-07-18T14:00:00', value: 31.17 },
  { date: '2023-07-18T15:00:00', value: 28.49 },
  { date: '2023-07-18T16:00:00', value: 12.24 },
  { date: '2023-07-18T17:00:00', value: 38.02 },
  { date: '2023-07-18T18:00:00', value: 17.55 },
  { date: '2023-07-18T19:00:00', value: 72.48 },
  { date: '2023-07-18T20:00:00', value: 99.15 },
  { date: '2023-07-18T21:00:00', value: 97.48 },
  { date: '2023-07-18T22:00:00', value: 25.36 },
  { date: '2023-07-18T23:00:00', value: 75.11 },
  { date: '2023-07-19T00:00:00', value: 64.85 },
  { date: '2023-07-19T01:00:00', value: 15.04 },
  { date: '2023-07-19T02:00:00', value: 60.47 },
  { date: '2023-07-19T03:00:00', value: 50.12 },
  { date: '2023-07-19T04:00:00', value: 79.33 },
  { date: '2023-07-19T05:00:00', value: 71.24 },
  { date: '2023-07-19T06:00:00', value: 90.0 },
  { date: '2023-07-19T07:00:00', value: 51.69 },
  { date: '2023-07-19T08:00:00', value: 82.76 },
  { date: '2023-07-19T09:00:00', value: 50.29 },
  { date: '2023-07-19T10:00:00', value: 47.99 },
  { date: '2023-07-19T11:00:00', value: 85.39 },
  { date: '2023-07-19T12:00:00', value: 43.32 },
  { date: '2023-07-19T13:00:00', value: 77.47 },
  { date: '2023-07-19T14:00:00', value: 11.95 },
  { date: '2023-07-19T15:00:00', value: 17.62 },
  { date: '2023-07-19T16:00:00', value: 62.16 },
  { date: '2023-07-19T17:00:00', value: 6.59 },
  { date: '2023-07-19T18:00:00', value: 45.64 },
  { date: '2023-07-19T19:00:00', value: 65.34 },
  { date: '2023-07-19T20:00:00', value: 86.86 },
  { date: '2023-07-19T21:00:00', value: 49.65 },
  { date: '2023-07-19T22:00:00', value: 13.13 },
  { date: '2023-07-19T23:00:00', value: 39.24 },
  { date: '2023-07-20T00:00:00', value: 68.63 },
  { date: '2023-07-20T01:00:00', value: 88.41 },
  { date: '2023-07-20T02:00:00', value: 64.82 },
  { date: '2023-07-20T03:00:00', value: 43.76 },
  { date: '2023-07-20T04:00:00', value: 84.28 },
  { date: '2023-07-20T05:00:00', value: 1.85 },
  { date: '2023-07-20T06:00:00', value: 99.18 },
  { date: '2023-07-20T07:00:00', value: 93.04 },
  { date: '2023-07-20T08:00:00', value: 94.6 },
  { date: '2023-07-20T09:00:00', value: 24.24 },
  { date: '2023-07-20T10:00:00', value: 63.23 },
  { date: '2023-07-20T11:00:00', value: 56.42 },
  { date: '2023-07-20T12:00:00', value: 47.94 },
  { date: '2023-07-20T13:00:00', value: 75.65 },
  { date: '2023-07-20T14:00:00', value: 76.23 },
  { date: '2023-07-20T15:00:00', value: 41.84 },
  { date: '2023-07-20T16:00:00', value: 34.49 },
  { date: '2023-07-20T17:00:00', value: 95.57 },
  { date: '2023-07-20T18:00:00', value: 5.75 },
  { date: '2023-07-20T19:00:00', value: 86.94 },
  { date: '2023-07-20T20:00:00', value: 47.91 },
  { date: '2023-07-20T21:00:00', value: 16.99 },
  { date: '2023-07-20T22:00:00', value: 13.87 },
  { date: '2023-07-20T23:00:00', value: 48.61 },
  { date: '2023-07-21T00:00:00', value: 62.4 },
  { date: '2023-07-21T01:00:00', value: 60.11 },
  { date: '2023-07-21T02:00:00', value: 45.5 },
  { date: '2023-07-21T03:00:00', value: 38.29 },
  { date: '2023-07-21T04:00:00', value: 81.32 },
  { date: '2023-07-21T05:00:00', value: 25.07 },
  { date: '2023-07-21T06:00:00', value: 50.27 },
  { date: '2023-07-21T07:00:00', value: 27.61 },
  { date: '2023-07-21T08:00:00', value: 32.93 },
  { date: '2023-07-21T09:00:00', value: 62.28 },
  { date: '2023-07-21T10:00:00', value: 85.67 },
  { date: '2023-07-21T11:00:00', value: 61.2 },
  { date: '2023-07-21T12:00:00', value: 4.01 },
  { date: '2023-07-21T13:00:00', value: 51.16 },
  { date: '2023-07-21T14:00:00', value: 96.94 },
  { date: '2023-07-21T15:00:00', value: 79.96 },
  { date: '2023-07-21T16:00:00', value: 33.82 },
  { date: '2023-07-21T17:00:00', value: 85.61 },
  { date: '2023-07-21T18:00:00', value: 66.05 },
  { date: '2023-07-21T19:00:00', value: 64.34 },
  { date: '2023-07-21T20:00:00', value: 98.54 },
  { date: '2023-07-21T21:00:00', value: 85.89 },
  { date: '2023-07-21T22:00:00', value: 69.86 },
  { date: '2023-07-21T23:00:00', value: 41.5 },
  { date: '2023-07-22T00:00:00', value: 81.0 },
  { date: '2023-07-22T01:00:00', value: 25.13 },
  { date: '2023-07-22T02:00:00', value: 50.24 },
  { date: '2023-07-22T03:00:00', value: 39.12 },
  { date: '2023-07-22T04:00:00', value: 31.13 },
  { date: '2023-07-22T05:00:00', value: 35.11 },
  { date: '2023-07-22T06:00:00', value: 96.48 },
  { date: '2023-07-22T07:00:00', value: 1.45 },
  { date: '2023-07-22T08:00:00', value: 86.93 },
  { date: '2023-07-22T09:00:00', value: 94.74 },
  { date: '2023-07-22T10:00:00', value: 83.68 },
  { date: '2023-07-22T11:00:00', value: 33.11 },
  { date: '2023-07-22T12:00:00', value: 85.55 },
  { date: '2023-07-22T13:00:00', value: 54.77 },
  { date: '2023-07-22T14:00:00', value: 3.23 },
  { date: '2023-07-22T15:00:00', value: 90.77 },
  { date: '2023-07-22T16:00:00', value: 89.03 },
  { date: '2023-07-22T17:00:00', value: 46.38 },
  { date: '2023-07-22T18:00:00', value: 46.08 },
  { date: '2023-07-22T19:00:00', value: 14.81 },
  { date: '2023-07-22T20:00:00', value: 49.72 },
  { date: '2023-07-22T21:00:00', value: 93.15 },
  { date: '2023-07-22T22:00:00', value: 64.22 },
  { date: '2023-07-22T23:00:00', value: 81.33 },
  { date: '2023-07-23T00:00:00', value: 33.3 },
  { date: '2023-07-23T01:00:00', value: 5.31 },
  { date: '2023-07-23T02:00:00', value: 35.44 },
  { date: '2023-07-23T03:00:00', value: 42.24 },
  { date: '2023-07-23T04:00:00', value: 53.24 },
  { date: '2023-07-23T05:00:00', value: 66.62 },
  { date: '2023-07-23T06:00:00', value: 52.58 },
  { date: '2023-07-23T07:00:00', value: 27.7 },
  { date: '2023-07-23T08:00:00', value: 38.01 },
  { date: '2023-07-23T09:00:00', value: 78.72 },
  { date: '2023-07-23T10:00:00', value: 71.9 },
  { date: '2023-07-23T11:00:00', value: 8.77 },
  { date: '2023-07-23T12:00:00', value: 52.86 },
  { date: '2023-07-23T13:00:00', value: 82.37 },
  { date: '2023-07-23T14:00:00', value: 84.47 },
  { date: '2023-07-23T15:00:00', value: 31.55 },
  { date: '2023-07-23T16:00:00', value: 4.81 },
  { date: '2023-07-23T17:00:00', value: 54.91 },
  { date: '2023-07-23T18:00:00', value: 91.07 },
  { date: '2023-07-23T19:00:00', value: 25.89 },
  { date: '2023-07-23T20:00:00', value: 4.32 },
  { date: '2023-07-23T21:00:00', value: 18.71 },
  { date: '2023-07-23T22:00:00', value: 44.35 },
  { date: '2023-07-23T23:00:00', value: 24.33 },
  { date: '2023-07-24T00:00:00', value: 7.59 },
  { date: '2023-07-24T01:00:00', value: 76.15 },
  { date: '2023-07-24T02:00:00', value: 23.42 },
  { date: '2023-07-24T03:00:00', value: 85.45 },
  { date: '2023-07-24T04:00:00', value: 2.78 },
  { date: '2023-07-24T05:00:00', value: 95.62 },
  { date: '2023-07-24T06:00:00', value: 49.62 },
  { date: '2023-07-24T07:00:00', value: 58.91 },
  { date: '2023-07-24T08:00:00', value: 3.48 },
  { date: '2023-07-24T09:00:00', value: 29.77 },
  { date: '2023-07-24T10:00:00', value: 52.87 },
  { date: '2023-07-24T11:00:00', value: 77.84 },
  { date: '2023-07-24T12:00:00', value: 49.79 },
  { date: '2023-07-24T13:00:00', value: 14.99 },
  { date: '2023-07-24T14:00:00', value: 48.91 },
  { date: '2023-07-24T15:00:00', value: 74.15 },
  { date: '2023-07-24T16:00:00', value: 89.72 },
  { date: '2023-07-24T17:00:00', value: 22.09 },
  { date: '2023-07-24T18:00:00', value: 78.32 },
  { date: '2023-07-24T19:00:00', value: 94.79 },
  { date: '2023-07-24T20:00:00', value: 1.12 },
  { date: '2023-07-24T21:00:00', value: 64.89 },
  { date: '2023-07-24T22:00:00', value: 56.89 },
  { date: '2023-07-24T23:00:00', value: 21.33 },
  { date: '2023-07-25T00:00:00', value: 69.65 },
  { date: '2023-07-25T01:00:00', value: 57.25 },
  { date: '2023-07-25T02:00:00', value: 29.11 },
  { date: '2023-07-25T03:00:00', value: 76.05 },
  { date: '2023-07-25T04:00:00', value: 30.23 },
  { date: '2023-07-25T05:00:00', value: 87.29 },
  { date: '2023-07-25T06:00:00', value: 47.26 },
  { date: '2023-07-25T07:00:00', value: 17.71 },
  { date: '2023-07-25T08:00:00', value: 71.79 },
  { date: '2023-07-25T09:00:00', value: 56.44 },
  { date: '2023-07-25T10:00:00', value: 31.63 },
  { date: '2023-07-25T11:00:00', value: 53.34 },
  { date: '2023-07-25T12:00:00', value: 89.6 },
  { date: '2023-07-25T13:00:00', value: 82.33 },
  { date: '2023-07-25T14:00:00', value: 22.66 },
  { date: '2023-07-25T15:00:00', value: 32.39 },
  { date: '2023-07-25T16:00:00', value: 24.41 },
  { date: '2023-07-25T17:00:00', value: 87.15 },
  { date: '2023-07-25T18:00:00', value: 30.72 },
  { date: '2023-07-25T19:00:00', value: 70.24 },
  { date: '2023-07-25T20:00:00', value: 1.12 },
  { date: '2023-07-25T21:00:00', value: 75.87 },
  { date: '2023-07-25T22:00:00', value: 32.95 },
  { date: '2023-07-25T23:00:00', value: 43.5 },
  { date: '2023-07-26T00:00:00', value: 75.58 },
  { date: '2023-07-26T01:00:00', value: 15.76 },
  { date: '2023-07-26T02:00:00', value: 69.76 },
  { date: '2023-07-26T03:00:00', value: 19.07 },
  { date: '2023-07-26T04:00:00', value: 69.75 },
  { date: '2023-07-26T05:00:00', value: 5.24 },
  { date: '2023-07-26T06:00:00', value: 78.75 },
  { date: '2023-07-26T07:00:00', value: 59.11 },
  { date: '2023-07-26T08:00:00', value: 80.11 },
  { date: '2023-07-26T09:00:00', value: 7.86 },
  { date: '2023-07-26T10:00:00', value: 71.66 },
  { date: '2023-07-26T11:00:00', value: 24.45 },
  { date: '2023-07-26T12:00:00', value: 48.73 },
  { date: '2023-07-26T13:00:00', value: 75.91 },
  { date: '2023-07-26T14:00:00', value: 2.56 },
  { date: '2023-07-26T15:00:00', value: 27.27 },
  { date: '2023-07-26T16:00:00', value: 63.26 },
  { date: '2023-07-26T17:00:00', value: 52.11 },
  { date: '2023-07-26T18:00:00', value: 64.05 },
  { date: '2023-07-26T19:00:00', value: 41.21 },
  { date: '2023-07-26T20:00:00', value: 76.65 },
  { date: '2023-07-26T21:00:00', value: 70.38 },
  { date: '2023-07-26T22:00:00', value: 15.83 },
  { date: '2023-07-26T23:00:00', value: 89.06 },
  { date: '2023-07-27T00:00:00', value: 7.43 },
  { date: '2023-07-27T01:00:00', value: 30.74 },
  { date: '2023-07-27T02:00:00', value: 52.28 },
  { date: '2023-07-27T03:00:00', value: 5.57 },
  { date: '2023-07-27T04:00:00', value: 25.63 },
  { date: '2023-07-27T05:00:00', value: 65.96 },
  { date: '2023-07-27T06:00:00', value: 53.24 },
  { date: '2023-07-27T07:00:00', value: 42.57 },
  { date: '2023-07-27T08:00:00', value: 34.55 },
  { date: '2023-07-27T09:00:00', value: 46.09 },
  { date: '2023-07-27T10:00:00', value: 26.2 },
  { date: '2023-07-27T11:00:00', value: 78.7 },
  { date: '2023-07-27T12:00:00', value: 41.44 },
  { date: '2023-07-27T13:00:00', value: 26.86 },
  { date: '2023-07-27T14:00:00', value: 96.36 },
  { date: '2023-07-27T15:00:00', value: 40.3 },
  { date: '2023-07-27T16:00:00', value: 90.83 },
  { date: '2023-07-27T17:00:00', value: 92.14 },
  { date: '2023-07-27T18:00:00', value: 35.07 },
  { date: '2023-07-27T19:00:00', value: 72.45 },
  { date: '2023-07-27T20:00:00', value: 76.82 },
  { date: '2023-07-27T21:00:00', value: 13.79 },
  { date: '2023-07-27T22:00:00', value: 10.53 },
  { date: '2023-07-27T23:00:00', value: 60.56 },
  { date: '2023-07-28T00:00:00', value: 10.25 },
  { date: '2023-07-28T01:00:00', value: 43.99 },
  { date: '2023-07-28T02:00:00', value: 95.21 },
  { date: '2023-07-28T03:00:00', value: 66.35 },
  { date: '2023-07-28T04:00:00', value: 42.08 },
  { date: '2023-07-28T05:00:00', value: 43.02 },
  { date: '2023-07-28T06:00:00', value: 64.92 },
  { date: '2023-07-28T07:00:00', value: 42.16 },
  { date: '2023-07-28T08:00:00', value: 73.09 },
  { date: '2023-07-28T09:00:00', value: 68.23 },
  { date: '2023-07-28T10:00:00', value: 92.95 },
  { date: '2023-07-28T11:00:00', value: 12.45 },
  { date: '2023-07-28T12:00:00', value: 7.23 },
  { date: '2023-07-28T13:00:00', value: 86.53 },
  { date: '2023-07-28T14:00:00', value: 90.6 },
  { date: '2023-07-28T15:00:00', value: 33.93 },
  { date: '2023-07-28T16:00:00', value: 94.64 },
  { date: '2023-07-28T17:00:00', value: 6.42 },
  { date: '2023-07-28T18:00:00', value: 42.51 },
  { date: '2023-07-28T19:00:00', value: 39.69 },
  { date: '2023-07-28T20:00:00', value: 15.39 },
  { date: '2023-07-28T21:00:00', value: 1.99 },
  { date: '2023-07-28T22:00:00', value: 96.84 },
  { date: '2023-07-28T23:00:00', value: 78.1 },
  { date: '2023-07-29T00:00:00', value: 87.02 },
  { date: '2023-07-29T01:00:00', value: 48.09 },
  { date: '2023-07-29T02:00:00', value: 14.24 },
  { date: '2023-07-29T03:00:00', value: 18.83 },
  { date: '2023-07-29T04:00:00', value: 20.32 },
  { date: '2023-07-29T05:00:00', value: 44.52 },
  { date: '2023-07-29T06:00:00', value: 98.77 },
  { date: '2023-07-29T07:00:00', value: 57.16 },
  { date: '2023-07-29T08:00:00', value: 74.93 },
  { date: '2023-07-29T09:00:00', value: 53.2 },
  { date: '2023-07-29T10:00:00', value: 81.02 },
  { date: '2023-07-29T11:00:00', value: 96.15 },
  { date: '2023-07-29T12:00:00', value: 84.85 },
  { date: '2023-07-29T13:00:00', value: 69.5 },
  { date: '2023-07-29T14:00:00', value: 86.86 },
  { date: '2023-07-29T15:00:00', value: 22.04 },
  { date: '2023-07-29T16:00:00', value: 54.55 },
  { date: '2023-07-29T17:00:00', value: 25.27 },
  { date: '2023-07-29T18:00:00', value: 64.75 },
  { date: '2023-07-29T19:00:00', value: 2.21 },
  { date: '2023-07-29T20:00:00', value: 29.53 },
  { date: '2023-07-29T21:00:00', value: 7.06 },
  { date: '2023-07-29T22:00:00', value: 60.07 },
  { date: '2023-07-29T23:00:00', value: 47.33 },
  { date: '2023-07-30T00:00:00', value: 99.2 },
  { date: '2023-07-30T01:00:00', value: 21.18 },
  { date: '2023-07-30T02:00:00', value: 8.67 },
  { date: '2023-07-30T03:00:00', value: 16.61 },
  { date: '2023-07-30T04:00:00', value: 41.85 },
  { date: '2023-07-30T05:00:00', value: 19.73 },
  { date: '2023-07-30T06:00:00', value: 50.11 },
  { date: '2023-07-30T07:00:00', value: 13.97 },
  { date: '2023-07-30T08:00:00', value: 38.92 },
  { date: '2023-07-30T09:00:00', value: 59.08 },
  { date: '2023-07-30T10:00:00', value: 87.22 },
  { date: '2023-07-30T11:00:00', value: 77.58 },
  { date: '2023-07-30T12:00:00', value: 58.02 },
  { date: '2023-07-30T13:00:00', value: 63.74 },
  { date: '2023-07-30T14:00:00', value: 89.62 },
  { date: '2023-07-30T15:00:00', value: 69.02 },
  { date: '2023-07-30T16:00:00', value: 40.04 },
  { date: '2023-07-30T17:00:00', value: 85.81 },
  { date: '2023-07-30T18:00:00', value: 19.12 },
  { date: '2023-07-30T19:00:00', value: 66.39 },
  { date: '2023-07-30T20:00:00', value: 19.2 },
  { date: '2023-07-30T21:00:00', value: 93.45 },
  { date: '2023-07-30T22:00:00', value: 6.08 },
  { date: '2023-07-30T23:00:00', value: 82.28 },
  { date: '2023-07-31T00:00:00', value: 13.23 },
  { date: '2023-07-31T01:00:00', value: 96.27 },
  { date: '2023-07-31T02:00:00', value: 28.29 },
  { date: '2023-07-31T03:00:00', value: 68.67 },
  { date: '2023-07-31T04:00:00', value: 5.93 },
  { date: '2023-07-31T05:00:00', value: 79.96 },
  { date: '2023-07-31T06:00:00', value: 99.29 },
  { date: '2023-07-31T07:00:00', value: 14.04 },
  { date: '2023-07-31T08:00:00', value: 33.69 },
  { date: '2023-07-31T09:00:00', value: 7.73 },
  { date: '2023-07-31T10:00:00', value: 69.61 },
  { date: '2023-07-31T11:00:00', value: 19.72 },
  { date: '2023-07-31T12:00:00', value: 44.09 },
  { date: '2023-07-31T13:00:00', value: 12.45 },
  { date: '2023-07-31T14:00:00', value: 60.29 },
  { date: '2023-07-31T15:00:00', value: 56.49 },
  { date: '2023-07-31T16:00:00', value: 9.07 },
  { date: '2023-07-31T17:00:00', value: 96.86 },
  { date: '2023-07-31T18:00:00', value: 41.62 },
  { date: '2023-07-31T19:00:00', value: 15.75 },
  { date: '2023-07-31T20:00:00', value: 9.01 },
  { date: '2023-07-31T21:00:00', value: 74.25 },
  { date: '2023-07-31T22:00:00', value: 55.17 },
  { date: '2023-07-31T23:00:00', value: 24.5 },
  { date: '2023-08-01T00:00:00', value: 25.78 },
  { date: '2023-08-01T01:00:00', value: 41.56 },
  { date: '2023-08-01T02:00:00', value: 15.49 },
  { date: '2023-08-01T03:00:00', value: 78.3 },
  { date: '2023-08-01T04:00:00', value: 33.3 },
  { date: '2023-08-01T05:00:00', value: 41.36 },
  { date: '2023-08-01T06:00:00', value: 21.92 },
  { date: '2023-08-01T07:00:00', value: 74.47 },
  { date: '2023-08-01T08:00:00', value: 37.35 },
  { date: '2023-08-01T09:00:00', value: 29.11 },
  { date: '2023-08-01T10:00:00', value: 44.82 },
  { date: '2023-08-01T11:00:00', value: 10.03 },
  { date: '2023-08-01T12:00:00', value: 12.68 },
  { date: '2023-08-01T13:00:00', value: 81.22 },
  { date: '2023-08-01T14:00:00', value: 1.96 },
  { date: '2023-08-01T15:00:00', value: 50.65 },
  { date: '2023-08-01T16:00:00', value: 35.56 },
  { date: '2023-08-01T17:00:00', value: 56.13 },
  { date: '2023-08-01T18:00:00', value: 55.02 },
  { date: '2023-08-01T19:00:00', value: 21.65 },
  { date: '2023-08-01T20:00:00', value: 67.54 },
  { date: '2023-08-01T21:00:00', value: 54.9 },
  { date: '2023-08-01T22:00:00', value: 47.27 },
  { date: '2023-08-01T23:00:00', value: 56.32 },
  { date: '2023-08-02T00:00:00', value: 96.96 },
  { date: '2023-08-02T01:00:00', value: 54.83 },
  { date: '2023-08-02T02:00:00', value: 14.63 },
  { date: '2023-08-02T03:00:00', value: 90.62 },
  { date: '2023-08-02T04:00:00', value: 72.39 },
  { date: '2023-08-02T05:00:00', value: 61.25 },
  { date: '2023-08-02T06:00:00', value: 30.61 },
  { date: '2023-08-02T07:00:00', value: 42.88 },
  { date: '2023-08-02T08:00:00', value: 37.63 },
  { date: '2023-08-02T09:00:00', value: 1.34 },
  { date: '2023-08-02T10:00:00', value: 3.06 },
  { date: '2023-08-02T11:00:00', value: 21.06 },
  { date: '2023-08-02T12:00:00', value: 73.53 },
  { date: '2023-08-02T13:00:00', value: 29.71 },
  { date: '2023-08-02T14:00:00', value: 2.1 },
  { date: '2023-08-02T15:00:00', value: 60.39 },
  { date: '2023-08-02T16:00:00', value: 99.11 },
  { date: '2023-08-02T17:00:00', value: 87.0 },
  { date: '2023-08-02T18:00:00', value: 61.76 },
  { date: '2023-08-02T19:00:00', value: 78.88 },
  { date: '2023-08-02T20:00:00', value: 98.96 },
  { date: '2023-08-02T21:00:00', value: 94.71 },
  { date: '2023-08-02T22:00:00', value: 11.66 },
  { date: '2023-08-02T23:00:00', value: 48.6 },
  { date: '2023-08-03T00:00:00', value: 54.25 },
  { date: '2023-08-03T01:00:00', value: 68.28 },
  { date: '2023-08-03T02:00:00', value: 10.55 },
  { date: '2023-08-03T03:00:00', value: 13.87 },
  { date: '2023-08-03T04:00:00', value: 35.36 },
  { date: '2023-08-03T05:00:00', value: 16.09 },
  { date: '2023-08-03T06:00:00', value: 58.27 },
  { date: '2023-08-03T07:00:00', value: 7.72 },
  { date: '2023-08-03T08:00:00', value: 16.71 },
  { date: '2023-08-03T09:00:00', value: 10.07 },
  { date: '2023-08-03T10:00:00', value: 15.12 },
  { date: '2023-08-03T11:00:00', value: 45.13 },
  { date: '2023-08-03T12:00:00', value: 15.29 },
  { date: '2023-08-03T13:00:00', value: 33.05 },
  { date: '2023-08-03T14:00:00', value: 2.6 },
  { date: '2023-08-03T15:00:00', value: 94.94 },
  { date: '2023-08-03T16:00:00', value: 54.58 },
  { date: '2023-08-03T17:00:00', value: 80.6 },
  { date: '2023-08-03T18:00:00', value: 8.52 },
  { date: '2023-08-03T19:00:00', value: 95.15 },
  { date: '2023-08-03T20:00:00', value: 22.52 },
  { date: '2023-08-03T21:00:00', value: 9.99 },
  { date: '2023-08-03T22:00:00', value: 10.96 },
  { date: '2023-08-03T23:00:00', value: 25.31 },
  { date: '2023-08-04T00:00:00', value: 93.23 },
  { date: '2023-08-04T01:00:00', value: 10.22 },
  { date: '2023-08-04T02:00:00', value: 22.31 },
  { date: '2023-08-04T03:00:00', value: 20.4 },
  { date: '2023-08-04T04:00:00', value: 48.55 },
  { date: '2023-08-04T05:00:00', value: 2.22 },
  { date: '2023-08-04T06:00:00', value: 6.84 },
  { date: '2023-08-04T07:00:00', value: 51.9 },
  { date: '2023-08-04T08:00:00', value: 96.23 },
  { date: '2023-08-04T09:00:00', value: 39.04 },
  { date: '2023-08-04T10:00:00', value: 47.14 },
  { date: '2023-08-04T11:00:00', value: 76.21 },
  { date: '2023-08-04T12:00:00', value: 65.3 },
  { date: '2023-08-04T13:00:00', value: 38.8 },
  { date: '2023-08-04T14:00:00', value: 43.32 },
  { date: '2023-08-04T15:00:00', value: 72.43 },
  { date: '2023-08-04T16:00:00', value: 26.58 },
  { date: '2023-08-04T17:00:00', value: 10.37 },
  { date: '2023-08-04T18:00:00', value: 42.3 },
  { date: '2023-08-04T19:00:00', value: 43.28 },
  { date: '2023-08-04T20:00:00', value: 86.93 },
  { date: '2023-08-04T21:00:00', value: 30.91 },
  { date: '2023-08-04T22:00:00', value: 10.95 },
  { date: '2023-08-04T23:00:00', value: 97.21 },
  { date: '2023-08-05T00:00:00', value: 86.3 },
  { date: '2023-08-05T01:00:00', value: 98.18 },
  { date: '2023-08-05T02:00:00', value: 57.87 },
  { date: '2023-08-05T03:00:00', value: 90.22 },
  { date: '2023-08-05T04:00:00', value: 57.75 },
  { date: '2023-08-05T05:00:00', value: 80.2 },
  { date: '2023-08-05T06:00:00', value: 46.39 },
  { date: '2023-08-05T07:00:00', value: 81.55 },
  { date: '2023-08-05T08:00:00', value: 3.61 },
  { date: '2023-08-05T09:00:00', value: 56.41 },
  { date: '2023-08-05T10:00:00', value: 49.16 },
  { date: '2023-08-05T11:00:00', value: 22.44 },
  { date: '2023-08-05T12:00:00', value: 9.91 },
  { date: '2023-08-05T13:00:00', value: 23.38 },
  { date: '2023-08-05T14:00:00', value: 73.19 },
  { date: '2023-08-05T15:00:00', value: 41.97 },
  { date: '2023-08-05T16:00:00', value: 18.7 },
  { date: '2023-08-05T17:00:00', value: 37.8 },
  { date: '2023-08-05T18:00:00', value: 49.31 },
  { date: '2023-08-05T19:00:00', value: 3.53 },
  { date: '2023-08-05T20:00:00', value: 79.57 },
  { date: '2023-08-05T21:00:00', value: 75.72 },
  { date: '2023-08-05T22:00:00', value: 14.68 },
  { date: '2023-08-05T23:00:00', value: 44.39 },
  { date: '2023-08-06T00:00:00', value: 23.57 },
  { date: '2023-08-06T01:00:00', value: 57.07 },
  { date: '2023-08-06T02:00:00', value: 71.4 },
  { date: '2023-08-06T03:00:00', value: 74.22 },
  { date: '2023-08-06T04:00:00', value: 33.53 },
  { date: '2023-08-06T05:00:00', value: 86.34 },
  { date: '2023-08-06T06:00:00', value: 40.94 },
  { date: '2023-08-06T07:00:00', value: 74.53 },
  { date: '2023-08-06T08:00:00', value: 83.9 },
  { date: '2023-08-06T09:00:00', value: 1.51 },
  { date: '2023-08-06T10:00:00', value: 20.93 },
  { date: '2023-08-06T11:00:00', value: 29.66 },
  { date: '2023-08-06T12:00:00', value: 76.78 },
  { date: '2023-08-06T13:00:00', value: 81.85 },
  { date: '2023-08-06T14:00:00', value: 87.61 },
  { date: '2023-08-06T15:00:00', value: 86.18 },
  { date: '2023-08-06T16:00:00', value: 2.15 },
  { date: '2023-08-06T17:00:00', value: 79.87 },
  { date: '2023-08-06T18:00:00', value: 71.0 },
  { date: '2023-08-06T19:00:00', value: 25.48 },
  { date: '2023-08-06T20:00:00', value: 39.0 },
  { date: '2023-08-06T21:00:00', value: 18.95 },
  { date: '2023-08-06T22:00:00', value: 45.56 },
  { date: '2023-08-06T23:00:00', value: 75.87 },
  { date: '2023-08-07T00:00:00', value: 97.26 },
  { date: '2023-08-07T01:00:00', value: 38.19 },
  { date: '2023-08-07T02:00:00', value: 53.89 },
  { date: '2023-08-07T03:00:00', value: 64.85 },
  { date: '2023-08-07T04:00:00', value: 59.19 },
  { date: '2023-08-07T05:00:00', value: 82.86 },
  { date: '2023-08-07T06:00:00', value: 70.64 },
  { date: '2023-08-07T07:00:00', value: 71.08 },
  { date: '2023-08-07T08:00:00', value: 10.77 },
  { date: '2023-08-07T09:00:00', value: 82.82 },
  { date: '2023-08-07T10:00:00', value: 66.27 },
  { date: '2023-08-07T11:00:00', value: 57.4 },
  { date: '2023-08-07T12:00:00', value: 40.72 },
  { date: '2023-08-07T13:00:00', value: 94.65 },
  { date: '2023-08-07T14:00:00', value: 98.0 },
  { date: '2023-08-07T15:00:00', value: 49.09 },
  { date: '2023-08-07T16:00:00', value: 92.97 },
  { date: '2023-08-07T17:00:00', value: 50.15 },
  { date: '2023-08-07T18:00:00', value: 19.64 },
  { date: '2023-08-07T19:00:00', value: 4.58 },
  { date: '2023-08-07T20:00:00', value: 10.6 },
  { date: '2023-08-07T21:00:00', value: 64.62 },
  { date: '2023-08-07T22:00:00', value: 38.89 },
  { date: '2023-08-07T23:00:00', value: 16.19 },
  { date: '2023-08-08T00:00:00', value: 10.34 },
  { date: '2023-08-08T01:00:00', value: 54.22 },
  { date: '2023-08-08T02:00:00', value: 25.19 },
  { date: '2023-08-08T03:00:00', value: 15.94 },
  { date: '2023-08-08T04:00:00', value: 96.22 },
  { date: '2023-08-08T05:00:00', value: 24.82 },
  { date: '2023-08-08T06:00:00', value: 33.73 },
  { date: '2023-08-08T07:00:00', value: 2.04 },
  { date: '2023-08-08T08:00:00', value: 19.81 },
  { date: '2023-08-08T09:00:00', value: 25.16 },
  { date: '2023-08-08T10:00:00', value: 71.78 },
  { date: '2023-08-08T11:00:00', value: 10.7 },
  { date: '2023-08-08T12:00:00', value: 90.49 },
  { date: '2023-08-08T13:00:00', value: 76.1 },
  { date: '2023-08-08T14:00:00', value: 56.45 },
  { date: '2023-08-08T15:00:00', value: 61.69 },
  { date: '2023-08-08T16:00:00', value: 56.98 },
  { date: '2023-08-08T17:00:00', value: 73.01 },
  { date: '2023-08-08T18:00:00', value: 18.86 },
  { date: '2023-08-08T19:00:00', value: 31.72 },
  { date: '2023-08-08T20:00:00', value: 24.09 },
  { date: '2023-08-08T21:00:00', value: 7.36 },
  { date: '2023-08-08T22:00:00', value: 89.52 },
  { date: '2023-08-08T23:00:00', value: 87.67 },
  { date: '2023-08-09T00:00:00', value: 64.34 },
  { date: '2023-08-09T01:00:00', value: 12.8 },
  { date: '2023-08-09T02:00:00', value: 33.72 },
  { date: '2023-08-09T03:00:00', value: 57.38 },
  { date: '2023-08-09T04:00:00', value: 36.14 },
  { date: '2023-08-09T05:00:00', value: 12.18 },
  { date: '2023-08-09T06:00:00', value: 42.27 },
  { date: '2023-08-09T07:00:00', value: 75.42 },
  { date: '2023-08-09T08:00:00', value: 28.56 },
  { date: '2023-08-09T09:00:00', value: 58.58 },
  { date: '2023-08-09T10:00:00', value: 76.04 },
  { date: '2023-08-09T11:00:00', value: 2.28 },
  { date: '2023-08-09T12:00:00', value: 34.63 },
  { date: '2023-08-09T13:00:00', value: 70.93 },
  { date: '2023-08-09T14:00:00', value: 17.07 },
  { date: '2023-08-09T15:00:00', value: 22.3 },
  { date: '2023-08-09T16:00:00', value: 64.49 },
  { date: '2023-08-09T17:00:00', value: 64.82 },
  { date: '2023-08-09T18:00:00', value: 46.69 },
  { date: '2023-08-09T19:00:00', value: 5.6 },
  { date: '2023-08-09T20:00:00', value: 84.11 },
  { date: '2023-08-09T21:00:00', value: 29.57 },
  { date: '2023-08-09T22:00:00', value: 12.11 },
  { date: '2023-08-09T23:00:00', value: 53.57 },
  { date: '2023-08-10T00:00:00', value: 76.35 },
  { date: '2023-08-10T01:00:00', value: 50.86 },
  { date: '2023-08-10T02:00:00', value: 97.71 },
  { date: '2023-08-10T03:00:00', value: 82.1 },
  { date: '2023-08-10T04:00:00', value: 6.99 },
  { date: '2023-08-10T05:00:00', value: 65.91 },
  { date: '2023-08-10T06:00:00', value: 71.68 },
  { date: '2023-08-10T07:00:00', value: 13.69 },
  { date: '2023-08-10T08:00:00', value: 9.44 },
  { date: '2023-08-10T09:00:00', value: 56.3 },
  { date: '2023-08-10T10:00:00', value: 33.12 },
  { date: '2023-08-10T11:00:00', value: 67.72 },
  { date: '2023-08-10T12:00:00', value: 79.32 },
  { date: '2023-08-10T13:00:00', value: 16.3 },
  { date: '2023-08-10T14:00:00', value: 69.6 },
  { date: '2023-08-10T15:00:00', value: 20.0 },
  { date: '2023-08-10T16:00:00', value: 4.01 },
  { date: '2023-08-10T17:00:00', value: 38.69 },
  { date: '2023-08-10T18:00:00', value: 31.91 },
  { date: '2023-08-10T19:00:00', value: 91.72 },
  { date: '2023-08-10T20:00:00', value: 80.81 },
  { date: '2023-08-10T21:00:00', value: 65.58 },
  { date: '2023-08-10T22:00:00', value: 32.35 },
  { date: '2023-08-10T23:00:00', value: 17.16 },
  { date: '2023-08-11T00:00:00', value: 95.91 },
  { date: '2023-08-11T01:00:00', value: 27.99 },
  { date: '2023-08-11T02:00:00', value: 50.17 },
  { date: '2023-08-11T03:00:00', value: 23.14 },
  { date: '2023-08-11T04:00:00', value: 1.13 },
  { date: '2023-08-11T05:00:00', value: 14.66 },
  { date: '2023-08-11T06:00:00', value: 30.29 },
  { date: '2023-08-11T07:00:00', value: 38.52 },
  { date: '2023-08-11T08:00:00', value: 21.84 },
  { date: '2023-08-11T09:00:00', value: 77.83 },
  { date: '2023-08-11T10:00:00', value: 51.92 },
  { date: '2023-08-11T11:00:00', value: 63.81 },
  { date: '2023-08-11T12:00:00', value: 97.59 },
  { date: '2023-08-11T13:00:00', value: 83.08 },
  { date: '2023-08-11T14:00:00', value: 75.09 },
  { date: '2023-08-11T15:00:00', value: 30.15 },
  { date: '2023-08-11T16:00:00', value: 13.93 },
  { date: '2023-08-11T17:00:00', value: 96.25 },
  { date: '2023-08-11T18:00:00', value: 16.03 },
  { date: '2023-08-11T19:00:00', value: 64.58 },
  { date: '2023-08-11T20:00:00', value: 89.06 },
  { date: '2023-08-11T21:00:00', value: 40.26 },
  { date: '2023-08-11T22:00:00', value: 32.85 },
  { date: '2023-08-11T23:00:00', value: 95.23 },
  { date: '2023-08-12T00:00:00', value: 42.3 },
  { date: '2023-08-12T01:00:00', value: 60.24 },
  { date: '2023-08-12T02:00:00', value: 55.7 },
  { date: '2023-08-12T03:00:00', value: 70.33 },
  { date: '2023-08-12T04:00:00', value: 82.25 },
  { date: '2023-08-12T05:00:00', value: 55.96 },
  { date: '2023-08-12T06:00:00', value: 2.66 },
  { date: '2023-08-12T07:00:00', value: 5.48 },
  { date: '2023-08-12T08:00:00', value: 14.93 },
  { date: '2023-08-12T09:00:00', value: 79.69 },
  { date: '2023-08-12T10:00:00', value: 8.19 },
  { date: '2023-08-12T11:00:00', value: 34.7 },
  { date: '2023-08-12T12:00:00', value: 94.14 },
  { date: '2023-08-12T13:00:00', value: 31.78 },
  { date: '2023-08-12T14:00:00', value: 79.74 },
  { date: '2023-08-12T15:00:00', value: 53.33 },
  { date: '2023-08-12T16:00:00', value: 17.41 },
  { date: '2023-08-12T17:00:00', value: 82.52 },
  { date: '2023-08-12T18:00:00', value: 57.59 },
  { date: '2023-08-12T19:00:00', value: 37.29 },
  { date: '2023-08-12T20:00:00', value: 61.37 },
  { date: '2023-08-12T21:00:00', value: 4.74 },
  { date: '2023-08-12T22:00:00', value: 74.02 },
  { date: '2023-08-12T23:00:00', value: 90.79 },
  { date: '2023-08-13T00:00:00', value: 36.28 },
  { date: '2023-08-13T01:00:00', value: 10.41 },
  { date: '2023-08-13T02:00:00', value: 51.64 },
  { date: '2023-08-13T03:00:00', value: 33.57 },
  { date: '2023-08-13T04:00:00', value: 20.85 },
  { date: '2023-08-13T05:00:00', value: 17.72 },
  { date: '2023-08-13T06:00:00', value: 2.2 },
  { date: '2023-08-13T07:00:00', value: 3.74 },
  { date: '2023-08-13T08:00:00', value: 61.89 },
  { date: '2023-08-13T09:00:00', value: 38.48 },
  { date: '2023-08-13T10:00:00', value: 49.01 },
  { date: '2023-08-13T11:00:00', value: 55.48 },
  { date: '2023-08-13T12:00:00', value: 30.96 },
  { date: '2023-08-13T13:00:00', value: 20.8 },
  { date: '2023-08-13T14:00:00', value: 72.12 },
  { date: '2023-08-13T15:00:00', value: 99.66 },
  { date: '2023-08-13T16:00:00', value: 92.58 },
  { date: '2023-08-13T17:00:00', value: 4.16 },
  { date: '2023-08-13T18:00:00', value: 24.28 },
  { date: '2023-08-13T19:00:00', value: 5.28 },
  { date: '2023-08-13T20:00:00', value: 57.19 },
  { date: '2023-08-13T21:00:00', value: 17.55 },
  { date: '2023-08-13T22:00:00', value: 11.44 },
  { date: '2023-08-13T23:00:00', value: 33.05 },
  { date: '2023-08-14T00:00:00', value: 44.91 },
  { date: '2023-08-14T01:00:00', value: 1.98 },
  { date: '2023-08-14T02:00:00', value: 24.71 },
  { date: '2023-08-14T03:00:00', value: 90.35 },
  { date: '2023-08-14T04:00:00', value: 92.18 },
  { date: '2023-08-14T05:00:00', value: 70.95 },
  { date: '2023-08-14T06:00:00', value: 67.45 },
  { date: '2023-08-14T07:00:00', value: 50.11 },
  { date: '2023-08-14T08:00:00', value: 40.04 },
  { date: '2023-08-14T09:00:00', value: 43.51 },
  { date: '2023-08-14T10:00:00', value: 26.22 },
  { date: '2023-08-14T11:00:00', value: 26.91 },
  { date: '2023-08-14T12:00:00', value: 76.34 },
  { date: '2023-08-14T13:00:00', value: 66.51 },
  { date: '2023-08-14T14:00:00', value: 92.92 },
  { date: '2023-08-14T15:00:00', value: 8.93 },
  { date: '2023-08-14T16:00:00', value: 56.02 },
  { date: '2023-08-14T17:00:00', value: 65.24 },
  { date: '2023-08-14T18:00:00', value: 9.35 },
  { date: '2023-08-14T19:00:00', value: 25.74 },
  { date: '2023-08-14T20:00:00', value: 2.38 },
  { date: '2023-08-14T21:00:00', value: 20.9 },
  { date: '2023-08-14T22:00:00', value: 13.91 },
  { date: '2023-08-14T23:00:00', value: 34.92 },
  { date: '2023-08-15T00:00:00', value: 10.64 },
  { date: '2023-08-15T01:00:00', value: 87.33 },
  { date: '2023-08-15T02:00:00', value: 2.47 },
  { date: '2023-08-15T03:00:00', value: 84.69 },
  { date: '2023-08-15T04:00:00', value: 22.95 },
  { date: '2023-08-15T05:00:00', value: 60.84 },
  { date: '2023-08-15T06:00:00', value: 78.18 },
  { date: '2023-08-15T07:00:00', value: 74.18 },
  { date: '2023-08-15T08:00:00', value: 26.67 },
  { date: '2023-08-15T09:00:00', value: 10.16 },
  { date: '2023-08-15T10:00:00', value: 17.7 },
  { date: '2023-08-15T11:00:00', value: 74.58 },
  { date: '2023-08-15T12:00:00', value: 40.33 },
  { date: '2023-08-15T13:00:00', value: 33.97 },
  { date: '2023-08-15T14:00:00', value: 83.69 },
  { date: '2023-08-15T15:00:00', value: 6.73 },
  { date: '2023-08-15T16:00:00', value: 9.37 },
  { date: '2023-08-15T17:00:00', value: 18.98 },
  { date: '2023-08-15T18:00:00', value: 33.66 },
  { date: '2023-08-15T19:00:00', value: 28.58 },
  { date: '2023-08-15T20:00:00', value: 86.24 },
  { date: '2023-08-15T21:00:00', value: 59.33 },
  { date: '2023-08-15T22:00:00', value: 2.33 },
  { date: '2023-08-15T23:00:00', value: 89.88 },
  { date: '2023-08-16T00:00:00', value: 5.07 },
  { date: '2023-08-16T01:00:00', value: 67.96 },
  { date: '2023-08-16T02:00:00', value: 95.75 },
  { date: '2023-08-16T03:00:00', value: 84.73 },
  { date: '2023-08-16T04:00:00', value: 50.78 },
  { date: '2023-08-16T05:00:00', value: 78.7 },
  { date: '2023-08-16T06:00:00', value: 37.85 },
  { date: '2023-08-16T07:00:00', value: 9.28 },
  { date: '2023-08-16T08:00:00', value: 94.43 },
  { date: '2023-08-16T09:00:00', value: 64.84 },
  { date: '2023-08-16T10:00:00', value: 46.58 },
  { date: '2023-08-16T11:00:00', value: 5.8 },
  { date: '2023-08-16T12:00:00', value: 50.9 },
  { date: '2023-08-16T13:00:00', value: 69.46 },
  { date: '2023-08-16T14:00:00', value: 43.31 },
  { date: '2023-08-16T15:00:00', value: 72.31 },
  { date: '2023-08-16T16:00:00', value: 31.38 },
  { date: '2023-08-16T17:00:00', value: 31.29 },
  { date: '2023-08-16T18:00:00', value: 65.4 },
  { date: '2023-08-16T19:00:00', value: 53.17 },
  { date: '2023-08-16T20:00:00', value: 11.54 },
  { date: '2023-08-16T21:00:00', value: 26.88 },
  { date: '2023-08-16T22:00:00', value: 61.03 },
  { date: '2023-08-16T23:00:00', value: 83.66 },
  { date: '2023-08-17T00:00:00', value: 2.3 },
  { date: '2023-08-17T01:00:00', value: 72.32 },
  { date: '2023-08-17T02:00:00', value: 98.75 },
  { date: '2023-08-17T03:00:00', value: 27.06 },
  { date: '2023-08-17T04:00:00', value: 96.35 },
  { date: '2023-08-17T05:00:00', value: 98.72 },
  { date: '2023-08-17T06:00:00', value: 47.38 },
  { date: '2023-08-17T07:00:00', value: 50.34 },
  { date: '2023-08-17T08:00:00', value: 37.69 },
  { date: '2023-08-17T09:00:00', value: 83.61 },
  { date: '2023-08-17T10:00:00', value: 56.98 },
  { date: '2023-08-17T11:00:00', value: 56.88 },
  { date: '2023-08-17T12:00:00', value: 84.47 },
  { date: '2023-08-17T13:00:00', value: 22.26 },
  { date: '2023-08-17T14:00:00', value: 28.96 },
  { date: '2023-08-17T15:00:00', value: 36.04 },
  { date: '2023-08-17T16:00:00', value: 10.77 },
  { date: '2023-08-17T17:00:00', value: 35.97 },
  { date: '2023-08-17T18:00:00', value: 44.57 },
  { date: '2023-08-17T19:00:00', value: 48.88 },
  { date: '2023-08-17T20:00:00', value: 44.55 },
  { date: '2023-08-17T21:00:00', value: 54.58 },
  { date: '2023-08-17T22:00:00', value: 55.04 },
  { date: '2023-08-17T23:00:00', value: 34.31 },
  { date: '2023-08-18T00:00:00', value: 32.21 },
  { date: '2023-08-18T01:00:00', value: 3.41 },
  { date: '2023-08-18T02:00:00', value: 52.69 },
  { date: '2023-08-18T03:00:00', value: 34.03 },
  { date: '2023-08-18T04:00:00', value: 18.52 },
  { date: '2023-08-18T05:00:00', value: 4.45 },
  { date: '2023-08-18T06:00:00', value: 63.67 },
  { date: '2023-08-18T07:00:00', value: 14.15 },
  { date: '2023-08-18T08:00:00', value: 9.64 },
  { date: '2023-08-18T09:00:00', value: 60.36 },
  { date: '2023-08-18T10:00:00', value: 82.64 },
  { date: '2023-08-18T11:00:00', value: 96.19 },
  { date: '2023-08-18T12:00:00', value: 16.64 },
  { date: '2023-08-18T13:00:00', value: 83.55 },
  { date: '2023-08-18T14:00:00', value: 78.92 },
  { date: '2023-08-18T15:00:00', value: 75.88 },
  { date: '2023-08-18T16:00:00', value: 47.34 },
  { date: '2023-08-18T17:00:00', value: 44.18 },
  { date: '2023-08-18T18:00:00', value: 7.37 },
  { date: '2023-08-18T19:00:00', value: 36.37 },
  { date: '2023-08-18T20:00:00', value: 68.78 },
  { date: '2023-08-18T21:00:00', value: 87.25 },
  { date: '2023-08-18T22:00:00', value: 8.48 },
  { date: '2023-08-18T23:00:00', value: 98.12 },
  { date: '2023-08-19T00:00:00', value: 76.48 },
  { date: '2023-08-19T01:00:00', value: 62.32 },
  { date: '2023-08-19T02:00:00', value: 29.16 },
  { date: '2023-08-19T03:00:00', value: 88.22 },
  { date: '2023-08-19T04:00:00', value: 15.55 },
  { date: '2023-08-19T05:00:00', value: 25.66 },
  { date: '2023-08-19T06:00:00', value: 28.39 },
  { date: '2023-08-19T07:00:00', value: 61.89 },
  { date: '2023-08-19T08:00:00', value: 54.94 },
  { date: '2023-08-19T09:00:00', value: 59.3 },
  { date: '2023-08-19T10:00:00', value: 41.82 },
  { date: '2023-08-19T11:00:00', value: 26.44 },
  { date: '2023-08-19T12:00:00', value: 49.66 },
  { date: '2023-08-19T13:00:00', value: 82.64 },
  { date: '2023-08-19T14:00:00', value: 48.65 },
  { date: '2023-08-19T15:00:00', value: 42.45 },
  { date: '2023-08-19T16:00:00', value: 94.12 },
  { date: '2023-08-19T17:00:00', value: 67.83 },
  { date: '2023-08-19T18:00:00', value: 99.96 },
  { date: '2023-08-19T19:00:00', value: 73.33 },
  { date: '2023-08-19T20:00:00', value: 69.26 },
  { date: '2023-08-19T21:00:00', value: 32.97 },
  { date: '2023-08-19T22:00:00', value: 79.78 },
  { date: '2023-08-19T23:00:00', value: 99.07 },
  { date: '2023-08-20T00:00:00', value: 22.75 },
  { date: '2023-08-20T01:00:00', value: 7.97 },
  { date: '2023-08-20T02:00:00', value: 77.71 },
  { date: '2023-08-20T03:00:00', value: 70.24 },
  { date: '2023-08-20T04:00:00', value: 65.98 },
  { date: '2023-08-20T05:00:00', value: 84.2 },
  { date: '2023-08-20T06:00:00', value: 87.24 },
  { date: '2023-08-20T07:00:00', value: 27.02 },
  { date: '2023-08-20T08:00:00', value: 62.77 },
  { date: '2023-08-20T09:00:00', value: 43.61 },
  { date: '2023-08-20T10:00:00', value: 69.72 },
  { date: '2023-08-20T11:00:00', value: 22.87 },
  { date: '2023-08-20T12:00:00', value: 82.65 },
  { date: '2023-08-20T13:00:00', value: 88.37 },
  { date: '2023-08-20T14:00:00', value: 45.38 },
  { date: '2023-08-20T15:00:00', value: 74.17 },
  { date: '2023-08-20T16:00:00', value: 97.27 },
  { date: '2023-08-20T17:00:00', value: 72.83 },
  { date: '2023-08-20T18:00:00', value: 73.27 },
  { date: '2023-08-20T19:00:00', value: 69.75 },
  { date: '2023-08-20T20:00:00', value: 32.57 },
  { date: '2023-08-20T21:00:00', value: 4.65 },
  { date: '2023-08-20T22:00:00', value: 8.11 },
  { date: '2023-08-20T23:00:00', value: 69.11 },
  { date: '2023-08-21T00:00:00', value: 68.95 },
  { date: '2023-08-21T01:00:00', value: 12.22 },
  { date: '2023-08-21T02:00:00', value: 61.18 },
  { date: '2023-08-21T03:00:00', value: 71.95 },
  { date: '2023-08-21T04:00:00', value: 96.05 },
  { date: '2023-08-21T05:00:00', value: 15.84 },
  { date: '2023-08-21T06:00:00', value: 90.14 },
  { date: '2023-08-21T07:00:00', value: 25.38 },
  { date: '2023-08-21T08:00:00', value: 31.15 },
  { date: '2023-08-21T09:00:00', value: 61.61 },
  { date: '2023-08-21T10:00:00', value: 77.46 },
  { date: '2023-08-21T11:00:00', value: 87.17 },
  { date: '2023-08-21T12:00:00', value: 73.81 },
  { date: '2023-08-21T13:00:00', value: 33.24 },
  { date: '2023-08-21T14:00:00', value: 90.44 },
  { date: '2023-08-21T15:00:00', value: 86.07 },
  { date: '2023-08-21T16:00:00', value: 79.11 },
  { date: '2023-08-21T17:00:00', value: 62.21 },
  { date: '2023-08-21T18:00:00', value: 7.71 },
  { date: '2023-08-21T19:00:00', value: 52.35 },
  { date: '2023-08-21T20:00:00', value: 92.72 },
  { date: '2023-08-21T21:00:00', value: 25.4 },
  { date: '2023-08-21T22:00:00', value: 27.14 },
  { date: '2023-08-21T23:00:00', value: 95.87 },
  { date: '2023-08-22T00:00:00', value: 98.69 },
  { date: '2023-08-22T01:00:00', value: 22.42 },
  { date: '2023-08-22T02:00:00', value: 12.43 },
  { date: '2023-08-22T03:00:00', value: 71.35 },
  { date: '2023-08-22T04:00:00', value: 51.17 },
  { date: '2023-08-22T05:00:00', value: 12.37 },
  { date: '2023-08-22T06:00:00', value: 29.14 },
  { date: '2023-08-22T07:00:00', value: 10.9 },
  { date: '2023-08-22T08:00:00', value: 6.78 },
  { date: '2023-08-22T09:00:00', value: 74.26 },
  { date: '2023-08-22T10:00:00', value: 83.84 },
  { date: '2023-08-22T11:00:00', value: 68.2 },
  { date: '2023-08-22T12:00:00', value: 92.22 },
  { date: '2023-08-22T13:00:00', value: 83.68 },
  { date: '2023-08-22T14:00:00', value: 49.81 },
  { date: '2023-08-22T15:00:00', value: 3.19 },
  { date: '2023-08-22T16:00:00', value: 12.24 },
  { date: '2023-08-22T17:00:00', value: 26.37 },
  { date: '2023-08-22T18:00:00', value: 50.3 },
  { date: '2023-08-22T19:00:00', value: 73.63 },
  { date: '2023-08-22T20:00:00', value: 94.28 },
  { date: '2023-08-22T21:00:00', value: 41.22 },
  { date: '2023-08-22T22:00:00', value: 86.6 },
  { date: '2023-08-22T23:00:00', value: 11.47 },
  { date: '2023-08-23T00:00:00', value: 52.45 },
  { date: '2023-08-23T01:00:00', value: 59.71 },
  { date: '2023-08-23T02:00:00', value: 68.36 },
  { date: '2023-08-23T03:00:00', value: 29.54 },
  { date: '2023-08-23T04:00:00', value: 15.13 },
  { date: '2023-08-23T05:00:00', value: 35.78 },
  { date: '2023-08-23T06:00:00', value: 53.59 },
  { date: '2023-08-23T07:00:00', value: 55.73 },
  { date: '2023-08-23T08:00:00', value: 23.52 },
  { date: '2023-08-23T09:00:00', value: 58.86 },
  { date: '2023-08-23T10:00:00', value: 51.49 },
  { date: '2023-08-23T11:00:00', value: 95.72 },
  { date: '2023-08-23T12:00:00', value: 51.09 },
  { date: '2023-08-23T13:00:00', value: 87.02 },
  { date: '2023-08-23T14:00:00', value: 27.65 },
  { date: '2023-08-23T15:00:00', value: 69.69 },
  { date: '2023-08-23T16:00:00', value: 7.35 },
  { date: '2023-08-23T17:00:00', value: 26.66 },
  { date: '2023-08-23T18:00:00', value: 38.69 },
  { date: '2023-08-23T19:00:00', value: 29.46 },
  { date: '2023-08-23T20:00:00', value: 79.03 },
  { date: '2023-08-23T21:00:00', value: 57.05 },
  { date: '2023-08-23T22:00:00', value: 38.75 },
  { date: '2023-08-23T23:00:00', value: 91.7 },
  { date: '2023-08-24T00:00:00', value: 70.67 },
  { date: '2023-08-24T01:00:00', value: 27.27 },
  { date: '2023-08-24T02:00:00', value: 81.91 },
  { date: '2023-08-24T03:00:00', value: 42.62 },
  { date: '2023-08-24T04:00:00', value: 85.52 },
  { date: '2023-08-24T05:00:00', value: 78.2 },
  { date: '2023-08-24T06:00:00', value: 85.91 },
  { date: '2023-08-24T07:00:00', value: 66.22 },
  { date: '2023-08-24T08:00:00', value: 15.63 },
  { date: '2023-08-24T09:00:00', value: 88.13 },
  { date: '2023-08-24T10:00:00', value: 60.8 },
  { date: '2023-08-24T11:00:00', value: 38.09 },
  { date: '2023-08-24T12:00:00', value: 87.85 },
  { date: '2023-08-24T13:00:00', value: 61.75 },
  { date: '2023-08-24T14:00:00', value: 75.59 },
  { date: '2023-08-24T15:00:00', value: 32.06 },
  { date: '2023-08-24T16:00:00', value: 60.91 },
  { date: '2023-08-24T17:00:00', value: 19.06 },
  { date: '2023-08-24T18:00:00', value: 96.11 },
  { date: '2023-08-24T19:00:00', value: 19.77 },
  { date: '2023-08-24T20:00:00', value: 5.29 },
  { date: '2023-08-24T21:00:00', value: 27.32 },
  { date: '2023-08-24T22:00:00', value: 14.59 },
  { date: '2023-08-24T23:00:00', value: 16.34 },
  { date: '2023-08-25T00:00:00', value: 87.29 },
  { date: '2023-08-25T01:00:00', value: 89.8 },
  { date: '2023-08-25T02:00:00', value: 90.52 },
  { date: '2023-08-25T03:00:00', value: 93.29 },
  { date: '2023-08-25T04:00:00', value: 77.22 },
  { date: '2023-08-25T05:00:00', value: 25.6 },
  { date: '2023-08-25T06:00:00', value: 6.58 },
  { date: '2023-08-25T07:00:00', value: 31.95 },
  { date: '2023-08-25T08:00:00', value: 23.63 },
  { date: '2023-08-25T09:00:00', value: 67.33 },
  { date: '2023-08-25T10:00:00', value: 14.14 },
  { date: '2023-08-25T11:00:00', value: 10.64 },
  { date: '2023-08-25T12:00:00', value: 37.0 },
  { date: '2023-08-25T13:00:00', value: 87.15 },
  { date: '2023-08-25T14:00:00', value: 30.09 },
  { date: '2023-08-25T15:00:00', value: 29.65 },
  { date: '2023-08-25T16:00:00', value: 68.68 },
  { date: '2023-08-25T17:00:00', value: 12.73 },
  { date: '2023-08-25T18:00:00', value: 62.49 },
  { date: '2023-08-25T19:00:00', value: 14.2 },
  { date: '2023-08-25T20:00:00', value: 37.87 },
  { date: '2023-08-25T21:00:00', value: 71.33 },
  { date: '2023-08-25T22:00:00', value: 37.32 },
  { date: '2023-08-25T23:00:00', value: 76.71 },
  { date: '2023-08-26T00:00:00', value: 84.22 },
  { date: '2023-08-26T01:00:00', value: 65.76 },
  { date: '2023-08-26T02:00:00', value: 48.26 },
  { date: '2023-08-26T03:00:00', value: 93.94 },
  { date: '2023-08-26T04:00:00', value: 34.75 },
  { date: '2023-08-26T05:00:00', value: 6.81 },
  { date: '2023-08-26T06:00:00', value: 7.05 },
  { date: '2023-08-26T07:00:00', value: 79.43 },
  { date: '2023-08-26T08:00:00', value: 25.07 },
  { date: '2023-08-26T09:00:00', value: 96.74 },
  { date: '2023-08-26T10:00:00', value: 13.83 },
  { date: '2023-08-26T11:00:00', value: 14.5 },
  { date: '2023-08-26T12:00:00', value: 38.65 },
  { date: '2023-08-26T13:00:00', value: 5.23 },
  { date: '2023-08-26T14:00:00', value: 95.04 },
  { date: '2023-08-26T15:00:00', value: 57.67 },
  { date: '2023-08-26T16:00:00', value: 47.8 },
  { date: '2023-08-26T17:00:00', value: 71.06 },
  { date: '2023-08-26T18:00:00', value: 1.37 },
  { date: '2023-08-26T19:00:00', value: 53.09 },
  { date: '2023-08-26T20:00:00', value: 31.83 },
  { date: '2023-08-26T21:00:00', value: 13.59 },
  { date: '2023-08-26T22:00:00', value: 41.74 },
  { date: '2023-08-26T23:00:00', value: 7.0 },
  { date: '2023-08-27T00:00:00', value: 70.14 },
  { date: '2023-08-27T01:00:00', value: 29.6 },
  { date: '2023-08-27T02:00:00', value: 88.02 },
  { date: '2023-08-27T03:00:00', value: 47.55 },
  { date: '2023-08-27T04:00:00', value: 42.9 },
  { date: '2023-08-27T05:00:00', value: 26.7 },
  { date: '2023-08-27T06:00:00', value: 72.73 },
  { date: '2023-08-27T07:00:00', value: 15.48 },
  { date: '2023-08-27T08:00:00', value: 37.03 },
  { date: '2023-08-27T09:00:00', value: 89.22 },
  { date: '2023-08-27T10:00:00', value: 11.22 },
  { date: '2023-08-27T11:00:00', value: 51.98 },
  { date: '2023-08-27T12:00:00', value: 16.46 },
  { date: '2023-08-27T13:00:00', value: 50.89 },
  { date: '2023-08-27T14:00:00', value: 66.0 },
  { date: '2023-08-27T15:00:00', value: 29.01 },
  { date: '2023-08-27T16:00:00', value: 18.36 },
  { date: '2023-08-27T17:00:00', value: 34.07 },
  { date: '2023-08-27T18:00:00', value: 35.2 },
  { date: '2023-08-27T19:00:00', value: 76.41 },
  { date: '2023-08-27T20:00:00', value: 21.92 },
  { date: '2023-08-27T21:00:00', value: 3.08 },
  { date: '2023-08-27T22:00:00', value: 99.5 },
  { date: '2023-08-27T23:00:00', value: 14.93 },
  { date: '2023-08-28T00:00:00', value: 43.44 },
  { date: '2023-08-28T01:00:00', value: 97.84 },
  { date: '2023-08-28T02:00:00', value: 41.17 },
  { date: '2023-08-28T03:00:00', value: 53.41 },
  { date: '2023-08-28T04:00:00', value: 93.77 },
  { date: '2023-08-28T05:00:00', value: 2.25 },
  { date: '2023-08-28T06:00:00', value: 76.22 },
  { date: '2023-08-28T07:00:00', value: 6.77 },
  { date: '2023-08-28T08:00:00', value: 92.81 },
  { date: '2023-08-28T09:00:00', value: 49.45 },
  { date: '2023-08-28T10:00:00', value: 73.03 },
  { date: '2023-08-28T11:00:00', value: 19.31 },
  { date: '2023-08-28T12:00:00', value: 77.48 },
  { date: '2023-08-28T13:00:00', value: 52.31 },
  { date: '2023-08-28T14:00:00', value: 73.4 },
  { date: '2023-08-28T15:00:00', value: 74.52 },
  { date: '2023-08-28T16:00:00', value: 62.96 },
  { date: '2023-08-28T17:00:00', value: 44.78 },
  { date: '2023-08-28T18:00:00', value: 99.31 },
  { date: '2023-08-28T19:00:00', value: 72.61 },
  { date: '2023-08-28T20:00:00', value: 88.95 },
  { date: '2023-08-28T21:00:00', value: 11.73 },
  { date: '2023-08-28T22:00:00', value: 59.66 },
  { date: '2023-08-28T23:00:00', value: 86.6 },
  { date: '2023-08-29T00:00:00', value: 21.13 },
  { date: '2023-08-29T01:00:00', value: 34.21 },
  { date: '2023-08-29T02:00:00', value: 30.57 },
  { date: '2023-08-29T03:00:00', value: 65.74 },
  { date: '2023-08-29T04:00:00', value: 63.21 },
  { date: '2023-08-29T05:00:00', value: 24.35 },
  { date: '2023-08-29T06:00:00', value: 65.03 },
  { date: '2023-08-29T07:00:00', value: 9.26 },
  { date: '2023-08-29T08:00:00', value: 15.23 },
  { date: '2023-08-29T09:00:00', value: 75.07 },
  { date: '2023-08-29T10:00:00', value: 74.98 },
  { date: '2023-08-29T11:00:00', value: 61.1 },
  { date: '2023-08-29T12:00:00', value: 33.55 },
  { date: '2023-08-29T13:00:00', value: 27.38 },
  { date: '2023-08-29T14:00:00', value: 22.55 },
  { date: '2023-08-29T15:00:00', value: 43.03 },
  { date: '2023-08-29T16:00:00', value: 60.49 },
  { date: '2023-08-29T17:00:00', value: 8.91 },
  { date: '2023-08-29T18:00:00', value: 42.09 },
  { date: '2023-08-29T19:00:00', value: 67.76 },
  { date: '2023-08-29T20:00:00', value: 77.03 },
  { date: '2023-08-29T21:00:00', value: 99.53 },
  { date: '2023-08-29T22:00:00', value: 16.94 },
  { date: '2023-08-29T23:00:00', value: 60.94 },
  { date: '2023-08-30T00:00:00', value: 51.52 },
  { date: '2023-08-30T01:00:00', value: 63.79 },
  { date: '2023-08-30T02:00:00', value: 19.61 },
  { date: '2023-08-30T03:00:00', value: 56.69 },
  { date: '2023-08-30T04:00:00', value: 53.26 },
  { date: '2023-08-30T05:00:00', value: 86.39 },
  { date: '2023-08-30T06:00:00', value: 40.07 },
  { date: '2023-08-30T07:00:00', value: 86.47 },
  { date: '2023-08-30T08:00:00', value: 87.8 },
  { date: '2023-08-30T09:00:00', value: 80.6 },
  { date: '2023-08-30T10:00:00', value: 31.18 },
  { date: '2023-08-30T11:00:00', value: 83.17 },
  { date: '2023-08-30T12:00:00', value: 85.06 },
  { date: '2023-08-30T13:00:00', value: 29.45 },
  { date: '2023-08-30T14:00:00', value: 81.0 },
  { date: '2023-08-30T15:00:00', value: 7.58 },
  { date: '2023-08-30T16:00:00', value: 53.38 },
  { date: '2023-08-30T17:00:00', value: 58.8 },
  { date: '2023-08-30T18:00:00', value: 48.61 },
  { date: '2023-08-30T19:00:00', value: 67.65 },
  { date: '2023-08-30T20:00:00', value: 75.84 },
  { date: '2023-08-30T21:00:00', value: 29.64 },
  { date: '2023-08-30T22:00:00', value: 44.98 },
  { date: '2023-08-30T23:00:00', value: 75.95 },
  { date: '2023-08-31T00:00:00', value: 79.53 },
  { date: '2023-08-31T01:00:00', value: 68.34 },
  { date: '2023-08-31T02:00:00', value: 70.6 },
  { date: '2023-08-31T03:00:00', value: 30.42 },
  { date: '2023-08-31T04:00:00', value: 46.43 },
  { date: '2023-08-31T05:00:00', value: 89.91 },
  { date: '2023-08-31T06:00:00', value: 74.85 },
  { date: '2023-08-31T07:00:00', value: 95.0 },
  { date: '2023-08-31T08:00:00', value: 18.25 },
  { date: '2023-08-31T09:00:00', value: 98.59 },
  { date: '2023-08-31T10:00:00', value: 86.07 },
  { date: '2023-08-31T11:00:00', value: 48.98 },
  { date: '2023-08-31T12:00:00', value: 60.72 },
  { date: '2023-08-31T13:00:00', value: 97.81 },
  { date: '2023-08-31T14:00:00', value: 69.49 },
  { date: '2023-08-31T15:00:00', value: 49.82 },
  { date: '2023-08-31T16:00:00', value: 2.19 },
  { date: '2023-08-31T17:00:00', value: 13.07 },
  { date: '2023-08-31T18:00:00', value: 71.62 },
  { date: '2023-08-31T19:00:00', value: 22.27 },
  { date: '2023-08-31T20:00:00', value: 1.84 },
  { date: '2023-08-31T21:00:00', value: 65.17 },
  { date: '2023-08-31T22:00:00', value: 18.73 },
  { date: '2023-08-31T23:00:00', value: 98.04 },
  { date: '2023-09-01T00:00:00', value: 2.27 },
  { date: '2023-09-01T01:00:00', value: 96.12 },
  { date: '2023-09-01T02:00:00', value: 72.51 },
  { date: '2023-09-01T03:00:00', value: 36.44 },
  { date: '2023-09-01T04:00:00', value: 77.9 },
  { date: '2023-09-01T05:00:00', value: 60.47 },
  { date: '2023-09-01T06:00:00', value: 82.54 },
  { date: '2023-09-01T07:00:00', value: 26.74 },
  { date: '2023-09-01T08:00:00', value: 97.44 },
  { date: '2023-09-01T09:00:00', value: 9.46 },
  { date: '2023-09-01T10:00:00', value: 69.61 },
  { date: '2023-09-01T11:00:00', value: 88.66 },
  { date: '2023-09-01T12:00:00', value: 49.68 },
  { date: '2023-09-01T13:00:00', value: 69.48 },
  { date: '2023-09-01T14:00:00', value: 42.44 },
  { date: '2023-09-01T15:00:00', value: 50.91 },
  { date: '2023-09-01T16:00:00', value: 83.21 },
  { date: '2023-09-01T17:00:00', value: 93.51 },
  { date: '2023-09-01T18:00:00', value: 78.58 },
  { date: '2023-09-01T19:00:00', value: 61.64 },
  { date: '2023-09-01T20:00:00', value: 42.27 },
  { date: '2023-09-01T21:00:00', value: 11.05 },
  { date: '2023-09-01T22:00:00', value: 44.21 },
  { date: '2023-09-01T23:00:00', value: 84.42 },
  { date: '2023-09-02T00:00:00', value: 20.38 },
  { date: '2023-09-02T01:00:00', value: 29.84 },
  { date: '2023-09-02T02:00:00', value: 97.59 },
  { date: '2023-09-02T03:00:00', value: 73.68 },
  { date: '2023-09-02T04:00:00', value: 89.85 },
  { date: '2023-09-02T05:00:00', value: 83.34 },
  { date: '2023-09-02T06:00:00', value: 87.25 },
  { date: '2023-09-02T07:00:00', value: 41.66 },
  { date: '2023-09-02T08:00:00', value: 50.06 },
  { date: '2023-09-02T09:00:00', value: 91.81 },
  { date: '2023-09-02T10:00:00', value: 81.51 },
  { date: '2023-09-02T11:00:00', value: 77.89 },
  { date: '2023-09-02T12:00:00', value: 85.52 },
  { date: '2023-09-02T13:00:00', value: 86.99 },
  { date: '2023-09-02T14:00:00', value: 62.69 },
  { date: '2023-09-02T15:00:00', value: 61.14 },
  { date: '2023-09-02T16:00:00', value: 37.08 },
  { date: '2023-09-02T17:00:00', value: 72.74 },
  { date: '2023-09-02T18:00:00', value: 50.59 },
  { date: '2023-09-02T19:00:00', value: 78.08 },
  { date: '2023-09-02T20:00:00', value: 70.72 },
  { date: '2023-09-02T21:00:00', value: 58.12 },
  { date: '2023-09-02T22:00:00', value: 90.44 },
  { date: '2023-09-02T23:00:00', value: 17.79 },
  { date: '2023-09-03T00:00:00', value: 74.02 },
  { date: '2023-09-03T01:00:00', value: 52.72 },
  { date: '2023-09-03T02:00:00', value: 1.83 },
  { date: '2023-09-03T03:00:00', value: 18.57 },
  { date: '2023-09-03T04:00:00', value: 77.99 },
  { date: '2023-09-03T05:00:00', value: 85.24 },
  { date: '2023-09-03T06:00:00', value: 85.0 },
  { date: '2023-09-03T07:00:00', value: 3.6 },
  { date: '2023-09-03T08:00:00', value: 79.01 },
  { date: '2023-09-03T09:00:00', value: 71.86 },
  { date: '2023-09-03T10:00:00', value: 98.0 },
  { date: '2023-09-03T11:00:00', value: 68.72 },
  { date: '2023-09-03T12:00:00', value: 82.54 },
  { date: '2023-09-03T13:00:00', value: 48.39 },
  { date: '2023-09-03T14:00:00', value: 93.33 },
  { date: '2023-09-03T15:00:00', value: 89.92 },
  { date: '2023-09-03T16:00:00', value: 53.62 },
  { date: '2023-09-03T17:00:00', value: 93.21 },
  { date: '2023-09-03T18:00:00', value: 47.07 },
  { date: '2023-09-03T19:00:00', value: 6.2 },
  { date: '2023-09-03T20:00:00', value: 85.95 },
  { date: '2023-09-03T21:00:00', value: 92.12 },
  { date: '2023-09-03T22:00:00', value: 15.33 },
  { date: '2023-09-03T23:00:00', value: 84.37 },
  { date: '2023-09-04T00:00:00', value: 16.18 },
  { date: '2023-09-04T01:00:00', value: 44.24 },
  { date: '2023-09-04T02:00:00', value: 49.33 },
  { date: '2023-09-04T03:00:00', value: 21.91 },
  { date: '2023-09-04T04:00:00', value: 41.73 },
  { date: '2023-09-04T05:00:00', value: 85.2 },
  { date: '2023-09-04T06:00:00', value: 53.82 },
  { date: '2023-09-04T07:00:00', value: 31.04 },
  { date: '2023-09-04T08:00:00', value: 56.07 },
  { date: '2023-09-04T09:00:00', value: 92.91 },
  { date: '2023-09-04T10:00:00', value: 28.09 },
  { date: '2023-09-04T11:00:00', value: 34.53 },
  { date: '2023-09-04T12:00:00', value: 21.94 },
  { date: '2023-09-04T13:00:00', value: 3.61 },
  { date: '2023-09-04T14:00:00', value: 75.51 },
  { date: '2023-09-04T15:00:00', value: 80.24 },
  { date: '2023-09-04T16:00:00', value: 53.47 },
  { date: '2023-09-04T17:00:00', value: 3.85 },
  { date: '2023-09-04T18:00:00', value: 5.23 },
  { date: '2023-09-04T19:00:00', value: 15.56 },
  { date: '2023-09-04T20:00:00', value: 68.84 },
  { date: '2023-09-04T21:00:00', value: 82.21 },
  { date: '2023-09-04T22:00:00', value: 6.46 },
  { date: '2023-09-04T23:00:00', value: 75.38 },
  { date: '2023-09-05T00:00:00', value: 21.62 },
  { date: '2023-09-05T01:00:00', value: 54.19 },
  { date: '2023-09-05T02:00:00', value: 82.51 },
  { date: '2023-09-05T03:00:00', value: 99.38 },
  { date: '2023-09-05T04:00:00', value: 92.14 },
  { date: '2023-09-05T05:00:00', value: 6.2 },
  { date: '2023-09-05T06:00:00', value: 64.76 },
  { date: '2023-09-05T07:00:00', value: 37.91 },
  { date: '2023-09-05T08:00:00', value: 73.7 },
  { date: '2023-09-05T09:00:00', value: 93.22 },
  { date: '2023-09-05T10:00:00', value: 53.86 },
  { date: '2023-09-05T11:00:00', value: 44.3 },
  { date: '2023-09-05T12:00:00', value: 8.86 },
  { date: '2023-09-05T13:00:00', value: 56.27 },
  { date: '2023-09-05T14:00:00', value: 35.32 },
  { date: '2023-09-05T15:00:00', value: 65.31 },
  { date: '2023-09-05T16:00:00', value: 65.06 },
  { date: '2023-09-05T17:00:00', value: 62.0 },
  { date: '2023-09-05T18:00:00', value: 50.29 },
  { date: '2023-09-05T19:00:00', value: 90.56 },
  { date: '2023-09-05T20:00:00', value: 26.62 },
  { date: '2023-09-05T21:00:00', value: 4.17 },
  { date: '2023-09-05T22:00:00', value: 38.58 },
  { date: '2023-09-05T23:00:00', value: 88.8 },
  { date: '2023-09-06T00:00:00', value: 56.1 },
  { date: '2023-09-06T01:00:00', value: 27.77 },
  { date: '2023-09-06T02:00:00', value: 63.28 },
  { date: '2023-09-06T03:00:00', value: 9.74 },
  { date: '2023-09-06T04:00:00', value: 95.44 },
  { date: '2023-09-06T05:00:00', value: 22.8 },
  { date: '2023-09-06T06:00:00', value: 35.72 },
  { date: '2023-09-06T07:00:00', value: 61.5 },
  { date: '2023-09-06T08:00:00', value: 70.57 },
  { date: '2023-09-06T09:00:00', value: 31.36 },
  { date: '2023-09-06T10:00:00', value: 90.38 },
  { date: '2023-09-06T11:00:00', value: 92.63 },
  { date: '2023-09-06T12:00:00', value: 63.45 },
  { date: '2023-09-06T13:00:00', value: 8.71 },
  { date: '2023-09-06T14:00:00', value: 18.62 },
  { date: '2023-09-06T15:00:00', value: 22.78 },
  { date: '2023-09-06T16:00:00', value: 57.27 },
  { date: '2023-09-06T17:00:00', value: 63.65 },
  { date: '2023-09-06T18:00:00', value: 2.31 },
  { date: '2023-09-06T19:00:00', value: 85.24 },
  { date: '2023-09-06T20:00:00', value: 72.77 },
  { date: '2023-09-06T21:00:00', value: 18.11 },
  { date: '2023-09-06T22:00:00', value: 91.99 },
  { date: '2023-09-06T23:00:00', value: 51.41 },
  { date: '2023-09-07T00:00:00', value: 20.48 },
  { date: '2023-09-07T01:00:00', value: 24.44 },
  { date: '2023-09-07T02:00:00', value: 24.27 },
  { date: '2023-09-07T03:00:00', value: 78.05 },
  { date: '2023-09-07T04:00:00', value: 51.45 },
  { date: '2023-09-07T05:00:00', value: 31.58 },
  { date: '2023-09-07T06:00:00', value: 56.37 },
  { date: '2023-09-07T07:00:00', value: 37.04 },
  { date: '2023-09-07T08:00:00', value: 33.63 },
  { date: '2023-09-07T09:00:00', value: 1.58 },
  { date: '2023-09-07T10:00:00', value: 61.17 },
  { date: '2023-09-07T11:00:00', value: 63.69 },
  { date: '2023-09-07T12:00:00', value: 76.63 },
  { date: '2023-09-07T13:00:00', value: 80.5 },
  { date: '2023-09-07T14:00:00', value: 55.13 },
  { date: '2023-09-07T15:00:00', value: 91.01 },
  { date: '2023-09-07T16:00:00', value: 52.52 },
  { date: '2023-09-07T17:00:00', value: 81.47 },
  { date: '2023-09-07T18:00:00', value: 89.56 },
  { date: '2023-09-07T19:00:00', value: 16.61 },
  { date: '2023-09-07T20:00:00', value: 81.67 },
  { date: '2023-09-07T21:00:00', value: 44.25 },
  { date: '2023-09-07T22:00:00', value: 61.45 },
  { date: '2023-09-07T23:00:00', value: 89.27 },
  { date: '2023-09-08T00:00:00', value: 1.91 },
  { date: '2023-09-08T01:00:00', value: 95.25 },
  { date: '2023-09-08T02:00:00', value: 17.45 },
  { date: '2023-09-08T03:00:00', value: 76.83 },
  { date: '2023-09-08T04:00:00', value: 23.61 },
  { date: '2023-09-08T05:00:00', value: 54.77 },
  { date: '2023-09-08T06:00:00', value: 66.09 },
  { date: '2023-09-08T07:00:00', value: 36.16 },
  { date: '2023-09-08T08:00:00', value: 24.49 },
  { date: '2023-09-08T09:00:00', value: 65.57 },
  { date: '2023-09-08T10:00:00', value: 34.97 },
  { date: '2023-09-08T11:00:00', value: 11.19 },
  { date: '2023-09-08T12:00:00', value: 42.56 },
  { date: '2023-09-08T13:00:00', value: 77.72 },
  { date: '2023-09-08T14:00:00', value: 35.78 },
  { date: '2023-09-08T15:00:00', value: 37.12 },
  { date: '2023-09-08T16:00:00', value: 21.53 },
  { date: '2023-09-08T17:00:00', value: 70.55 },
  { date: '2023-09-08T18:00:00', value: 39.91 },
  { date: '2023-09-08T19:00:00', value: 54.33 },
  { date: '2023-09-08T20:00:00', value: 10.22 },
  { date: '2023-09-08T21:00:00', value: 34.24 },
  { date: '2023-09-08T22:00:00', value: 7.1 },
  { date: '2023-09-08T23:00:00', value: 50.91 },
  { date: '2023-09-09T00:00:00', value: 58.61 },
  { date: '2023-09-09T01:00:00', value: 89.45 },
  { date: '2023-09-09T02:00:00', value: 79.85 },
  { date: '2023-09-09T03:00:00', value: 65.73 },
  { date: '2023-09-09T04:00:00', value: 2.74 },
  { date: '2023-09-09T05:00:00', value: 67.03 },
  { date: '2023-09-09T06:00:00', value: 79.81 },
  { date: '2023-09-09T07:00:00', value: 28.55 },
  { date: '2023-09-09T08:00:00', value: 51.14 },
  { date: '2023-09-09T09:00:00', value: 98.95 },
  { date: '2023-09-09T10:00:00', value: 19.08 },
  { date: '2023-09-09T11:00:00', value: 41.75 },
  { date: '2023-09-09T12:00:00', value: 93.64 },
  { date: '2023-09-09T13:00:00', value: 63.08 },
  { date: '2023-09-09T14:00:00', value: 45.74 },
  { date: '2023-09-09T15:00:00', value: 33.56 },
  { date: '2023-09-09T16:00:00', value: 6.14 },
  { date: '2023-09-09T17:00:00', value: 34.9 },
  { date: '2023-09-09T18:00:00', value: 68.12 },
  { date: '2023-09-09T19:00:00', value: 52.89 },
  { date: '2023-09-09T20:00:00', value: 65.57 },
  { date: '2023-09-09T21:00:00', value: 46.23 },
  { date: '2023-09-09T22:00:00', value: 63.94 },
  { date: '2023-09-09T23:00:00', value: 56.73 },
  { date: '2023-09-10T00:00:00', value: 2.32 },
  { date: '2023-09-10T01:00:00', value: 17.34 },
  { date: '2023-09-10T02:00:00', value: 28.23 },
  { date: '2023-09-10T03:00:00', value: 90.0 },
  { date: '2023-09-10T04:00:00', value: 37.39 },
  { date: '2023-09-10T05:00:00', value: 11.09 },
  { date: '2023-09-10T06:00:00', value: 64.85 },
  { date: '2023-09-10T07:00:00', value: 56.63 },
  { date: '2023-09-10T08:00:00', value: 50.38 },
  { date: '2023-09-10T09:00:00', value: 43.11 },
  { date: '2023-09-10T10:00:00', value: 68.37 },
  { date: '2023-09-10T11:00:00', value: 78.23 },
  { date: '2023-09-10T12:00:00', value: 95.05 },
  { date: '2023-09-10T13:00:00', value: 61.15 },
  { date: '2023-09-10T14:00:00', value: 11.66 },
  { date: '2023-09-10T15:00:00', value: 48.09 },
  { date: '2023-09-10T16:00:00', value: 97.61 },
  { date: '2023-09-10T17:00:00', value: 60.62 },
  { date: '2023-09-10T18:00:00', value: 14.96 },
  { date: '2023-09-10T19:00:00', value: 80.3 },
  { date: '2023-09-10T20:00:00', value: 31.31 },
  { date: '2023-09-10T21:00:00', value: 19.62 },
  { date: '2023-09-10T22:00:00', value: 62.69 },
  { date: '2023-09-10T23:00:00', value: 79.04 },
  { date: '2023-09-11T00:00:00', value: 41.25 },
  { date: '2023-09-11T01:00:00', value: 49.04 },
  { date: '2023-09-11T02:00:00', value: 60.88 },
  { date: '2023-09-11T03:00:00', value: 57.93 },
  { date: '2023-09-11T04:00:00', value: 2.75 },
  { date: '2023-09-11T05:00:00', value: 61.26 },
  { date: '2023-09-11T06:00:00', value: 4.49 },
  { date: '2023-09-11T07:00:00', value: 82.92 },
  { date: '2023-09-11T08:00:00', value: 1.57 },
  { date: '2023-09-11T09:00:00', value: 79.14 },
  { date: '2023-09-11T10:00:00', value: 79.94 },
  { date: '2023-09-11T11:00:00', value: 89.79 },
  { date: '2023-09-11T12:00:00', value: 70.89 },
  { date: '2023-09-11T13:00:00', value: 8.35 },
  { date: '2023-09-11T14:00:00', value: 90.47 },
  { date: '2023-09-11T15:00:00', value: 11.01 },
  { date: '2023-09-11T16:00:00', value: 79.88 },
  { date: '2023-09-11T17:00:00', value: 84.15 },
  { date: '2023-09-11T18:00:00', value: 63.15 },
  { date: '2023-09-11T19:00:00', value: 42.76 },
  { date: '2023-09-11T20:00:00', value: 61.31 },
  { date: '2023-09-11T21:00:00', value: 15.88 },
  { date: '2023-09-11T22:00:00', value: 6.48 },
  { date: '2023-09-11T23:00:00', value: 31.78 },
  { date: '2023-09-12T00:00:00', value: 2.93 },
  { date: '2023-09-12T01:00:00', value: 99.02 },
  { date: '2023-09-12T02:00:00', value: 4.74 },
  { date: '2023-09-12T03:00:00', value: 8.83 },
  { date: '2023-09-12T04:00:00', value: 2.56 },
  { date: '2023-09-12T05:00:00', value: 15.51 },
  { date: '2023-09-12T06:00:00', value: 23.18 },
  { date: '2023-09-12T07:00:00', value: 53.12 },
  { date: '2023-09-12T08:00:00', value: 99.44 },
  { date: '2023-09-12T09:00:00', value: 86.65 },
  { date: '2023-09-12T10:00:00', value: 99.25 },
  { date: '2023-09-12T11:00:00', value: 30.38 },
  { date: '2023-09-12T12:00:00', value: 40.85 },
  { date: '2023-09-12T13:00:00', value: 64.05 },
  { date: '2023-09-12T14:00:00', value: 97.38 },
  { date: '2023-09-12T15:00:00', value: 59.94 },
  { date: '2023-09-12T16:00:00', value: 15.03 },
  { date: '2023-09-12T17:00:00', value: 53.53 },
  { date: '2023-09-12T18:00:00', value: 13.27 },
  { date: '2023-09-12T19:00:00', value: 2.83 },
  { date: '2023-09-12T20:00:00', value: 36.4 },
  { date: '2023-09-12T21:00:00', value: 80.61 },
  { date: '2023-09-12T22:00:00', value: 15.57 },
  { date: '2023-09-12T23:00:00', value: 24.25 },
  { date: '2023-09-13T00:00:00', value: 75.03 },
  { date: '2023-09-13T01:00:00', value: 44.02 },
  { date: '2023-09-13T02:00:00', value: 91.07 },
  { date: '2023-09-13T03:00:00', value: 81.69 },
  { date: '2023-09-13T04:00:00', value: 82.32 },
  { date: '2023-09-13T05:00:00', value: 99.06 },
  { date: '2023-09-13T06:00:00', value: 37.37 },
  { date: '2023-09-13T07:00:00', value: 40.04 },
  { date: '2023-09-13T08:00:00', value: 68.43 },
  { date: '2023-09-13T09:00:00', value: 95.31 },
  { date: '2023-09-13T10:00:00', value: 20.92 },
  { date: '2023-09-13T11:00:00', value: 58.24 },
  { date: '2023-09-13T12:00:00', value: 83.63 },
  { date: '2023-09-13T13:00:00', value: 3.95 },
  { date: '2023-09-13T14:00:00', value: 29.68 },
  { date: '2023-09-13T15:00:00', value: 85.85 },
  { date: '2023-09-13T16:00:00', value: 69.15 },
  { date: '2023-09-13T17:00:00', value: 24.96 },
  { date: '2023-09-13T18:00:00', value: 68.9 },
  { date: '2023-09-13T19:00:00', value: 42.51 },
  { date: '2023-09-13T20:00:00', value: 99.24 },
  { date: '2023-09-13T21:00:00', value: 66.53 },
  { date: '2023-09-13T22:00:00', value: 44.56 },
  { date: '2023-09-13T23:00:00', value: 55.6 },
  { date: '2023-09-14T00:00:00', value: 37.55 },
  { date: '2023-09-14T01:00:00', value: 44.16 },
  { date: '2023-09-14T02:00:00', value: 37.4 },
  { date: '2023-09-14T03:00:00', value: 20.09 },
  { date: '2023-09-14T04:00:00', value: 85.62 },
  { date: '2023-09-14T05:00:00', value: 99.35 },
  { date: '2023-09-14T06:00:00', value: 88.17 },
  { date: '2023-09-14T07:00:00', value: 61.82 },
  { date: '2023-09-14T08:00:00', value: 13.92 },
  { date: '2023-09-14T09:00:00', value: 43.89 },
  { date: '2023-09-14T10:00:00', value: 70.7 },
  { date: '2023-09-14T11:00:00', value: 3.13 },
  { date: '2023-09-14T12:00:00', value: 45.56 },
  { date: '2023-09-14T13:00:00', value: 33.38 },
  { date: '2023-09-14T14:00:00', value: 76.13 },
  { date: '2023-09-14T15:00:00', value: 17.58 },
  { date: '2023-09-14T16:00:00', value: 8.34 },
  { date: '2023-09-14T17:00:00', value: 84.87 },
  { date: '2023-09-14T18:00:00', value: 22.95 },
  { date: '2023-09-14T19:00:00', value: 57.88 },
  { date: '2023-09-14T20:00:00', value: 73.8 },
  { date: '2023-09-14T21:00:00', value: 59.69 },
  { date: '2023-09-14T22:00:00', value: 54.53 },
  { date: '2023-09-14T23:00:00', value: 7.88 },
  { date: '2023-09-15T00:00:00', value: 15.05 },
  { date: '2023-09-15T01:00:00', value: 79.24 },
  { date: '2023-09-15T02:00:00', value: 48.53 },
  { date: '2023-09-15T03:00:00', value: 63.24 },
  { date: '2023-09-15T04:00:00', value: 39.92 },
  { date: '2023-09-15T05:00:00', value: 58.3 },
  { date: '2023-09-15T06:00:00', value: 25.17 },
  { date: '2023-09-15T07:00:00', value: 3.04 },
  { date: '2023-09-15T08:00:00', value: 96.22 },
  { date: '2023-09-15T09:00:00', value: 22.41 },
  { date: '2023-09-15T10:00:00', value: 76.6 },
  { date: '2023-09-15T11:00:00', value: 96.06 },
  { date: '2023-09-15T12:00:00', value: 98.68 },
  { date: '2023-09-15T13:00:00', value: 42.09 },
  { date: '2023-09-15T14:00:00', value: 86.93 },
  { date: '2023-09-15T15:00:00', value: 29.22 },
  { date: '2023-09-15T16:00:00', value: 20.24 },
  { date: '2023-09-15T17:00:00', value: 93.61 },
  { date: '2023-09-15T18:00:00', value: 66.56 },
  { date: '2023-09-15T19:00:00', value: 10.7 },
  { date: '2023-09-15T20:00:00', value: 45.05 },
  { date: '2023-09-15T21:00:00', value: 25.19 },
  { date: '2023-09-15T22:00:00', value: 80.05 },
  { date: '2023-09-15T23:00:00', value: 65.41 },
  { date: '2023-09-16T00:00:00', value: 82.36 },
  { date: '2023-09-16T01:00:00', value: 52.87 },
  { date: '2023-09-16T02:00:00', value: 99.78 },
  { date: '2023-09-16T03:00:00', value: 54.42 },
  { date: '2023-09-16T04:00:00', value: 92.04 },
  { date: '2023-09-16T05:00:00', value: 80.0 },
  { date: '2023-09-16T06:00:00', value: 68.21 },
  { date: '2023-09-16T07:00:00', value: 49.91 },
  { date: '2023-09-16T08:00:00', value: 5.3 },
  { date: '2023-09-16T09:00:00', value: 72.18 },
  { date: '2023-09-16T10:00:00', value: 5.31 },
  { date: '2023-09-16T11:00:00', value: 42.57 },
  { date: '2023-09-16T12:00:00', value: 81.94 },
  { date: '2023-09-16T13:00:00', value: 98.07 },
  { date: '2023-09-16T14:00:00', value: 26.96 },
  { date: '2023-09-16T15:00:00', value: 4.68 },
  { date: '2023-09-16T16:00:00', value: 91.18 },
  { date: '2023-09-16T17:00:00', value: 87.91 },
  { date: '2023-09-16T18:00:00', value: 88.94 },
  { date: '2023-09-16T19:00:00', value: 6.52 },
  { date: '2023-09-16T20:00:00', value: 82.51 },
  { date: '2023-09-16T21:00:00', value: 3.24 },
  { date: '2023-09-16T22:00:00', value: 76.86 },
  { date: '2023-09-16T23:00:00', value: 35.19 },
  { date: '2023-09-17T00:00:00', value: 27.76 },
  { date: '2023-09-17T01:00:00', value: 11.62 },
  { date: '2023-09-17T02:00:00', value: 56.02 },
  { date: '2023-09-17T03:00:00', value: 64.02 },
  { date: '2023-09-17T04:00:00', value: 58.5 },
  { date: '2023-09-17T05:00:00', value: 4.02 },
  { date: '2023-09-17T06:00:00', value: 45.68 },
  { date: '2023-09-17T07:00:00', value: 31.12 },
  { date: '2023-09-17T08:00:00', value: 10.78 },
  { date: '2023-09-17T09:00:00', value: 80.71 },
  { date: '2023-09-17T10:00:00', value: 61.2 },
  { date: '2023-09-17T11:00:00', value: 99.89 },
  { date: '2023-09-17T12:00:00', value: 72.9 },
  { date: '2023-09-17T13:00:00', value: 99.65 },
  { date: '2023-09-17T14:00:00', value: 52.36 },
  { date: '2023-09-17T15:00:00', value: 82.42 },
  { date: '2023-09-17T16:00:00', value: 95.7 },
  { date: '2023-09-17T17:00:00', value: 36.9 },
  { date: '2023-09-17T18:00:00', value: 87.14 },
  { date: '2023-09-17T19:00:00', value: 83.16 },
  { date: '2023-09-17T20:00:00', value: 87.78 },
  { date: '2023-09-17T21:00:00', value: 20.85 },
  { date: '2023-09-17T22:00:00', value: 85.87 },
  { date: '2023-09-17T23:00:00', value: 95.23 },
  { date: '2023-09-18T00:00:00', value: 49.53 },
  { date: '2023-09-18T01:00:00', value: 88.74 },
  { date: '2023-09-18T02:00:00', value: 30.27 },
  { date: '2023-09-18T03:00:00', value: 33.3 },
  { date: '2023-09-18T04:00:00', value: 65.57 },
  { date: '2023-09-18T05:00:00', value: 71.31 },
  { date: '2023-09-18T06:00:00', value: 15.35 },
  { date: '2023-09-18T07:00:00', value: 73.64 },
  { date: '2023-09-18T08:00:00', value: 81.91 },
  { date: '2023-09-18T09:00:00', value: 24.69 },
  { date: '2023-09-18T10:00:00', value: 73.07 },
  { date: '2023-09-18T11:00:00', value: 72.37 },
  { date: '2023-09-18T12:00:00', value: 46.43 },
  { date: '2023-09-18T13:00:00', value: 27.29 },
  { date: '2023-09-18T14:00:00', value: 43.74 },
  { date: '2023-09-18T15:00:00', value: 13.4 },
  { date: '2023-09-18T16:00:00', value: 90.12 },
  { date: '2023-09-18T17:00:00', value: 52.2 },
  { date: '2023-09-18T18:00:00', value: 32.5 },
  { date: '2023-09-18T19:00:00', value: 47.07 },
  { date: '2023-09-18T20:00:00', value: 15.69 },
  { date: '2023-09-18T21:00:00', value: 33.4 },
  { date: '2023-09-18T22:00:00', value: 3.04 },
  { date: '2023-09-18T23:00:00', value: 95.71 },
  { date: '2023-09-19T00:00:00', value: 99.94 },
  { date: '2023-09-19T01:00:00', value: 11.72 },
  { date: '2023-09-19T02:00:00', value: 96.57 },
  { date: '2023-09-19T03:00:00', value: 80.53 },
  { date: '2023-09-19T04:00:00', value: 41.5 },
  { date: '2023-09-19T05:00:00', value: 16.05 },
  { date: '2023-09-19T06:00:00', value: 73.71 },
  { date: '2023-09-19T07:00:00', value: 17.43 },
  { date: '2023-09-19T08:00:00', value: 70.77 },
  { date: '2023-09-19T09:00:00', value: 51.0 },
  { date: '2023-09-19T10:00:00', value: 41.02 },
  { date: '2023-09-19T11:00:00', value: 13.46 },
  { date: '2023-09-19T12:00:00', value: 57.06 },
  { date: '2023-09-19T13:00:00', value: 96.04 },
  { date: '2023-09-19T14:00:00', value: 57.09 },
  { date: '2023-09-19T15:00:00', value: 87.52 },
  { date: '2023-09-19T16:00:00', value: 67.39 },
  { date: '2023-09-19T17:00:00', value: 66.82 },
  { date: '2023-09-19T18:00:00', value: 33.23 },
  { date: '2023-09-19T19:00:00', value: 62.51 },
  { date: '2023-09-19T20:00:00', value: 86.82 },
  { date: '2023-09-19T21:00:00', value: 29.83 },
  { date: '2023-09-19T22:00:00', value: 74.57 },
  { date: '2023-09-19T23:00:00', value: 55.12 },
  { date: '2023-09-20T00:00:00', value: 37.2 },
  { date: '2023-09-20T01:00:00', value: 72.96 },
  { date: '2023-09-20T02:00:00', value: 22.84 },
  { date: '2023-09-20T03:00:00', value: 31.69 },
  { date: '2023-09-20T04:00:00', value: 30.72 },
  { date: '2023-09-20T05:00:00', value: 30.5 },
  { date: '2023-09-20T06:00:00', value: 86.18 },
  { date: '2023-09-20T07:00:00', value: 75.79 },
  { date: '2023-09-20T08:00:00', value: 87.1 },
  { date: '2023-09-20T09:00:00', value: 22.18 },
  { date: '2023-09-20T10:00:00', value: 18.95 },
  { date: '2023-09-20T11:00:00', value: 74.91 },
  { date: '2023-09-20T12:00:00', value: 28.77 },
  { date: '2023-09-20T13:00:00', value: 16.93 },
  { date: '2023-09-20T14:00:00', value: 13.04 },
  { date: '2023-09-20T15:00:00', value: 33.72 },
  { date: '2023-09-20T16:00:00', value: 1.44 },
  { date: '2023-09-20T17:00:00', value: 96.27 },
  { date: '2023-09-20T18:00:00', value: 53.62 },
  { date: '2023-09-20T19:00:00', value: 32.6 },
  { date: '2023-09-20T20:00:00', value: 14.7 },
  { date: '2023-09-20T21:00:00', value: 15.98 },
  { date: '2023-09-20T22:00:00', value: 3.64 },
  { date: '2023-09-20T23:00:00', value: 51.83 },
  { date: '2023-09-21T00:00:00', value: 82.79 },
  { date: '2023-09-21T01:00:00', value: 28.8 },
  { date: '2023-09-21T02:00:00', value: 25.34 },
  { date: '2023-09-21T03:00:00', value: 26.53 },
  { date: '2023-09-21T04:00:00', value: 59.49 },
  { date: '2023-09-21T05:00:00', value: 46.51 },
  { date: '2023-09-21T06:00:00', value: 8.31 },
  { date: '2023-09-21T07:00:00', value: 53.09 },
  { date: '2023-09-21T08:00:00', value: 82.94 },
  { date: '2023-09-21T09:00:00', value: 21.65 },
  { date: '2023-09-21T10:00:00', value: 15.05 },
  { date: '2023-09-21T11:00:00', value: 53.55 },
  { date: '2023-09-21T12:00:00', value: 34.02 },
  { date: '2023-09-21T13:00:00', value: 66.44 },
  { date: '2023-09-21T14:00:00', value: 82.18 },
  { date: '2023-09-21T15:00:00', value: 48.63 },
  { date: '2023-09-21T16:00:00', value: 86.34 },
  { date: '2023-09-21T17:00:00', value: 12.41 },
  { date: '2023-09-21T18:00:00', value: 90.69 },
  { date: '2023-09-21T19:00:00', value: 22.81 },
  { date: '2023-09-21T20:00:00', value: 52.33 },
  { date: '2023-09-21T21:00:00', value: 19.15 },
  { date: '2023-09-21T22:00:00', value: 45.76 },
  { date: '2023-09-21T23:00:00', value: 58.61 },
  { date: '2023-09-22T00:00:00', value: 13.96 },
  { date: '2023-09-22T01:00:00', value: 67.48 },
  { date: '2023-09-22T02:00:00', value: 72.57 },
  { date: '2023-09-22T03:00:00', value: 50.03 },
  { date: '2023-09-22T04:00:00', value: 97.84 },
  { date: '2023-09-22T05:00:00', value: 98.67 },
  { date: '2023-09-22T06:00:00', value: 70.51 },
  { date: '2023-09-22T07:00:00', value: 2.96 },
  { date: '2023-09-22T08:00:00', value: 35.1 },
  { date: '2023-09-22T09:00:00', value: 35.95 },
  { date: '2023-09-22T10:00:00', value: 27.29 },
  { date: '2023-09-22T11:00:00', value: 59.27 },
  { date: '2023-09-22T12:00:00', value: 51.94 },
  { date: '2023-09-22T13:00:00', value: 45.64 },
  { date: '2023-09-22T14:00:00', value: 47.54 },
  { date: '2023-09-22T15:00:00', value: 47.76 },
  { date: '2023-09-22T16:00:00', value: 14.52 },
  { date: '2023-09-22T17:00:00', value: 96.96 },
  { date: '2023-09-22T18:00:00', value: 8.82 },
  { date: '2023-09-22T19:00:00', value: 62.63 },
  { date: '2023-09-22T20:00:00', value: 16.09 },
  { date: '2023-09-22T21:00:00', value: 68.15 },
  { date: '2023-09-22T22:00:00', value: 36.0 },
  { date: '2023-09-22T23:00:00', value: 59.68 },
  { date: '2023-09-23T00:00:00', value: 58.75 },
  { date: '2023-09-23T01:00:00', value: 89.48 },
  { date: '2023-09-23T02:00:00', value: 78.32 },
  { date: '2023-09-23T03:00:00', value: 7.3 },
  { date: '2023-09-23T04:00:00', value: 82.84 },
  { date: '2023-09-23T05:00:00', value: 14.65 },
  { date: '2023-09-23T06:00:00', value: 86.16 },
  { date: '2023-09-23T07:00:00', value: 80.6 },
  { date: '2023-09-23T08:00:00', value: 30.7 },
  { date: '2023-09-23T09:00:00', value: 89.16 },
  { date: '2023-09-23T10:00:00', value: 56.08 },
  { date: '2023-09-23T11:00:00', value: 60.42 },
  { date: '2023-09-23T12:00:00', value: 69.13 },
  { date: '2023-09-23T13:00:00', value: 94.42 },
  { date: '2023-09-23T14:00:00', value: 56.23 },
  { date: '2023-09-23T15:00:00', value: 45.33 },
  { date: '2023-09-23T16:00:00', value: 70.04 },
  { date: '2023-09-23T17:00:00', value: 74.15 },
  { date: '2023-09-23T18:00:00', value: 86.71 },
  { date: '2023-09-23T19:00:00', value: 68.16 },
  { date: '2023-09-23T20:00:00', value: 62.73 },
  { date: '2023-09-23T21:00:00', value: 6.22 },
  { date: '2023-09-23T22:00:00', value: 94.6 },
  { date: '2023-09-23T23:00:00', value: 9.52 },
  { date: '2023-09-24T00:00:00', value: 34.77 },
  { date: '2023-09-24T01:00:00', value: 15.26 },
  { date: '2023-09-24T02:00:00', value: 21.78 },
  { date: '2023-09-24T03:00:00', value: 46.2 },
  { date: '2023-09-24T04:00:00', value: 10.66 },
  { date: '2023-09-24T05:00:00', value: 48.31 },
  { date: '2023-09-24T06:00:00', value: 97.89 },
  { date: '2023-09-24T07:00:00', value: 62.54 },
  { date: '2023-09-24T08:00:00', value: 69.39 },
  { date: '2023-09-24T09:00:00', value: 4.18 },
  { date: '2023-09-24T10:00:00', value: 62.71 },
  { date: '2023-09-24T11:00:00', value: 53.25 },
  { date: '2023-09-24T12:00:00', value: 83.91 },
  { date: '2023-09-24T13:00:00', value: 18.87 },
  { date: '2023-09-24T14:00:00', value: 7.78 },
  { date: '2023-09-24T15:00:00', value: 93.57 },
  { date: '2023-09-24T16:00:00', value: 38.11 },
  { date: '2023-09-24T17:00:00', value: 68.42 },
  { date: '2023-09-24T18:00:00', value: 34.49 },
  { date: '2023-09-24T19:00:00', value: 88.91 },
  { date: '2023-09-24T20:00:00', value: 68.38 },
  { date: '2023-09-24T21:00:00', value: 30.0 },
  { date: '2023-09-24T22:00:00', value: 16.95 },
  { date: '2023-09-24T23:00:00', value: 48.4 },
  { date: '2023-09-25T00:00:00', value: 27.56 },
  { date: '2023-09-25T01:00:00', value: 82.04 },
  { date: '2023-09-25T02:00:00', value: 18.93 },
  { date: '2023-09-25T03:00:00', value: 83.57 },
  { date: '2023-09-25T04:00:00', value: 4.23 },
  { date: '2023-09-25T05:00:00', value: 38.24 },
  { date: '2023-09-25T06:00:00', value: 84.62 },
  { date: '2023-09-25T07:00:00', value: 5.02 },
  { date: '2023-09-25T08:00:00', value: 73.24 },
  { date: '2023-09-25T09:00:00', value: 26.23 },
  { date: '2023-09-25T10:00:00', value: 7.77 },
  { date: '2023-09-25T11:00:00', value: 54.99 },
  { date: '2023-09-25T12:00:00', value: 12.49 },
  { date: '2023-09-25T13:00:00', value: 47.09 },
  { date: '2023-09-25T14:00:00', value: 22.2 },
  { date: '2023-09-25T15:00:00', value: 86.66 },
  { date: '2023-09-25T16:00:00', value: 24.31 },
  { date: '2023-09-25T17:00:00', value: 74.02 },
  { date: '2023-09-25T18:00:00', value: 83.9 },
  { date: '2023-09-25T19:00:00', value: 45.91 },
  { date: '2023-09-25T20:00:00', value: 71.37 },
  { date: '2023-09-25T21:00:00', value: 51.95 },
  { date: '2023-09-25T22:00:00', value: 86.36 },
  { date: '2023-09-25T23:00:00', value: 6.12 },
  { date: '2023-09-26T00:00:00', value: 67.29 },
  { date: '2023-09-26T01:00:00', value: 75.54 },
  { date: '2023-09-26T02:00:00', value: 78.09 },
  { date: '2023-09-26T03:00:00', value: 61.63 },
  { date: '2023-09-26T04:00:00', value: 36.42 },
  { date: '2023-09-26T05:00:00', value: 58.38 },
  { date: '2023-09-26T06:00:00', value: 64.23 },
  { date: '2023-09-26T07:00:00', value: 71.12 },
  { date: '2023-09-26T08:00:00', value: 56.02 },
  { date: '2023-09-26T09:00:00', value: 59.92 },
  { date: '2023-09-26T10:00:00', value: 19.9 },
  { date: '2023-09-26T11:00:00', value: 97.41 },
  { date: '2023-09-26T12:00:00', value: 54.42 },
  { date: '2023-09-26T13:00:00', value: 26.35 },
  { date: '2023-09-26T14:00:00', value: 21.08 },
  { date: '2023-09-26T15:00:00', value: 68.1 },
  { date: '2023-09-26T16:00:00', value: 21.57 },
  { date: '2023-09-26T17:00:00', value: 62.45 },
  { date: '2023-09-26T18:00:00', value: 85.82 },
  { date: '2023-09-26T19:00:00', value: 19.78 },
  { date: '2023-09-26T20:00:00', value: 32.13 },
  { date: '2023-09-26T21:00:00', value: 86.1 },
  { date: '2023-09-26T22:00:00', value: 15.93 },
  { date: '2023-09-26T23:00:00', value: 73.72 },
  { date: '2023-09-27T00:00:00', value: 86.9 },
  { date: '2023-09-27T01:00:00', value: 32.24 },
  { date: '2023-09-27T02:00:00', value: 41.14 },
  { date: '2023-09-27T03:00:00', value: 46.66 },
  { date: '2023-09-27T04:00:00', value: 39.69 },
  { date: '2023-09-27T05:00:00', value: 11.15 },
  { date: '2023-09-27T06:00:00', value: 4.09 },
  { date: '2023-09-27T07:00:00', value: 98.33 },
  { date: '2023-09-27T08:00:00', value: 94.44 },
  { date: '2023-09-27T09:00:00', value: 3.64 },
  { date: '2023-09-27T10:00:00', value: 64.13 },
  { date: '2023-09-27T11:00:00', value: 34.53 },
  { date: '2023-09-27T12:00:00', value: 62.35 },
  { date: '2023-09-27T13:00:00', value: 68.62 },
  { date: '2023-09-27T14:00:00', value: 21.61 },
  { date: '2023-09-27T15:00:00', value: 36.26 },
  { date: '2023-09-27T16:00:00', value: 51.52 },
  { date: '2023-09-27T17:00:00', value: 87.85 },
  { date: '2023-09-27T18:00:00', value: 9.95 },
  { date: '2023-09-27T19:00:00', value: 18.14 },
  { date: '2023-09-27T20:00:00', value: 45.84 },
  { date: '2023-09-27T21:00:00', value: 71.09 },
  { date: '2023-09-27T22:00:00', value: 28.99 },
  { date: '2023-09-27T23:00:00', value: 44.61 },
  { date: '2023-09-28T00:00:00', value: 75.29 },
  { date: '2023-09-28T01:00:00', value: 29.89 },
  { date: '2023-09-28T02:00:00', value: 76.15 },
  { date: '2023-09-28T03:00:00', value: 74.09 },
  { date: '2023-09-28T04:00:00', value: 82.17 },
  { date: '2023-09-28T05:00:00', value: 26.91 },
  { date: '2023-09-28T06:00:00', value: 10.44 },
  { date: '2023-09-28T07:00:00', value: 44.66 },
  { date: '2023-09-28T08:00:00', value: 69.33 },
  { date: '2023-09-28T09:00:00', value: 59.12 },
  { date: '2023-09-28T10:00:00', value: 70.58 },
  { date: '2023-09-28T11:00:00', value: 95.32 },
  { date: '2023-09-28T12:00:00', value: 90.15 },
  { date: '2023-09-28T13:00:00', value: 70.91 },
  { date: '2023-09-28T14:00:00', value: 28.84 },
  { date: '2023-09-28T15:00:00', value: 62.99 },
  { date: '2023-09-28T16:00:00', value: 98.28 },
  { date: '2023-09-28T17:00:00', value: 96.27 },
  { date: '2023-09-28T18:00:00', value: 6.35 },
  { date: '2023-09-28T19:00:00', value: 62.03 },
  { date: '2023-09-28T20:00:00', value: 70.87 },
  { date: '2023-09-28T21:00:00', value: 18.15 },
  { date: '2023-09-28T22:00:00', value: 54.21 },
  { date: '2023-09-28T23:00:00', value: 21.37 },
  { date: '2023-09-29T00:00:00', value: 39.72 },
  { date: '2023-09-29T01:00:00', value: 41.19 },
  { date: '2023-09-29T02:00:00', value: 17.25 },
  { date: '2023-09-29T03:00:00', value: 52.03 },
  { date: '2023-09-29T04:00:00', value: 70.32 },
  { date: '2023-09-29T05:00:00', value: 43.88 },
  { date: '2023-09-29T06:00:00', value: 24.33 },
  { date: '2023-09-29T07:00:00', value: 55.93 },
  { date: '2023-09-29T08:00:00', value: 25.4 },
  { date: '2023-09-29T09:00:00', value: 69.64 },
  { date: '2023-09-29T10:00:00', value: 83.47 },
  { date: '2023-09-29T11:00:00', value: 87.87 },
  { date: '2023-09-29T12:00:00', value: 43.18 },
  { date: '2023-09-29T13:00:00', value: 95.88 },
  { date: '2023-09-29T14:00:00', value: 39.07 },
  { date: '2023-09-29T15:00:00', value: 58.24 },
  { date: '2023-09-29T16:00:00', value: 97.38 },
  { date: '2023-09-29T17:00:00', value: 69.31 },
  { date: '2023-09-29T18:00:00', value: 4.91 },
  { date: '2023-09-29T19:00:00', value: 36.89 },
  { date: '2023-09-29T20:00:00', value: 45.89 },
  { date: '2023-09-29T21:00:00', value: 45.39 },
  { date: '2023-09-29T22:00:00', value: 3.78 },
  { date: '2023-09-29T23:00:00', value: 14.61 },
  { date: '2023-09-30T00:00:00', value: 1.71 },
  { date: '2023-09-30T01:00:00', value: 89.28 },
  { date: '2023-09-30T02:00:00', value: 18.58 },
  { date: '2023-09-30T03:00:00', value: 42.72 },
  { date: '2023-09-30T04:00:00', value: 69.67 },
  { date: '2023-09-30T05:00:00', value: 12.41 },
  { date: '2023-09-30T06:00:00', value: 1.51 },
  { date: '2023-09-30T07:00:00', value: 22.51 },
  { date: '2023-09-30T08:00:00', value: 90.29 },
  { date: '2023-09-30T09:00:00', value: 94.37 },
  { date: '2023-09-30T10:00:00', value: 74.28 },
  { date: '2023-09-30T11:00:00', value: 50.76 },
  { date: '2023-09-30T12:00:00', value: 58.92 },
  { date: '2023-09-30T13:00:00', value: 65.79 },
  { date: '2023-09-30T14:00:00', value: 30.71 },
  { date: '2023-09-30T15:00:00', value: 18.59 },
  { date: '2023-09-30T16:00:00', value: 15.6 },
  { date: '2023-09-30T17:00:00', value: 77.19 },
  { date: '2023-09-30T18:00:00', value: 73.12 },
  { date: '2023-09-30T19:00:00', value: 79.43 },
  { date: '2023-09-30T20:00:00', value: 73.79 },
  { date: '2023-09-30T21:00:00', value: 63.84 },
  { date: '2023-09-30T22:00:00', value: 69.21 },
  { date: '2023-09-30T23:00:00', value: 35.13 },
  { date: '2023-10-01T00:00:00', value: 82.13 },
  { date: '2023-10-01T01:00:00', value: 12.93 },
  { date: '2023-10-01T02:00:00', value: 37.92 },
  { date: '2023-10-01T03:00:00', value: 67.16 },
  { date: '2023-10-01T04:00:00', value: 31.55 },
  { date: '2023-10-01T05:00:00', value: 38.0 },
  { date: '2023-10-01T06:00:00', value: 11.3 },
  { date: '2023-10-01T07:00:00', value: 5.92 },
  { date: '2023-10-01T08:00:00', value: 53.24 },
  { date: '2023-10-01T09:00:00', value: 15.28 },
  { date: '2023-10-01T10:00:00', value: 83.38 },
  { date: '2023-10-01T11:00:00', value: 40.46 },
  { date: '2023-10-01T12:00:00', value: 60.9 },
  { date: '2023-10-01T13:00:00', value: 80.27 },
  { date: '2023-10-01T14:00:00', value: 26.91 },
  { date: '2023-10-01T15:00:00', value: 44.31 },
  { date: '2023-10-01T16:00:00', value: 38.22 },
  { date: '2023-10-01T17:00:00', value: 96.51 },
  { date: '2023-10-01T18:00:00', value: 69.81 },
  { date: '2023-10-01T19:00:00', value: 80.92 },
  { date: '2023-10-01T20:00:00', value: 10.37 },
  { date: '2023-10-01T21:00:00', value: 66.0 },
  { date: '2023-10-01T22:00:00', value: 20.24 },
  { date: '2023-10-01T23:00:00', value: 61.25 },
  { date: '2023-10-02T00:00:00', value: 65.7 },
  { date: '2023-10-02T01:00:00', value: 18.76 },
  { date: '2023-10-02T02:00:00', value: 3.01 },
  { date: '2023-10-02T03:00:00', value: 73.12 },
  { date: '2023-10-02T04:00:00', value: 91.19 },
  { date: '2023-10-02T05:00:00', value: 71.36 },
  { date: '2023-10-02T06:00:00', value: 88.34 },
  { date: '2023-10-02T07:00:00', value: 8.49 },
  { date: '2023-10-02T08:00:00', value: 87.9 },
  { date: '2023-10-02T09:00:00', value: 47.64 },
  { date: '2023-10-02T10:00:00', value: 34.66 },
  { date: '2023-10-02T11:00:00', value: 99.49 },
  { date: '2023-10-02T12:00:00', value: 30.57 },
  { date: '2023-10-02T13:00:00', value: 59.27 },
  { date: '2023-10-02T14:00:00', value: 76.48 },
  { date: '2023-10-02T15:00:00', value: 93.36 },
  { date: '2023-10-02T16:00:00', value: 28.78 },
  { date: '2023-10-02T17:00:00', value: 27.74 },
  { date: '2023-10-02T18:00:00', value: 12.63 },
  { date: '2023-10-02T19:00:00', value: 90.26 },
  { date: '2023-10-02T20:00:00', value: 81.8 },
  { date: '2023-10-02T21:00:00', value: 96.77 },
  { date: '2023-10-02T22:00:00', value: 42.54 },
  { date: '2023-10-02T23:00:00', value: 58.37 },
  { date: '2023-10-03T00:00:00', value: 28.67 },
  { date: '2023-10-03T01:00:00', value: 93.28 },
  { date: '2023-10-03T02:00:00', value: 83.96 },
  { date: '2023-10-03T03:00:00', value: 70.15 },
  { date: '2023-10-03T04:00:00', value: 94.14 },
  { date: '2023-10-03T05:00:00', value: 4.57 },
  { date: '2023-10-03T06:00:00', value: 55.55 },
  { date: '2023-10-03T07:00:00', value: 66.81 },
  { date: '2023-10-03T08:00:00', value: 92.22 },
  { date: '2023-10-03T09:00:00', value: 96.64 },
  { date: '2023-10-03T10:00:00', value: 83.07 },
  { date: '2023-10-03T11:00:00', value: 80.83 },
  { date: '2023-10-03T12:00:00', value: 8.22 },
  { date: '2023-10-03T13:00:00', value: 58.8 },
  { date: '2023-10-03T14:00:00', value: 63.54 },
  { date: '2023-10-03T15:00:00', value: 85.3 },
  { date: '2023-10-03T16:00:00', value: 71.73 },
  { date: '2023-10-03T17:00:00', value: 18.45 },
  { date: '2023-10-03T18:00:00', value: 98.48 },
  { date: '2023-10-03T19:00:00', value: 22.16 },
  { date: '2023-10-03T20:00:00', value: 46.04 },
  { date: '2023-10-03T21:00:00', value: 32.92 },
  { date: '2023-10-03T22:00:00', value: 70.44 },
  { date: '2023-10-03T23:00:00', value: 80.85 },
  { date: '2023-10-04T00:00:00', value: 65.03 },
  { date: '2023-10-04T01:00:00', value: 59.52 },
  { date: '2023-10-04T02:00:00', value: 88.66 },
  { date: '2023-10-04T03:00:00', value: 64.99 },
  { date: '2023-10-04T04:00:00', value: 27.89 },
  { date: '2023-10-04T05:00:00', value: 49.75 },
  { date: '2023-10-04T06:00:00', value: 75.72 },
  { date: '2023-10-04T07:00:00', value: 7.28 },
  { date: '2023-10-04T08:00:00', value: 55.73 },
  { date: '2023-10-04T09:00:00', value: 99.32 },
  { date: '2023-10-04T10:00:00', value: 38.27 },
  { date: '2023-10-04T11:00:00', value: 54.15 },
  { date: '2023-10-04T12:00:00', value: 77.5 },
  { date: '2023-10-04T13:00:00', value: 96.18 },
  { date: '2023-10-04T14:00:00', value: 12.24 },
  { date: '2023-10-04T15:00:00', value: 67.52 },
  { date: '2023-10-04T16:00:00', value: 21.05 },
  { date: '2023-10-04T17:00:00', value: 35.96 },
  { date: '2023-10-04T18:00:00', value: 39.02 },
  { date: '2023-10-04T19:00:00', value: 14.13 },
  { date: '2023-10-04T20:00:00', value: 71.12 },
  { date: '2023-10-04T21:00:00', value: 45.64 },
  { date: '2023-10-04T22:00:00', value: 62.81 },
  { date: '2023-10-04T23:00:00', value: 5.53 },
  { date: '2023-10-05T00:00:00', value: 84.77 },
  { date: '2023-10-05T01:00:00', value: 61.44 },
  { date: '2023-10-05T02:00:00', value: 98.05 },
  { date: '2023-10-05T03:00:00', value: 27.44 },
  { date: '2023-10-05T04:00:00', value: 2.96 },
  { date: '2023-10-05T05:00:00', value: 32.69 },
  { date: '2023-10-05T06:00:00', value: 44.2 },
  { date: '2023-10-05T07:00:00', value: 13.51 },
  { date: '2023-10-05T08:00:00', value: 21.01 },
  { date: '2023-10-05T09:00:00', value: 11.98 },
  { date: '2023-10-05T10:00:00', value: 1.72 },
  { date: '2023-10-05T11:00:00', value: 75.23 },
  { date: '2023-10-05T12:00:00', value: 1.86 },
  { date: '2023-10-05T13:00:00', value: 93.97 },
  { date: '2023-10-05T14:00:00', value: 83.83 },
  { date: '2023-10-05T15:00:00', value: 79.78 },
  { date: '2023-10-05T16:00:00', value: 96.22 },
  { date: '2023-10-05T17:00:00', value: 87.99 },
  { date: '2023-10-05T18:00:00', value: 6.0 },
  { date: '2023-10-05T19:00:00', value: 21.11 },
  { date: '2023-10-05T20:00:00', value: 37.85 },
  { date: '2023-10-05T21:00:00', value: 4.31 },
  { date: '2023-10-05T22:00:00', value: 96.27 },
  { date: '2023-10-05T23:00:00', value: 69.55 },
  { date: '2023-10-06T00:00:00', value: 32.99 },
  { date: '2023-10-06T01:00:00', value: 54.41 },
  { date: '2023-10-06T02:00:00', value: 95.76 },
  { date: '2023-10-06T03:00:00', value: 5.35 },
  { date: '2023-10-06T04:00:00', value: 68.26 },
  { date: '2023-10-06T05:00:00', value: 62.8 },
  { date: '2023-10-06T06:00:00', value: 57.98 },
  { date: '2023-10-06T07:00:00', value: 42.7 },
  { date: '2023-10-06T08:00:00', value: 42.29 },
  { date: '2023-10-06T09:00:00', value: 82.47 },
  { date: '2023-10-06T10:00:00', value: 56.02 },
  { date: '2023-10-06T11:00:00', value: 34.75 },
  { date: '2023-10-06T12:00:00', value: 23.89 },
  { date: '2023-10-06T13:00:00', value: 8.22 },
  { date: '2023-10-06T14:00:00', value: 32.42 },
  { date: '2023-10-06T15:00:00', value: 53.28 },
  { date: '2023-10-06T16:00:00', value: 90.69 },
  { date: '2023-10-06T17:00:00', value: 34.51 },
  { date: '2023-10-06T18:00:00', value: 41.66 },
  { date: '2023-10-06T19:00:00', value: 44.28 },
  { date: '2023-10-06T20:00:00', value: 26.26 },
  { date: '2023-10-06T21:00:00', value: 29.74 },
  { date: '2023-10-06T22:00:00', value: 51.31 },
  { date: '2023-10-06T23:00:00', value: 67.99 },
  { date: '2023-10-07T00:00:00', value: 21.2 },
  { date: '2023-10-07T01:00:00', value: 96.52 },
  { date: '2023-10-07T02:00:00', value: 82.59 },
  { date: '2023-10-07T03:00:00', value: 69.32 },
  { date: '2023-10-07T04:00:00', value: 68.5 },
  { date: '2023-10-07T05:00:00', value: 69.32 },
  { date: '2023-10-07T06:00:00', value: 22.43 },
  { date: '2023-10-07T07:00:00', value: 72.95 },
  { date: '2023-10-07T08:00:00', value: 31.22 },
  { date: '2023-10-07T09:00:00', value: 48.73 },
  { date: '2023-10-07T10:00:00', value: 8.48 },
  { date: '2023-10-07T11:00:00', value: 36.47 },
  { date: '2023-10-07T12:00:00', value: 9.86 },
  { date: '2023-10-07T13:00:00', value: 23.57 },
  { date: '2023-10-07T14:00:00', value: 4.42 },
  { date: '2023-10-07T15:00:00', value: 80.32 },
  { date: '2023-10-07T16:00:00', value: 1.57 },
  { date: '2023-10-07T17:00:00', value: 61.08 },
  { date: '2023-10-07T18:00:00', value: 62.83 },
  { date: '2023-10-07T19:00:00', value: 8.82 },
  { date: '2023-10-07T20:00:00', value: 42.48 },
  { date: '2023-10-07T21:00:00', value: 82.89 },
  { date: '2023-10-07T22:00:00', value: 7.35 },
  { date: '2023-10-07T23:00:00', value: 27.65 },
  { date: '2023-10-08T00:00:00', value: 22.71 },
  { date: '2023-10-08T01:00:00', value: 7.47 },
  { date: '2023-10-08T02:00:00', value: 14.36 },
  { date: '2023-10-08T03:00:00', value: 60.61 },
  { date: '2023-10-08T04:00:00', value: 39.87 },
  { date: '2023-10-08T05:00:00', value: 82.4 },
  { date: '2023-10-08T06:00:00', value: 80.3 },
  { date: '2023-10-08T07:00:00', value: 58.27 },
  { date: '2023-10-08T08:00:00', value: 88.47 },
  { date: '2023-10-08T09:00:00', value: 55.3 },
  { date: '2023-10-08T10:00:00', value: 72.44 },
  { date: '2023-10-08T11:00:00', value: 29.06 },
  { date: '2023-10-08T12:00:00', value: 97.41 },
  { date: '2023-10-08T13:00:00', value: 38.76 },
  { date: '2023-10-08T14:00:00', value: 73.46 },
  { date: '2023-10-08T15:00:00', value: 88.47 },
  { date: '2023-10-08T16:00:00', value: 30.59 },
  { date: '2023-10-08T17:00:00', value: 8.65 },
  { date: '2023-10-08T18:00:00', value: 62.65 },
  { date: '2023-10-08T19:00:00', value: 16.74 },
  { date: '2023-10-08T20:00:00', value: 92.18 },
  { date: '2023-10-08T21:00:00', value: 7.27 },
  { date: '2023-10-08T22:00:00', value: 53.54 },
  { date: '2023-10-08T23:00:00', value: 74.07 },
  { date: '2023-10-09T00:00:00', value: 86.84 },
  { date: '2023-10-09T01:00:00', value: 26.67 },
  { date: '2023-10-09T02:00:00', value: 9.9 },
  { date: '2023-10-09T03:00:00', value: 55.07 },
  { date: '2023-10-09T04:00:00', value: 81.25 },
  { date: '2023-10-09T05:00:00', value: 23.65 },
  { date: '2023-10-09T06:00:00', value: 62.0 },
  { date: '2023-10-09T07:00:00', value: 10.46 },
  { date: '2023-10-09T08:00:00', value: 4.83 },
  { date: '2023-10-09T09:00:00', value: 45.57 },
  { date: '2023-10-09T10:00:00', value: 75.11 },
  { date: '2023-10-09T11:00:00', value: 40.92 },
  { date: '2023-10-09T12:00:00', value: 88.6 },
  { date: '2023-10-09T13:00:00', value: 73.99 },
  { date: '2023-10-09T14:00:00', value: 68.15 },
  { date: '2023-10-09T15:00:00', value: 19.73 },
  { date: '2023-10-09T16:00:00', value: 92.12 },
  { date: '2023-10-09T17:00:00', value: 21.42 },
  { date: '2023-10-09T18:00:00', value: 20.89 },
  { date: '2023-10-09T19:00:00', value: 66.22 },
  { date: '2023-10-09T20:00:00', value: 43.44 },
  { date: '2023-10-09T21:00:00', value: 28.14 },
  { date: '2023-10-09T22:00:00', value: 28.41 },
  { date: '2023-10-09T23:00:00', value: 29.6 },
  { date: '2023-10-10T00:00:00', value: 43.36 },
  { date: '2023-10-10T01:00:00', value: 6.98 },
  { date: '2023-10-10T02:00:00', value: 30.88 },
  { date: '2023-10-10T03:00:00', value: 18.99 },
  { date: '2023-10-10T04:00:00', value: 70.01 },
  { date: '2023-10-10T05:00:00', value: 13.85 },
  { date: '2023-10-10T06:00:00', value: 61.88 },
  { date: '2023-10-10T07:00:00', value: 44.98 },
  { date: '2023-10-10T08:00:00', value: 70.76 },
  { date: '2023-10-10T09:00:00', value: 46.43 },
  { date: '2023-10-10T10:00:00', value: 84.28 },
  { date: '2023-10-10T11:00:00', value: 1.22 },
  { date: '2023-10-10T12:00:00', value: 49.81 },
  { date: '2023-10-10T13:00:00', value: 37.87 },
  { date: '2023-10-10T14:00:00', value: 82.78 },
  { date: '2023-10-10T15:00:00', value: 37.24 },
  { date: '2023-10-10T16:00:00', value: 59.09 },
  { date: '2023-10-10T17:00:00', value: 6.35 },
  { date: '2023-10-10T18:00:00', value: 53.64 },
  { date: '2023-10-10T19:00:00', value: 57.44 },
  { date: '2023-10-10T20:00:00', value: 5.93 },
  { date: '2023-10-10T21:00:00', value: 33.85 },
  { date: '2023-10-10T22:00:00', value: 97.28 },
  { date: '2023-10-10T23:00:00', value: 58.64 },
  { date: '2023-10-11T00:00:00', value: 27.94 },
  { date: '2023-10-11T01:00:00', value: 31.28 },
  { date: '2023-10-11T02:00:00', value: 85.61 },
  { date: '2023-10-11T03:00:00', value: 70.53 },
  { date: '2023-10-11T04:00:00', value: 84.7 },
  { date: '2023-10-11T05:00:00', value: 51.61 },
  { date: '2023-10-11T06:00:00', value: 50.78 },
  { date: '2023-10-11T07:00:00', value: 2.29 },
  { date: '2023-10-11T08:00:00', value: 97.17 },
  { date: '2023-10-11T09:00:00', value: 60.62 },
  { date: '2023-10-11T10:00:00', value: 82.38 },
  { date: '2023-10-11T11:00:00', value: 98.85 },
  { date: '2023-10-11T12:00:00', value: 40.7 },
  { date: '2023-10-11T13:00:00', value: 69.35 },
  { date: '2023-10-11T14:00:00', value: 61.9 },
  { date: '2023-10-11T15:00:00', value: 32.31 },
  { date: '2023-10-11T16:00:00', value: 56.0 },
  { date: '2023-10-11T17:00:00', value: 47.82 },
  { date: '2023-10-11T18:00:00', value: 9.11 },
  { date: '2023-10-11T19:00:00', value: 50.52 },
  { date: '2023-10-11T20:00:00', value: 69.3 },
  { date: '2023-10-11T21:00:00', value: 63.85 },
  { date: '2023-10-11T22:00:00', value: 4.4 },
  { date: '2023-10-11T23:00:00', value: 46.79 },
  { date: '2023-10-12T00:00:00', value: 93.67 },
  { date: '2023-10-12T01:00:00', value: 5.87 },
  { date: '2023-10-12T02:00:00', value: 89.76 },
  { date: '2023-10-12T03:00:00', value: 80.12 },
  { date: '2023-10-12T04:00:00', value: 13.82 },
  { date: '2023-10-12T05:00:00', value: 40.92 },
  { date: '2023-10-12T06:00:00', value: 61.54 },
  { date: '2023-10-12T07:00:00', value: 25.73 },
  { date: '2023-10-12T08:00:00', value: 23.02 },
  { date: '2023-10-12T09:00:00', value: 88.2 },
  { date: '2023-10-12T10:00:00', value: 86.7 },
  { date: '2023-10-12T11:00:00', value: 80.75 },
  { date: '2023-10-12T12:00:00', value: 67.02 },
  { date: '2023-10-12T13:00:00', value: 18.93 },
  { date: '2023-10-12T14:00:00', value: 65.06 },
  { date: '2023-10-12T15:00:00', value: 72.33 },
  { date: '2023-10-12T16:00:00', value: 41.07 },
  { date: '2023-10-12T17:00:00', value: 32.92 },
  { date: '2023-10-12T18:00:00', value: 68.87 },
  { date: '2023-10-12T19:00:00', value: 99.87 },
  { date: '2023-10-12T20:00:00', value: 48.13 },
  { date: '2023-10-12T21:00:00', value: 4.25 },
  { date: '2023-10-12T22:00:00', value: 67.19 },
  { date: '2023-10-12T23:00:00', value: 88.66 },
  { date: '2023-10-13T00:00:00', value: 70.44 },
  { date: '2023-10-13T01:00:00', value: 55.05 },
  { date: '2023-10-13T02:00:00', value: 98.36 },
  { date: '2023-10-13T03:00:00', value: 49.75 },
  { date: '2023-10-13T04:00:00', value: 39.39 },
  { date: '2023-10-13T05:00:00', value: 65.57 },
  { date: '2023-10-13T06:00:00', value: 50.36 },
  { date: '2023-10-13T07:00:00', value: 9.15 },
  { date: '2023-10-13T08:00:00', value: 47.83 },
  { date: '2023-10-13T09:00:00', value: 91.3 },
  { date: '2023-10-13T10:00:00', value: 62.96 },
  { date: '2023-10-13T11:00:00', value: 62.87 },
  { date: '2023-10-13T12:00:00', value: 82.7 },
  { date: '2023-10-13T13:00:00', value: 18.0 },
  { date: '2023-10-13T14:00:00', value: 1.33 },
  { date: '2023-10-13T15:00:00', value: 93.89 },
  { date: '2023-10-13T16:00:00', value: 94.98 },
  { date: '2023-10-13T17:00:00', value: 2.69 },
  { date: '2023-10-13T18:00:00', value: 35.9 },
  { date: '2023-10-13T19:00:00', value: 61.32 },
  { date: '2023-10-13T20:00:00', value: 78.84 },
  { date: '2023-10-13T21:00:00', value: 76.38 },
  { date: '2023-10-13T22:00:00', value: 65.12 },
  { date: '2023-10-13T23:00:00', value: 93.38 },
  { date: '2023-10-14T00:00:00', value: 36.06 },
  { date: '2023-10-14T01:00:00', value: 30.33 },
  { date: '2023-10-14T02:00:00', value: 27.44 },
  { date: '2023-10-14T03:00:00', value: 8.55 },
  { date: '2023-10-14T04:00:00', value: 40.37 },
  { date: '2023-10-14T05:00:00', value: 71.49 },
  { date: '2023-10-14T06:00:00', value: 87.5 },
  { date: '2023-10-14T07:00:00', value: 82.93 },
  { date: '2023-10-14T08:00:00', value: 98.91 },
  { date: '2023-10-14T09:00:00', value: 58.31 },
  { date: '2023-10-14T10:00:00', value: 59.68 },
  { date: '2023-10-14T11:00:00', value: 35.04 },
  { date: '2023-10-14T12:00:00', value: 7.46 },
  { date: '2023-10-14T13:00:00', value: 59.68 },
  { date: '2023-10-14T14:00:00', value: 14.99 },
  { date: '2023-10-14T15:00:00', value: 17.86 },
  { date: '2023-10-14T16:00:00', value: 34.82 },
  { date: '2023-10-14T17:00:00', value: 39.05 },
  { date: '2023-10-14T18:00:00', value: 99.16 },
  { date: '2023-10-14T19:00:00', value: 38.06 },
  { date: '2023-10-14T20:00:00', value: 90.71 },
  { date: '2023-10-14T21:00:00', value: 34.88 },
  { date: '2023-10-14T22:00:00', value: 49.11 },
  { date: '2023-10-14T23:00:00', value: 62.48 },
  { date: '2023-10-15T00:00:00', value: 41.7 },
  { date: '2023-10-15T01:00:00', value: 43.76 },
  { date: '2023-10-15T02:00:00', value: 73.94 },
  { date: '2023-10-15T03:00:00', value: 32.87 },
  { date: '2023-10-15T04:00:00', value: 60.75 },
  { date: '2023-10-15T05:00:00', value: 66.64 },
  { date: '2023-10-15T06:00:00', value: 68.45 },
  { date: '2023-10-15T07:00:00', value: 65.31 },
  { date: '2023-10-15T08:00:00', value: 84.29 },
  { date: '2023-10-15T09:00:00', value: 23.46 },
  { date: '2023-10-15T10:00:00', value: 55.51 },
  { date: '2023-10-15T11:00:00', value: 45.08 },
  { date: '2023-10-15T12:00:00', value: 60.92 },
  { date: '2023-10-15T13:00:00', value: 6.5 },
  { date: '2023-10-15T14:00:00', value: 43.93 },
  { date: '2023-10-15T15:00:00', value: 60.02 },
  { date: '2023-10-15T16:00:00', value: 51.14 },
  { date: '2023-10-15T17:00:00', value: 86.08 },
  { date: '2023-10-15T18:00:00', value: 54.88 },
  { date: '2023-10-15T19:00:00', value: 65.32 },
  { date: '2023-10-15T20:00:00', value: 45.09 },
  { date: '2023-10-15T21:00:00', value: 89.04 },
  { date: '2023-10-15T22:00:00', value: 53.08 },
  { date: '2023-10-15T23:00:00', value: 22.18 },
  { date: '2023-10-16T00:00:00', value: 64.27 },
  { date: '2023-10-16T01:00:00', value: 5.71 },
  { date: '2023-10-16T02:00:00', value: 2.09 },
  { date: '2023-10-16T03:00:00', value: 51.08 },
  { date: '2023-10-16T04:00:00', value: 67.83 },
  { date: '2023-10-16T05:00:00', value: 82.63 },
  { date: '2023-10-16T06:00:00', value: 60.66 },
  { date: '2023-10-16T07:00:00', value: 84.72 },
  { date: '2023-10-16T08:00:00', value: 47.26 },
  { date: '2023-10-16T09:00:00', value: 66.92 },
  { date: '2023-10-16T10:00:00', value: 44.41 },
  { date: '2023-10-16T11:00:00', value: 60.66 },
  { date: '2023-10-16T12:00:00', value: 63.29 },
  { date: '2023-10-16T13:00:00', value: 47.57 },
  { date: '2023-10-16T14:00:00', value: 90.9 },
  { date: '2023-10-16T15:00:00', value: 90.87 },
  { date: '2023-10-16T16:00:00', value: 17.97 },
  { date: '2023-10-16T17:00:00', value: 83.87 },
  { date: '2023-10-16T18:00:00', value: 72.18 },
  { date: '2023-10-16T19:00:00', value: 76.72 },
  { date: '2023-10-16T20:00:00', value: 75.98 },
  { date: '2023-10-16T21:00:00', value: 67.14 },
  { date: '2023-10-16T22:00:00', value: 49.34 },
  { date: '2023-10-16T23:00:00', value: 45.24 },
  { date: '2023-10-17T00:00:00', value: 82.18 },
  { date: '2023-10-17T01:00:00', value: 75.01 },
  { date: '2023-10-17T02:00:00', value: 97.62 },
  { date: '2023-10-17T03:00:00', value: 86.73 },
  { date: '2023-10-17T04:00:00', value: 93.99 },
  { date: '2023-10-17T05:00:00', value: 3.66 },
  { date: '2023-10-17T06:00:00', value: 65.43 },
  { date: '2023-10-17T07:00:00', value: 64.79 },
  { date: '2023-10-17T08:00:00', value: 43.74 },
  { date: '2023-10-17T09:00:00', value: 43.27 },
  { date: '2023-10-17T10:00:00', value: 61.23 },
  { date: '2023-10-17T11:00:00', value: 28.48 },
  { date: '2023-10-17T12:00:00', value: 5.47 },
  { date: '2023-10-17T13:00:00', value: 51.0 },
  { date: '2023-10-17T14:00:00', value: 6.59 },
  { date: '2023-10-17T15:00:00', value: 40.22 },
  { date: '2023-10-17T16:00:00', value: 20.57 },
  { date: '2023-10-17T17:00:00', value: 46.26 },
  { date: '2023-10-17T18:00:00', value: 70.66 },
  { date: '2023-10-17T19:00:00', value: 72.63 },
  { date: '2023-10-17T20:00:00', value: 34.47 },
  { date: '2023-10-17T21:00:00', value: 37.31 },
  { date: '2023-10-17T22:00:00', value: 28.48 },
  { date: '2023-10-17T23:00:00', value: 35.99 },
  { date: '2023-10-18T00:00:00', value: 87.71 },
  { date: '2023-10-18T01:00:00', value: 8.89 },
  { date: '2023-10-18T02:00:00', value: 32.34 },
  { date: '2023-10-18T03:00:00', value: 1.94 },
  { date: '2023-10-18T04:00:00', value: 2.14 },
  { date: '2023-10-18T05:00:00', value: 41.89 },
  { date: '2023-10-18T06:00:00', value: 5.87 },
  { date: '2023-10-18T07:00:00', value: 83.32 },
  { date: '2023-10-18T08:00:00', value: 80.62 },
  { date: '2023-10-18T09:00:00', value: 24.59 },
  { date: '2023-10-18T10:00:00', value: 49.32 },
  { date: '2023-10-18T11:00:00', value: 13.92 },
  { date: '2023-10-18T12:00:00', value: 29.63 },
  { date: '2023-10-18T13:00:00', value: 95.43 },
  { date: '2023-10-18T14:00:00', value: 66.28 },
  { date: '2023-10-18T15:00:00', value: 95.82 },
  { date: '2023-10-18T16:00:00', value: 52.09 },
  { date: '2023-10-18T17:00:00', value: 58.91 },
  { date: '2023-10-18T18:00:00', value: 92.97 },
  { date: '2023-10-18T19:00:00', value: 8.89 },
  { date: '2023-10-18T20:00:00', value: 54.46 },
  { date: '2023-10-18T21:00:00', value: 40.91 },
  { date: '2023-10-18T22:00:00', value: 79.13 },
  { date: '2023-10-18T23:00:00', value: 9.96 },
  { date: '2023-10-19T00:00:00', value: 30.11 },
  { date: '2023-10-19T01:00:00', value: 83.26 },
  { date: '2023-10-19T02:00:00', value: 71.73 },
  { date: '2023-10-19T03:00:00', value: 97.06 },
  { date: '2023-10-19T04:00:00', value: 45.7 },
  { date: '2023-10-19T05:00:00', value: 5.8 },
  { date: '2023-10-19T06:00:00', value: 53.69 },
  { date: '2023-10-19T07:00:00', value: 97.37 },
  { date: '2023-10-19T08:00:00', value: 84.52 },
  { date: '2023-10-19T09:00:00', value: 65.07 },
  { date: '2023-10-19T10:00:00', value: 53.41 },
  { date: '2023-10-19T11:00:00', value: 2.84 },
  { date: '2023-10-19T12:00:00', value: 12.13 },
  { date: '2023-10-19T13:00:00', value: 14.71 },
  { date: '2023-10-19T14:00:00', value: 85.48 },
  { date: '2023-10-19T15:00:00', value: 56.62 },
  { date: '2023-10-19T16:00:00', value: 20.68 },
  { date: '2023-10-19T17:00:00', value: 28.63 },
  { date: '2023-10-19T18:00:00', value: 19.4 },
  { date: '2023-10-19T19:00:00', value: 31.69 },
  { date: '2023-10-19T20:00:00', value: 69.35 },
  { date: '2023-10-19T21:00:00', value: 84.87 },
  { date: '2023-10-19T22:00:00', value: 91.45 },
  { date: '2023-10-19T23:00:00', value: 40.12 },
  { date: '2023-10-20T00:00:00', value: 24.21 },
  { date: '2023-10-20T01:00:00', value: 88.35 },
  { date: '2023-10-20T02:00:00', value: 17.83 },
  { date: '2023-10-20T03:00:00', value: 55.73 },
  { date: '2023-10-20T04:00:00', value: 84.36 },
  { date: '2023-10-20T05:00:00', value: 28.06 },
  { date: '2023-10-20T06:00:00', value: 27.69 },
  { date: '2023-10-20T07:00:00', value: 93.94 },
  { date: '2023-10-20T08:00:00', value: 94.07 },
  { date: '2023-10-20T09:00:00', value: 57.91 },
  { date: '2023-10-20T10:00:00', value: 76.57 },
  { date: '2023-10-20T11:00:00', value: 25.26 },
  { date: '2023-10-20T12:00:00', value: 8.99 },
  { date: '2023-10-20T13:00:00', value: 51.65 },
  { date: '2023-10-20T14:00:00', value: 77.79 },
  { date: '2023-10-20T15:00:00', value: 97.4 },
  { date: '2023-10-20T16:00:00', value: 77.39 },
  { date: '2023-10-20T17:00:00', value: 88.93 },
  { date: '2023-10-20T18:00:00', value: 83.68 },
  { date: '2023-10-20T19:00:00', value: 37.59 },
  { date: '2023-10-20T20:00:00', value: 94.71 },
  { date: '2023-10-20T21:00:00', value: 61.15 },
  { date: '2023-10-20T22:00:00', value: 89.37 },
  { date: '2023-10-20T23:00:00', value: 59.65 },
  { date: '2023-10-21T00:00:00', value: 76.73 },
  { date: '2023-10-21T01:00:00', value: 91.4 },
  { date: '2023-10-21T02:00:00', value: 5.03 },
  { date: '2023-10-21T03:00:00', value: 4.02 },
  { date: '2023-10-21T04:00:00', value: 14.68 },
  { date: '2023-10-21T05:00:00', value: 61.62 },
  { date: '2023-10-21T06:00:00', value: 70.87 },
  { date: '2023-10-21T07:00:00', value: 65.12 },
  { date: '2023-10-21T08:00:00', value: 22.04 },
  { date: '2023-10-21T09:00:00', value: 15.84 },
  { date: '2023-10-21T10:00:00', value: 82.42 },
  { date: '2023-10-21T11:00:00', value: 85.92 },
  { date: '2023-10-21T12:00:00', value: 59.37 },
  { date: '2023-10-21T13:00:00', value: 42.3 },
  { date: '2023-10-21T14:00:00', value: 77.06 },
  { date: '2023-10-21T15:00:00', value: 40.2 },
  { date: '2023-10-21T16:00:00', value: 11.71 },
  { date: '2023-10-21T17:00:00', value: 71.95 },
  { date: '2023-10-21T18:00:00', value: 96.22 },
  { date: '2023-10-21T19:00:00', value: 4.52 },
  { date: '2023-10-21T20:00:00', value: 16.25 },
  { date: '2023-10-21T21:00:00', value: 51.1 },
  { date: '2023-10-21T22:00:00', value: 86.55 },
  { date: '2023-10-21T23:00:00', value: 84.28 },
  { date: '2023-10-22T00:00:00', value: 17.62 },
  { date: '2023-10-22T01:00:00', value: 60.07 },
  { date: '2023-10-22T02:00:00', value: 64.24 },
  { date: '2023-10-22T03:00:00', value: 53.65 },
  { date: '2023-10-22T04:00:00', value: 33.15 },
  { date: '2023-10-22T05:00:00', value: 5.63 },
  { date: '2023-10-22T06:00:00', value: 50.8 },
  { date: '2023-10-22T07:00:00', value: 14.25 },
  { date: '2023-10-22T08:00:00', value: 73.23 },
  { date: '2023-10-22T09:00:00', value: 33.11 },
  { date: '2023-10-22T10:00:00', value: 23.93 },
  { date: '2023-10-22T11:00:00', value: 29.68 },
  { date: '2023-10-22T12:00:00', value: 21.82 },
  { date: '2023-10-22T13:00:00', value: 89.67 },
  { date: '2023-10-22T14:00:00', value: 35.72 },
  { date: '2023-10-22T15:00:00', value: 28.64 },
  { date: '2023-10-22T16:00:00', value: 14.27 },
  { date: '2023-10-22T17:00:00', value: 60.57 },
  { date: '2023-10-22T18:00:00', value: 69.51 },
  { date: '2023-10-22T19:00:00', value: 85.92 },
  { date: '2023-10-22T20:00:00', value: 43.71 },
  { date: '2023-10-22T21:00:00', value: 98.05 },
  { date: '2023-10-22T22:00:00', value: 78.14 },
  { date: '2023-10-22T23:00:00', value: 34.04 },
  { date: '2023-10-23T00:00:00', value: 13.81 },
  { date: '2023-10-23T01:00:00', value: 26.33 },
  { date: '2023-10-23T02:00:00', value: 64.73 },
  { date: '2023-10-23T03:00:00', value: 4.64 },
  { date: '2023-10-23T04:00:00', value: 46.32 },
  { date: '2023-10-23T05:00:00', value: 81.22 },
  { date: '2023-10-23T06:00:00', value: 24.32 },
  { date: '2023-10-23T07:00:00', value: 51.77 },
  { date: '2023-10-23T08:00:00', value: 97.48 },
  { date: '2023-10-23T09:00:00', value: 88.71 },
  { date: '2023-10-23T10:00:00', value: 68.12 },
  { date: '2023-10-23T11:00:00', value: 88.72 },
  { date: '2023-10-23T12:00:00', value: 91.42 },
  { date: '2023-10-23T13:00:00', value: 66.19 },
  { date: '2023-10-23T14:00:00', value: 45.48 },
  { date: '2023-10-23T15:00:00', value: 23.71 },
  { date: '2023-10-23T16:00:00', value: 24.75 },
  { date: '2023-10-23T17:00:00', value: 48.32 },
  { date: '2023-10-23T18:00:00', value: 57.38 },
  { date: '2023-10-23T19:00:00', value: 20.11 },
  { date: '2023-10-23T20:00:00', value: 56.1 },
  { date: '2023-10-23T21:00:00', value: 24.79 },
  { date: '2023-10-23T22:00:00', value: 38.62 },
  { date: '2023-10-23T23:00:00', value: 3.85 },
  { date: '2023-10-24T00:00:00', value: 23.38 },
  { date: '2023-10-24T01:00:00', value: 97.47 },
  { date: '2023-10-24T02:00:00', value: 43.99 },
  { date: '2023-10-24T03:00:00', value: 34.14 },
  { date: '2023-10-24T04:00:00', value: 14.15 },
  { date: '2023-10-24T05:00:00', value: 10.11 },
  { date: '2023-10-24T06:00:00', value: 36.5 },
  { date: '2023-10-24T07:00:00', value: 39.29 },
  { date: '2023-10-24T08:00:00', value: 73.47 },
  { date: '2023-10-24T09:00:00', value: 34.08 },
  { date: '2023-10-24T10:00:00', value: 85.95 },
  { date: '2023-10-24T11:00:00', value: 5.8 },
  { date: '2023-10-24T12:00:00', value: 98.53 },
  { date: '2023-10-24T13:00:00', value: 11.1 },
  { date: '2023-10-24T14:00:00', value: 16.35 },
  { date: '2023-10-24T15:00:00', value: 18.11 },
  { date: '2023-10-24T16:00:00', value: 5.4 },
  { date: '2023-10-24T17:00:00', value: 9.39 },
  { date: '2023-10-24T18:00:00', value: 42.47 },
  { date: '2023-10-24T19:00:00', value: 52.64 },
  { date: '2023-10-24T20:00:00', value: 62.3 },
  { date: '2023-10-24T21:00:00', value: 32.92 },
  { date: '2023-10-24T22:00:00', value: 55.33 },
  { date: '2023-10-24T23:00:00', value: 43.43 },
  { date: '2023-10-25T00:00:00', value: 90.48 },
  { date: '2023-10-25T01:00:00', value: 17.43 },
  { date: '2023-10-25T02:00:00', value: 21.5 },
  { date: '2023-10-25T03:00:00', value: 16.11 },
  { date: '2023-10-25T04:00:00', value: 38.71 },
  { date: '2023-10-25T05:00:00', value: 40.67 },
  { date: '2023-10-25T06:00:00', value: 92.47 },
  { date: '2023-10-25T07:00:00', value: 58.8 },
  { date: '2023-10-25T08:00:00', value: 74.73 },
  { date: '2023-10-25T09:00:00', value: 80.61 },
  { date: '2023-10-25T10:00:00', value: 74.31 },
  { date: '2023-10-25T11:00:00', value: 61.26 },
  { date: '2023-10-25T12:00:00', value: 55.95 },
  { date: '2023-10-25T13:00:00', value: 81.51 },
  { date: '2023-10-25T14:00:00', value: 68.85 },
  { date: '2023-10-25T15:00:00', value: 50.62 },
  { date: '2023-10-25T16:00:00', value: 78.76 },
  { date: '2023-10-25T17:00:00', value: 76.21 },
  { date: '2023-10-25T18:00:00', value: 40.56 },
  { date: '2023-10-25T19:00:00', value: 95.69 },
  { date: '2023-10-25T20:00:00', value: 69.26 },
  { date: '2023-10-25T21:00:00', value: 53.98 },
  { date: '2023-10-25T22:00:00', value: 31.64 },
  { date: '2023-10-25T23:00:00', value: 92.0 },
  { date: '2023-10-26T00:00:00', value: 36.36 },
  { date: '2023-10-26T01:00:00', value: 56.18 },
  { date: '2023-10-26T02:00:00', value: 50.44 },
  { date: '2023-10-26T03:00:00', value: 23.67 },
  { date: '2023-10-26T04:00:00', value: 65.59 },
  { date: '2023-10-26T05:00:00', value: 19.88 },
  { date: '2023-10-26T06:00:00', value: 29.13 },
  { date: '2023-10-26T07:00:00', value: 54.53 },
  { date: '2023-10-26T08:00:00', value: 74.8 },
  { date: '2023-10-26T09:00:00', value: 93.14 },
  { date: '2023-10-26T10:00:00', value: 47.18 },
  { date: '2023-10-26T11:00:00', value: 55.86 },
  { date: '2023-10-26T12:00:00', value: 46.17 },
  { date: '2023-10-26T13:00:00', value: 37.63 },
  { date: '2023-10-26T14:00:00', value: 26.39 },
  { date: '2023-10-26T15:00:00', value: 5.48 },
  { date: '2023-10-26T16:00:00', value: 44.12 },
  { date: '2023-10-26T17:00:00', value: 37.04 },
  { date: '2023-10-26T18:00:00', value: 50.78 },
  { date: '2023-10-26T19:00:00', value: 48.41 },
  { date: '2023-10-26T20:00:00', value: 62.72 },
  { date: '2023-10-26T21:00:00', value: 28.63 },
  { date: '2023-10-26T22:00:00', value: 4.39 },
  { date: '2023-10-26T23:00:00', value: 26.16 },
  { date: '2023-10-27T00:00:00', value: 73.93 },
  { date: '2023-10-27T01:00:00', value: 15.09 },
  { date: '2023-10-27T02:00:00', value: 42.63 },
  { date: '2023-10-27T03:00:00', value: 40.87 },
  { date: '2023-10-27T04:00:00', value: 71.15 },
  { date: '2023-10-27T05:00:00', value: 54.41 },
  { date: '2023-10-27T06:00:00', value: 83.08 },
  { date: '2023-10-27T07:00:00', value: 89.42 },
  { date: '2023-10-27T08:00:00', value: 70.0 },
  { date: '2023-10-27T09:00:00', value: 76.07 },
  { date: '2023-10-27T10:00:00', value: 43.65 },
  { date: '2023-10-27T11:00:00', value: 26.07 },
  { date: '2023-10-27T12:00:00', value: 18.16 },
  { date: '2023-10-27T13:00:00', value: 13.76 },
  { date: '2023-10-27T14:00:00', value: 23.63 },
  { date: '2023-10-27T15:00:00', value: 52.64 },
  { date: '2023-10-27T16:00:00', value: 21.63 },
  { date: '2023-10-27T17:00:00', value: 5.52 },
  { date: '2023-10-27T18:00:00', value: 85.84 },
  { date: '2023-10-27T19:00:00', value: 74.0 },
  { date: '2023-10-27T20:00:00', value: 62.99 },
  { date: '2023-10-27T21:00:00', value: 68.34 },
  { date: '2023-10-27T22:00:00', value: 67.79 },
  { date: '2023-10-27T23:00:00', value: 73.17 },
  { date: '2023-10-28T00:00:00', value: 1.79 },
  { date: '2023-10-28T01:00:00', value: 66.62 },
  { date: '2023-10-28T02:00:00', value: 91.89 },
  { date: '2023-10-28T03:00:00', value: 73.88 },
  { date: '2023-10-28T04:00:00', value: 75.54 },
  { date: '2023-10-28T05:00:00', value: 25.66 },
  { date: '2023-10-28T06:00:00', value: 27.25 },
  { date: '2023-10-28T07:00:00', value: 51.16 },
  { date: '2023-10-28T08:00:00', value: 57.67 },
  { date: '2023-10-28T09:00:00', value: 99.88 },
  { date: '2023-10-28T10:00:00', value: 99.57 },
  { date: '2023-10-28T11:00:00', value: 73.87 },
  { date: '2023-10-28T12:00:00', value: 22.17 },
  { date: '2023-10-28T13:00:00', value: 82.86 },
  { date: '2023-10-28T14:00:00', value: 41.4 },
  { date: '2023-10-28T15:00:00', value: 58.07 },
  { date: '2023-10-28T16:00:00', value: 74.39 },
  { date: '2023-10-28T17:00:00', value: 34.54 },
  { date: '2023-10-28T18:00:00', value: 94.9 },
  { date: '2023-10-28T19:00:00', value: 97.41 },
  { date: '2023-10-28T20:00:00', value: 36.49 },
  { date: '2023-10-28T21:00:00', value: 45.17 },
  { date: '2023-10-28T22:00:00', value: 60.31 },
  { date: '2023-10-28T23:00:00', value: 30.07 },
  { date: '2023-10-29T00:00:00', value: 20.15 },
  { date: '2023-10-29T01:00:00', value: 31.05 },
  { date: '2023-10-29T02:00:00', value: 66.47 },
  { date: '2023-10-29T03:00:00', value: 89.78 },
  { date: '2023-10-29T04:00:00', value: 86.47 },
  { date: '2023-10-29T05:00:00', value: 85.0 },
  { date: '2023-10-29T06:00:00', value: 59.68 },
  { date: '2023-10-29T07:00:00', value: 27.64 },
  { date: '2023-10-29T08:00:00', value: 75.34 },
  { date: '2023-10-29T09:00:00', value: 91.54 },
  { date: '2023-10-29T10:00:00', value: 40.02 },
  { date: '2023-10-29T11:00:00', value: 85.98 },
  { date: '2023-10-29T12:00:00', value: 33.68 },
  { date: '2023-10-29T13:00:00', value: 24.81 },
  { date: '2023-10-29T14:00:00', value: 16.86 },
  { date: '2023-10-29T15:00:00', value: 28.18 },
  { date: '2023-10-29T16:00:00', value: 50.95 },
  { date: '2023-10-29T17:00:00', value: 52.81 },
  { date: '2023-10-29T18:00:00', value: 47.37 },
  { date: '2023-10-29T19:00:00', value: 16.13 },
  { date: '2023-10-29T20:00:00', value: 92.12 },
  { date: '2023-10-29T21:00:00', value: 11.07 },
  { date: '2023-10-29T22:00:00', value: 46.26 },
  { date: '2023-10-29T23:00:00', value: 68.25 },
  { date: '2023-10-30T00:00:00', value: 44.18 },
  { date: '2023-10-30T01:00:00', value: 5.88 },
  { date: '2023-10-30T02:00:00', value: 5.87 },
  { date: '2023-10-30T03:00:00', value: 96.49 },
  { date: '2023-10-30T04:00:00', value: 99.99 },
  { date: '2023-10-30T05:00:00', value: 10.81 },
  { date: '2023-10-30T06:00:00', value: 1.41 },
  { date: '2023-10-30T07:00:00', value: 67.25 },
  { date: '2023-10-30T08:00:00', value: 28.55 },
  { date: '2023-10-30T09:00:00', value: 55.34 },
  { date: '2023-10-30T10:00:00', value: 10.25 },
  { date: '2023-10-30T11:00:00', value: 91.98 },
  { date: '2023-10-30T12:00:00', value: 43.96 },
  { date: '2023-10-30T13:00:00', value: 50.78 },
  { date: '2023-10-30T14:00:00', value: 12.33 },
  { date: '2023-10-30T15:00:00', value: 22.51 },
  { date: '2023-10-30T16:00:00', value: 70.7 },
  { date: '2023-10-30T17:00:00', value: 2.53 },
  { date: '2023-10-30T18:00:00', value: 35.62 },
  { date: '2023-10-30T19:00:00', value: 95.4 },
  { date: '2023-10-30T20:00:00', value: 77.15 },
  { date: '2023-10-30T21:00:00', value: 81.54 },
  { date: '2023-10-30T22:00:00', value: 70.27 },
  { date: '2023-10-30T23:00:00', value: 28.4 },
  { date: '2023-10-31T00:00:00', value: 39.13 },
  { date: '2023-10-31T01:00:00', value: 96.92 },
  { date: '2023-10-31T02:00:00', value: 66.61 },
  { date: '2023-10-31T03:00:00', value: 29.07 },
  { date: '2023-10-31T04:00:00', value: 75.59 },
  { date: '2023-10-31T05:00:00', value: 60.59 },
  { date: '2023-10-31T06:00:00', value: 38.75 },
  { date: '2023-10-31T07:00:00', value: 45.77 },
  { date: '2023-10-31T08:00:00', value: 10.32 },
  { date: '2023-10-31T09:00:00', value: 40.69 },
  { date: '2023-10-31T10:00:00', value: 89.77 },
  { date: '2023-10-31T11:00:00', value: 7.29 },
  { date: '2023-10-31T12:00:00', value: 57.83 },
  { date: '2023-10-31T13:00:00', value: 51.0 },
  { date: '2023-10-31T14:00:00', value: 82.98 },
  { date: '2023-10-31T15:00:00', value: 68.02 },
  { date: '2023-10-31T16:00:00', value: 7.61 },
  { date: '2023-10-31T17:00:00', value: 22.43 },
  { date: '2023-10-31T18:00:00', value: 90.09 },
  { date: '2023-10-31T19:00:00', value: 91.75 },
  { date: '2023-10-31T20:00:00', value: 91.34 },
  { date: '2023-10-31T21:00:00', value: 80.8 },
  { date: '2023-10-31T22:00:00', value: 4.91 },
  { date: '2023-10-31T23:00:00', value: 18.28 },
  { date: '2023-11-01T00:00:00', value: 11.91 },
  { date: '2023-11-01T01:00:00', value: 91.24 },
  { date: '2023-11-01T02:00:00', value: 53.53 },
  { date: '2023-11-01T03:00:00', value: 33.68 },
  { date: '2023-11-01T04:00:00', value: 60.8 },
  { date: '2023-11-01T05:00:00', value: 3.76 },
  { date: '2023-11-01T06:00:00', value: 58.17 },
  { date: '2023-11-01T07:00:00', value: 37.26 },
  { date: '2023-11-01T08:00:00', value: 53.5 },
  { date: '2023-11-01T09:00:00', value: 22.54 },
  { date: '2023-11-01T10:00:00', value: 41.98 },
  { date: '2023-11-01T11:00:00', value: 75.02 },
  { date: '2023-11-01T12:00:00', value: 95.76 },
  { date: '2023-11-01T13:00:00', value: 47.93 },
  { date: '2023-11-01T14:00:00', value: 25.34 },
  { date: '2023-11-01T15:00:00', value: 12.63 },
  { date: '2023-11-01T16:00:00', value: 87.01 },
  { date: '2023-11-01T17:00:00', value: 39.16 },
  { date: '2023-11-01T18:00:00', value: 28.15 },
  { date: '2023-11-01T19:00:00', value: 42.52 },
  { date: '2023-11-01T20:00:00', value: 96.07 },
  { date: '2023-11-01T21:00:00', value: 34.28 },
  { date: '2023-11-01T22:00:00', value: 27.36 },
  { date: '2023-11-01T23:00:00', value: 25.24 },
  { date: '2023-11-02T00:00:00', value: 7.36 },
  { date: '2023-11-02T01:00:00', value: 33.34 },
  { date: '2023-11-02T02:00:00', value: 62.84 },
  { date: '2023-11-02T03:00:00', value: 44.24 },
  { date: '2023-11-02T04:00:00', value: 50.32 },
  { date: '2023-11-02T05:00:00', value: 89.41 },
  { date: '2023-11-02T06:00:00', value: 16.02 },
  { date: '2023-11-02T07:00:00', value: 20.58 },
  { date: '2023-11-02T08:00:00', value: 19.06 },
  { date: '2023-11-02T09:00:00', value: 93.97 },
  { date: '2023-11-02T10:00:00', value: 47.42 },
  { date: '2023-11-02T11:00:00', value: 64.45 },
  { date: '2023-11-02T12:00:00', value: 33.23 },
  { date: '2023-11-02T13:00:00', value: 1.52 },
  { date: '2023-11-02T14:00:00', value: 61.09 },
  { date: '2023-11-02T15:00:00', value: 35.26 },
  { date: '2023-11-02T16:00:00', value: 47.63 },
  { date: '2023-11-02T17:00:00', value: 87.82 },
  { date: '2023-11-02T18:00:00', value: 27.1 },
  { date: '2023-11-02T19:00:00', value: 28.17 },
  { date: '2023-11-02T20:00:00', value: 88.45 },
  { date: '2023-11-02T21:00:00', value: 32.86 },
  { date: '2023-11-02T22:00:00', value: 24.85 },
  { date: '2023-11-02T23:00:00', value: 34.85 },
  { date: '2023-11-03T00:00:00', value: 86.02 },
  { date: '2023-11-03T01:00:00', value: 86.41 },
  { date: '2023-11-03T02:00:00', value: 89.16 },
  { date: '2023-11-03T03:00:00', value: 40.45 },
  { date: '2023-11-03T04:00:00', value: 31.66 },
  { date: '2023-11-03T05:00:00', value: 84.21 },
  { date: '2023-11-03T06:00:00', value: 71.16 },
  { date: '2023-11-03T07:00:00', value: 35.55 },
  { date: '2023-11-03T08:00:00', value: 66.3 },
  { date: '2023-11-03T09:00:00', value: 77.4 },
  { date: '2023-11-03T10:00:00', value: 26.33 },
  { date: '2023-11-03T11:00:00', value: 69.61 },
  { date: '2023-11-03T12:00:00', value: 63.92 },
  { date: '2023-11-03T13:00:00', value: 78.7 },
  { date: '2023-11-03T14:00:00', value: 18.72 },
  { date: '2023-11-03T15:00:00', value: 21.85 },
  { date: '2023-11-03T16:00:00', value: 54.92 },
  { date: '2023-11-03T17:00:00', value: 49.64 },
  { date: '2023-11-03T18:00:00', value: 95.22 },
  { date: '2023-11-03T19:00:00', value: 90.58 },
  { date: '2023-11-03T20:00:00', value: 34.07 },
  { date: '2023-11-03T21:00:00', value: 69.38 },
  { date: '2023-11-03T22:00:00', value: 67.73 },
  { date: '2023-11-03T23:00:00', value: 73.83 },
  { date: '2023-11-04T00:00:00', value: 97.97 },
  { date: '2023-11-04T01:00:00', value: 60.29 },
  { date: '2023-11-04T02:00:00', value: 83.74 },
  { date: '2023-11-04T03:00:00', value: 65.51 },
  { date: '2023-11-04T04:00:00', value: 70.1 },
  { date: '2023-11-04T05:00:00', value: 86.83 },
  { date: '2023-11-04T06:00:00', value: 5.27 },
  { date: '2023-11-04T07:00:00', value: 15.21 },
  { date: '2023-11-04T08:00:00', value: 88.5 },
  { date: '2023-11-04T09:00:00', value: 9.01 },
  { date: '2023-11-04T10:00:00', value: 28.99 },
  { date: '2023-11-04T11:00:00', value: 20.27 },
  { date: '2023-11-04T12:00:00', value: 63.28 },
  { date: '2023-11-04T13:00:00', value: 21.04 },
  { date: '2023-11-04T14:00:00', value: 53.43 },
  { date: '2023-11-04T15:00:00', value: 61.53 },
  { date: '2023-11-04T16:00:00', value: 40.11 },
  { date: '2023-11-04T17:00:00', value: 2.75 },
  { date: '2023-11-04T18:00:00', value: 59.12 },
  { date: '2023-11-04T19:00:00', value: 18.71 },
  { date: '2023-11-04T20:00:00', value: 36.93 },
  { date: '2023-11-04T21:00:00', value: 83.44 },
  { date: '2023-11-04T22:00:00', value: 23.23 },
  { date: '2023-11-04T23:00:00', value: 25.72 },
  { date: '2023-11-05T00:00:00', value: 7.24 },
  { date: '2023-11-05T01:00:00', value: 1.5 },
  { date: '2023-11-05T02:00:00', value: 92.75 },
  { date: '2023-11-05T03:00:00', value: 72.49 },
  { date: '2023-11-05T04:00:00', value: 90.51 },
  { date: '2023-11-05T05:00:00', value: 92.47 },
  { date: '2023-11-05T06:00:00', value: 86.62 },
  { date: '2023-11-05T07:00:00', value: 24.95 },
  { date: '2023-11-05T08:00:00', value: 65.21 },
  { date: '2023-11-05T09:00:00', value: 40.24 },
  { date: '2023-11-05T10:00:00', value: 22.27 },
  { date: '2023-11-05T11:00:00', value: 84.08 },
  { date: '2023-11-05T12:00:00', value: 22.38 },
  { date: '2023-11-05T13:00:00', value: 22.87 },
  { date: '2023-11-05T14:00:00', value: 23.14 },
  { date: '2023-11-05T15:00:00', value: 59.83 },
  { date: '2023-11-05T16:00:00', value: 95.47 },
  { date: '2023-11-05T17:00:00', value: 67.74 },
  { date: '2023-11-05T18:00:00', value: 82.5 },
  { date: '2023-11-05T19:00:00', value: 67.11 },
  { date: '2023-11-05T20:00:00', value: 81.91 },
  { date: '2023-11-05T21:00:00', value: 99.93 },
  { date: '2023-11-05T22:00:00', value: 69.3 },
  { date: '2023-11-05T23:00:00', value: 76.08 },
  { date: '2023-11-06T00:00:00', value: 8.21 },
  { date: '2023-11-06T01:00:00', value: 14.09 },
  { date: '2023-11-06T02:00:00', value: 88.49 },
  { date: '2023-11-06T03:00:00', value: 21.01 },
  { date: '2023-11-06T04:00:00', value: 43.69 },
  { date: '2023-11-06T05:00:00', value: 55.63 },
  { date: '2023-11-06T06:00:00', value: 61.54 },
  { date: '2023-11-06T07:00:00', value: 30.31 },
  { date: '2023-11-06T08:00:00', value: 47.71 },
  { date: '2023-11-06T09:00:00', value: 10.14 },
  { date: '2023-11-06T10:00:00', value: 19.59 },
  { date: '2023-11-06T11:00:00', value: 41.72 },
  { date: '2023-11-06T12:00:00', value: 72.92 },
  { date: '2023-11-06T13:00:00', value: 41.15 },
  { date: '2023-11-06T14:00:00', value: 69.7 },
  { date: '2023-11-06T15:00:00', value: 78.98 },
  { date: '2023-11-06T16:00:00', value: 81.28 },
  { date: '2023-11-06T17:00:00', value: 7.4 },
  { date: '2023-11-06T18:00:00', value: 5.08 },
  { date: '2023-11-06T19:00:00', value: 27.33 },
  { date: '2023-11-06T20:00:00', value: 68.03 },
  { date: '2023-11-06T21:00:00', value: 16.72 },
  { date: '2023-11-06T22:00:00', value: 30.86 },
  { date: '2023-11-06T23:00:00', value: 30.32 },
  { date: '2023-11-07T00:00:00', value: 50.76 },
  { date: '2023-11-07T01:00:00', value: 75.63 },
  { date: '2023-11-07T02:00:00', value: 23.06 },
  { date: '2023-11-07T03:00:00', value: 21.99 },
  { date: '2023-11-07T04:00:00', value: 36.03 },
  { date: '2023-11-07T05:00:00', value: 47.01 },
  { date: '2023-11-07T06:00:00', value: 14.7 },
  { date: '2023-11-07T07:00:00', value: 6.83 },
  { date: '2023-11-07T08:00:00', value: 97.86 },
  { date: '2023-11-07T09:00:00', value: 9.51 },
  { date: '2023-11-07T10:00:00', value: 68.5 },
  { date: '2023-11-07T11:00:00', value: 78.79 },
  { date: '2023-11-07T12:00:00', value: 81.71 },
  { date: '2023-11-07T13:00:00', value: 70.86 },
  { date: '2023-11-07T14:00:00', value: 16.5 },
  { date: '2023-11-07T15:00:00', value: 18.87 },
  { date: '2023-11-07T16:00:00', value: 34.8 },
  { date: '2023-11-07T17:00:00', value: 87.46 },
  { date: '2023-11-07T18:00:00', value: 3.6 },
  { date: '2023-11-07T19:00:00', value: 67.56 },
  { date: '2023-11-07T20:00:00', value: 13.01 },
  { date: '2023-11-07T21:00:00', value: 17.88 },
  { date: '2023-11-07T22:00:00', value: 46.79 },
  { date: '2023-11-07T23:00:00', value: 40.09 },
  { date: '2023-11-08T00:00:00', value: 37.77 },
  { date: '2023-11-08T01:00:00', value: 27.83 },
  { date: '2023-11-08T02:00:00', value: 84.54 },
  { date: '2023-11-08T03:00:00', value: 78.75 },
  { date: '2023-11-08T04:00:00', value: 4.14 },
  { date: '2023-11-08T05:00:00', value: 76.58 },
  { date: '2023-11-08T06:00:00', value: 75.87 },
  { date: '2023-11-08T07:00:00', value: 28.68 },
  { date: '2023-11-08T08:00:00', value: 21.69 },
  { date: '2023-11-08T09:00:00', value: 78.85 },
  { date: '2023-11-08T10:00:00', value: 94.27 },
  { date: '2023-11-08T11:00:00', value: 60.28 },
  { date: '2023-11-08T12:00:00', value: 16.72 },
  { date: '2023-11-08T13:00:00', value: 56.43 },
  { date: '2023-11-08T14:00:00', value: 21.38 },
  { date: '2023-11-08T15:00:00', value: 17.55 },
  { date: '2023-11-08T16:00:00', value: 13.4 },
  { date: '2023-11-08T17:00:00', value: 48.78 },
  { date: '2023-11-08T18:00:00', value: 10.82 },
  { date: '2023-11-08T19:00:00', value: 83.77 },
  { date: '2023-11-08T20:00:00', value: 17.36 },
  { date: '2023-11-08T21:00:00', value: 74.21 },
  { date: '2023-11-08T22:00:00', value: 6.68 },
  { date: '2023-11-08T23:00:00', value: 48.27 },
  { date: '2023-11-09T00:00:00', value: 91.07 },
  { date: '2023-11-09T01:00:00', value: 88.19 },
  { date: '2023-11-09T02:00:00', value: 66.54 },
  { date: '2023-11-09T03:00:00', value: 72.62 },
  { date: '2023-11-09T04:00:00', value: 88.51 },
  { date: '2023-11-09T05:00:00', value: 42.82 },
  { date: '2023-11-09T06:00:00', value: 44.13 },
  { date: '2023-11-09T07:00:00', value: 9.68 },
  { date: '2023-11-09T08:00:00', value: 34.26 },
  { date: '2023-11-09T09:00:00', value: 16.1 },
  { date: '2023-11-09T10:00:00', value: 46.87 },
  { date: '2023-11-09T11:00:00', value: 87.59 },
  { date: '2023-11-09T12:00:00', value: 34.2 },
  { date: '2023-11-09T13:00:00', value: 37.44 },
  { date: '2023-11-09T14:00:00', value: 21.49 },
  { date: '2023-11-09T15:00:00', value: 41.47 },
  { date: '2023-11-09T16:00:00', value: 35.97 },
  { date: '2023-11-09T17:00:00', value: 22.52 },
  { date: '2023-11-09T18:00:00', value: 52.3 },
  { date: '2023-11-09T19:00:00', value: 35.19 },
  { date: '2023-11-09T20:00:00', value: 62.43 },
  { date: '2023-11-09T21:00:00', value: 31.67 },
  { date: '2023-11-09T22:00:00', value: 74.95 },
  { date: '2023-11-09T23:00:00', value: 74.61 },
  { date: '2023-11-10T00:00:00', value: 84.52 },
  { date: '2023-11-10T01:00:00', value: 37.2 },
  { date: '2023-11-10T02:00:00', value: 12.17 },
  { date: '2023-11-10T03:00:00', value: 45.56 },
  { date: '2023-11-10T04:00:00', value: 60.61 },
  { date: '2023-11-10T05:00:00', value: 41.08 },
  { date: '2023-11-10T06:00:00', value: 51.71 },
  { date: '2023-11-10T07:00:00', value: 63.86 },
  { date: '2023-11-10T08:00:00', value: 52.19 },
  { date: '2023-11-10T09:00:00', value: 33.48 },
  { date: '2023-11-10T10:00:00', value: 70.57 },
  { date: '2023-11-10T11:00:00', value: 31.84 },
  { date: '2023-11-10T12:00:00', value: 36.27 },
  { date: '2023-11-10T13:00:00', value: 82.85 },
  { date: '2023-11-10T14:00:00', value: 8.47 },
  { date: '2023-11-10T15:00:00', value: 7.89 },
  { date: '2023-11-10T16:00:00', value: 78.47 },
  { date: '2023-11-10T17:00:00', value: 22.91 },
  { date: '2023-11-10T18:00:00', value: 87.28 },
  { date: '2023-11-10T19:00:00', value: 80.67 },
  { date: '2023-11-10T20:00:00', value: 88.8 },
  { date: '2023-11-10T21:00:00', value: 90.05 },
  { date: '2023-11-10T22:00:00', value: 9.81 },
  { date: '2023-11-10T23:00:00', value: 9.5 },
  { date: '2023-11-11T00:00:00', value: 87.22 },
  { date: '2023-11-11T01:00:00', value: 53.76 },
  { date: '2023-11-11T02:00:00', value: 15.67 },
  { date: '2023-11-11T03:00:00', value: 64.88 },
  { date: '2023-11-11T04:00:00', value: 67.46 },
  { date: '2023-11-11T05:00:00', value: 43.99 },
  { date: '2023-11-11T06:00:00', value: 49.76 },
  { date: '2023-11-11T07:00:00', value: 77.15 },
  { date: '2023-11-11T08:00:00', value: 25.99 },
  { date: '2023-11-11T09:00:00', value: 36.89 },
  { date: '2023-11-11T10:00:00', value: 39.82 },
  { date: '2023-11-11T11:00:00', value: 80.55 },
  { date: '2023-11-11T12:00:00', value: 74.69 },
  { date: '2023-11-11T13:00:00', value: 62.77 },
  { date: '2023-11-11T14:00:00', value: 58.52 },
  { date: '2023-11-11T15:00:00', value: 18.88 },
  { date: '2023-11-11T16:00:00', value: 1.07 },
  { date: '2023-11-11T17:00:00', value: 47.29 },
  { date: '2023-11-11T18:00:00', value: 74.52 },
  { date: '2023-11-11T19:00:00', value: 19.86 },
  { date: '2023-11-11T20:00:00', value: 22.46 },
  { date: '2023-11-11T21:00:00', value: 6.74 },
  { date: '2023-11-11T22:00:00', value: 63.37 },
  { date: '2023-11-11T23:00:00', value: 96.32 },
  { date: '2023-11-12T00:00:00', value: 21.99 },
  { date: '2023-11-12T01:00:00', value: 42.12 },
  { date: '2023-11-12T02:00:00', value: 53.32 },
  { date: '2023-11-12T03:00:00', value: 41.8 },
  { date: '2023-11-12T04:00:00', value: 1.38 },
  { date: '2023-11-12T05:00:00', value: 35.83 },
  { date: '2023-11-12T06:00:00', value: 67.92 },
  { date: '2023-11-12T07:00:00', value: 45.56 },
  { date: '2023-11-12T08:00:00', value: 96.71 },
  { date: '2023-11-12T09:00:00', value: 60.08 },
  { date: '2023-11-12T10:00:00', value: 89.33 },
  { date: '2023-11-12T11:00:00', value: 10.51 },
  { date: '2023-11-12T12:00:00', value: 57.38 },
  { date: '2023-11-12T13:00:00', value: 9.87 },
  { date: '2023-11-12T14:00:00', value: 85.27 },
  { date: '2023-11-12T15:00:00', value: 42.46 },
  { date: '2023-11-12T16:00:00', value: 18.56 },
  { date: '2023-11-12T17:00:00', value: 21.15 },
  { date: '2023-11-12T18:00:00', value: 89.59 },
  { date: '2023-11-12T19:00:00', value: 87.92 },
  { date: '2023-11-12T20:00:00', value: 72.47 },
  { date: '2023-11-12T21:00:00', value: 86.41 },
  { date: '2023-11-12T22:00:00', value: 61.33 },
  { date: '2023-11-12T23:00:00', value: 62.08 },
  { date: '2023-11-13T00:00:00', value: 64.21 },
  { date: '2023-11-13T01:00:00', value: 83.77 },
  { date: '2023-11-13T02:00:00', value: 51.91 },
  { date: '2023-11-13T03:00:00', value: 57.44 },
  { date: '2023-11-13T04:00:00', value: 26.23 },
  { date: '2023-11-13T05:00:00', value: 28.18 },
  { date: '2023-11-13T06:00:00', value: 92.41 },
  { date: '2023-11-13T07:00:00', value: 65.85 },
  { date: '2023-11-13T08:00:00', value: 33.05 },
  { date: '2023-11-13T09:00:00', value: 43.92 },
  { date: '2023-11-13T10:00:00', value: 31.51 },
  { date: '2023-11-13T11:00:00', value: 74.23 },
  { date: '2023-11-13T12:00:00', value: 89.94 },
  { date: '2023-11-13T13:00:00', value: 15.85 },
  { date: '2023-11-13T14:00:00', value: 8.38 },
  { date: '2023-11-13T15:00:00', value: 61.8 },
  { date: '2023-11-13T16:00:00', value: 90.1 },
  { date: '2023-11-13T17:00:00', value: 17.32 },
  { date: '2023-11-13T18:00:00', value: 21.76 },
  { date: '2023-11-13T19:00:00', value: 55.36 },
  { date: '2023-11-13T20:00:00', value: 30.05 },
  { date: '2023-11-13T21:00:00', value: 90.53 },
  { date: '2023-11-13T22:00:00', value: 28.31 },
  { date: '2023-11-13T23:00:00', value: 17.77 },
  { date: '2023-11-14T00:00:00', value: 10.59 },
  { date: '2023-11-14T01:00:00', value: 61.52 },
  { date: '2023-11-14T02:00:00', value: 14.41 },
  { date: '2023-11-14T03:00:00', value: 36.15 },
  { date: '2023-11-14T04:00:00', value: 62.09 },
  { date: '2023-11-14T05:00:00', value: 34.95 },
  { date: '2023-11-14T06:00:00', value: 13.63 },
  { date: '2023-11-14T07:00:00', value: 40.05 },
  { date: '2023-11-14T08:00:00', value: 65.24 },
  { date: '2023-11-14T09:00:00', value: 13.59 },
  { date: '2023-11-14T10:00:00', value: 80.47 },
  { date: '2023-11-14T11:00:00', value: 44.25 },
  { date: '2023-11-14T12:00:00', value: 80.63 },
  { date: '2023-11-14T13:00:00', value: 12.85 },
  { date: '2023-11-14T14:00:00', value: 15.61 },
  { date: '2023-11-14T15:00:00', value: 73.75 },
  { date: '2023-11-14T16:00:00', value: 33.57 },
  { date: '2023-11-14T17:00:00', value: 75.66 },
  { date: '2023-11-14T18:00:00', value: 70.16 },
  { date: '2023-11-14T19:00:00', value: 89.84 },
  { date: '2023-11-14T20:00:00', value: 62.84 },
  { date: '2023-11-14T21:00:00', value: 1.34 },
  { date: '2023-11-14T22:00:00', value: 91.13 },
  { date: '2023-11-14T23:00:00', value: 18.56 },
  { date: '2023-11-15T00:00:00', value: 84.61 },
  { date: '2023-11-15T01:00:00', value: 82.36 },
  { date: '2023-11-15T02:00:00', value: 99.27 },
  { date: '2023-11-15T03:00:00', value: 52.94 },
  { date: '2023-11-15T04:00:00', value: 80.66 },
  { date: '2023-11-15T05:00:00', value: 91.14 },
  { date: '2023-11-15T06:00:00', value: 83.12 },
  { date: '2023-11-15T07:00:00', value: 67.56 },
  { date: '2023-11-15T08:00:00', value: 9.04 },
  { date: '2023-11-15T09:00:00', value: 10.63 },
  { date: '2023-11-15T10:00:00', value: 53.7 },
  { date: '2023-11-15T11:00:00', value: 84.71 },
  { date: '2023-11-15T12:00:00', value: 96.7 },
  { date: '2023-11-15T13:00:00', value: 36.16 },
  { date: '2023-11-15T14:00:00', value: 6.25 },
  { date: '2023-11-15T15:00:00', value: 45.98 },
  { date: '2023-11-15T16:00:00', value: 11.58 },
  { date: '2023-11-15T17:00:00', value: 41.43 },
  { date: '2023-11-15T18:00:00', value: 10.18 },
  { date: '2023-11-15T19:00:00', value: 92.36 },
  { date: '2023-11-15T20:00:00', value: 53.63 },
  { date: '2023-11-15T21:00:00', value: 34.17 },
  { date: '2023-11-15T22:00:00', value: 62.96 },
  { date: '2023-11-15T23:00:00', value: 36.37 },
  { date: '2023-11-16T00:00:00', value: 55.13 },
  { date: '2023-11-16T01:00:00', value: 1.06 },
  { date: '2023-11-16T02:00:00', value: 68.3 },
  { date: '2023-11-16T03:00:00', value: 82.84 },
  { date: '2023-11-16T04:00:00', value: 35.07 },
  { date: '2023-11-16T05:00:00', value: 53.45 },
  { date: '2023-11-16T06:00:00', value: 39.59 },
  { date: '2023-11-16T07:00:00', value: 96.17 },
  { date: '2023-11-16T08:00:00', value: 27.99 },
  { date: '2023-11-16T09:00:00', value: 52.07 },
  { date: '2023-11-16T10:00:00', value: 23.95 },
  { date: '2023-11-16T11:00:00', value: 49.96 },
  { date: '2023-11-16T12:00:00', value: 61.51 },
  { date: '2023-11-16T13:00:00', value: 52.18 },
  { date: '2023-11-16T14:00:00', value: 60.61 },
  { date: '2023-11-16T15:00:00', value: 95.96 },
  { date: '2023-11-16T16:00:00', value: 3.82 },
  { date: '2023-11-16T17:00:00', value: 30.35 },
  { date: '2023-11-16T18:00:00', value: 60.93 },
  { date: '2023-11-16T19:00:00', value: 73.71 },
  { date: '2023-11-16T20:00:00', value: 10.5 },
  { date: '2023-11-16T21:00:00', value: 73.58 },
  { date: '2023-11-16T22:00:00', value: 20.99 },
  { date: '2023-11-16T23:00:00', value: 25.11 },
  { date: '2023-11-17T00:00:00', value: 3.03 },
  { date: '2023-11-17T01:00:00', value: 26.65 },
  { date: '2023-11-17T02:00:00', value: 27.8 },
  { date: '2023-11-17T03:00:00', value: 43.29 },
  { date: '2023-11-17T04:00:00', value: 66.24 },
  { date: '2023-11-17T05:00:00', value: 30.35 },
  { date: '2023-11-17T06:00:00', value: 60.07 },
  { date: '2023-11-17T07:00:00', value: 68.02 },
  { date: '2023-11-17T08:00:00', value: 6.43 },
  { date: '2023-11-17T09:00:00', value: 64.89 },
  { date: '2023-11-17T10:00:00', value: 71.08 },
  { date: '2023-11-17T11:00:00', value: 95.45 },
  { date: '2023-11-17T12:00:00', value: 44.77 },
  { date: '2023-11-17T13:00:00', value: 30.69 },
  { date: '2023-11-17T14:00:00', value: 18.79 },
  { date: '2023-11-17T15:00:00', value: 72.55 },
  { date: '2023-11-17T16:00:00', value: 83.74 },
  { date: '2023-11-17T17:00:00', value: 73.49 },
  { date: '2023-11-17T18:00:00', value: 64.65 },
  { date: '2023-11-17T19:00:00', value: 17.75 },
  { date: '2023-11-17T20:00:00', value: 15.96 },
  { date: '2023-11-17T21:00:00', value: 68.63 },
  { date: '2023-11-17T22:00:00', value: 48.29 },
  { date: '2023-11-17T23:00:00', value: 3.95 },
  { date: '2023-11-18T00:00:00', value: 76.19 },
  { date: '2023-11-18T01:00:00', value: 18.59 },
  { date: '2023-11-18T02:00:00', value: 4.97 },
  { date: '2023-11-18T03:00:00', value: 69.93 },
  { date: '2023-11-18T04:00:00', value: 41.87 },
  { date: '2023-11-18T05:00:00', value: 15.67 },
  { date: '2023-11-18T06:00:00', value: 50.25 },
  { date: '2023-11-18T07:00:00', value: 71.02 },
  { date: '2023-11-18T08:00:00', value: 76.13 },
  { date: '2023-11-18T09:00:00', value: 79.12 },
  { date: '2023-11-18T10:00:00', value: 75.12 },
  { date: '2023-11-18T11:00:00', value: 65.59 },
  { date: '2023-11-18T12:00:00', value: 53.45 },
  { date: '2023-11-18T13:00:00', value: 49.65 },
  { date: '2023-11-18T14:00:00', value: 22.86 },
  { date: '2023-11-18T15:00:00', value: 99.44 },
  { date: '2023-11-18T16:00:00', value: 2.08 },
  { date: '2023-11-18T17:00:00', value: 62.5 },
  { date: '2023-11-18T18:00:00', value: 30.52 },
  { date: '2023-11-18T19:00:00', value: 78.87 },
  { date: '2023-11-18T20:00:00', value: 32.45 },
  { date: '2023-11-18T21:00:00', value: 13.62 },
  { date: '2023-11-18T22:00:00', value: 85.08 },
  { date: '2023-11-18T23:00:00', value: 72.29 },
  { date: '2023-11-19T00:00:00', value: 61.63 },
  { date: '2023-11-19T01:00:00', value: 11.14 },
  { date: '2023-11-19T02:00:00', value: 77.69 },
  { date: '2023-11-19T03:00:00', value: 43.57 },
  { date: '2023-11-19T04:00:00', value: 88.95 },
  { date: '2023-11-19T05:00:00', value: 32.4 },
  { date: '2023-11-19T06:00:00', value: 99.12 },
  { date: '2023-11-19T07:00:00', value: 16.16 },
  { date: '2023-11-19T08:00:00', value: 71.95 },
  { date: '2023-11-19T09:00:00', value: 19.07 },
  { date: '2023-11-19T10:00:00', value: 47.21 },
  { date: '2023-11-19T11:00:00', value: 38.02 },
  { date: '2023-11-19T12:00:00', value: 56.66 },
  { date: '2023-11-19T13:00:00', value: 56.69 },
  { date: '2023-11-19T14:00:00', value: 77.48 },
  { date: '2023-11-19T15:00:00', value: 97.73 },
  { date: '2023-11-19T16:00:00', value: 74.46 },
  { date: '2023-11-19T17:00:00', value: 98.08 },
  { date: '2023-11-19T18:00:00', value: 79.44 },
  { date: '2023-11-19T19:00:00', value: 75.58 },
  { date: '2023-11-19T20:00:00', value: 54.27 },
  { date: '2023-11-19T21:00:00', value: 36.36 },
  { date: '2023-11-19T22:00:00', value: 18.35 },
  { date: '2023-11-19T23:00:00', value: 19.33 },
  { date: '2023-11-20T00:00:00', value: 46.08 },
  { date: '2023-11-20T01:00:00', value: 15.11 },
  { date: '2023-11-20T02:00:00', value: 65.69 },
  { date: '2023-11-20T03:00:00', value: 28.44 },
  { date: '2023-11-20T04:00:00', value: 99.45 },
  { date: '2023-11-20T05:00:00', value: 31.12 },
  { date: '2023-11-20T06:00:00', value: 54.28 },
  { date: '2023-11-20T07:00:00', value: 10.68 },
  { date: '2023-11-20T08:00:00', value: 11.81 },
  { date: '2023-11-20T09:00:00', value: 80.62 },
  { date: '2023-11-20T10:00:00', value: 42.29 },
  { date: '2023-11-20T11:00:00', value: 21.21 },
  { date: '2023-11-20T12:00:00', value: 73.51 },
  { date: '2023-11-20T13:00:00', value: 86.57 },
  { date: '2023-11-20T14:00:00', value: 94.02 },
  { date: '2023-11-20T15:00:00', value: 56.09 },
  { date: '2023-11-20T16:00:00', value: 47.85 },
  { date: '2023-11-20T17:00:00', value: 44.34 },
  { date: '2023-11-20T18:00:00', value: 32.51 },
  { date: '2023-11-20T19:00:00', value: 36.86 },
  { date: '2023-11-20T20:00:00', value: 9.73 },
  { date: '2023-11-20T21:00:00', value: 31.5 },
  { date: '2023-11-20T22:00:00', value: 45.26 },
  { date: '2023-11-20T23:00:00', value: 6.0 },
  { date: '2023-11-21T00:00:00', value: 7.78 },
  { date: '2023-11-21T01:00:00', value: 33.59 },
  { date: '2023-11-21T02:00:00', value: 11.32 },
  { date: '2023-11-21T03:00:00', value: 97.37 },
  { date: '2023-11-21T04:00:00', value: 47.02 },
  { date: '2023-11-21T05:00:00', value: 72.66 },
  { date: '2023-11-21T06:00:00', value: 56.49 },
  { date: '2023-11-21T07:00:00', value: 99.07 },
  { date: '2023-11-21T08:00:00', value: 89.2 },
  { date: '2023-11-21T09:00:00', value: 83.45 },
  { date: '2023-11-21T10:00:00', value: 93.14 },
  { date: '2023-11-21T11:00:00', value: 41.16 },
  { date: '2023-11-21T12:00:00', value: 83.81 },
  { date: '2023-11-21T13:00:00', value: 85.54 },
  { date: '2023-11-21T14:00:00', value: 90.28 },
  { date: '2023-11-21T15:00:00', value: 74.52 },
  { date: '2023-11-21T16:00:00', value: 95.63 },
  { date: '2023-11-21T17:00:00', value: 72.99 },
  { date: '2023-11-21T18:00:00', value: 43.24 },
  { date: '2023-11-21T19:00:00', value: 15.71 },
  { date: '2023-11-21T20:00:00', value: 6.87 },
  { date: '2023-11-21T21:00:00', value: 11.95 },
  { date: '2023-11-21T22:00:00', value: 54.49 },
  { date: '2023-11-21T23:00:00', value: 10.79 },
  { date: '2023-11-22T00:00:00', value: 72.67 },
  { date: '2023-11-22T01:00:00', value: 31.49 },
  { date: '2023-11-22T02:00:00', value: 8.97 },
  { date: '2023-11-22T03:00:00', value: 50.06 },
  { date: '2023-11-22T04:00:00', value: 66.18 },
  { date: '2023-11-22T05:00:00', value: 99.78 },
  { date: '2023-11-22T06:00:00', value: 78.35 },
  { date: '2023-11-22T07:00:00', value: 42.99 },
  { date: '2023-11-22T08:00:00', value: 76.38 },
  { date: '2023-11-22T09:00:00', value: 26.6 },
  { date: '2023-11-22T10:00:00', value: 44.72 },
  { date: '2023-11-22T11:00:00', value: 3.73 },
  { date: '2023-11-22T12:00:00', value: 1.75 },
  { date: '2023-11-22T13:00:00', value: 75.87 },
  { date: '2023-11-22T14:00:00', value: 46.66 },
  { date: '2023-11-22T15:00:00', value: 83.26 },
  { date: '2023-11-22T16:00:00', value: 66.07 },
  { date: '2023-11-22T17:00:00', value: 46.26 },
  { date: '2023-11-22T18:00:00', value: 77.61 },
  { date: '2023-11-22T19:00:00', value: 25.89 },
  { date: '2023-11-22T20:00:00', value: 13.41 },
  { date: '2023-11-22T21:00:00', value: 72.03 },
  { date: '2023-11-22T22:00:00', value: 48.76 },
  { date: '2023-11-22T23:00:00', value: 61.92 },
  { date: '2023-11-23T00:00:00', value: 11.99 },
  { date: '2023-11-23T01:00:00', value: 54.44 },
  { date: '2023-11-23T02:00:00', value: 51.94 },
  { date: '2023-11-23T03:00:00', value: 93.32 },
  { date: '2023-11-23T04:00:00', value: 42.88 },
  { date: '2023-11-23T05:00:00', value: 54.29 },
  { date: '2023-11-23T06:00:00', value: 71.74 },
  { date: '2023-11-23T07:00:00', value: 15.22 },
  { date: '2023-11-23T08:00:00', value: 96.5 },
  { date: '2023-11-23T09:00:00', value: 73.16 },
  { date: '2023-11-23T10:00:00', value: 88.23 },
  { date: '2023-11-23T11:00:00', value: 81.84 },
  { date: '2023-11-23T12:00:00', value: 10.0 },
  { date: '2023-11-23T13:00:00', value: 65.47 },
  { date: '2023-11-23T14:00:00', value: 81.96 },
  { date: '2023-11-23T15:00:00', value: 90.22 },
  { date: '2023-11-23T16:00:00', value: 74.23 },
  { date: '2023-11-23T17:00:00', value: 26.47 },
  { date: '2023-11-23T18:00:00', value: 86.01 },
  { date: '2023-11-23T19:00:00', value: 60.09 },
  { date: '2023-11-23T20:00:00', value: 16.49 },
  { date: '2023-11-23T21:00:00', value: 39.77 },
  { date: '2023-11-23T22:00:00', value: 92.7 },
  { date: '2023-11-23T23:00:00', value: 49.75 },
  { date: '2023-11-24T00:00:00', value: 37.51 },
  { date: '2023-11-24T01:00:00', value: 14.87 },
  { date: '2023-11-24T02:00:00', value: 59.85 },
  { date: '2023-11-24T03:00:00', value: 46.9 },
  { date: '2023-11-24T04:00:00', value: 4.75 },
  { date: '2023-11-24T05:00:00', value: 97.36 },
  { date: '2023-11-24T06:00:00', value: 63.68 },
  { date: '2023-11-24T07:00:00', value: 67.66 },
  { date: '2023-11-24T08:00:00', value: 14.49 },
  { date: '2023-11-24T09:00:00', value: 63.45 },
  { date: '2023-11-24T10:00:00', value: 63.07 },
  { date: '2023-11-24T11:00:00', value: 62.13 },
  { date: '2023-11-24T12:00:00', value: 94.18 },
  { date: '2023-11-24T13:00:00', value: 37.57 },
  { date: '2023-11-24T14:00:00', value: 14.45 },
  { date: '2023-11-24T15:00:00', value: 26.62 },
  { date: '2023-11-24T16:00:00', value: 91.38 },
  { date: '2023-11-24T17:00:00', value: 18.34 },
  { date: '2023-11-24T18:00:00', value: 41.2 },
  { date: '2023-11-24T19:00:00', value: 20.77 },
  { date: '2023-11-24T20:00:00', value: 19.98 },
  { date: '2023-11-24T21:00:00', value: 99.64 },
  { date: '2023-11-24T22:00:00', value: 38.9 },
  { date: '2023-11-24T23:00:00', value: 10.65 },
  { date: '2023-11-25T00:00:00', value: 5.27 },
  { date: '2023-11-25T01:00:00', value: 27.1 },
  { date: '2023-11-25T02:00:00', value: 79.0 },
  { date: '2023-11-25T03:00:00', value: 77.07 },
  { date: '2023-11-25T04:00:00', value: 33.56 },
  { date: '2023-11-25T05:00:00', value: 45.51 },
  { date: '2023-11-25T06:00:00', value: 1.03 },
  { date: '2023-11-25T07:00:00', value: 73.98 },
  { date: '2023-11-25T08:00:00', value: 92.16 },
  { date: '2023-11-25T09:00:00', value: 52.22 },
  { date: '2023-11-25T10:00:00', value: 71.96 },
  { date: '2023-11-25T11:00:00', value: 82.63 },
  { date: '2023-11-25T12:00:00', value: 28.04 },
  { date: '2023-11-25T13:00:00', value: 17.05 },
  { date: '2023-11-25T14:00:00', value: 63.85 },
  { date: '2023-11-25T15:00:00', value: 19.32 },
  { date: '2023-11-25T16:00:00', value: 34.89 },
  { date: '2023-11-25T17:00:00', value: 78.21 },
  { date: '2023-11-25T18:00:00', value: 81.09 },
  { date: '2023-11-25T19:00:00', value: 11.72 },
  { date: '2023-11-25T20:00:00', value: 17.7 },
  { date: '2023-11-25T21:00:00', value: 79.5 },
  { date: '2023-11-25T22:00:00', value: 3.18 },
  { date: '2023-11-25T23:00:00', value: 10.88 },
  { date: '2023-11-26T00:00:00', value: 38.02 },
  { date: '2023-11-26T01:00:00', value: 41.58 },
  { date: '2023-11-26T02:00:00', value: 3.85 },
  { date: '2023-11-26T03:00:00', value: 68.33 },
  { date: '2023-11-26T04:00:00', value: 2.63 },
  { date: '2023-11-26T05:00:00', value: 86.19 },
  { date: '2023-11-26T06:00:00', value: 45.38 },
  { date: '2023-11-26T07:00:00', value: 40.4 },
  { date: '2023-11-26T08:00:00', value: 63.03 },
  { date: '2023-11-26T09:00:00', value: 11.09 },
  { date: '2023-11-26T10:00:00', value: 75.04 },
  { date: '2023-11-26T11:00:00', value: 7.13 },
  { date: '2023-11-26T12:00:00', value: 39.56 },
  { date: '2023-11-26T13:00:00', value: 97.33 },
  { date: '2023-11-26T14:00:00', value: 79.09 },
  { date: '2023-11-26T15:00:00', value: 17.61 },
  { date: '2023-11-26T16:00:00', value: 66.77 },
  { date: '2023-11-26T17:00:00', value: 97.04 },
  { date: '2023-11-26T18:00:00', value: 29.39 },
  { date: '2023-11-26T19:00:00', value: 87.41 },
  { date: '2023-11-26T20:00:00', value: 58.57 },
  { date: '2023-11-26T21:00:00', value: 12.43 },
  { date: '2023-11-26T22:00:00', value: 96.01 },
  { date: '2023-11-26T23:00:00', value: 94.56 },
  { date: '2023-11-27T00:00:00', value: 5.43 },
  { date: '2023-11-27T01:00:00', value: 52.96 },
  { date: '2023-11-27T02:00:00', value: 56.25 },
  { date: '2023-11-27T03:00:00', value: 79.7 },
  { date: '2023-11-27T04:00:00', value: 11.05 },
  { date: '2023-11-27T05:00:00', value: 40.08 },
  { date: '2023-11-27T06:00:00', value: 17.07 },
  { date: '2023-11-27T07:00:00', value: 96.77 },
  { date: '2023-11-27T08:00:00', value: 65.59 },
  { date: '2023-11-27T09:00:00', value: 42.45 },
  { date: '2023-11-27T10:00:00', value: 65.62 },
  { date: '2023-11-27T11:00:00', value: 46.87 },
  { date: '2023-11-27T12:00:00', value: 82.83 },
  { date: '2023-11-27T13:00:00', value: 11.29 },
  { date: '2023-11-27T14:00:00', value: 86.67 },
  { date: '2023-11-27T15:00:00', value: 46.3 },
  { date: '2023-11-27T16:00:00', value: 9.21 },
  { date: '2023-11-27T17:00:00', value: 68.85 },
  { date: '2023-11-27T18:00:00', value: 79.51 },
  { date: '2023-11-27T19:00:00', value: 86.52 },
  { date: '2023-11-27T20:00:00', value: 69.24 },
  { date: '2023-11-27T21:00:00', value: 64.79 },
  { date: '2023-11-27T22:00:00', value: 21.53 },
  { date: '2023-11-27T23:00:00', value: 57.47 },
  { date: '2023-11-28T00:00:00', value: 2.19 },
  { date: '2023-11-28T01:00:00', value: 6.82 },
  { date: '2023-11-28T02:00:00', value: 53.22 },
  { date: '2023-11-28T03:00:00', value: 58.47 },
  { date: '2023-11-28T04:00:00', value: 64.92 },
  { date: '2023-11-28T05:00:00', value: 67.05 },
  { date: '2023-11-28T06:00:00', value: 9.87 },
  { date: '2023-11-28T07:00:00', value: 61.95 },
  { date: '2023-11-28T08:00:00', value: 53.39 },
  { date: '2023-11-28T09:00:00', value: 58.93 },
  { date: '2023-11-28T10:00:00', value: 29.62 },
  { date: '2023-11-28T11:00:00', value: 50.73 },
  { date: '2023-11-28T12:00:00', value: 12.45 },
  { date: '2023-11-28T13:00:00', value: 35.33 },
  { date: '2023-11-28T14:00:00', value: 94.46 },
  { date: '2023-11-28T15:00:00', value: 93.73 },
  { date: '2023-11-28T16:00:00', value: 66.03 },
  { date: '2023-11-28T17:00:00', value: 75.1 },
  { date: '2023-11-28T18:00:00', value: 94.19 },
  { date: '2023-11-28T19:00:00', value: 81.46 },
  { date: '2023-11-28T20:00:00', value: 46.54 },
  { date: '2023-11-28T21:00:00', value: 3.36 },
  { date: '2023-11-28T22:00:00', value: 43.38 },
  { date: '2023-11-28T23:00:00', value: 4.65 },
  { date: '2023-11-29T00:00:00', value: 15.42 },
  { date: '2023-11-29T01:00:00', value: 48.72 },
  { date: '2023-11-29T02:00:00', value: 77.48 },
  { date: '2023-11-29T03:00:00', value: 29.94 },
  { date: '2023-11-29T04:00:00', value: 33.82 },
  { date: '2023-11-29T05:00:00', value: 78.89 },
  { date: '2023-11-29T06:00:00', value: 24.84 },
  { date: '2023-11-29T07:00:00', value: 54.0 },
  { date: '2023-11-29T08:00:00', value: 18.58 },
  { date: '2023-11-29T09:00:00', value: 70.75 },
  { date: '2023-11-29T10:00:00', value: 63.62 },
  { date: '2023-11-29T11:00:00', value: 93.71 },
  { date: '2023-11-29T12:00:00', value: 59.24 },
  { date: '2023-11-29T13:00:00', value: 95.35 },
  { date: '2023-11-29T14:00:00', value: 58.25 },
  { date: '2023-11-29T15:00:00', value: 9.38 },
  { date: '2023-11-29T16:00:00', value: 65.12 },
  { date: '2023-11-29T17:00:00', value: 39.55 },
  { date: '2023-11-29T18:00:00', value: 5.76 },
  { date: '2023-11-29T19:00:00', value: 82.69 },
  { date: '2023-11-29T20:00:00', value: 36.99 },
  { date: '2023-11-29T21:00:00', value: 82.56 },
  { date: '2023-11-29T22:00:00', value: 45.94 },
  { date: '2023-11-29T23:00:00', value: 29.13 },
  { date: '2023-11-30T00:00:00', value: 88.35 },
  { date: '2023-11-30T01:00:00', value: 13.48 },
  { date: '2023-11-30T02:00:00', value: 4.0 },
  { date: '2023-11-30T03:00:00', value: 25.73 },
  { date: '2023-11-30T04:00:00', value: 40.54 },
  { date: '2023-11-30T05:00:00', value: 54.57 },
  { date: '2023-11-30T06:00:00', value: 33.18 },
  { date: '2023-11-30T07:00:00', value: 28.99 },
  { date: '2023-11-30T08:00:00', value: 57.38 },
  { date: '2023-11-30T09:00:00', value: 48.39 },
  { date: '2023-11-30T10:00:00', value: 2.42 },
  { date: '2023-11-30T11:00:00', value: 20.99 },
  { date: '2023-11-30T12:00:00', value: 22.17 },
  { date: '2023-11-30T13:00:00', value: 77.5 },
  { date: '2023-11-30T14:00:00', value: 44.15 },
  { date: '2023-11-30T15:00:00', value: 57.28 },
  { date: '2023-11-30T16:00:00', value: 89.87 },
  { date: '2023-11-30T17:00:00', value: 14.06 },
  { date: '2023-11-30T18:00:00', value: 64.99 },
  { date: '2023-11-30T19:00:00', value: 39.07 },
  { date: '2023-11-30T20:00:00', value: 26.32 },
  { date: '2023-11-30T21:00:00', value: 57.62 },
  { date: '2023-11-30T22:00:00', value: 23.32 },
  { date: '2023-11-30T23:00:00', value: 96.63 },
  { date: '2023-12-01T00:00:00', value: 82.41 },
  { date: '2023-12-01T01:00:00', value: 49.87 },
  { date: '2023-12-01T02:00:00', value: 72.09 },
  { date: '2023-12-01T03:00:00', value: 15.04 },
  { date: '2023-12-01T04:00:00', value: 69.18 },
  { date: '2023-12-01T05:00:00', value: 40.99 },
  { date: '2023-12-01T06:00:00', value: 42.98 },
  { date: '2023-12-01T07:00:00', value: 35.74 },
  { date: '2023-12-01T08:00:00', value: 45.99 },
  { date: '2023-12-01T09:00:00', value: 17.74 },
  { date: '2023-12-01T10:00:00', value: 85.64 },
  { date: '2023-12-01T11:00:00', value: 45.16 },
  { date: '2023-12-01T12:00:00', value: 67.87 },
  { date: '2023-12-01T13:00:00', value: 16.84 },
  { date: '2023-12-01T14:00:00', value: 71.4 },
  { date: '2023-12-01T15:00:00', value: 95.12 },
  { date: '2023-12-01T16:00:00', value: 13.49 },
  { date: '2023-12-01T17:00:00', value: 97.45 },
  { date: '2023-12-01T18:00:00', value: 29.3 },
  { date: '2023-12-01T19:00:00', value: 56.84 },
  { date: '2023-12-01T20:00:00', value: 78.76 },
  { date: '2023-12-01T21:00:00', value: 81.51 },
  { date: '2023-12-01T22:00:00', value: 75.81 },
  { date: '2023-12-01T23:00:00', value: 2.25 },
  { date: '2023-12-02T00:00:00', value: 64.62 },
  { date: '2023-12-02T01:00:00', value: 7.59 },
  { date: '2023-12-02T02:00:00', value: 72.48 },
  { date: '2023-12-02T03:00:00', value: 11.64 },
  { date: '2023-12-02T04:00:00', value: 89.67 },
  { date: '2023-12-02T05:00:00', value: 86.29 },
  { date: '2023-12-02T06:00:00', value: 14.76 },
  { date: '2023-12-02T07:00:00', value: 27.65 },
  { date: '2023-12-02T08:00:00', value: 97.46 },
  { date: '2023-12-02T09:00:00', value: 23.62 },
  { date: '2023-12-02T10:00:00', value: 58.58 },
  { date: '2023-12-02T11:00:00', value: 26.35 },
  { date: '2023-12-02T12:00:00', value: 2.39 },
  { date: '2023-12-02T13:00:00', value: 58.82 },
  { date: '2023-12-02T14:00:00', value: 28.32 },
  { date: '2023-12-02T15:00:00', value: 87.44 },
  { date: '2023-12-02T16:00:00', value: 1.9 },
  { date: '2023-12-02T17:00:00', value: 68.6 },
  { date: '2023-12-02T18:00:00', value: 37.06 },
  { date: '2023-12-02T19:00:00', value: 17.8 },
  { date: '2023-12-02T20:00:00', value: 57.45 },
  { date: '2023-12-02T21:00:00', value: 89.55 },
  { date: '2023-12-02T22:00:00', value: 61.81 },
  { date: '2023-12-02T23:00:00', value: 7.49 },
  { date: '2023-12-03T00:00:00', value: 75.17 },
  { date: '2023-12-03T01:00:00', value: 56.68 },
  { date: '2023-12-03T02:00:00', value: 49.34 },
  { date: '2023-12-03T03:00:00', value: 57.92 },
  { date: '2023-12-03T04:00:00', value: 99.94 },
  { date: '2023-12-03T05:00:00', value: 8.78 },
  { date: '2023-12-03T06:00:00', value: 12.8 },
  { date: '2023-12-03T07:00:00', value: 10.5 },
  { date: '2023-12-03T08:00:00', value: 18.02 },
  { date: '2023-12-03T09:00:00', value: 82.25 },
  { date: '2023-12-03T10:00:00', value: 93.52 },
  { date: '2023-12-03T11:00:00', value: 30.83 },
  { date: '2023-12-03T12:00:00', value: 51.09 },
  { date: '2023-12-03T13:00:00', value: 5.76 },
  { date: '2023-12-03T14:00:00', value: 14.32 },
  { date: '2023-12-03T15:00:00', value: 19.87 },
  { date: '2023-12-03T16:00:00', value: 45.09 },
  { date: '2023-12-03T17:00:00', value: 73.48 },
  { date: '2023-12-03T18:00:00', value: 67.84 },
  { date: '2023-12-03T19:00:00', value: 81.38 },
  { date: '2023-12-03T20:00:00', value: 68.56 },
  { date: '2023-12-03T21:00:00', value: 45.15 },
  { date: '2023-12-03T22:00:00', value: 37.45 },
  { date: '2023-12-03T23:00:00', value: 33.0 },
  { date: '2023-12-04T00:00:00', value: 50.59 },
  { date: '2023-12-04T01:00:00', value: 94.42 },
  { date: '2023-12-04T02:00:00', value: 46.5 },
  { date: '2023-12-04T03:00:00', value: 88.17 },
  { date: '2023-12-04T04:00:00', value: 89.19 },
  { date: '2023-12-04T05:00:00', value: 7.47 },
  { date: '2023-12-04T06:00:00', value: 25.58 },
  { date: '2023-12-04T07:00:00', value: 41.09 },
  { date: '2023-12-04T08:00:00', value: 2.56 },
  { date: '2023-12-04T09:00:00', value: 39.1 },
  { date: '2023-12-04T10:00:00', value: 44.42 },
  { date: '2023-12-04T11:00:00', value: 45.48 },
  { date: '2023-12-04T12:00:00', value: 11.39 },
  { date: '2023-12-04T13:00:00', value: 96.23 },
  { date: '2023-12-04T14:00:00', value: 89.77 },
  { date: '2023-12-04T15:00:00', value: 39.3 },
  { date: '2023-12-04T16:00:00', value: 13.17 },
  { date: '2023-12-04T17:00:00', value: 60.46 },
  { date: '2023-12-04T18:00:00', value: 95.65 },
  { date: '2023-12-04T19:00:00', value: 39.61 },
  { date: '2023-12-04T20:00:00', value: 36.09 },
  { date: '2023-12-04T21:00:00', value: 17.5 },
  { date: '2023-12-04T22:00:00', value: 98.3 },
  { date: '2023-12-04T23:00:00', value: 21.73 },
  { date: '2023-12-05T00:00:00', value: 34.12 },
  { date: '2023-12-05T01:00:00', value: 45.18 },
  { date: '2023-12-05T02:00:00', value: 81.65 },
  { date: '2023-12-05T03:00:00', value: 53.6 },
  { date: '2023-12-05T04:00:00', value: 44.43 },
  { date: '2023-12-05T05:00:00', value: 65.46 },
  { date: '2023-12-05T06:00:00', value: 37.82 },
  { date: '2023-12-05T07:00:00', value: 20.1 },
  { date: '2023-12-05T08:00:00', value: 60.45 },
  { date: '2023-12-05T09:00:00', value: 23.74 },
  { date: '2023-12-05T10:00:00', value: 27.42 },
  { date: '2023-12-05T11:00:00', value: 86.15 },
  { date: '2023-12-05T12:00:00', value: 52.64 },
  { date: '2023-12-05T13:00:00', value: 86.0 },
  { date: '2023-12-05T14:00:00', value: 66.52 },
  { date: '2023-12-05T15:00:00', value: 30.56 },
  { date: '2023-12-05T16:00:00', value: 64.62 },
  { date: '2023-12-05T17:00:00', value: 25.77 },
  { date: '2023-12-05T18:00:00', value: 1.0 },
  { date: '2023-12-05T19:00:00', value: 82.51 },
  { date: '2023-12-05T20:00:00', value: 29.65 },
  { date: '2023-12-05T21:00:00', value: 70.16 },
  { date: '2023-12-05T22:00:00', value: 35.83 },
  { date: '2023-12-05T23:00:00', value: 3.73 },
  { date: '2023-12-06T00:00:00', value: 3.08 },
  { date: '2023-12-06T01:00:00', value: 53.15 },
  { date: '2023-12-06T02:00:00', value: 78.13 },
  { date: '2023-12-06T03:00:00', value: 64.91 },
  { date: '2023-12-06T04:00:00', value: 44.04 },
  { date: '2023-12-06T05:00:00', value: 28.25 },
  { date: '2023-12-06T06:00:00', value: 11.37 },
  { date: '2023-12-06T07:00:00', value: 37.89 },
  { date: '2023-12-06T08:00:00', value: 96.89 },
  { date: '2023-12-06T09:00:00', value: 70.88 },
  { date: '2023-12-06T10:00:00', value: 79.9 },
  { date: '2023-12-06T11:00:00', value: 26.2 },
  { date: '2023-12-06T12:00:00', value: 73.24 },
  { date: '2023-12-06T13:00:00', value: 71.84 },
  { date: '2023-12-06T14:00:00', value: 79.36 },
  { date: '2023-12-06T15:00:00', value: 59.27 },
  { date: '2023-12-06T16:00:00', value: 46.02 },
  { date: '2023-12-06T17:00:00', value: 16.47 },
  { date: '2023-12-06T18:00:00', value: 70.67 },
  { date: '2023-12-06T19:00:00', value: 53.44 },
  { date: '2023-12-06T20:00:00', value: 91.17 },
  { date: '2023-12-06T21:00:00', value: 69.73 },
  { date: '2023-12-06T22:00:00', value: 79.12 },
  { date: '2023-12-06T23:00:00', value: 26.31 },
  { date: '2023-12-07T00:00:00', value: 89.91 },
  { date: '2023-12-07T01:00:00', value: 28.62 },
  { date: '2023-12-07T02:00:00', value: 91.71 },
  { date: '2023-12-07T03:00:00', value: 33.07 },
  { date: '2023-12-07T04:00:00', value: 63.49 },
  { date: '2023-12-07T05:00:00', value: 4.66 },
  { date: '2023-12-07T06:00:00', value: 96.71 },
  { date: '2023-12-07T07:00:00', value: 16.68 },
  { date: '2023-12-07T08:00:00', value: 36.5 },
  { date: '2023-12-07T09:00:00', value: 17.7 },
  { date: '2023-12-07T10:00:00', value: 64.53 },
  { date: '2023-12-07T11:00:00', value: 56.94 },
  { date: '2023-12-07T12:00:00', value: 13.28 },
  { date: '2023-12-07T13:00:00', value: 85.92 },
  { date: '2023-12-07T14:00:00', value: 83.39 },
  { date: '2023-12-07T15:00:00', value: 62.58 },
  { date: '2023-12-07T16:00:00', value: 96.86 },
  { date: '2023-12-07T17:00:00', value: 93.61 },
  { date: '2023-12-07T18:00:00', value: 39.38 },
  { date: '2023-12-07T19:00:00', value: 14.93 },
  { date: '2023-12-07T20:00:00', value: 48.9 },
  { date: '2023-12-07T21:00:00', value: 70.71 },
  { date: '2023-12-07T22:00:00', value: 46.42 },
  { date: '2023-12-07T23:00:00', value: 10.28 },
  { date: '2023-12-08T00:00:00', value: 96.25 },
  { date: '2023-12-08T01:00:00', value: 67.35 },
  { date: '2023-12-08T02:00:00', value: 34.85 },
  { date: '2023-12-08T03:00:00', value: 11.32 },
  { date: '2023-12-08T04:00:00', value: 46.17 },
  { date: '2023-12-08T05:00:00', value: 86.55 },
  { date: '2023-12-08T06:00:00', value: 38.31 },
  { date: '2023-12-08T07:00:00', value: 20.36 },
  { date: '2023-12-08T08:00:00', value: 6.04 },
  { date: '2023-12-08T09:00:00', value: 88.38 },
  { date: '2023-12-08T10:00:00', value: 35.11 },
  { date: '2023-12-08T11:00:00', value: 39.63 },
  { date: '2023-12-08T12:00:00', value: 38.46 },
  { date: '2023-12-08T13:00:00', value: 84.06 },
  { date: '2023-12-08T14:00:00', value: 44.73 },
  { date: '2023-12-08T15:00:00', value: 33.83 },
  { date: '2023-12-08T16:00:00', value: 29.27 },
  { date: '2023-12-08T17:00:00', value: 32.96 },
  { date: '2023-12-08T18:00:00', value: 95.19 },
  { date: '2023-12-08T19:00:00', value: 91.66 },
  { date: '2023-12-08T20:00:00', value: 12.18 },
  { date: '2023-12-08T21:00:00', value: 15.12 },
  { date: '2023-12-08T22:00:00', value: 20.84 },
  { date: '2023-12-08T23:00:00', value: 9.95 },
  { date: '2023-12-09T00:00:00', value: 37.31 },
  { date: '2023-12-09T01:00:00', value: 38.76 },
  { date: '2023-12-09T02:00:00', value: 83.82 },
  { date: '2023-12-09T03:00:00', value: 68.14 },
  { date: '2023-12-09T04:00:00', value: 53.33 },
  { date: '2023-12-09T05:00:00', value: 20.04 },
  { date: '2023-12-09T06:00:00', value: 96.12 },
  { date: '2023-12-09T07:00:00', value: 51.08 },
  { date: '2023-12-09T08:00:00', value: 35.34 },
  { date: '2023-12-09T09:00:00', value: 73.43 },
  { date: '2023-12-09T10:00:00', value: 5.56 },
  { date: '2023-12-09T11:00:00', value: 90.39 },
  { date: '2023-12-09T12:00:00', value: 39.12 },
  { date: '2023-12-09T13:00:00', value: 45.36 },
  { date: '2023-12-09T14:00:00', value: 14.83 },
  { date: '2023-12-09T15:00:00', value: 94.84 },
  { date: '2023-12-09T16:00:00', value: 44.41 },
  { date: '2023-12-09T17:00:00', value: 61.89 },
  { date: '2023-12-09T18:00:00', value: 40.36 },
  { date: '2023-12-09T19:00:00', value: 86.69 },
  { date: '2023-12-09T20:00:00', value: 71.45 },
  { date: '2023-12-09T21:00:00', value: 86.27 },
  { date: '2023-12-09T22:00:00', value: 57.72 },
  { date: '2023-12-09T23:00:00', value: 44.84 },
  { date: '2023-12-10T00:00:00', value: 2.84 },
  { date: '2023-12-10T01:00:00', value: 37.84 },
  { date: '2023-12-10T02:00:00', value: 82.16 },
  { date: '2023-12-10T03:00:00', value: 15.27 },
  { date: '2023-12-10T04:00:00', value: 23.47 },
  { date: '2023-12-10T05:00:00', value: 71.15 },
  { date: '2023-12-10T06:00:00', value: 85.39 },
  { date: '2023-12-10T07:00:00', value: 13.43 },
  { date: '2023-12-10T08:00:00', value: 94.9 },
  { date: '2023-12-10T09:00:00', value: 46.89 },
  { date: '2023-12-10T10:00:00', value: 26.5 },
  { date: '2023-12-10T11:00:00', value: 82.81 },
  { date: '2023-12-10T12:00:00', value: 45.04 },
  { date: '2023-12-10T13:00:00', value: 72.44 },
  { date: '2023-12-10T14:00:00', value: 31.04 },
  { date: '2023-12-10T15:00:00', value: 47.84 },
  { date: '2023-12-10T16:00:00', value: 63.03 },
  { date: '2023-12-10T17:00:00', value: 65.39 },
  { date: '2023-12-10T18:00:00', value: 58.47 },
  { date: '2023-12-10T19:00:00', value: 45.18 },
  { date: '2023-12-10T20:00:00', value: 70.12 },
  { date: '2023-12-10T21:00:00', value: 55.13 },
  { date: '2023-12-10T22:00:00', value: 13.86 },
  { date: '2023-12-10T23:00:00', value: 34.09 },
  { date: '2023-12-11T00:00:00', value: 66.19 },
  { date: '2023-12-11T01:00:00', value: 66.95 },
  { date: '2023-12-11T02:00:00', value: 51.83 },
  { date: '2023-12-11T03:00:00', value: 21.23 },
  { date: '2023-12-11T04:00:00', value: 77.14 },
  { date: '2023-12-11T05:00:00', value: 13.86 },
  { date: '2023-12-11T06:00:00', value: 94.42 },
  { date: '2023-12-11T07:00:00', value: 97.52 },
  { date: '2023-12-11T08:00:00', value: 6.23 },
  { date: '2023-12-11T09:00:00', value: 29.08 },
  { date: '2023-12-11T10:00:00', value: 83.75 },
  { date: '2023-12-11T11:00:00', value: 23.3 },
  { date: '2023-12-11T12:00:00', value: 15.51 },
  { date: '2023-12-11T13:00:00', value: 42.45 },
  { date: '2023-12-11T14:00:00', value: 46.94 },
  { date: '2023-12-11T15:00:00', value: 45.15 },
  { date: '2023-12-11T16:00:00', value: 99.98 },
  { date: '2023-12-11T17:00:00', value: 61.04 },
  { date: '2023-12-11T18:00:00', value: 52.32 },
  { date: '2023-12-11T19:00:00', value: 2.43 },
  { date: '2023-12-11T20:00:00', value: 85.58 },
  { date: '2023-12-11T21:00:00', value: 9.7 },
  { date: '2023-12-11T22:00:00', value: 49.23 },
  { date: '2023-12-11T23:00:00', value: 44.84 },
  { date: '2023-12-12T00:00:00', value: 98.1 },
  { date: '2023-12-12T01:00:00', value: 84.38 },
  { date: '2023-12-12T02:00:00', value: 57.46 },
  { date: '2023-12-12T03:00:00', value: 28.4 },
  { date: '2023-12-12T04:00:00', value: 53.67 },
  { date: '2023-12-12T05:00:00', value: 13.24 },
  { date: '2023-12-12T06:00:00', value: 93.69 },
  { date: '2023-12-12T07:00:00', value: 17.17 },
  { date: '2023-12-12T08:00:00', value: 52.56 },
  { date: '2023-12-12T09:00:00', value: 84.14 },
  { date: '2023-12-12T10:00:00', value: 2.05 },
  { date: '2023-12-12T11:00:00', value: 75.12 },
  { date: '2023-12-12T12:00:00', value: 56.28 },
  { date: '2023-12-12T13:00:00', value: 88.88 },
  { date: '2023-12-12T14:00:00', value: 71.95 },
  { date: '2023-12-12T15:00:00', value: 40.5 },
  { date: '2023-12-12T16:00:00', value: 39.91 },
  { date: '2023-12-12T17:00:00', value: 34.44 },
  { date: '2023-12-12T18:00:00', value: 26.32 },
  { date: '2023-12-12T19:00:00', value: 32.06 },
  { date: '2023-12-12T20:00:00', value: 47.45 },
  { date: '2023-12-12T21:00:00', value: 9.83 },
  { date: '2023-12-12T22:00:00', value: 29.37 },
  { date: '2023-12-12T23:00:00', value: 73.12 },
  { date: '2023-12-13T00:00:00', value: 77.15 },
  { date: '2023-12-13T01:00:00', value: 17.33 },
  { date: '2023-12-13T02:00:00', value: 45.08 },
  { date: '2023-12-13T03:00:00', value: 17.52 },
  { date: '2023-12-13T04:00:00', value: 67.88 },
  { date: '2023-12-13T05:00:00', value: 44.91 },
  { date: '2023-12-13T06:00:00', value: 31.27 },
  { date: '2023-12-13T07:00:00', value: 65.05 },
  { date: '2023-12-13T08:00:00', value: 79.08 },
  { date: '2023-12-13T09:00:00', value: 53.79 },
  { date: '2023-12-13T10:00:00', value: 74.41 },
  { date: '2023-12-13T11:00:00', value: 29.83 },
  { date: '2023-12-13T12:00:00', value: 35.93 },
  { date: '2023-12-13T13:00:00', value: 38.25 },
  { date: '2023-12-13T14:00:00', value: 72.41 },
  { date: '2023-12-13T15:00:00', value: 4.95 },
  { date: '2023-12-13T16:00:00', value: 45.0 },
  { date: '2023-12-13T17:00:00', value: 36.8 },
  { date: '2023-12-13T18:00:00', value: 19.48 },
  { date: '2023-12-13T19:00:00', value: 28.78 },
  { date: '2023-12-13T20:00:00', value: 5.02 },
  { date: '2023-12-13T21:00:00', value: 89.98 },
  { date: '2023-12-13T22:00:00', value: 6.74 },
  { date: '2023-12-13T23:00:00', value: 75.7 },
  { date: '2023-12-14T00:00:00', value: 9.41 },
  { date: '2023-12-14T01:00:00', value: 9.38 },
  { date: '2023-12-14T02:00:00', value: 38.26 },
  { date: '2023-12-14T03:00:00', value: 62.91 },
  { date: '2023-12-14T04:00:00', value: 12.15 },
  { date: '2023-12-14T05:00:00', value: 87.06 },
  { date: '2023-12-14T06:00:00', value: 44.02 },
  { date: '2023-12-14T07:00:00', value: 26.11 },
  { date: '2023-12-14T08:00:00', value: 71.91 },
  { date: '2023-12-14T09:00:00', value: 92.24 },
  { date: '2023-12-14T10:00:00', value: 77.77 },
  { date: '2023-12-14T11:00:00', value: 5.53 },
  { date: '2023-12-14T12:00:00', value: 95.32 },
  { date: '2023-12-14T13:00:00', value: 42.15 },
  { date: '2023-12-14T14:00:00', value: 15.18 },
  { date: '2023-12-14T15:00:00', value: 70.07 },
  { date: '2023-12-14T16:00:00', value: 97.54 },
  { date: '2023-12-14T17:00:00', value: 51.68 },
  { date: '2023-12-14T18:00:00', value: 93.65 },
  { date: '2023-12-14T19:00:00', value: 64.77 },
  { date: '2023-12-14T20:00:00', value: 61.41 },
  { date: '2023-12-14T21:00:00', value: 70.79 },
  { date: '2023-12-14T22:00:00', value: 50.33 },
  { date: '2023-12-14T23:00:00', value: 12.65 },
  { date: '2023-12-15T00:00:00', value: 78.98 },
  { date: '2023-12-15T01:00:00', value: 32.8 },
  { date: '2023-12-15T02:00:00', value: 91.97 },
  { date: '2023-12-15T03:00:00', value: 73.14 },
  { date: '2023-12-15T04:00:00', value: 22.68 },
  { date: '2023-12-15T05:00:00', value: 85.66 },
  { date: '2023-12-15T06:00:00', value: 20.46 },
  { date: '2023-12-15T07:00:00', value: 83.8 },
  { date: '2023-12-15T08:00:00', value: 10.71 },
  { date: '2023-12-15T09:00:00', value: 43.09 },
  { date: '2023-12-15T10:00:00', value: 80.09 },
  { date: '2023-12-15T11:00:00', value: 91.3 },
  { date: '2023-12-15T12:00:00', value: 39.27 },
  { date: '2023-12-15T13:00:00', value: 56.26 },
  { date: '2023-12-15T14:00:00', value: 45.64 },
  { date: '2023-12-15T15:00:00', value: 15.95 },
  { date: '2023-12-15T16:00:00', value: 46.49 },
  { date: '2023-12-15T17:00:00', value: 37.02 },
  { date: '2023-12-15T18:00:00', value: 83.46 },
  { date: '2023-12-15T19:00:00', value: 91.55 },
  { date: '2023-12-15T20:00:00', value: 75.29 },
  { date: '2023-12-15T21:00:00', value: 9.85 },
  { date: '2023-12-15T22:00:00', value: 45.32 },
  { date: '2023-12-15T23:00:00', value: 71.3 },
  { date: '2023-12-16T00:00:00', value: 37.18 },
  { date: '2023-12-16T01:00:00', value: 42.61 },
  { date: '2023-12-16T02:00:00', value: 97.75 },
  { date: '2023-12-16T03:00:00', value: 70.5 },
  { date: '2023-12-16T04:00:00', value: 79.33 },
  { date: '2023-12-16T05:00:00', value: 13.22 },
  { date: '2023-12-16T06:00:00', value: 50.58 },
  { date: '2023-12-16T07:00:00', value: 49.97 },
  { date: '2023-12-16T08:00:00', value: 53.29 },
  { date: '2023-12-16T09:00:00', value: 13.44 },
  { date: '2023-12-16T10:00:00', value: 82.66 },
  { date: '2023-12-16T11:00:00', value: 49.17 },
  { date: '2023-12-16T12:00:00', value: 79.45 },
  { date: '2023-12-16T13:00:00', value: 65.45 },
  { date: '2023-12-16T14:00:00', value: 55.02 },
  { date: '2023-12-16T15:00:00', value: 35.08 },
  { date: '2023-12-16T16:00:00', value: 78.59 },
  { date: '2023-12-16T17:00:00', value: 29.39 },
  { date: '2023-12-16T18:00:00', value: 44.98 },
  { date: '2023-12-16T19:00:00', value: 67.09 },
  { date: '2023-12-16T20:00:00', value: 3.27 },
  { date: '2023-12-16T21:00:00', value: 91.75 },
  { date: '2023-12-16T22:00:00', value: 3.47 },
  { date: '2023-12-16T23:00:00', value: 97.41 },
  { date: '2023-12-17T00:00:00', value: 80.65 },
  { date: '2023-12-17T01:00:00', value: 20.78 },
  { date: '2023-12-17T02:00:00', value: 71.51 },
  { date: '2023-12-17T03:00:00', value: 23.79 },
  { date: '2023-12-17T04:00:00', value: 35.78 },
  { date: '2023-12-17T05:00:00', value: 11.69 },
  { date: '2023-12-17T06:00:00', value: 64.9 },
  { date: '2023-12-17T07:00:00', value: 79.27 },
  { date: '2023-12-17T08:00:00', value: 66.62 },
  { date: '2023-12-17T09:00:00', value: 79.02 },
  { date: '2023-12-17T10:00:00', value: 61.37 },
  { date: '2023-12-17T11:00:00', value: 70.68 },
  { date: '2023-12-17T12:00:00', value: 53.38 },
  { date: '2023-12-17T13:00:00', value: 12.91 },
  { date: '2023-12-17T14:00:00', value: 33.27 },
  { date: '2023-12-17T15:00:00', value: 39.81 },
  { date: '2023-12-17T16:00:00', value: 86.13 },
  { date: '2023-12-17T17:00:00', value: 65.5 },
  { date: '2023-12-17T18:00:00', value: 91.44 },
  { date: '2023-12-17T19:00:00', value: 73.51 },
  { date: '2023-12-17T20:00:00', value: 14.38 },
  { date: '2023-12-17T21:00:00', value: 43.77 },
  { date: '2023-12-17T22:00:00', value: 79.92 },
  { date: '2023-12-17T23:00:00', value: 82.76 },
  { date: '2023-12-18T00:00:00', value: 79.48 },
  { date: '2023-12-18T01:00:00', value: 50.08 },
  { date: '2023-12-18T02:00:00', value: 93.54 },
  { date: '2023-12-18T03:00:00', value: 24.42 },
  { date: '2023-12-18T04:00:00', value: 31.84 },
  { date: '2023-12-18T05:00:00', value: 50.39 },
  { date: '2023-12-18T06:00:00', value: 75.04 },
  { date: '2023-12-18T07:00:00', value: 26.89 },
  { date: '2023-12-18T08:00:00', value: 43.95 },
  { date: '2023-12-18T09:00:00', value: 8.72 },
  { date: '2023-12-18T10:00:00', value: 20.44 },
  { date: '2023-12-18T11:00:00', value: 67.81 },
  { date: '2023-12-18T12:00:00', value: 96.39 },
  { date: '2023-12-18T13:00:00', value: 23.3 },
  { date: '2023-12-18T14:00:00', value: 71.26 },
  { date: '2023-12-18T15:00:00', value: 6.76 },
  { date: '2023-12-18T16:00:00', value: 62.33 },
  { date: '2023-12-18T17:00:00', value: 43.74 },
  { date: '2023-12-18T18:00:00', value: 13.02 },
  { date: '2023-12-18T19:00:00', value: 69.31 },
  { date: '2023-12-18T20:00:00', value: 1.48 },
  { date: '2023-12-18T21:00:00', value: 26.82 },
  { date: '2023-12-18T22:00:00', value: 24.39 },
  { date: '2023-12-18T23:00:00', value: 26.55 },
  { date: '2023-12-19T00:00:00', value: 74.11 },
  { date: '2023-12-19T01:00:00', value: 41.4 },
  { date: '2023-12-19T02:00:00', value: 61.97 },
  { date: '2023-12-19T03:00:00', value: 66.75 },
  { date: '2023-12-19T04:00:00', value: 2.95 },
  { date: '2023-12-19T05:00:00', value: 92.37 },
  { date: '2023-12-19T06:00:00', value: 19.88 },
  { date: '2023-12-19T07:00:00', value: 6.52 },
  { date: '2023-12-19T08:00:00', value: 86.24 },
  { date: '2023-12-19T09:00:00', value: 8.29 },
  { date: '2023-12-19T10:00:00', value: 6.48 },
  { date: '2023-12-19T11:00:00', value: 11.99 },
  { date: '2023-12-19T12:00:00', value: 16.98 },
  { date: '2023-12-19T13:00:00', value: 39.89 },
  { date: '2023-12-19T14:00:00', value: 11.61 },
  { date: '2023-12-19T15:00:00', value: 45.03 },
  { date: '2023-12-19T16:00:00', value: 67.18 },
  { date: '2023-12-19T17:00:00', value: 3.92 },
  { date: '2023-12-19T18:00:00', value: 58.39 },
  { date: '2023-12-19T19:00:00', value: 82.52 },
  { date: '2023-12-19T20:00:00', value: 76.73 },
  { date: '2023-12-19T21:00:00', value: 7.96 },
  { date: '2023-12-19T22:00:00', value: 53.59 },
  { date: '2023-12-19T23:00:00', value: 5.97 },
  { date: '2023-12-20T00:00:00', value: 52.76 },
  { date: '2023-12-20T01:00:00', value: 54.15 },
  { date: '2023-12-20T02:00:00', value: 69.88 },
  { date: '2023-12-20T03:00:00', value: 27.89 },
  { date: '2023-12-20T04:00:00', value: 18.37 },
  { date: '2023-12-20T05:00:00', value: 23.99 },
  { date: '2023-12-20T06:00:00', value: 47.32 },
  { date: '2023-12-20T07:00:00', value: 85.54 },
  { date: '2023-12-20T08:00:00', value: 25.14 },
  { date: '2023-12-20T09:00:00', value: 66.26 },
  { date: '2023-12-20T10:00:00', value: 64.31 },
  { date: '2023-12-20T11:00:00', value: 80.15 },
  { date: '2023-12-20T12:00:00', value: 74.67 },
  { date: '2023-12-20T13:00:00', value: 56.31 },
  { date: '2023-12-20T14:00:00', value: 56.75 },
  { date: '2023-12-20T15:00:00', value: 6.68 },
  { date: '2023-12-20T16:00:00', value: 87.18 },
  { date: '2023-12-20T17:00:00', value: 41.65 },
  { date: '2023-12-20T18:00:00', value: 43.26 },
  { date: '2023-12-20T19:00:00', value: 51.1 },
  { date: '2023-12-20T20:00:00', value: 59.08 },
  { date: '2023-12-20T21:00:00', value: 15.9 },
  { date: '2023-12-20T22:00:00', value: 27.86 },
  { date: '2023-12-20T23:00:00', value: 77.48 },
  { date: '2023-12-21T00:00:00', value: 18.53 },
  { date: '2023-12-21T01:00:00', value: 34.42 },
  { date: '2023-12-21T02:00:00', value: 10.99 },
  { date: '2023-12-21T03:00:00', value: 5.01 },
  { date: '2023-12-21T04:00:00', value: 79.1 },
  { date: '2023-12-21T05:00:00', value: 90.97 },
  { date: '2023-12-21T06:00:00', value: 24.13 },
  { date: '2023-12-21T07:00:00', value: 58.9 },
  { date: '2023-12-21T08:00:00', value: 51.06 },
  { date: '2023-12-21T09:00:00', value: 25.22 },
  { date: '2023-12-21T10:00:00', value: 58.71 },
  { date: '2023-12-21T11:00:00', value: 3.63 },
  { date: '2023-12-21T12:00:00', value: 87.79 },
  { date: '2023-12-21T13:00:00', value: 92.07 },
  { date: '2023-12-21T14:00:00', value: 2.57 },
  { date: '2023-12-21T15:00:00', value: 47.32 },
  { date: '2023-12-21T16:00:00', value: 78.94 },
  { date: '2023-12-21T17:00:00', value: 70.5 },
  { date: '2023-12-21T18:00:00', value: 45.06 },
  { date: '2023-12-21T19:00:00', value: 61.27 },
  { date: '2023-12-21T20:00:00', value: 66.22 },
  { date: '2023-12-21T21:00:00', value: 54.05 },
  { date: '2023-12-21T22:00:00', value: 45.95 },
  { date: '2023-12-21T23:00:00', value: 47.27 },
  { date: '2023-12-22T00:00:00', value: 75.82 },
  { date: '2023-12-22T01:00:00', value: 36.45 },
  { date: '2023-12-22T02:00:00', value: 60.09 },
  { date: '2023-12-22T03:00:00', value: 40.19 },
  { date: '2023-12-22T04:00:00', value: 36.15 },
  { date: '2023-12-22T05:00:00', value: 99.52 },
  { date: '2023-12-22T06:00:00', value: 51.68 },
  { date: '2023-12-22T07:00:00', value: 77.57 },
  { date: '2023-12-22T08:00:00', value: 77.7 },
  { date: '2023-12-22T09:00:00', value: 95.44 },
  { date: '2023-12-22T10:00:00', value: 21.27 },
  { date: '2023-12-22T11:00:00', value: 88.69 },
  { date: '2023-12-22T12:00:00', value: 84.89 },
  { date: '2023-12-22T13:00:00', value: 77.55 },
  { date: '2023-12-22T14:00:00', value: 77.07 },
  { date: '2023-12-22T15:00:00', value: 61.41 },
  { date: '2023-12-22T16:00:00', value: 47.94 },
  { date: '2023-12-22T17:00:00', value: 8.28 },
  { date: '2023-12-22T18:00:00', value: 56.93 },
  { date: '2023-12-22T19:00:00', value: 25.56 },
  { date: '2023-12-22T20:00:00', value: 51.14 },
  { date: '2023-12-22T21:00:00', value: 91.31 },
  { date: '2023-12-22T22:00:00', value: 64.9 },
  { date: '2023-12-22T23:00:00', value: 14.85 },
  { date: '2023-12-23T00:00:00', value: 5.23 },
  { date: '2023-12-23T01:00:00', value: 4.39 },
  { date: '2023-12-23T02:00:00', value: 71.89 },
  { date: '2023-12-23T03:00:00', value: 84.94 },
  { date: '2023-12-23T04:00:00', value: 76.94 },
  { date: '2023-12-23T05:00:00', value: 25.44 },
  { date: '2023-12-23T06:00:00', value: 83.48 },
  { date: '2023-12-23T07:00:00', value: 19.45 },
  { date: '2023-12-23T08:00:00', value: 18.24 },
  { date: '2023-12-23T09:00:00', value: 81.21 },
  { date: '2023-12-23T10:00:00', value: 85.16 },
  { date: '2023-12-23T11:00:00', value: 97.13 },
  { date: '2023-12-23T12:00:00', value: 65.78 },
  { date: '2023-12-23T13:00:00', value: 39.18 },
  { date: '2023-12-23T14:00:00', value: 63.99 },
  { date: '2023-12-23T15:00:00', value: 12.89 },
  { date: '2023-12-23T16:00:00', value: 2.28 },
  { date: '2023-12-23T17:00:00', value: 38.03 },
  { date: '2023-12-23T18:00:00', value: 73.1 },
  { date: '2023-12-23T19:00:00', value: 60.1 },
  { date: '2023-12-23T20:00:00', value: 88.51 },
  { date: '2023-12-23T21:00:00', value: 26.75 },
  { date: '2023-12-23T22:00:00', value: 36.99 },
  { date: '2023-12-23T23:00:00', value: 42.8 },
  { date: '2023-12-24T00:00:00', value: 17.15 },
  { date: '2023-12-24T01:00:00', value: 22.57 },
  { date: '2023-12-24T02:00:00', value: 53.2 },
  { date: '2023-12-24T03:00:00', value: 58.35 },
  { date: '2023-12-24T04:00:00', value: 1.37 },
  { date: '2023-12-24T05:00:00', value: 32.39 },
  { date: '2023-12-24T06:00:00', value: 24.81 },
  { date: '2023-12-24T07:00:00', value: 40.03 },
  { date: '2023-12-24T08:00:00', value: 65.56 },
  { date: '2023-12-24T09:00:00', value: 88.82 },
  { date: '2023-12-24T10:00:00', value: 75.37 },
  { date: '2023-12-24T11:00:00', value: 48.92 },
  { date: '2023-12-24T12:00:00', value: 24.15 },
  { date: '2023-12-24T13:00:00', value: 29.09 },
  { date: '2023-12-24T14:00:00', value: 68.77 },
  { date: '2023-12-24T15:00:00', value: 17.06 },
  { date: '2023-12-24T16:00:00', value: 60.1 },
  { date: '2023-12-24T17:00:00', value: 95.38 },
  { date: '2023-12-24T18:00:00', value: 29.69 },
  { date: '2023-12-24T19:00:00', value: 76.16 },
  { date: '2023-12-24T20:00:00', value: 31.79 },
  { date: '2023-12-24T21:00:00', value: 91.91 },
  { date: '2023-12-24T22:00:00', value: 23.46 },
  { date: '2023-12-24T23:00:00', value: 30.33 },
  { date: '2023-12-25T00:00:00', value: 75.8 },
  { date: '2023-12-25T01:00:00', value: 52.91 },
  { date: '2023-12-25T02:00:00', value: 98.06 },
  { date: '2023-12-25T03:00:00', value: 67.79 },
  { date: '2023-12-25T04:00:00', value: 78.94 },
  { date: '2023-12-25T05:00:00', value: 73.07 },
  { date: '2023-12-25T06:00:00', value: 14.57 },
  { date: '2023-12-25T07:00:00', value: 6.54 },
  { date: '2023-12-25T08:00:00', value: 44.23 },
  { date: '2023-12-25T09:00:00', value: 8.08 },
  { date: '2023-12-25T10:00:00', value: 68.25 },
  { date: '2023-12-25T11:00:00', value: 19.27 },
  { date: '2023-12-25T12:00:00', value: 22.26 },
  { date: '2023-12-25T13:00:00', value: 77.44 },
  { date: '2023-12-25T14:00:00', value: 49.01 },
  { date: '2023-12-25T15:00:00', value: 41.31 },
  { date: '2023-12-25T16:00:00', value: 4.65 },
  { date: '2023-12-25T17:00:00', value: 68.75 },
  { date: '2023-12-25T18:00:00', value: 83.59 },
  { date: '2023-12-25T19:00:00', value: 39.95 },
  { date: '2023-12-25T20:00:00', value: 91.87 },
  { date: '2023-12-25T21:00:00', value: 58.85 },
  { date: '2023-12-25T22:00:00', value: 17.68 },
  { date: '2023-12-25T23:00:00', value: 29.87 },
  { date: '2023-12-26T00:00:00', value: 32.12 },
  { date: '2023-12-26T01:00:00', value: 37.87 },
  { date: '2023-12-26T02:00:00', value: 68.1 },
  { date: '2023-12-26T03:00:00', value: 54.44 },
  { date: '2023-12-26T04:00:00', value: 92.8 },
  { date: '2023-12-26T05:00:00', value: 40.39 },
  { date: '2023-12-26T06:00:00', value: 88.72 },
  { date: '2023-12-26T07:00:00', value: 53.55 },
  { date: '2023-12-26T08:00:00', value: 37.38 },
  { date: '2023-12-26T09:00:00', value: 94.03 },
  { date: '2023-12-26T10:00:00', value: 30.48 },
  { date: '2023-12-26T11:00:00', value: 93.54 },
  { date: '2023-12-26T12:00:00', value: 9.85 },
  { date: '2023-12-26T13:00:00', value: 75.65 },
  { date: '2023-12-26T14:00:00', value: 47.9 },
  { date: '2023-12-26T15:00:00', value: 84.14 },
  { date: '2023-12-26T16:00:00', value: 21.74 },
  { date: '2023-12-26T17:00:00', value: 9.77 },
  { date: '2023-12-26T18:00:00', value: 42.61 },
  { date: '2023-12-26T19:00:00', value: 81.63 },
  { date: '2023-12-26T20:00:00', value: 76.01 },
  { date: '2023-12-26T21:00:00', value: 35.19 },
  { date: '2023-12-26T22:00:00', value: 63.34 },
  { date: '2023-12-26T23:00:00', value: 6.01 },
  { date: '2023-12-27T00:00:00', value: 99.11 },
  { date: '2023-12-27T01:00:00', value: 65.44 },
  { date: '2023-12-27T02:00:00', value: 15.03 },
  { date: '2023-12-27T03:00:00', value: 74.21 },
  { date: '2023-12-27T04:00:00', value: 80.13 },
  { date: '2023-12-27T05:00:00', value: 83.54 },
  { date: '2023-12-27T06:00:00', value: 81.8 },
  { date: '2023-12-27T07:00:00', value: 53.22 },
  { date: '2023-12-27T08:00:00', value: 67.86 },
  { date: '2023-12-27T09:00:00', value: 1.74 },
  { date: '2023-12-27T10:00:00', value: 64.27 },
  { date: '2023-12-27T11:00:00', value: 29.83 },
  { date: '2023-12-27T12:00:00', value: 98.72 },
  { date: '2023-12-27T13:00:00', value: 65.45 },
  { date: '2023-12-27T14:00:00', value: 11.13 },
  { date: '2023-12-27T15:00:00', value: 15.13 },
  { date: '2023-12-27T16:00:00', value: 57.54 },
  { date: '2023-12-27T17:00:00', value: 62.89 },
  { date: '2023-12-27T18:00:00', value: 72.28 },
  { date: '2023-12-27T19:00:00', value: 73.64 },
  { date: '2023-12-27T20:00:00', value: 13.71 },
  { date: '2023-12-27T21:00:00', value: 31.2 },
  { date: '2023-12-27T22:00:00', value: 77.31 },
  { date: '2023-12-27T23:00:00', value: 80.28 },
  { date: '2023-12-28T00:00:00', value: 81.48 },
  { date: '2023-12-28T01:00:00', value: 52.28 },
  { date: '2023-12-28T02:00:00', value: 62.75 },
  { date: '2023-12-28T03:00:00', value: 51.12 },
  { date: '2023-12-28T04:00:00', value: 73.13 },
  { date: '2023-12-28T05:00:00', value: 2.34 },
  { date: '2023-12-28T06:00:00', value: 73.26 },
  { date: '2023-12-28T07:00:00', value: 74.87 },
  { date: '2023-12-28T08:00:00', value: 66.17 },
  { date: '2023-12-28T09:00:00', value: 50.76 },
  { date: '2023-12-28T10:00:00', value: 19.29 },
  { date: '2023-12-28T11:00:00', value: 21.87 },
  { date: '2023-12-28T12:00:00', value: 43.88 },
  { date: '2023-12-28T13:00:00', value: 29.57 },
  { date: '2023-12-28T14:00:00', value: 94.2 },
  { date: '2023-12-28T15:00:00', value: 4.62 },
  { date: '2023-12-28T16:00:00', value: 83.29 },
  { date: '2023-12-28T17:00:00', value: 57.85 },
  { date: '2023-12-28T18:00:00', value: 56.04 },
  { date: '2023-12-28T19:00:00', value: 85.36 },
  { date: '2023-12-28T20:00:00', value: 1.74 },
  { date: '2023-12-28T21:00:00', value: 87.86 },
  { date: '2023-12-28T22:00:00', value: 71.22 },
  { date: '2023-12-28T23:00:00', value: 45.17 },
  { date: '2023-12-29T00:00:00', value: 22.09 },
  { date: '2023-12-29T01:00:00', value: 28.23 },
  { date: '2023-12-29T02:00:00', value: 26.95 },
  { date: '2023-12-29T03:00:00', value: 44.27 },
  { date: '2023-12-29T04:00:00', value: 75.84 },
  { date: '2023-12-29T05:00:00', value: 69.61 },
  { date: '2023-12-29T06:00:00', value: 44.77 },
  { date: '2023-12-29T07:00:00', value: 20.74 },
  { date: '2023-12-29T08:00:00', value: 44.71 },
  { date: '2023-12-29T09:00:00', value: 12.78 },
  { date: '2023-12-29T10:00:00', value: 30.58 },
  { date: '2023-12-29T11:00:00', value: 25.47 },
  { date: '2023-12-29T12:00:00', value: 95.16 },
  { date: '2023-12-29T13:00:00', value: 59.51 },
  { date: '2023-12-29T14:00:00', value: 2.91 },
  { date: '2023-12-29T15:00:00', value: 90.85 },
  { date: '2023-12-29T16:00:00', value: 27.87 },
  { date: '2023-12-29T17:00:00', value: 18.51 },
  { date: '2023-12-29T18:00:00', value: 33.45 },
  { date: '2023-12-29T19:00:00', value: 25.15 },
  { date: '2023-12-29T20:00:00', value: 36.95 },
  { date: '2023-12-29T21:00:00', value: 45.02 },
  { date: '2023-12-29T22:00:00', value: 40.48 },
  { date: '2023-12-29T23:00:00', value: 48.91 },
  { date: '2023-12-30T00:00:00', value: 47.03 },
  { date: '2023-12-30T01:00:00', value: 57.58 },
  { date: '2023-12-30T02:00:00', value: 24.58 },
  { date: '2023-12-30T03:00:00', value: 45.99 },
  { date: '2023-12-30T04:00:00', value: 97.2 },
  { date: '2023-12-30T05:00:00', value: 55.95 },
  { date: '2023-12-30T06:00:00', value: 73.18 },
  { date: '2023-12-30T07:00:00', value: 98.17 },
  { date: '2023-12-30T08:00:00', value: 52.71 },
  { date: '2023-12-30T09:00:00', value: 44.0 },
  { date: '2023-12-30T10:00:00', value: 87.81 },
  { date: '2023-12-30T11:00:00', value: 80.47 },
  { date: '2023-12-30T12:00:00', value: 63.4 },
  { date: '2023-12-30T13:00:00', value: 62.51 },
  { date: '2023-12-30T14:00:00', value: 52.71 },
  { date: '2023-12-30T15:00:00', value: 29.08 },
  { date: '2023-12-30T16:00:00', value: 25.82 },
  { date: '2023-12-30T17:00:00', value: 4.46 },
  { date: '2023-12-30T18:00:00', value: 35.16 },
  { date: '2023-12-30T19:00:00', value: 85.61 },
  { date: '2023-12-30T20:00:00', value: 54.16 },
  { date: '2023-12-30T21:00:00', value: 1.35 },
  { date: '2023-12-30T22:00:00', value: 49.74 },
  { date: '2023-12-30T23:00:00', value: 21.93 },
  { date: '2023-12-31T00:00:00', value: 54.29 },
  { date: '2023-12-31T01:00:00', value: 64.04 },
  { date: '2023-12-31T02:00:00', value: 14.2 },
  { date: '2023-12-31T03:00:00', value: 44.11 },
  { date: '2023-12-31T04:00:00', value: 23.99 },
  { date: '2023-12-31T05:00:00', value: 16.25 },
  { date: '2023-12-31T06:00:00', value: 78.74 },
  { date: '2023-12-31T07:00:00', value: 99.05 },
  { date: '2023-12-31T08:00:00', value: 4.43 },
  { date: '2023-12-31T09:00:00', value: 70.45 },
  { date: '2023-12-31T10:00:00', value: 55.51 },
  { date: '2023-12-31T11:00:00', value: 55.43 },
  { date: '2023-12-31T12:00:00', value: 34.63 },
  { date: '2023-12-31T13:00:00', value: 8.65 },
  { date: '2023-12-31T14:00:00', value: 82.98 },
  { date: '2023-12-31T15:00:00', value: 32.77 },
  { date: '2023-12-31T16:00:00', value: 74.46 },
  { date: '2023-12-31T17:00:00', value: 63.38 },
  { date: '2023-12-31T18:00:00', value: 3.78 },
  { date: '2023-12-31T19:00:00', value: 31.61 },
  { date: '2023-12-31T20:00:00', value: 62.42 },
  { date: '2023-12-31T21:00:00', value: 6.2 },
  { date: '2023-12-31T22:00:00', value: 31.81 },
  { date: '2023-12-31T23:00:00', value: 47.8 },
]
